var bodyScrollLockOptions = {
  reserveScrollBarGap: false,
};

window.lazySizesConfig = window.lazySizesConfig || {};
lazySizesConfig.loadMode = 1; // Load elements on view or nearby
lazySizesConfig.expand = 10; // Expand the lazy-loading area by 10px
lazySizesConfig.expFactor = 1.5; // Increase expand amount by 1.5 times
lazySizesConfig.throttleDelay = 300; // Delay in milliseconds before checking the scroll position


var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
if (window.theme && window.theme.moneyFormat) {
  Shopify.money_format = window.theme.moneyFormat;
} else {
  Shopify.money_format = "${{amount}}";
}
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  var placeholderMatch = formatString.match(placeholderRegex);
  if (!placeholderMatch) return formatString;

  var placeholder = placeholderMatch[1];

  // Thousands/decimal separators per Shopify money placeholder.
  // Unknown placeholders fall back to the default "amount" style so the
  // amount is never dropped from the formatted string.
  var separators = {
    amount: [",", "."],
    amount_no_decimals: [",", "."],
    amount_with_comma_separator: [".", ","],
    amount_no_decimals_with_comma_separator: [".", ","],
    amount_with_apostrophe_separator: ["'", "."],
    amount_no_decimals_with_space_separator: [" ", ","],
    amount_with_space_separator: [" ", ","],
    amount_with_period_and_space_separator: [" ", "."],
  };

  var separator = separators[placeholder] || separators.amount;
  var precision = 2;

  if (
    placeholder.indexOf("no_decimals") !== -1 ||
    (window.theme && window.theme.removeDecimalPricing)
  ) {
    precision = 0;
  }

  value = formatWithDelimiters(cents, precision, separator[0], separator[1]);

  return formatString.replace(placeholderRegex, value);
};

/**
 * DOM event delegator
 *
 * The delegator will listen
 * for events that bubble up
 * to the root node.
 *
 * @constructor
 * @param {Node|string} [root] The root node or a selector string matching the root node
 */
function Delegate(root) {
  /**
   * Maintain a map of listener
   * lists, keyed by event name.
   *
   * @type Object
   */
  this.listenerMap = [{}, {}];
  if (root) {
    this.root(root);
  }

  /** @type function() */
  this.handle = Delegate.prototype.handle.bind(this);

  // Cache of event listeners removed during an event cycle
  this._removedListeners = [];
}

/**
 * Start listening for events
 * on the provided DOM element
 *
 * @param  {Node|string} [root] The root node or a selector string matching the root node
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.root = function (root) {
  const listenerMap = this.listenerMap;
  let eventType;

  // Remove master event listeners
  if (this.rootElement) {
    for (eventType in listenerMap[1]) {
      if (listenerMap[1].hasOwnProperty(eventType)) {
        this.rootElement.removeEventListener(eventType, this.handle, true);
      }
    }
    for (eventType in listenerMap[0]) {
      if (listenerMap[0].hasOwnProperty(eventType)) {
        this.rootElement.removeEventListener(eventType, this.handle, false);
      }
    }
  }

  // If no root or root is not
  // a dom node, then remove internal
  // root reference and exit here
  if (!root || !root.addEventListener) {
    if (this.rootElement) {
      delete this.rootElement;
    }
    return this;
  }

  /**
   * The root node at which
   * listeners are attached.
   *
   * @type Node
   */
  this.rootElement = root;

  // Set up master event listeners
  for (eventType in listenerMap[1]) {
    if (listenerMap[1].hasOwnProperty(eventType)) {
      this.rootElement.addEventListener(eventType, this.handle, true);
    }
  }
  for (eventType in listenerMap[0]) {
    if (listenerMap[0].hasOwnProperty(eventType)) {
      this.rootElement.addEventListener(eventType, this.handle, false);
    }
  }

  return this;
};

/**
 * @param {string} eventType
 * @returns boolean
 */
Delegate.prototype.captureForType = function (eventType) {
  return (
    ["blur", "error", "focus", "load", "resize", "scroll"].indexOf(
      eventType
    ) !== -1
  );
};

/**
 * Attach a handler to one
 * event for all elements
 * that match the selector,
 * now or in the future
 *
 * The handler function receives
 * three arguments: the DOM event
 * object, the node that matched
 * the selector while the event
 * was bubbling and a reference
 * to itself. Within the handler,
 * 'this' is equal to the second
 * argument.
 *
 * The node that actually received
 * the event can be accessed via
 * 'event.target'.
 *
 * @param {string} eventType Listen for these events
 * @param {string|undefined} selector Only handle events on elements matching this selector, if undefined match root element
 * @param {function()} handler Handler function - event data passed here will be in event.data
 * @param {boolean} [useCapture] see 'useCapture' in <https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener>
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.on = function (eventType, selector, handler, useCapture) {
  let root;
  let listenerMap;
  let matcher;
  let matcherParam;

  if (!eventType) {
    throw new TypeError("Invalid event type: " + eventType);
  }

  // handler can be passed as
  // the second or third argument
  if (typeof selector === "function") {
    useCapture = handler;
    handler = selector;
    selector = null;
  }

  // Fallback to sensible defaults
  // if useCapture not set
  if (useCapture === undefined) {
    useCapture = this.captureForType(eventType);
  }

  if (typeof handler !== "function") {
    throw new TypeError("Handler must be a type of Function");
  }

  root = this.rootElement;
  listenerMap = this.listenerMap[useCapture ? 1 : 0];

  // Add master handler for type if not created yet
  if (!listenerMap[eventType]) {
    if (root) {
      root.addEventListener(eventType, this.handle, useCapture);
    }
    listenerMap[eventType] = [];
  }

  if (!selector) {
    matcherParam = null;

    // COMPLEX - matchesRoot needs to have access to
    // this.rootElement, so bind the function to this.
    matcher = matchesRoot.bind(this);

    // Compile a matcher for the given selector
  } else if (/^[a-z]+$/i.test(selector)) {
    matcherParam = selector;
    matcher = matchesTag;
  } else if (/^#[a-z0-9\-_]+$/i.test(selector)) {
    matcherParam = selector.slice(1);
    matcher = matchesId;
  } else {
    matcherParam = selector;
    matcher = Element.prototype.matches;
  }

  // Add to the list of listeners
  listenerMap[eventType].push({
    selector: selector,
    handler: handler,
    matcher: matcher,
    matcherParam: matcherParam,
  });

  return this;
};

/**
 * Remove an event handler
 * for elements that match
 * the selector, forever
 *
 * @param {string} [eventType] Remove handlers for events matching this type, considering the other parameters
 * @param {string} [selector] If this parameter is omitted, only handlers which match the other two will be removed
 * @param {function()} [handler] If this parameter is omitted, only handlers which match the previous two will be removed
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.off = function (eventType, selector, handler, useCapture) {
  let i;
  let listener;
  let listenerMap;
  let listenerList;
  let singleEventType;

  // Handler can be passed as
  // the second or third argument
  if (typeof selector === "function") {
    useCapture = handler;
    handler = selector;
    selector = null;
  }

  // If useCapture not set, remove
  // all event listeners
  if (useCapture === undefined) {
    this.off(eventType, selector, handler, true);
    this.off(eventType, selector, handler, false);
    return this;
  }

  listenerMap = this.listenerMap[useCapture ? 1 : 0];
  if (!eventType) {
    for (singleEventType in listenerMap) {
      if (listenerMap.hasOwnProperty(singleEventType)) {
        this.off(singleEventType, selector, handler);
      }
    }

    return this;
  }

  listenerList = listenerMap[eventType];
  if (!listenerList || !listenerList.length) {
    return this;
  }

  // Remove only parameter matches
  // if specified
  for (i = listenerList.length - 1; i >= 0; i--) {
    listener = listenerList[i];

    if (
      (!selector || selector === listener.selector) &&
      (!handler || handler === listener.handler)
    ) {
      this._removedListeners.push(listener);
      listenerList.splice(i, 1);
    }
  }

  // All listeners removed
  if (!listenerList.length) {
    delete listenerMap[eventType];

    // Remove the main handler
    if (this.rootElement) {
      this.rootElement.removeEventListener(eventType, this.handle, useCapture);
    }
  }

  return this;
};

/**
 * Handle an arbitrary event.
 *
 * @param {Event} event
 */
Delegate.prototype.handle = function (event) {
  let i;
  let l;
  const type = event.type;
  let root;
  let phase;
  let listener;
  let returned;
  let listenerList = [];
  let target;
  const eventIgnore = "ftLabsDelegateIgnore";

  if (event[eventIgnore] === true) {
    return;
  }

  target = event.target;

  // Hardcode value of Node.TEXT_NODE
  // as not defined in IE8
  if (target.nodeType === 3) {
    target = target.parentNode;
  }

  // Handle SVG <use> elements in IE
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }

  root = this.rootElement;

  phase = event.eventPhase || (event.target !== event.currentTarget ? 3 : 2);

  // eslint-disable-next-line default-case
  switch (phase) {
    case 1: //Event.CAPTURING_PHASE:
      listenerList = this.listenerMap[1][type];
      break;
    case 2: //Event.AT_TARGET:
      if (this.listenerMap[0] && this.listenerMap[0][type]) {
        listenerList = listenerList.concat(this.listenerMap[0][type]);
      }
      if (this.listenerMap[1] && this.listenerMap[1][type]) {
        listenerList = listenerList.concat(this.listenerMap[1][type]);
      }
      break;
    case 3: //Event.BUBBLING_PHASE:
      listenerList = this.listenerMap[0][type];
      break;
  }

  let toFire = [];

  // Need to continuously check
  // that the specific list is
  // still populated in case one
  // of the callbacks actually
  // causes the list to be destroyed.
  l = listenerList.length;
  while (target && l) {
    for (i = 0; i < l; i++) {
      listener = listenerList[i];

      // Bail from this loop if
      // the length changed and
      // no more listeners are
      // defined between i and l.
      if (!listener) {
        break;
      }

      if (
        target.tagName &&
        ["button", "input", "select", "textarea"].indexOf(
          target.tagName.toLowerCase()
        ) > -1 &&
        target.hasAttribute("disabled")
      ) {
        // Remove things that have previously fired
        toFire = [];
      }
      // Check for match and fire
      // the event if there's one
      //
      // TODO:MCG:20120117: Need a way
      // to check if event#stopImmediatePropagation
      // was called. If so, break both loops.
      else if (listener.matcher.call(target, listener.matcherParam, target)) {
        toFire.push([event, target, listener]);
      }
    }

    // TODO:MCG:20120117: Need a way to
    // check if event#stopPropagation
    // was called. If so, break looping
    // through the DOM. Stop if the
    // delegation root has been reached
    if (target === root) {
      break;
    }

    l = listenerList.length;

    // Fall back to parentNode since SVG children have no parentElement in IE
    target = target.parentElement || target.parentNode;

    // Do not traverse up to document root when using parentNode, though
    if (target instanceof HTMLDocument) {
      break;
    }
  }

  let ret;

  for (i = 0; i < toFire.length; i++) {
    // Has it been removed during while the event function was fired
    if (this._removedListeners.indexOf(toFire[i][2]) > -1) {
      continue;
    }
    returned = this.fire.apply(this, toFire[i]);

    // Stop propagation to subsequent
    // callbacks if the callback returned
    // false
    if (returned === false) {
      toFire[i][0][eventIgnore] = true;
      toFire[i][0].preventDefault();
      ret = false;
      break;
    }
  }

  return ret;
};

/**
 * Fire a listener on a target.
 *
 * @param {Event} event
 * @param {Node} target
 * @param {Object} listener
 * @returns {boolean}
 */
Delegate.prototype.fire = function (event, target, listener) {
  return listener.handler.call(target, event, target);
};

/**
 * Check whether an element
 * matches a tag selector.
 *
 * Tags are NOT case-sensitive,
 * except in XML (and XML-based
 * languages such as XHTML).
 *
 * @param {string} tagName The tag name to test against
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesTag(tagName, element) {
  return tagName.toLowerCase() === element.tagName.toLowerCase();
}

/**
 * Check whether an element
 * matches the root.
 *
 * @param {?String} selector In this case this is always passed through as null and not used
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesRoot(selector, element) {
  if (this.rootElement === window) {
    return (
      // Match the outer document (dispatched from document)
      element === document ||
      // The <html> element (dispatched from document.body or document.documentElement)
      element === document.documentElement ||
      // Or the window itself (dispatched from window)
      element === window
    );
  }
  return this.rootElement === element;
}

/**
 * Check whether the ID of
 * the element in 'this'
 * matches the given ID.
 *
 * IDs are case-sensitive.
 *
 * @param {string} id The ID to test against
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesId(id, element) {
  return id === element.id;
}

/**
 * Short hand for off()
 * and root(), ie both
 * with no parameters
 *
 * @return void
 */
Delegate.prototype.destroy = function () {
  this.off();
  this.root();
};

class Popup {
  constructor(element) {
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.bindEvents();
  }
  bindEvents() {
    this.delegateElement.on(
      "click",
      '[data-action="open-modal"]',
      this.openModal.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="close-modal"]',
      this.closeModal.bind(this)
    );
    document.addEventListener(
      "posted_successfully",
      this.openModalSpecial.bind(this)
    );

    this.delegateElement.on(
      "keydown",
      (event)=>{
        if (event.key === "Escape") {
          this.closeModal();
        }
      }
    );

    this.onClickOutsideListener = this.closeModal.bind(this);
  }

  openModal() {
    event.preventDefault();
    event.stopPropagation();
    this.pageOverlayElement.classList.add("is-visible");
    this.activeModal = document.getElementById(
      event.target.getAttribute("aria-controls")
    );
    this.activeModal.setAttribute("aria-hidden", "false");
    this.activeModal.style.display = "block";
    this.pageOverlayElement.addEventListener(
      "click",
      this.onClickOutsideListener
    );
    var focus = this.element.querySelector("[data-scrollable]");

    setTimeout(() => {
      trapFocus(this.activeModal);
    }, 100);
    bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
  }

  openModalSpecial() {
    event.preventDefault();
    event.stopPropagation();
    this.pageOverlayElement.classList.add("is-visible");
    this.activeModal = document.getElementById(event.detail.id);
    this.activeModal.setAttribute("aria-hidden", "false");
    var focus = this.element.querySelector("[data-scrollable]");
    this.pageOverlayElement.addEventListener(
      "click",
      this.onClickOutsideListener
    );
    bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
    trapFocus(this.activeModal);
  }

  closeModal() {
    this.activeModal = document.body.querySelector(
      '.Popup[aria-hidden="false"]'
    );
    this.pageOverlayElement.classList.remove("is-visible");
    this.pageOverlayElement.removeEventListener(
      "click",
      this.onClickOutsideListener
    );
    this.activeModal.setAttribute("aria-hidden", "true");

    bodyScrollLock.clearAllBodyScrollLocks();
    this.activeModal.removeAttribute("style");
  }
}

class RevolutionImageZoom {
  constructor(element, slideshow) {
    this.element = element;
    this.slideshow = slideshow;
    this.delegateElement = new Delegate(this.element);
    this.delegateRoot = new Delegate(document.body);
    this.syncHeight();
    this.bindEvents();
  }

  syncHeight() {
    document.documentElement.style.setProperty(
      "--window-inner-height",
      `${window.innerHeight}px`
    );
  }

  bindEvents() {
    window.addEventListener('resize', this.syncHeight());
    this.delegateElement.on(
      "click",
      '[data-action="open-product-zoom"]',
      this.initPhotoSwipe.bind(this)
    );
    this.delegateElement.on(
      "click",
      ".product__swiper-desktop .swiper-zoom-target",
      this.initPhotoSwipeFromImageClick.bind(this)
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--close",
      this.photoswiperClose.bind(this)
    );
  }
  photoswiperClose() {
    this.photoSwipeInstance.close;
    if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
      document.documentElement.classList.remove("pswp-open-in-ios");
    }
  }

  initPhotoSwipe(event, target) {
    const swiperClass =
      this.element.querySelector(".product__swiper-desktop.swiper-initialized")
        ? ".product__swiper-desktop"
        : ".product__swiper-mobile";

    const zoomSlides = Array.from(
      this.element.querySelectorAll(`${swiperClass} .ProductSliderCell--Zoom`)
    ).filter((slide) => !slide.closest(".swiper-slide-duplicate"));

    const images = zoomSlides
      .map((slide) => slide.querySelector("img"))
      .filter(Boolean);

    // Default to the currently active zoom slide.
    let selectedIndex = 0;
    const activeSlide =
      this.element.querySelector(
        `${swiperClass} .swiper-slide-active.ProductSliderCell--Zoom`
      ) ||
      this.element.querySelector(
        `${swiperClass} .ProductSliderCell--Zoom.swiper-slide-active`
      );

    // If the active slide is a duplicate (loop mode), match by data-image-position.
    const activeImagePosition = activeSlide?.getAttribute("data-image-position");
    if (activeImagePosition) {
      const idx = zoomSlides.findIndex(
        (slide) => slide.getAttribute("data-image-position") === activeImagePosition
      );
      if (idx >= 0) selectedIndex = idx;
    }

    this.createPhotoSwipeInstance(
      this.createPhotoSwipeItemsFromImages(images),
      selectedIndex
    );
  }

  initPhotoSwipeFromImageClick(event, target) {
    // Check if the current breakpoint is "pocket". If it is, return without doing anything.
    // 27.12.2023. per clients request photo swipe instance is turned back on for mobile
    /*
    if (new Responsive().matchesBreakpoint('pocket')) {
      return;
    }
    */

    // Create an array of images from the siblings of the target element.    

    const images = [];
    const siblings = Array.from(this.element.querySelectorAll(".swiper-zoom-target"));

    siblings.forEach((item) => {
      if (item.querySelector('img') && !item.closest('.swiper-slide-duplicate')) {
        images.push(item.querySelector('img'));
      }
    });

    // Get the image position from the target element's data attribute.
    const closest = target.closest('.swiper-zoom-target') || target.querySelector('.swiper-zoom-target');
    const imagePosition = parseInt(closest.getAttribute('data-image-position'));

    // Create the PhotoSwipe instance using the images and image position.
    this.createPhotoSwipeInstance(this.createPhotoSwipeItemsFromImages(images), imagePosition);
  }

  createPhotoSwipeItemsFromImages(images) {
    return images.map(function (image) {
      var maxWidth = parseInt(image.getAttribute("data-max-width")),
        maxHeight = parseInt(image.getAttribute("data-max-height")),
        maxDimension = new Responsive().matchesBreakpoint("pocket")
          ? 800
          : 2200,
        reduceFactor = 1.0;

      if (maxWidth >= maxHeight) {
        reduceFactor = Math.max(maxWidth / maxDimension, 1.0);
      } else {
        reduceFactor = Math.max(maxHeight / maxDimension, 1.0);
      }
      var requestedWidth = Math.floor(maxWidth / reduceFactor);
      var requestedHeight = Math.floor(maxHeight / reduceFactor);
      return {
        msrc: image.currentSrc || image.src,
        w: requestedWidth,
        h: requestedHeight,
        initialZoomLevel: 0.65,
        src: new RevolutionImage().getSizedImageUrl(
          image.getAttribute("data-original-src"),
          requestedWidth + "x" + requestedHeight
        ),
      };
    });
  }

  createPhotoSwipeInstance(items, selectedImageIndex) {
    let _this = this;
    const photoswipeContainer = document.querySelector(".pswp");

    const swiperClass = 
      this.element.querySelector(".product__swiper-desktop.swiper-initialized") ? ".product__swiper-desktop" : ".product__swiper-mobile";    

    this.photoSwipeInstance = new PhotoSwipe(
      photoswipeContainer,
      false,
      items,
      {
        index: selectedImageIndex,
        showHideOpacity: true,
        showAnimationDuration: 500,
        loop: false,
        history: false,
        closeOnVerticalDrag: true,
        allowPanToNext: false,
        pinchToClose: false,
        errorMsg: '<p class="pswp__error-msg"></p>',
        scaleMode: "orig",
        getDoubleTapZoom: function getDoubleTapZoom(isMouseClick, item) {
          if (isMouseClick) {
            return 1.35;
          } else {
            return item.initialZoomLevel < 0.7 ? 1 : 1.33;
          }
        },
        getThumbBoundsFn: function getThumbBoundsFn(index) {
          var allThumbnail = _this.element.querySelectorAll(
            `${swiperClass} .ProductSliderCell--Zoom img`
          ),
            thumbnail = allThumbnail[index],
            pageYScroll =
              window.pageYOffset || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
        },
      }
    );

    this.photoSwipeInstance.listen(
      "beforeChange",
      this.onslideChanged.bind(this)
    );
    this.photoSwipeInstance.listen(
      "destroy",
      this.destroyPhotoSwipe.bind(this)
    );
    this.photoSwipeInstance.listen("doubleTap", this.onDoubleTap.bind(this));
    this.photoSwipeInstance.listen(
      "initialZoomIn",
      this.onInitialZoomIn.bind(this)
    );
    this.photoSwipeInstance.listen(
      "initialZoomOut",
      this.onInitialZoomOut.bind(this)
    );

    this.delegateRoot.on(
      "pswpTap",
      ".pswp__scroll-wrap",
      this.onSingleTap.bind(this)
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--close",
      this.photoSwipeInstance.close
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--prev",
      this.photoSwipeInstance.prev
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--next",
      this.photoSwipeInstance.next
    );
    this.photoSwipeInstance.listen('close', this.photoswiperClose.bind(this));
    if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
      document.documentElement.classList.add("pswp-open-in-ios");
    }
    this.photoSwipeInstance.init();
  }

  onslideChanged() {
    if (this.photoSwipeInstance.getCurrentIndex() === 0) {
      this.photoSwipeInstance.scrollWrap
        .querySelector(".pswp__button--prev")
        .setAttribute("disabled", "disabled");
    } else {
      this.photoSwipeInstance.scrollWrap
        .querySelector(".pswp__button--prev")
        .removeAttribute("disabled");
    }

    if (
      this.photoSwipeInstance.getCurrentIndex() + 1 ===
      this.photoSwipeInstance.options.getNumItemsFn()
    ) {
      this.photoSwipeInstance.scrollWrap
        .querySelector(".pswp__button--next")
        .setAttribute("disabled", "disabled");
    } else {
      this.photoSwipeInstance.scrollWrap
        .querySelector(".pswp__button--next")
        .removeAttribute("disabled");
    }
  }

  onSingleTap(event) {
    if (!event.detail || event.detail.pointerType === "mouse") {
      if (event.target.classList.contains("pswp__img")) {
        this.photoSwipeInstance.toggleDesktopZoom(event.detail.releasePoint);
      }
    } else {
      if (event.target.classList.contains("pswp__button")) {
        return;
      }

      event.target
        .closest(".pswp")
        .querySelector(".pswp__ui")
        .classList.toggle("pswp__ui--hidden");
    }
  }

  onDoubleTap(point) {
    var initialZoomLevel = this.photoSwipeInstance.currItem.initialZoomLevel;

    if (this.photoSwipeInstance.getZoomLevel() !== initialZoomLevel) {
      this.photoSwipeInstance.zoomTo(initialZoomLevel, point, 333);
    } else {
      this.photoSwipeInstance.zoomTo(
        initialZoomLevel < 0.7 ? 1 : 1.33,
        point,
        333
      );
    }
  }

  onInitialZoomIn() {
    document.querySelector(".pswp__ui").classList.remove("pswp__ui--hidden");
  }
  onInitialZoomOut() {
    document.querySelector(".pswp__ui").classList.add("pswp__ui--hidden");
  }
  destroyPhotoSwipe() {
    this.delegateRoot.off("pswpTap");
    this.photoSwipeInstance = null;
  }
}

class RevolutionSelectbox {
  static elementList = [];

  constructor(element, popover, additionalOverlay) {
    if (RevolutionSelectbox.elementList.includes(element)) return;
    RevolutionSelectbox.elementList.push(element);

    this.element = element;
    this.popover = popover;
    this.changeOverlay = additionalOverlay;
    this.domDelegate = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.dropdown = this.element.querySelector(".RevolutionSelectbox");
    let responsive = new Responsive();
    let breakpoint = responsive.getCurrentBreakpoint();

    this.mainDropdown = this.element.querySelector(
      ".RevolutionSelectbox--Content"
    );

    this.mainDropdownContent = this.element.querySelector(
      ".RevolutionSelectbox--InnerContent"
    );
    this.mainButton = this.element.querySelector(".RevolutionSelectbox--Button");

    this.connectedSelect = this.element.getAttribute("data-select");
    this.selectbox = this.element.querySelector(
      "[name=" + this.connectedSelect + "]"
    );
    if (this.selectbox == null) {
      this.selectbox = this.element.querySelector(
        "[name2=" + this.connectedSelect + "]"
      );
    }

    this.pageOverlayElement_2 =
      this.element.closest(".localizationSelectorsDesktop")?.querySelector(".localizationOverlay_2");

    if (this.popover == true) {
      this.mainDropdown.classList.add("PopoverContent");
      if (this.changeOverlay) {
        this.pageOverlayElement = document.querySelector(".localizationOverlay");
      } else {
        this.pageOverlayElement = document.querySelector(".pageOverlay");
      }
    }

    this.bindEvents();
    this.initSelectbox();

    const menus = Array.from(this.element.querySelectorAll('[data-sort="true"]'));
    menus.forEach(menu => {
      this.sortMenu(menu);
    })
  }

  bindEvents() {
    this.onClickOutsideListener = this.onClickOutside.bind(this);

    this.domDelegate.on(
      "click",
      "[data-action=toggle-selectbox]",
      this.toggleDropdown.bind(this)
    );

    this.domDelegate.on(
      "click",
      "[data-action=close-selectbox]",
      this.closeDropdown.bind(this)
    );

    this.domDelegate.on(
      "click",
      "[data-action=selectbox-submit]",
      this.selectboxSubmit.bind(this)
    );
    this.domDelegate.on(
      "keypress",
      "[data-action=selectbox-submit]",
      this.selectboxSubmit.bind(this)
    );

    this.domDelegate.on(
      "click",
      "[data-action=selectbox-change]",
      this.selectboxChange.bind(this)
    );

    this.domDelegate.on(
      "keydown",
      "[data-action=selectbox-change]",
      (event)=>{
        if (event.key === "Enter" || event.keyCode === 13) {
          this.selectboxChange();
        }
      }
    );
    this.domDelegate.on(
      "keydown",
      (event)=>{
        if (event.key === "Escape") {
          this.closeDropdown(event, event.target, false);
        }
      }
    );

    this.delegateBody.on("theme:render", this.onClickOutside.bind(this));
    this.delegateBody.on("menu:open", this.onClickOutside.bind(this));
    this.domDelegate.on("click", "body", this.onClickOutside.bind(this));
  }

  // Tear down all listeners and drop the element from the static registry so a
  // fresh instance can be created if the host element reconnects.
  destroy() {
    if (this.domDelegate) this.domDelegate.destroy();
    if (this.delegateBody) this.delegateBody.destroy();
    if (this.onClickOutsideListener) {
      window.removeEventListener("click", this.onClickOutsideListener);
      if (this.pageOverlayElement) {
        this.pageOverlayElement.removeEventListener("click", this.onClickOutsideListener);
      }
      if (this.pageOverlayElement_2) {
        this.pageOverlayElement_2.removeEventListener("click", this.onClickOutsideListener);
      }
    }
    const idx = RevolutionSelectbox.elementList.indexOf(this.element);
    if (idx !== -1) RevolutionSelectbox.elementList.splice(idx, 1);
  }

  selectboxChange() {
    var value = event.target.getAttribute("data-value");
    var selectboxID = event.target.getAttribute("data-selectboxid");
    var innerContent = event.target.innerHTML;

    let iconHtml = '';
    const iconElement = event.target.querySelector('.country--icon');
    if (iconElement) iconHtml = iconElement.outerHTML;

    var selEl = this.element.querySelector("#" + selectboxID);

    if (selEl.nodeName == "SELECT") {
      selEl.value = value;
      selEl.dispatchEvent(new Event("change"));
    } else if (selEl.nodeName == "INPUT") {
      const allOptions = event.target.parentElement.querySelectorAll('.RevolutionSelectbox--Item');
      allOptions.forEach((item) => {
        item.classList.remove('selecteditem');
      })
      event.target.classList.add('selecteditem');
      selEl.value = value;
      selEl.dispatchEvent(new Event("change"));
    } else {
      selEl
        .querySelector('[value="' + value + '"]')
        .setAttribute("checked", "true");
    }

    const title = this.mainButton.querySelector(".RevolutionSelectbox--Title");
    title.innerHTML = iconHtml + innerContent;
    title.classList.add('changed');

    if (this.element.classList.contains('dropdownSelector')) {
      this.element.querySelector('.RevolutionSelectbox--Item[disabled="true"]').removeAttribute('disabled');
      event.target.setAttribute('disabled', 'true');
    }

    this.closeDropdown(event, this.element);
  }

  onClickOutside(event) {
    const withinBoundaries = event.composedPath().includes(this.element);

    if (!withinBoundaries || event.target.classList.contains("RevolutionSelectBoxSort")) {
      const keepOverlay = event.target.closest('.SidebarMenuSelectors--Item [data-action="toggle-selectbox"]') ? true : false;

      this.closeDropdown(event, this.element, keepOverlay);
    }
  }

  selectboxSubmit(event) {
    if (event.key != "Enter" && event.key !== undefined) {
      return;
    }
    var value = event.target.getAttribute("data-value");
    this.selectbox.value = value;

    let iconHtml = '';
    const iconElement = event.target.querySelector('.country--icon');
    if (iconElement) iconHtml = iconElement.outerHTML;

    this.closeDropdown(event, this.element);

    const title = this.mainButton.querySelector(".RevolutionSelectbox--Title");
    const name = title.dataset.useShortTitle ? event.target.getAttribute("data-short-name") : event.target.getAttribute("data-name");

    title.innerHTML = iconHtml + name;

    this.selectbox.parentElement.submit();
  }

  initSelectbox() {
    const selectedItem = this.mainDropdown.querySelector('[selected="selected"]');
    if (!selectedItem) return this.element.style.display = "block";

    const titleElement = this.element.querySelector(".RevolutionSelectbox--Title");
    const dataName = titleElement.dataset.useShortTitle ? selectedItem.getAttribute("data-short-name") : selectedItem.getAttribute("data-name");

    const iconElement = selectedItem.querySelector('.country--icon');
    const iconHtml = iconElement && selectedItem ? iconElement.outerHTML : "";

    titleElement.innerHTML = iconHtml + dataName;
    this.element.style.display = "block";
  }

  toggleDropdown(event, target) {
    event.preventDefault();
    var isOpen = target.getAttribute("aria-expanded") === "true";

    if (isOpen) {
      this.closeDropdown(event, target);
    } else {
      this.openDropdown(target);
    }
  }

  openDropdown(target) {
    // Dispatch "close:search" and "menu:close" events on the element.
    this.element.dispatchEvent(new CustomEvent('close:search', { bubbles: true }));


    if (this.breakpoint == "desk") {
      this.element.dispatchEvent(new CustomEvent('menu:close', { bubbles: true }));
    }


    // Find all siblings with class ".RevolutionSelectbox".
    const siblings = Array.from(target.parentElement.parentElement.children)
      .filter((item) => item.classList.contains('RevolutionSelectbox'));

    // Hide the dropdown content for all siblings.
    siblings.forEach((item) => {
      item.querySelector('.RevolutionSelectbox--Button').setAttribute('aria-expanded', false);
      item.querySelector('.RevolutionSelectbox--Content').setAttribute('aria-hidden', true);
      item.querySelector('.RevolutionSelectbox--Content').style.display = 'none';
    });

    // If the dropdown is a popover, show the page overlay and disable body scrolling.
    if (this.popover) {
      this.pageOverlayElement.classList.add('is-visible');
      this.pageOverlayElement.addEventListener('click', this.onClickOutsideListener);
      const focus = this.element.querySelector('[data-scrollable]');
      bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);

      document.querySelector('#shopify-section-header').zIndex = 0;

      if (document.querySelector('#shopify-section-announcement_bar')) {
        document.querySelector('#shopify-section-announcement_bar').zIndex = 0;
      }


      trapFocus(this.mainDropdown);
      if (document.querySelector('#Drawer').getAttribute('aria-expanded') === 'true') {
        document.querySelector('.Drawer--Wrapper').style.overflow = 'hidden';
      }
    } else if (this.pageOverlayElement_2) {
      bodyScrollLock.disableBodyScroll(bodyScrollLockOptions);
      this.pageOverlayElement_2.classList.add('is-visible');
      this.pageOverlayElement_2.addEventListener('click', this.onClickOutsideListener);
    }

    // Show the dropdown content for the target element and set its state to "expanded".
    target.setAttribute('aria-expanded', true);
    const content = target.parentElement.querySelector('.RevolutionSelectbox--Content');

    // Reopening within the close timeout would otherwise blank the panel mid-open.
    clearTimeout(content._hideTimeout);

    content.style.display = 'block';

    // Two rAFs: the first can still fire before the display:block frame is
    // committed, so only the second reliably runs after it. Flipping aria-hidden
    // then means the open transition always animates from the collapsed state
    // instead of racing the first paint (a single rAF made the reveal randomly
    // pop open or flash).
    requestAnimationFrame(() => {
      requestAnimationFrame(() => { content.setAttribute('aria-hidden', false); });
    })

    window.addEventListener('click', this.onClickOutsideListener);
  }

  closeDropdown(event, target, keepOverlay) {
    let closestDropdown = target.closest(".RevolutionSelectbox");
    if (!closestDropdown) {
      closestDropdown = target.querySelector("[aria-expanded='true']").parentElement;
    }

    const content = closestDropdown.querySelector(".RevolutionSelectbox--Content");
    closestDropdown.querySelector(".RevolutionSelectbox--Button").setAttribute("aria-expanded", false);
    content.setAttribute("aria-hidden", true);

    // Swap display on a frame boundary after the 0.3s close animation has fully
    // rendered; track the timer per-content so a quick reopen can cancel it.
    clearTimeout(content._hideTimeout);
    content._hideTimeout = setTimeout(() => {
      requestAnimationFrame(() => { content.style.display = "none"; });
    }, 300);

    if (this.popover == true) {
      if (!keepOverlay) {
        this.pageOverlayElement.classList.remove("is-visible");
        this.pageOverlayElement.removeEventListener("click", this.onClickOutsideListener);
      }

      document.querySelector('#shopify-section-header').zIndex = 3;

      if (document.querySelector('#shopify-section-announcement_bar')) {
        document.querySelector('#shopify-section-announcement_bar').zIndex = 3;
      }

      const menuDrawer = document.querySelector('#Drawer');
      if (menuDrawer.getAttribute('aria-expanded') == "true") {
        document.querySelector('.Drawer--Wrapper').style.overflow = "auto";
      }

      const targetIsLocalizationSelectors = target.closest("localization-selectors");
      if (!keepOverlay && !targetIsLocalizationSelectors) bodyScrollLock.clearAllBodyScrollLocks();

    } else if (this.pageOverlayElement_2) {
      bodyScrollLock.clearAllBodyScrollLocks();
      this.pageOverlayElement_2.classList.remove("is-visible");
      this.pageOverlayElement_2.removeEventListener("click", this.onClickOutsideListener);
    }


    removeTrapFocus();
    window.removeEventListener("click", this.onClickOutsideListener);
  }

  sortMenu(elem) {
    const list = elem.querySelectorAll(".RevolutionSelectbox--Item");

    if (list.length > 1) {
      Array.from(elem.children).forEach(child => {
        child.remove();
      });

      const sortedList = Array.from(list).sort((a, b) => {
        const textA = a.innerText.trim().toLowerCase();
        const textB = b.innerText.trim().toLowerCase();

        if (textA < textB) {
          return -1;
        }
        if (textA > textB) {
          return 1;
        }
        return 0;
      });

      sortedList.forEach(item => {
        elem.append(item);
      })
    }
  }
}

class Form {
  constructor() { }

  serialize(form) {
    function stringKey(key, value) {
      var beginBracket = key.lastIndexOf("[");

      if (beginBracket === -1) {
        var _hash = {};
        _hash[key] = value;
        return _hash;
      }

      var newKey = key.substr(0, beginBracket);
      var newValue = {};

      newValue[key.substring(beginBracket + 1, key.length - 1)] = value;

      return stringKey(newKey, newValue);
    }

    var hash = {};

    for (var i = 0, len = form.elements.length; i < len; i++) {
      var formElement = form.elements[i];

      if (formElement.name === "" || formElement.disabled) {
        continue;
      }

      if (
        formElement.name &&
        !formElement.disabled &&
        (formElement.checked ||
          /select|textarea/i.test(formElement.nodeName) ||
          /hidden|text|search|tel|url|email|password|datetime|date|month|week|time|datetime-local|number|range|color/i.test(
            formElement.type
          ))
      ) {
        var stringKeys = stringKey(formElement.name, formElement.value);
        hash = this.extend(hash, stringKeys);
      }
    }

    return hash;
  }
  extend() {
    var extended = {},
      i = 0,
      _this = this;

    // Merge the object into the extended object
    var merge = function merge(obj) {
      for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) {
          // If property is an object, merge properties
          if (Object.prototype.toString.call(obj[prop]) === "[object Object]") {
            extended[prop] = _this.extend(extended[prop], obj[prop]);
          } else {
            extended[prop] = obj[prop];
          }
        }
      }
    };

    // Loop through each object and conduct a merge
    for (; i < arguments.length; i++) {
      merge(arguments[i]);
    }

    return extended;
  }
}

class AddToCart {
  constructor(element) {
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.pageLoader = document.body.querySelector(".pageLoader");
    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on(
      "click",
      "[data-action=add-to-cart]",
      this.addToCart.bind(this)
    );

    this.delegateElement.on(
      "submit",
      'form[action="/cart/addall"]',
      this.addAllToCart.bind(this)
    );

    this.delegateElement.on(
      "click",
      "[data-action=add-all-to-cart]",
      this.addAllToCart.bind(this)
    );

    this.delegateElement.on(
      "click",
      "[data-action=add-all-to-cart-purifier]",
      this.addAllToCartPurifier.bind(this)
    );
  }

  destroy() {
    this.delegateElement.destroy();
  }

  // Called when a cart add resolves to zero line items (posting an empty
  // `items` array is what makes Shopify return "Required parameter missing or
  // invalid: items"). Only claim the selection is "unavailable" when that is
  // VERIFIED: the gas-exchange option sets data-selectedAvailable="false", which
  // is derived in Liquid from the actual variant that would be added - not from
  // a blank selling plan or a config gap. An empty cart with an available
  // selection is a real bug, so show a neutral error and log it instead of
  // mislabelling the cause.
  handleEmptyCartItems(buttons) {
    const gasEl = document.querySelector("gas-exchange-us");
    const confirmedUnavailable = !!gasEl && gasEl.dataset.selectedAvailable === "false";
    const message = confirmedUnavailable
      ? gasEl.dataset.unavailable || "This option is currently unavailable."
      : "Something went wrong adding this to your cart. Please try again.";

    if (!confirmedUnavailable) {
      console.warn(
        "[add-to-cart] Resolved 0 line items but the selection is marked available - this is a bug, not an availability issue.",
        gasEl
      );
    }

    buttons.forEach((button) => {
      button.removeAttribute("disabled");
      const errorMessageElement = document.createElement("span");
      errorMessageElement.className = "product-form__unavailable Alert Alert--error u-p4";
      errorMessageElement.innerHTML = message;
      button.insertAdjacentElement("afterend", errorMessageElement);
      setTimeout(() => errorMessageElement.remove(), 4000);
    });
  }

  addAllToCart(event) {
    var _this = this;
    event.preventDefault(); // Prevent form to be submitted

    // Honor the add-to-cart gate. Validations such as the US-cylinder ZIP check
    // mark the button as unavailable by setting [disabled] on its inner
    // .Product--AddToCartButton, and CSS then blocks pointer clicks. But keyboard
    // activation, form submits (Enter in the ZIP field) and programmatic .click()
    // calls bypass pointer-events, so enforce the disabled state here too -
    // otherwise a US cylinder can be added without a valid ZIP code.
    const trigger = event.target;
    const atcButton =
      (trigger.closest && trigger.closest('[data-action="add-all-to-cart"]')) ||
      (trigger.querySelector && trigger.querySelector('[data-action="add-all-to-cart"]'));
    if (atcButton && atcButton.querySelector('.Product--AddToCartButton[disabled]')) {
      return;
    }

    var addToCartButton = this.element.querySelectorAll(".AddToCartAjax");

    // First, we switch the status of the button
    addToCartButton.forEach((item) => {
      item.setAttribute("disabled", "disabled");
    })
    document.dispatchEvent(new CustomEvent("theme:loading:start"));

    // Then we add the product in Ajax
    var formElement = event.target.closest("form");

    var formHelper = new Form();
    const formElementSerialized = formHelper.serialize(formElement);

    const items = [];
    const keys = Object.keys(formElementSerialized);
    var quant = 1;
    let alreadyBought = "false";
    let sellingPlan = "";
    keys.forEach((key) => {

      if (key != "event_id") {

        let findItem = document.body
          .querySelector('[name="' + key + '"]');
        let productSku = findItem.dataset.sku;
        let productID = findItem.dataset.id;
        let productPrice = findItem.dataset.price
        let productTitle = findItem.dataset.title;
        let productVariantTitle = findItem.dataset.variantTitle;

        if (productID) {
          quant = document.body.querySelector("#quantity--id_" + productID);
          if (quant) {
            quant = quant.getAttribute("value");
          } else {
            quant = 1;
          }
          const sellingPlanEl = document.querySelector(`[name="plan_${productID}"]`);
          if (sellingPlanEl) {
            sellingPlan = sellingPlanEl.value;
            quant = 1;

          }

        }

        if (productID) {
          items.push({
            id: productID,
            product_sku: productSku,
            product_name: productTitle,
            product_price: productPrice,
            product_variant_title: productVariantTitle,
            quantity: quant,
            selling_plan: sellingPlan
          });
        }

        if (window.theme.gasInCart == 'true' && sellingPlan) {
          alreadyBought = 'true';

        }
        sellingPlan = "";

      }
    });
    if (alreadyBought == 'true') {
      addToCartButton.forEach((item) => {
        item.removeAttribute("disabled");

      })
      this.element.dispatchEvent(new CustomEvent('gas:error', { bubbles: true }));
      return;
    }

    // No line item resolved. Don't post an empty cart request - explain why
    // (verified-unavailable vs. an actual bug) instead.
    if (!items.length) {
      this.handleEmptyCartItems(addToCartButton);
      event.preventDefault();
      return;
    }

    fetch("/cart/add.js", {
      body: JSON.stringify({
        items: items,
      }),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest", // This is needed as currently there is a bug in Shopify that assumes this header
      },
    }).then(function (response) {
      if (response.ok) {
        addToCartButton.forEach((item) => {
          item.removeAttribute("disabled");

        })
    
        // We simply trigger an event so the mini-cart can re-render
        _this.element.dispatchEvent(
          new CustomEvent("product:added", {
            bubbles: true,
            detail: {
              variant: _this.currentVariant,
              quantity: keys.length,
            },
          })
        );
      } else {
        response.json().then(function (content) {
          var errorMessageElement = document.createElement("span");
          errorMessageElement.className =
            "product-form__unavailable Alert Alert--error u-p4";
          errorMessageElement.innerHTML = content["description"];

          addToCartButton.forEach((item) => {
            const msg = errorMessageElement.cloneNode(true);
            item.removeAttribute("disabled");
            item.insertAdjacentElement(
              "afterend",
              msg
            );
            setTimeout(function () {
              msg.remove();
            }, 2500);
          });

        });
      }
    });

    event.preventDefault();
  }

  async addAllToCartPurifier(event) {
    event.preventDefault(); // Prevent form to be submitted
    const addToCartButtons = this.element.querySelectorAll(".AddToCartAjax");

    // First, we switch the status of the button
    addToCartButtons.forEach((item) => {
      item.setAttribute("disabled", "disabled");
    })
    document.dispatchEvent(new CustomEvent("theme:loading:start"));

    // Then we add the product in Ajax
    const formElement = event.target.closest("form");

    let alreadyInCart = false;
    const items = [];
    const inputs = [formElement.querySelector(".main-product"), formElement.querySelector(".side-product")]

    inputs.forEach((input) => {
      if (input) {
        const productId = input.dataset.productId;
        const variantId = input.value;
        const sellingPlan = input.dataset.sellingPlan;

        if (sellingPlan && variantId && document.querySelector(`.cartItem[data-product-id="${productId}"]`)) {
          alreadyInCart = true;
        }

        items.push({
          product_id: productId,
          id: variantId,
          quantity: "1",
          selling_plan: sellingPlan
        });
      }
    })

    // No line item resolved; explain why instead of posting an empty `items`
    // array (which Shopify rejects as missing/invalid).
    if (!items.length) {
      this.handleEmptyCartItems(addToCartButtons);
      return;
    }

    if (alreadyInCart) {
      this.element.dispatchEvent(new CustomEvent('open:loop:popup', { bubbles: true }));
      addToCartButtons.forEach(button => {
        button.removeAttribute("disabled");
      });

      return;
    }

    try {
      const response = await fetch("/cart/add.js", {
        body: JSON.stringify({
          items: items,
        }),
        credentials: "same-origin",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest", // This is needed as currently there is a bug in Shopify that assumes this header
        },
      });

      if (!response.ok) {
        const content = await response.json();

        const errorMessageElement = document.createElement("span");
        errorMessageElement.className = "product-form__unavailable Alert Alert--error u-p4";
        errorMessageElement.innerHTML = content["description"];

        addToCartButtons.forEach(button => {
          button.insertAdjacentElement("afterend", errorMessageElement);
        })

        setTimeout(function () {
          errorMessageElement.remove();
        }, 2500);

        throw response;
      }

      addToCartButtons.forEach(button => {
        button.removeAttribute("disabled");
      })

      // We simply trigger an event so the mini-cart can re-render
      this.element.dispatchEvent(
        new CustomEvent("product:added", {
          bubbles: true,
          detail: {
            variant: this.currentVariant,
          },
        })
      );
    } catch (error) {
      console.error(error);
    }
  }

  // check if there is custom quantity set for this product
  // if so triggers error popup and stops atc
  checkForCustomQuantity(target) {
    const buttonWrapper = target.closest(".ProductAction--Inner");
    if (!buttonWrapper) return false;

    const customQuantityInput = buttonWrapper.querySelector("#CustomQuantityInput");
    if (!customQuantityInput) return false;

    const variantId = buttonWrapper.querySelector("#product-id-input").value;
    const isInCart = document.querySelector(`[data-custom-quantity-item="${variantId}"]`);

    if (!isInCart) return false;

    const quantitySelector = isInCart.querySelector(".QuantitySelector__CurrentQuantity");
  
    if (!quantitySelector || quantitySelector.value == null || quantitySelector.max == null ){

     buttonWrapper.dispatchEvent(
        new CustomEvent("open:loop:popup", {
          bubbles: true,
        })
      );
      
      return true;

    } else if (quantitySelector.value >= quantitySelector.max) {
      quantitySelector.dispatchEvent(
        new CustomEvent("open:loop:popup", {
          bubbles: true,
        })
      );

      return true;
    }

    return false;
  }

  async addToCart() {
    event.preventDefault();

    // if there is no more of this product allowed in cart return
    if (this.checkForCustomQuantity(event.target)) return;

    this.pageLoader.style.width = "100%";

    const addToCartButton = event.target;
    addToCartButton.setAttribute("disabled", "disabled");

    const formElement = event.target.closest("form");
    const productIdInput = formElement.querySelector('[name="id"]');
    productIdInput.removeAttribute("disabled");

    const formHelper = new Form();
    const serialized = formHelper.serialize(formElement);

    const productId = productIdInput.dataset.productid;

    if (serialized.selling_plan && document.querySelector(`.cartItem[data-product-id="${productId}"]`)) {
      this.element.dispatchEvent(new CustomEvent('open:loop:popup', { bubbles: true }));
      addToCartButton.removeAttribute("disabled");

      return;
    }

    try {
      const response = await fetch(`${window.routes.localeRootUrl}/cart/add.js`, {
        body: JSON.stringify(serialized),
        credentials: "same-origin",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
      });

      if (!response.ok) {
        const content = await response.json();
        this.handleError(content.description, addToCartButton);

        return;
      }

      if (window.location.href.indexOf("cart") != -1) {
        location.reload();
        return;
      }

      addToCartButton.removeAttribute("disabled");

      this.element.dispatchEvent(new CustomEvent("product:added", {
        bubbles: true,
        detail: {
          variant: serialized.id,
          quantity: serialized.quantity,
        },
      }));

    } catch (error) {
      console.error('Error adding to cart:', error);
      this.handleError('An unexpected error occurred.', addToCartButton);
    }
  }

  handleError(errorMessage, addToCartButton) {
    if (this.element.querySelector(".ProductForm--Error")) {
      this.element.querySelector(".ProductForm--Error").classList.add("visible");

      setTimeout(() => {
        this.element.querySelector(".ProductForm--Error").classList.remove("visible");
      }, 2500);

    } else {
      const errorMessageElement = document.createElement("span");
      errorMessageElement.className = "u-p4 accent";
      errorMessageElement.innerHTML = errorMessage;
      addToCartButton.insertAdjacentElement("afterend", errorMessageElement);

      setTimeout(() => {
        errorMessageElement.remove();
      }, 2500);
    }

    addToCartButton.removeAttribute("disabled");
    this.pageLoader.style.left = "unset";
    this.pageLoader.style.right = "0px";
    this.pageLoader.style.width = "0%";

    setTimeout(() => {
      this.pageLoader.style.left = "0px";
      this.pageLoader.style.right = "unset";
    }, 550);
  }
}


class DomHelper {
  getSiblings(element, filter) {
    if (!element) return [];

    var includeSelf =
      arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var siblings = [];
    var currentElement = element;

    // Do the previous first
    while ((currentElement = currentElement.previousElementSibling)) {
      if (!filter || currentElement.matches(filter)) {
        siblings.push(currentElement);
      }
    }

    if (includeSelf) {
      siblings.push(element);
    }

    // Then the next side
    currentElement = element;

    while ((currentElement = currentElement.nextElementSibling)) {
      if (!filter || currentElement.matches(filter)) {
        siblings.push(currentElement);
      }
    }

    return siblings;
  }

  nodeListToArray(nodeList, filter) {
    var items = [];

    for (var i = 0; i !== nodeList.length; ++i) {
      if (!filter || nodeList[i].matches(filter)) {
        items.push(nodeList[i]);
      }
    }

    return items;
  }
  outerWidthWithMargin(element) {
    var width = element.offsetWidth,
      style = getComputedStyle(element);

    width += parseInt(style.marginLeft) + parseInt(style.marginRight);

    return width;
  }
  outerHeightWithMargin(element) {
    var height = element.offsetHeight,
      style = getComputedStyle(element);

    height += parseInt(style.marginTop) + parseInt(style.marginBottom);

    return height;
  }
}

class Dropdown {
  constructor(element, dropdownClass) {
    this.element = element;
    this.elemClass = dropdownClass;
    this.domDelegate = new Delegate(this.element);
    this.closeTimeouts = new WeakMap();
    this.animLocks = new WeakMap();
    this.bindEvents();
  }

  bindEvents() {
    this.domDelegate.on(
      "click",
      "[data-action=toggle-dropdown]",
      this.toggleDropdown.bind(this)
    );
  
    this.domDelegate.on(
      "keydown",
      (event)=>{
        if (event.key === "Escape") {
          this.closeDropdown(event.target.closest(".Dropdown"));
        }
      }
    );

  }

  isInDescriptionDrawer(elem) {
    return elem && elem.closest(".description-drawer__dropdowns");
  }

  setDescriptionDrawerScrollTarget(scrollableElement) {
    if (typeof bodyScrollLock === "undefined") return;
    bodyScrollLock.clearAllBodyScrollLocks();
    if (scrollableElement) {
      bodyScrollLock.disableBodyScroll(scrollableElement, bodyScrollLockOptions);
    }
  }

  openDescriptionDrawerDropdown(elem) {
    const button = elem.querySelector(".Dropdown--Button");
    const content = elem.querySelector(".Dropdown--Content");
    if (!button || !content) return;
    const duration = "0.3s";

    elem.setAttribute("data-dropdown-animating", "true");
    elem.classList.add("description-drawer__dropdown--expanding");
    button.setAttribute("aria-expanded", "true");
    content.setAttribute("aria-hidden", "false");
    content.style.pointerEvents = "none";
    content.style.transition = "height " + duration + " ease-in-out";
    content.style.height = "0px";
    content.offsetHeight;
    content.style.height = "100%";

    const onOpenEnd = function (ev) {
      if (ev.propertyName !== "height") return;
      content.removeEventListener("transitionend", onOpenEnd);
      elem.removeAttribute("data-dropdown-animating");
      content.style.pointerEvents = "all";
      content.style.height = "auto";
      content.style.transition = "";
      elem.classList.remove("description-drawer__dropdown--expanding");
      elem.classList.add("description-drawer__dropdown--expanded");
      var drawer = elem.closest(".description-drawer");
      if (drawer) {
        this.setDescriptionDrawerScrollTarget(content);
      }
    }.bind(this);
    content.addEventListener("transitionend", onOpenEnd);
  }

  closeDescriptionDrawerDropdown(elem, instant) {
    const button = elem.querySelector(".Dropdown--Button");
    const content = elem.querySelector(".Dropdown--Content");
    if (!button || !content) return;

    if (instant) {
      content.style.transition = "none";
      content.style.height = "0px";
      content.setAttribute("aria-hidden", "true");
      button.setAttribute("aria-expanded", "false");
      elem.classList.remove("description-drawer__dropdown--expanded", "description-drawer__dropdown--expanding");
      content.style.height = "";
      content.style.transition = "";
      button.style.pointerEvents = "all";
      content.style.pointerEvents = "all";
      var drawer = elem.closest(".description-drawer");
      if (drawer && !drawer.querySelector(".description-drawer__dropdown--expanded")) {
        var wrapper = drawer.querySelector("[data-scrollable]");
        this.setDescriptionDrawerScrollTarget(wrapper);
      }
      return;
    }

    const duration = "0.3s";
    elem.setAttribute("data-dropdown-animating", "true");
    elem.classList.add("description-drawer__dropdown--expanding");
    elem.classList.remove("description-drawer__dropdown--expanded");
    content.style.height = "100%";
    content.style.transition = "height " + duration + " ease-in-out";
    content.offsetHeight;
    button.style.pointerEvents = "none";
    content.style.height = "0px";
    button.setAttribute("aria-expanded", "false");

    const onCloseEnd = function (ev) {
      if (ev.propertyName !== "height") return;
      content.removeEventListener("transitionend", onCloseEnd);
      elem.removeAttribute("data-dropdown-animating");
      content.setAttribute("aria-hidden", "true");
      content.style.height = "";
      content.style.transition = "";
      elem.classList.remove("description-drawer__dropdown--expanding");
      button.style.pointerEvents = "all";
      content.style.pointerEvents = "all";
      var drawer = elem.closest(".description-drawer");
      if (drawer) {
        var wrapper = drawer.querySelector("[data-scrollable]");
        this.setDescriptionDrawerScrollTarget(wrapper);
      }
    }.bind(this);
    content.addEventListener("transitionend", onCloseEnd);
  }

  openDropdown(elem) {
    const button = elem.querySelector(".Dropdown--Button");
    const content = elem.querySelector(".Dropdown--Content");
    if (!button || !content) return;

    const pendingClose = this.closeTimeouts.get(elem);
    if (pendingClose) {
      clearTimeout(pendingClose);
      this.closeTimeouts.delete(elem);
    }

    const pendingAnimLock = this.animLocks.get(elem);
    if (pendingAnimLock) {
      clearTimeout(pendingAnimLock);
      this.animLocks.delete(elem);
    }

    const parentSibling = elem.closest(".parentSibling");
    const siblings = parentSibling ? new DomHelper().getSiblings(parentSibling, ".parentSibling") : [];
    const inDrawer = this.isInDescriptionDrawer(elem);

    if (inDrawer) {
      siblings.forEach((item) => { this.closeDropdown(item, { instant: true }); });
      this.openDescriptionDrawerDropdown(elem);
    } else {
      siblings.forEach((item) => { this.closeDropdown(item); });
      elem.setAttribute("data-dropdown-animating", "true");
      button.setAttribute("aria-expanded", "true");
      content.setAttribute("aria-hidden", "false");
      new RevolutionAnimation(content, "true").slideDown();
      const t = setTimeout(() => {
        elem.removeAttribute("data-dropdown-animating");
        this.animLocks.delete(elem);
      }, 300);
      this.animLocks.set(elem, t);
    }
  }

  closeDropdown(elem, options) {
    if (elem.classList.contains("FiltersFlowDropdown")) return;

    const button = elem.querySelector(".Dropdown--Button");
    const content = elem.querySelector(".Dropdown--Content");
    if (!button || !content) return;

    const pendingClose = this.closeTimeouts.get(elem);
    if (pendingClose) {
      clearTimeout(pendingClose);
      this.closeTimeouts.delete(elem);
    }

    const pendingAnimLock = this.animLocks.get(elem);
    if (pendingAnimLock) {
      clearTimeout(pendingAnimLock);
      this.animLocks.delete(elem);
    }

    if (this.isInDescriptionDrawer(elem)) {
      this.closeDescriptionDrawerDropdown(elem, options && options.instant === true);
    } else {
      elem.setAttribute("data-dropdown-animating", "true");
      new RevolutionAnimation(content, "false").slideUp();
      button.setAttribute("aria-expanded", "false");
      button.style.pointerEvents = "none";
      const t = setTimeout(() => {
        content.setAttribute("aria-hidden", "true");
        button.style.pointerEvents = "all";
        elem.removeAttribute("data-dropdown-animating");
        this.animLocks.delete(elem);
      }, 250);
      this.closeTimeouts.set(elem, t);
      this.animLocks.set(elem, t);
    }
  }

  toggleDropdown(event, target) {
    event.preventDefault();

    var mainDropdown = target.closest(".Dropdown");
    if (this.elemClass) mainDropdown = target.closest("." + this.elemClass);
    if (!mainDropdown) return;
    if (mainDropdown.hasAttribute("data-dropdown-animating")) return;

    var isOpen = target.getAttribute("aria-expanded") === "true";
    if (isOpen) {
      this.closeDropdown(mainDropdown, target);
    } else {
      this.openDropdown(mainDropdown, target);
    }
  }
}

(function (funcName, baseObj) {
  "use strict";
  // The public function name defaults to window.docReady
  // but you can modify the last line of this function to pass in a different object or method name
  // if you want to put them in a different namespace and those will be used instead of
  // window.docReady(...)
  funcName = funcName || "docReady";
  baseObj = baseObj || window;
  var readyList = [];
  var readyFired = false;
  var readyEventHandlersInstalled = false;

  // call this when the document is ready
  // this function protects itself against being called more than once
  function ready() {
    if (!readyFired) {
      // this must be set to true before we start calling callbacks
      readyFired = true;
      for (var i = 0; i < readyList.length; i++) {
        // if a callback here happens to add new ready handlers,
        // the docReady() function will see that it already fired
        // and will schedule the callback to run right after
        // this event loop finishes so all handlers will still execute
        // in order and no new ones will be added to the readyList
        // while we are processing the list
        readyList[i].fn.call(window, readyList[i].ctx);
      }
      // allow any closures held by these functions to free
      readyList = [];
    }
  }

  function readyStateChange() {
    if (document.readyState === "complete") {
      ready();
    }
  }

  // This is the one public interface
  // docReady(fn, context);
  // the context argument is optional - if present, it will be passed
  // as an argument to the callback
  baseObj[funcName] = function (callback, context) {
    if (typeof callback !== "function") {
      throw new TypeError("callback for docReady(fn) must be a function");
    }
    // if ready has already fired, then just schedule the callback
    // to fire asynchronously, but right away
    if (readyFired) {
      setTimeout(function () {
        callback(context);
      }, 1);
      return;
    } else {
      // add the function and context to the list
      readyList.push({ fn: callback, ctx: context });
    }
    // if document already ready to go, schedule the ready function to run
    // IE only safe when readyState is "complete", others safe when readyState is "interactive"
    if (
      document.readyState === "complete" ||
      (!document.attachEvent && document.readyState === "interactive")
    ) {
      setTimeout(ready, 1);
    } else if (!readyEventHandlersInstalled) {
      // otherwise if we don't have event handlers installed, install them
      if (document.addEventListener) {
        // first choice is DOMContentLoaded event
        document.addEventListener("load", ready, false);
        // backup is window load event
        window.addEventListener("DOMContentLoaded", ready, false);
      } else {
        // must be IE
        document.attachEvent("onreadystatechange", readyStateChange);
        window.attachEvent("onload", ready);
      }
      readyEventHandlersInstalled = true;
    }
  };
})("docReady", window);
// modify this previous line to pass in your own method name
// and object for the method to be attached to

/*GLOBAL FUNCTIONS */

function handleFirstTab(e) {
  if (e.keyCode === 9) {
    document.body.classList.add("user-is-tabbing");

    window.removeEventListener("keydown", handleFirstTab);
    window.addEventListener("mousedown", handleMouseDownOnce);
  }
}

function handleMouseDownOnce() {
  document.body.classList.remove("user-is-tabbing");

  window.removeEventListener("mousedown", handleMouseDownOnce);
  window.addEventListener("keydown", handleFirstTab);
}

window.addEventListener("keydown", handleFirstTab);

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe, .focusable"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);
  
  if (first) {
    first.focus();
  } else {
    elementToFocus.focus();
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

class Responsive {
  constructor() {
    var _this = this;

    this.currentBreakpoint = this.getCurrentBreakpoint();

    window.addEventListener("resize", function () {
      var newBreakpoint = _this.getCurrentBreakpoint();

      if (_this.currentBreakpoint === newBreakpoint) {
        return;
      }

      document.dispatchEvent(
        new CustomEvent("breakpoint:changed", {
          detail: {
            previousBreakpoint: _this.currentBreakpoint,
            currentBreakpoint: newBreakpoint,
          },
        })
      );

      _this.currentBreakpoint = newBreakpoint;
    });
  }

  matchesBreakpoint(breakpoint) {
    switch (breakpoint) {
      case "phone":
        return window.matchMedia("screen and (max-width: 640px)").matches;

      case "tablet":
        return window.matchMedia(
          "screen and (min-width: 641px) and (max-width: 1024px)"
        ).matches;

      case "tablet-and-up":
        return window.matchMedia("screen and (min-width: 768px)").matches;

      case "pocket":
        return window.matchMedia("screen and (max-width: 1024px)").matches;

      case "lap-and-up":
        return window.matchMedia("screen and (min-width: 1025px)").matches;

      case "desk":
        return window.matchMedia("screen and (min-width: 1280px)").matches;
    }
  }
  getCurrentBreakpoint() {
    if (window.matchMedia("screen and (max-width: 640px)").matches) {
      return "phone";
    }

    if (
      window.matchMedia("screen and (min-width: 641px) and (max-width: 1024px)")
        .matches
    ) {
      return "tablet";
    }

    if (
      window.matchMedia(
        "screen and (min-width: 1008px) and (max-width: 1279px)"
      ).matches
    ) {
      return "lap";
    }

    if (window.matchMedia("screen and (min-width: 1280px)").matches) {
      return "desk";
    }
  }
}
class RevolutionImage {
  constructor() { }

  getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === "master") {
      return src.replace(/http(s)?:/, "");
    }

    var match = src.match(
      /\.(jpg|jpeg|gif|webp|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
    );

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return (prefix[0] + "_" + size + suffix).replace(/http(s)?:/, "");
    } else {
      return null;
    }
  }
  getSupportedSizes(image, desiredSizes) {
    var supportedSizes = [],
      imageWidth = image["width"];

    desiredSizes.forEach(function (width) {
      if (imageWidth >= width) {
        supportedSizes.push(width);
      }
    });

    return supportedSizes;
  }
}

class RevolutionSwiper {
  constructor(element, additionalSwiper, pauseButton) {
    var options =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.element = element;
    this.thumb = additionalSwiper;
    this.initialConfig = JSON.parse(
      element.getAttribute("data-swiper-settings")
    );

    if (additionalSwiper) {
      this.initialConfigThumbs = JSON.parse(
        additionalSwiper.getAttribute("data-swiper-thumb-settings")
      );
    }
    this.options = options;
    this.build();
  }

  toggleSwiper(target) {
    const paused = target.getAttribute("data-paused");

    if (paused === "true") {
      target.setAttribute("data-paused", "false");
      this.swiperElement.autoplay.run();
    } else if (paused === "false") {
      target.setAttribute("data-paused", "true");
      this.swiperElement.autoplay.pause();
    }
  }

  selectCell(index) {
    this.swiperElement.slideTo(index);
  }

  resize() {
    this.swiperElement.resize();
  }

  build() {
    let configThumb = this.initialConfigThumbs;

    if (configThumb != null) {
      this.thumbSwiper = new Swiper(this.thumb, configThumb);
      this.initialConfig.thumbs["swiper"] = this.thumbSwiper;
    }

    this.swiperElement = new Swiper(this.element, this.initialConfig);
    this.selectedIndex = this.swiperElement.activeIndex;

    this.bindEvents();
  }

  bindEvents() {
    const _this = this;

    this.swiperElement.on("slideChange", function () {
      _this.element.dispatchEvent(
        new CustomEvent("swiper:slide-changed", {
          bubbles: true,
          detail: {
            currentIndex: _this.swiperElement.activeIndex,
            element: _this.swiperElement.el[0],
          },
        })
      );
    });

    this.swiperElement.on("click", function () {
      const target = event.target.closest(".vjs-volume-control");
      if (!target) return;

      target.dispatchEvent(
        new CustomEvent("change:volume", { bubbles: true })
      )
    });

   

  }
}

class Drawer {
  constructor(element) {
    var options =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    const header = this.element.localName === "main-menu-dropdown" || this.element.localName === "main-menu-drawer";
    this.pageOverlayElement = header ? document.querySelector(".header__page-overlay") : document.querySelector(".pageOverlay");

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );
    this.onOpen = options["onOpen"] || function () { };
    this.onClose = options["onClose"] || function () { };
    this.isOpen = false;

    this.bindEvents();
  }

  bindEvents() {
    this.delegateBody.on(
      "click",
      '[data-action="open-drawer"][data-toggle-id="' + this.element.id + '"]',
      this.openDrawer.bind(this)
    );

    this.delegateBody.on(
      "click",
      '[data-action="close-drawer"][data-toggle-id="' + this.element.id + '"]',
      this.closeDrawer.bind(this)
    );

    this.delegateBody.on(
      "click",
      '[data-action="toggle-drawer"][data-toggle-id="' + this.element.id + '"]',
      this.toggleDrawer.bind(this)
    );

    this.delegateBody.on(
      "keypress",
      '[data-action="toggle-drawer"][data-toggle-id="' + this.element.id + '"]',
      this.toggleDrawer.bind(this)
    );

    this.delegateBody.on(
      "keypress",
      '[data-action="toggle-subdrawer"]',
      this.toggleNextElement.bind(this)
    );

    this.delegateElement.on(
      "click",
      '[data-action="toggle-subdrawer"]',
      this.toggleNextElement.bind(this)
    );

    this.delegateBody.on(
      "keypress",
      '[data-action="toggle-prev-subdrawer"]',
      this.togglePreviusElement.bind(this)
    );

    this.delegateElement.on(
      "click",
      '[data-action="toggle-prev-subdrawer"]',
      this.togglePreviusElement.bind(this)
    );

    this.delegateElement.on(
      "keydown",
      (event)=>{
        if (event.key === "Escape") {
          this.closeDrawer(event);
        }
      }
    );

    this._openListener = this.openDrawer.bind(this);
    this._closeListener = this.closeDrawer.bind(this);

    this.calculateMaxHeightListener = this.maxHeight.bind(this);
    window.addEventListener("resize", this.calculateMaxHeightListener);

    this.delegateBody.on("cart-drawer:close-other", this._closeListener);
    this.delegateBody.on("menu:close", this._closeListener);
  }

  // Remove every listener this drawer registered (element + document.body
  // delegates, the window resize handler and the overlay click handler).
  destroy() {
    if (this.delegateElement) this.delegateElement.destroy();
    if (this.delegateBody) this.delegateBody.destroy();
    if (this.calculateMaxHeightListener) {
      window.removeEventListener("resize", this.calculateMaxHeightListener);
    }
    if (this.pageOverlayElement && this._closeListener) {
      this.pageOverlayElement.removeEventListener("click", this._closeListener);
    }
  }

  toggleNextElement(event, target) {
    if (event instanceof KeyboardEvent && event.key !== "Enter") return;

    var nextEl = target.getAttribute('data-toggle-id'),
      subdrawer = this.element.querySelector('#' + nextEl);

    this.drawerSec = this.element.querySelectorAll('.drawer__secondColumn');
    this.drawerSec.forEach((element) => {
      element.setAttribute('aria-expanded', "false");
    });
    if (subdrawer && subdrawer.getAttribute('aria-expanded') == "false") {
      subdrawer.setAttribute('aria-expanded', "true");
    }
  }

  togglePreviusElement(event, target) {
    if (event instanceof KeyboardEvent && event.key !== "Enter") return;

    target.closest('.Drawer--wrapper').setAttribute("aria-expanded", "false");
  }

  maxHeight() {

    const id = this.element.getAttribute("id");
    if (id == "quantityDrawer" || id == "Drawer" || id == "market-drawer") {
      return;
    }
    this.element.style.height = window.innerHeight + "px";
    if (id == "cart" || id == "sidebarFavorites") {
      var footer = this.element.querySelector(".CartDrawer--Footer");
      var footerHeight = 0;
      if (footer !== null) {
        footerHeight = footer.offsetHeight;
      }

      var header = this.element.querySelector(".CartHeader").offsetHeight;
      document.documentElement.style.setProperty("--cartHeader-height", header + "px");
      var cartItem = this.element.querySelector(".cartItem");
      if (cartItem !== null) {
        var itemHeight = cartItem.offsetHeight;
      }

      var itemWrapper = this.element.querySelector(".CartItems--Wrapper");

      let freeShipping = this.element.querySelector('.cartDrawer--freeShipping');
      if (freeShipping) {
        freeShipping = freeShipping.offsetHeight;
      }
      if (itemWrapper !== null) {
        let breakpointDesk = new Responsive().getCurrentBreakpoint();
        if (breakpointDesk == "phone" || breakpointDesk == "pocket" || breakpointDesk == "tablet") {

          itemWrapper.style.height =
            window.innerHeight - footerHeight - freeShipping - header - 8 + "px";
        }
        else {
          itemWrapper.style.height =
            window.innerHeight - footerHeight - freeShipping - header - 16 + "px";
        }
      }
    } else if (id == "sidebarDrawer") {
      this.element.style.height =
        window.innerHeight + "px";
    } else {
      var filterBar = document.querySelector(".FilterBar");
      var mobileHeader = document.querySelector(".header");
      var breakpoint = new Responsive().getCurrentBreakpoint();

      if (filterBar !== null && breakpoint == "phone") {
        var filterBarHeight = filterBar.offsetHeight;
        var mobileHeaderHeight = mobileHeader.offsetHeight;

        this.element.style.height =
          window.innerHeight + "px";
      }
    }
  }

  toggleDrawer() {
    if (event instanceof KeyboardEvent && event.key !== "Enter") return;

    event.preventDefault();
    this.isOpen ? this.closeDrawer() : this.openDrawer(event);
  }

  calculateVisibleHeight(element) {
    if (!element) return 0;

    const rect = element.getBoundingClientRect();
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;

    const top = Math.max(rect.top, 0);
    const bottom = Math.min(rect.bottom, windowHeight);

    return Math.max(bottom - top, 0);
  }

  openDrawer(event) {
    this.maxHeight();
    var drawerId = this.element.getAttribute("id");
    var drawerId2 = this.element.getAttribute("data-id");    

    this.dispatchCustomEvent("close:search");

    switch (drawerId) {
      case "Drawer":
        this.handleMobileDrawerOpen();
        break;
      case "cart": 
        this.handleCartOpen(event);
        break;
      case "sidebarDrawer": 
        this.handleSidebarOpen();
        break;
      case "favoritesDrawer":
        this.dispatchCustomEvent("favorite-product:open");
        break;
    }

    if (this.isOpen && drawerId2 !== "drawer__secondColumn") return;

    // The market drawer stacks on top of whatever opened it (e.g. the mobile
    // menu trigger) instead of replacing it, so it must not broadcast the
    // close-other event that would shut the menu underneath.
    if (drawerId !== "market-drawer") this.dispatchCustomEvent("cart-drawer:close-other");
    this.maxHeight();

    if (this.element.localName === "main-menu-dropdown") {
      const mobileMenu = document.querySelector("#shopify-section-sidebar_menu");
      mobileMenu.style.display = "block";
      
      window.requestAnimationFrame(() => {
        this.element.setAttribute("aria-expanded", "true");
      });
    } else {
      this.element.setAttribute("aria-expanded", "true");
    }

    this.pageOverlayElement.classList.add("is-visible");
    this.pageOverlayElement.addEventListener("click", this._closeListener);

    var focus = this.element.querySelectorAll("[data-scrollable]");

    focus.forEach((item) => {
      bodyScrollLock.disableBodyScroll(item, bodyScrollLockOptions);
    });

    if (drawerId2 == "drawer__secondColumn") {
    } else {
      this.isOpen = true;
    }

    setTimeout(() => {
      trapFocus(this.element);
    }, 400);
    if (drawerId2 == "drawer__secondColumn") {
    } else {
      this.onOpen();
    }
    return false;
  }

  closeDrawer(event) {
    if (!this.isOpen) {
      return;
    }

    var drawerId = this.element.getAttribute("id");
    if (event) {
      event.preventDefault();
    }

    // The market drawer can open on top of the still-open mobile menu (#Drawer).
    // When it closes in that state, undo only what this drawer added and hand
    // control back to the menu, leaving the menu's overlay, header and scroll
    // lock untouched, instead of running the full teardown below.
    const menuDrawer = document.querySelector("#Drawer");
    const menuStillOpen = menuDrawer && menuDrawer.getAttribute("aria-expanded") === "true";
    if (drawerId === "market-drawer" && menuStillOpen) {
      // Hide this drawer and remove its overlay.
      this.element.setAttribute("aria-expanded", "false");
      this.pageOverlayElement.classList.remove("is-visible");
      this.pageOverlayElement.removeEventListener("click", this._closeListener);

      // Hand the focus trap back to the menu.
      removeTrapFocus(this.element);
      trapFocus(menuDrawer);

      // Deliberately no body-scroll release: the menu still holds its own lock and
      // must stay locked, and this body-scroll-lock build unfreezes the whole body
      // on ANY enableBodyScroll() call. This drawer's now-hidden lock is cleared
      // when the menu itself closes.
      this.isOpen = false;
      this.onClose();
      return;
    }

    if (drawerId == "Drawer") document.querySelector('#mobile-menu').classList.toggle('is-active');

    const header = document.querySelector('#header');

    if (!header.classList.contains('Header--Scrolled') && window.theme.transparentHeader) {
      header.removeAttribute('style');
      header.classList.add('Header--Transparent');
    }


    if (drawerId == "favoritesDrawer" && this.element.querySelector(".swiperFavorites--titleButtons")) {
      this.element.querySelector(
        ".swiperFavorites--titleButtons"
      ).style.display = "none";
      if (this.element.querySelector(".favUpsell__Container")) {
        this.element.querySelector(".favUpsell__Container").remove();
      }
    }

    bodyScrollLock.clearAllBodyScrollLocks();

    this.element.setAttribute("aria-expanded", "false");

    if (this.element.localName === "main-menu-dropdown") {
      setTimeout(() => {
        const mobileMenu = document.querySelector("#shopify-section-sidebar_menu");
        mobileMenu.style.display = "none";
      }, 300);
    }

    if (
      this.element.classList.contains("sizeDrawer_Wrapper") == true &&
      document.body.querySelector("#cart").getAttribute("aria-expanded") ==
      "true"
    ) {
      return;
    }



    this.pageOverlayElement.classList.remove("is-visible");
    this.pageOverlayElement.removeEventListener("click", this._closeListener);
    removeTrapFocus(this.element);

    this.isOpen = false;
    this.onClose();
  }

  handleHeaderOpen() {
    const mobileMenu = document.querySelector("#shopify-section-sidebar_menu");

  }

  handleMobileDrawerOpen() {
    document.querySelector('#mobile-menu')?.classList.toggle('is-active');
    const header = document.querySelector('#header');

    if (!header.classList.contains('Header--Scrolled') && window.theme.transparentHeader) {
      header.classList.remove('Header--Transparent');
    }

    const isSticky = document.querySelector(".header--Sticky");
    const announcementBar = document.querySelector('.announcementBar');
    let announcementBarHeight = 0;

    if (!isSticky) {        
      requestAnimationFrame(() => {
        window.scrollTo({ top: -1, behavior: 'smooth' });
      })

      announcementBarHeight = announcementBar.offsetHeight;
    } else {
      announcementBarHeight = this.calculateVisibleHeight(announcementBar);
    }

    this.element.style.top = announcementBarHeight + header.offsetHeight + "px";
  }

  handleCartOpen(event) {
    const isTrusted = event?.isTrusted || false;
    const detail = { initiatorIsAtc: !isTrusted };

    this.dispatchCustomEvent("cart-drawer:open", detail);

    const emptyText = this.element.querySelector(".emptyItem--Text");
    if (emptyText) emptyText.style.display = "flex";
  }

  handleSidebarOpen() {
    const closeIcon = document.querySelector(".SidebarDrawer__Close");
    if (closeIcon) closeIcon.style.display = "block";

    this.dispatchCustomEvent("sidebar-drawer:open")
  }

  dispatchCustomEvent(name, detail) {
    const settings = {
      bubbles: true,
    };

    if (detail) settings.detail = detail;

    this.element.dispatchEvent(
      new CustomEvent(name, settings)
    );
  }
}


class RevolutionAnimation {
  static slideDownHandlers = new WeakMap();
  constructor(element, directAnimation) {
    this.element = element;
    if (!directAnimation) {
      this.intersectionObserver = [];
      var contentToAnimate = document.querySelectorAll("[data-animation]");
      contentToAnimate.forEach((item, i) => {
        this.animateElement(item, i);
      });

      // Listen for changes to the DOM and animate any new elements
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {

            if (node.nodeType === Node.ELEMENT_NODE) {
              const newContentToAnimate = node.querySelectorAll("[data-animation]");
              newContentToAnimate.forEach((item, i) => {
                this.animateElement(item, i);
              });
            }
          });
        });
      });

      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  slideUp() {
    const existing = RevolutionAnimation.slideDownHandlers.get(this.element);
    if (existing) {
      this.element.removeEventListener("transitionend", existing);
      RevolutionAnimation.slideDownHandlers.delete(this.element);
    }
    this.element.style.height = this.element.scrollHeight + "px";
    this.element.offsetHeight;
    this.element.style.height = 0;
  }

  slideDown() {
    if (this.element.style.height === "auto") {
      return;
    }
    this.element.style.pointerEvents = "none";
    const existing = RevolutionAnimation.slideDownHandlers.get(this.element);
    if (existing) {
      this.element.removeEventListener("transitionend", existing);
      RevolutionAnimation.slideDownHandlers.delete(this.element);
    }

    // Ensure we always animate from 0 -> scrollHeight (first open included).
    this.element.setAttribute("aria-hidden", false);
    this.element.style.height = "0px";
    this.element.offsetHeight;

    var _this = this;
    this.element.style.height = this.element.scrollHeight + "px";
    var transitionEnded = function transitionEnded(event) {
      _this.element.style.pointerEvents = "all";
      if (event.propertyName === "height") {
        _this.element.style.height = "auto";
        _this.element.removeEventListener("transitionend", transitionEnded);
        RevolutionAnimation.slideDownHandlers.delete(_this.element);
      }
    };

    RevolutionAnimation.slideDownHandlers.set(this.element, transitionEnded);
    this.element.addEventListener("transitionend", transitionEnded);
  }

  // A function to animate a list of elements by scaling them out
  elementScaleOut(elements) {
    // Get the animation duration and delay from the theme settings
    const animationDuration = window.theme.animationDuration * 2;
    const animationDelay = window.theme.animationBetweenElements;

    // Loop through each element in the list
    elements.forEach((element, index) => {
      // Check if the element has already been loaded
      if (element.hasAttribute("data-loaded")) {
        // If so, skip this element
        return;
      }

      // Mark the element as loaded to prevent duplicate animations
      element.setAttribute("data-loaded", true);

      // Define the animation keyframes
      const keyframes = [
        { transform: "scale(104%)", opacity: "0" },
        { transform: "scale(100%)", opacity: "1" },
      ];

      // Define the animation options
      const animationOptions = {
        duration: animationDuration,
        fill: "forwards",
      };

      // Schedule the animation with a delay based on the element's position in the list
      setTimeout(() => {
        element.animate(keyframes, animationOptions);
      }, animationDelay * index);
    });
  }



  elementScaleIn(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "scale(96%)", opacity: "0" },
          { transform: "scale(100%)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration * 2,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  elementFromTop(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateY(-30px)", opacity: "0" },
          { transform: "translateY(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  elementFromBottom(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateY(30px)", opacity: "0" },
          { transform: "translateY(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  elementFromRight(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(30px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
        item.setAttribute("data-loaded", true);
      }, window.theme.animationBetweenElements * i);
    });
  }

  elementFromLeft(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(-30px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
        item.setAttribute("data-loaded", true);
      }, window.theme.animationBetweenElements * i);
    });
  }

  elementFadeIn(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { opacity: "0" },
          { opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
        item.setAttribute("data-loaded", true);
      }, window.theme.animationBetweenElements * i);
    });
  }

  elementFromRightBig(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(120px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
        item.setAttribute("data-loaded", true);
      }, window.theme.animationBetweenElements * i);
    });
  }
  elementFromLeftBig(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(-120px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  animateElement(animatedItem, index) {
    const options = {
      integer: index,
      type: animatedItem.dataset.animation,
    };

    if (this.intersectionObserver[index]) {
      this.intersectionObserver[index].disconnect();
    }

    this.intersectionObserver[index] = new IntersectionObserver(
      (results) => {
        const integer = options.integer;
        const elements = [];

        // Iterate over the IntersectionObserverEntry objects in the results array.
        results.forEach((result) => {
          // Check if the target element is intersecting the root element or if its intersection ratio is greater than 0.
          if (result.isIntersecting || result.intersectionRatio > 0) {
            // Add the target element to the elements array.
            elements.push(result.target);
            // Unobserve the target element.
            this.intersectionObserver[integer].unobserve(result.target);
          }
        });

        // If there are no elements to reveal, return.
        if (elements.length === 0) {
          return;
        }

        // An object that maps each animation type to the corresponding animation function.
        const animations = {
          elementFromTop: 'elementFromTop',
          elementFromBottom: 'elementFromBottom',
          elementFromRight: 'elementFromRight',
          elementFromLeft: 'elementFromLeft',
          elementFromLeftBig: 'elementFromLeftBig',
          elementFromRightBig: 'elementFromRightBig',
          elementScaleIn: 'elementScaleIn',
          elementScaleOut: 'elementScaleOut'
        };

        // Get the animation function corresponding to the type from the animations object.
        const animation = animations[options.type];
        // If the animation function exists, call it with the elements array.
        if (animation) {
          this[animation](elements);
        }
      },
      { threshold: 0.1 }
    );

    if (animatedItem.classList.contains('animatedContent')) {
      this.intersectionObserver[index].observe(animatedItem);
    }

    animatedItem.querySelectorAll('.animatedContent').forEach((item) => {
      this.intersectionObserver[index].observe(item);
    });
  }
}

if (window.theme.enableAnimations) {
  document.addEventListener("DOMContentLoaded", function () {
    new RevolutionAnimation();
  });
}


class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.input = this.querySelector("input");
    this.changeEvent = new Event("quantity:changed", { bubbles: true });
    this.options = JSON.parse(this.element.getAttribute("data-settings"));

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);

    if (this.options['noVariants'] == "true") {
      this.toggleAddButton();
    }
  }


  toggleAddButton() {
    let quantity = "";
    const addButton = document.querySelector(".ProductPage--ATC"),
      addButtonInner = addButton.querySelector(".SelfAlign"),
      quantityEl = document.querySelector('.QuantitySelector__ProductQuantity');
    if (quantityEl) {
      quantity = quantityEl.value();
    }
    if (window.variantInfo.show_icon) {
      var buySvg =
        '<svg class="Svg Svg--basket mr-sl" width="20" height="20" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M25.31 5.19547C25.1687 5.02127 24.9568 4.91946 24.7325 4.91797H9.11751L9.60501 6.41797H23.75L21.7475 15.418H10.4975L7.07001 4.56547C6.99476 4.33174 6.80986 4.14965 6.57501 4.07797L3.50001 3.13297C3.24278 3.05393 2.96292 3.11812 2.76584 3.30137C2.56877 3.48461 2.48443 3.75907 2.54459 4.02137C2.60476 4.28366 2.80028 4.49393 3.05751 4.57297L5.75001 5.39797L9.19251 16.273L7.96251 17.278L7.86501 17.3755C7.2374 18.0987 7.21221 19.1659 7.80501 19.918C8.21952 20.4221 8.84817 20.7002 9.50001 20.668H22.0175C22.4317 20.668 22.7675 20.3322 22.7675 19.918C22.7675 19.5038 22.4317 19.168 22.0175 19.168H9.38001C9.20436 19.162 9.0446 19.0646 8.95873 18.9113C8.87286 18.7579 8.87334 18.5709 8.96001 18.418L10.7675 16.918H22.3475C22.705 16.9267 23.0189 16.6818 23.0975 16.333L25.475 5.83297C25.5212 5.6064 25.4603 5.37117 25.31 5.19547ZM20.75 25.168C21.682 25.168 22.4375 24.4125 22.4375 23.4805C22.4375 22.5485 21.682 21.793 20.75 21.793C19.818 21.793 19.0625 22.5485 19.0625 23.4805C19.0625 24.4125 19.818 25.168 20.75 25.168ZM12.185 23.4805C12.185 24.4125 11.4295 25.168 10.4975 25.168C9.56553 25.168 8.81001 24.4125 8.81001 23.4805C8.81001 22.5485 9.56553 21.793 10.4975 21.793C11.4295 21.793 12.185 22.5485 12.185 23.4805Z" fill="#121212"></path></svg>';
    } else {
      var buySvg = "";
    }

    if (!addButton) return;
    if (!quantity) { quantity = 1; }


    addButton.removeAttribute("disabled");
    addButton.classList.remove("ProductCard--Sold__Out");
    if (window.variantInfo.show_price) {
      var priceElement =
        "<span class='u-p3 ml-s'>" +
        Shopify.formatMoney(
          this.options['price'] * quantity,
          window.theme.moneyFormat
        );
      +"</span>";
    } else {
      var priceElement = "";
    }

    addButtonInner.innerHTML =
      buySvg + window.variantStrings.addToCart + priceElement;

  }

}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class ProductForm extends HTMLElement {
  constructor() {
    super();
    new AddToCart(this);
  }
}

customElements.define("product-form", ProductForm);

class Countdown extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.counter = 0;
    this.counter = this.element.querySelector(".component-countDown");
    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    setInterval(this.countDown.bind(this), 1000);
  }

  countDown() {
    const dateNow = new Date();
    const countDate = new Date(
      "March 3, 2030," + this.options["countdownTime"]
    );
    const nOfDays = this.options["countdownDays"];
    const difference = countDate - dateNow;

    var textDays = 0;
    const seconds = 1000;
    const minutes = seconds * 60;
    const hours = minutes * 60;
    const days = hours * 24;
    const todaysDay = dateNow.getDay();

    const textHours = Math.floor((difference % days) / hours);
    const textMinutes = Math.floor((difference % hours) / minutes);
    const textSeconds = Math.floor((difference % minutes) / seconds);

    if (todaysDay == 1) {
      textDays = nOfDays;
    } else if (todaysDay == 0) {
      textDays = 0;
    } else {
      textDays = nOfDays - todaysDay;
      if (textDays < 0) {
        const mDays = todaysDay % nOfDays;
        textDays = nOfDays - mDays;
      }
    }

    if (this.options["excludeWeekends"] && todaysDay == 5) {
      textDays = textDays + 2;
    } else if (this.options["excludeWeekends"] && todaysDay == 6) {
      textDays = textDays + 1;
    }

    const displayHours = textHours;
    const formatHours = displayHours < 10 ? `0${displayHours}` : displayHours;
    const formatMinutes = textMinutes < 10 ? `0${textMinutes}` : textMinutes;
    const formatSeconds = textSeconds < 10 ? `0${textSeconds}` : textSeconds;
    if (textDays > 0 && nOfDays > 1) {
      this.counter.innerText = `${textDays}d ${formatHours}:${formatMinutes}:${formatSeconds}`;
    } else {
      this.counter.innerText = `${formatHours}:${formatMinutes}:${formatSeconds}`;
    }
  }
}
customElements.define("countdown-element", Countdown);

class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.sidebarDrawer = new Drawer(this.element);
    this.loader = this.element.querySelector(".itemLoader");
    this.cartCount = document.querySelector(".CartCount__Count");
    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    this.pageLoader = document.body.querySelector(".pageLoader");
    this.breakpoint = new Responsive().getCurrentBreakpoint();
    new AddToCart(this.element);
    if (window.theme.enableAnimations) {
      new RevolutionAnimation(this.element);
    }
    if (this.element.querySelector('[data-gas-item]')) {
      window.theme.gasInCart = "true";
    }

    this.isFirstOpen = true;
  }

  onUnload() {
    this.delegateElement.off();
    document.removeEventListener("product:added", this.onProductAddedListener);
  }

  connectedCallback() {
    if (window.theme.listener == "false") {
      this.onProductAddedListener = this.onProductAdded.bind(this);
      document.addEventListener("cart-drawer:open", this.onOpen.bind(this));
      document.addEventListener("product:added", this.onProductAddedListener);
      this.delegateElement.on(
        "click",
        '[data-action="update-item-quantity"], [data-action="remove-item"]',
        this.updateItemQuantity.bind(this)
      );

      this.delegateElement.on(
        "change",
        '[data-action="update-change-quantity"]',
        this.updateItemQuantity.bind(this)
      );
      this.delegateElement.on(
        "quantity:changed",
        ".QuantitySelector__CurrentQuantity",
        this.updateItemQuantity.bind(this)
      );
      this.delegateElement.on(
        "click",
        ".cart--checkoutBtn",
        this.sendCartData.bind(this)
      );

      this.delegateElement.on(
        "keydown",
        ".Gwp--GiftItem, .ConnectedItems--ProductBox",
        this.handleGiftEnter.bind(this)
      );

      window.theme.listener = "true";
    }
  }

  handleGiftEnter(event) {
    if (event.key === "Enter" || event.code === "Enter") {
      event.preventDefault();
      const item = event.target;      
      item.click();
    }
  }

  async sendCartData() {
    event.preventDefault();
    event.stopPropagation();

    const gifts = document.querySelector("gwp-block")?.getAttribute("data-gifts");
    let bundleElems = this.element.querySelectorAll("[data-bundle-content]");

    const attributes = {};

    if (bundleElems.length) {
      let bundlesString = "";

      Array.from(bundleElems).forEach(bundle => {
        bundlesString = bundlesString + bundle.dataset.bundleContent;
      });

      attributes.bundles = bundlesString;
    } else {
      attributes.bundles = "";
    }

    if (gifts) {
      attributes.gifts = gifts;
    } else {
      attributes.gifts = "";
    }

    try {
      await fetch(window.routes.localeRootUrl + "/cart/update.js", {
        body: JSON.stringify({ attributes: attributes }),
        credentials: "same-origin",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
      });
    } catch (error) {
      console.log(error);
    }

    location.href = "/checkout";
  }

  async getCartData() {
    try {
      const response = await fetch(window.routes.localeRootUrl + "/cart.js", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
      });

      const data = await response.json();
      return data;

    } catch (error) {
      console.log('Fetch Error:', error);
    }
  }

  onOpen() {
    // Get the value of the aria-expanded attribute.
    const isExpanded = this.element.getAttribute("aria-expanded") === "true";

    // Early exit if the drawer is already expanded.
    if (isExpanded) {
      return;
    }

    // Calculate the height of the cart header and free shipping elements.
    const cartHeader = document.querySelector(".CartHeader");
    const freeShipping = document.querySelector(".cartDrawer--freeShipping");
    const cartHeaderHeight = cartHeader ? cartHeader.offsetHeight : 0;
    const freeShippingHeight = freeShipping ? freeShipping.offsetHeight : 0;
    let totalHeight = cartHeaderHeight;

    // Set the height of the cart header using a CSS variable.
    if (window.theme.cartCount > 0) {
      totalHeight = cartHeaderHeight + freeShippingHeight;
    }
    document.documentElement.style.setProperty("--cartHeader-height", totalHeight + "px");

    // Load recommendations if the option is enabled.
    const initiatorIsAtc = event.detail.initiatorIsAtc;
    if (this.options.showRecommendations && (this.isFirstOpen && !initiatorIsAtc)) {
      this.loadRecommendations();
      this.isFirstOpen = false;
    }
  }

  updateItemQuantity(event, target) {
    event.preventDefault();

    target
      .closest(".cartItem")
      .querySelector(".itemLoader")
      .classList.add("is-visible");
    var _this = this;

    var quantity = null;
    if (target.tagName === "INPUT") {
      quantity = parseInt(Math.max(parseInt(target.value) || 0, 0));

      if (target.max && quantity > target.max) quantity = target.max
    } else {
      quantity = parseInt(target.getAttribute("data-quantity"));
    }

    fetch(window.routes.localeRootUrl + "/cart/change.js", {
      body: JSON.stringify({
        id: target.getAttribute("data-line-id"),
        quantity: quantity,
      }),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then(function () {
      _this.renderCart(target.getAttribute("data-id"), true);
    });
  }

  onProductAdded() {
    var _this = this;

    if (window.theme.cartType === "page") return window.location = "/cart";

    this.renderCart().then(function () {
      _this.sidebarDrawer.openDrawer();
    });
  }

  renderCart(lineNumber, quantityChange) {
    this.pageLoader.style.width = 100 + "%";

    var _this = this;
    return fetch(window.routes.localeRootUrl + "/?section_id=cart_drawer", {
      credentials: "same-origin",
      method: "GET",
    }).then(function (content) {
      content.text().then(function (html) {
        _this.replaceContent(html, lineNumber, quantityChange);
      });
    });
  }

  replaceContent(html, lineNumber, quantityChange) {
    var _this = this;
    this.pageLoader.style.left = "unset";
    this.pageLoader.style.right = 0 + "px";
    this.pageLoader.style.width = 0 + "%";
    setTimeout(() => {
      this.pageLoader.style.left = 0 + "px";
      this.pageLoader.style.right = "unset";
    }, 550);
    var tempElement = document.createElement("div");
    tempElement.innerHTML = html;
    if (tempElement.querySelector('[data-gas-item]')) {
      window.theme.gasInCart = "true";
    } else {
      window.theme.gasInCart = "false";
    }
    this.tempOptions = JSON.parse(
      tempElement.querySelector("#cart").getAttribute("data-settings")
    );

    this.options = this.tempOptions;

    this.element.setAttribute('data-settings', tempElement.querySelector("#cart").getAttribute("data-settings"));

    const progressElement = tempElement.querySelector('.cartDrawer--freeShipping');

    if (progressElement && this.element.querySelector(".cartDrawer--freeShipping")) {
      this.element.querySelector('.cartDrawer--freeShipping').innerHTML = progressElement.innerHTML;
    }

    if (!tempElement.querySelector('.cart__error-msg') && this.element.querySelector('.cart__error-msg')) {
      this.element.querySelector('.cart__error-msg').remove();
    }


    var number = this.tempOptions["itemCount"];
    this.cartCount.innerHTML = `${number}`;

    window.theme.cartCount = parseInt(number);

    if (lineNumber) {
      var cartNodeParent = this.element.querySelector("#" + lineNumber);
      const itemToReplaceWith = tempElement.querySelector(
        "#" + lineNumber + " .cartItem--Informations"
      );
      if (cartNodeParent.querySelector(".itemLoader")) {
        cartNodeParent
          .querySelector(".itemLoader")
          .classList.remove("is-visible");
      }
      if (itemToReplaceWith) {
        cartNodeParent.replaceChild(
          itemToReplaceWith,
          cartNodeParent.querySelector(".cartItem--Informations")
        );
      } else {
        cartNodeParent.classList.add("removing");
        cartNodeParent.animate(
          [
            // keyframes
            { transform: "translateY(0px)", opacity: "1" },
            { transform: "translateY(30px)", opacity: "0" },
          ],
          {
            // timing options
            duration: 500,
            fill: "forwards",
          }
        );
        setTimeout(() => {
          cartNodeParent.remove();
        }, 500);

        if (this.options["showRecommendations"]) {
          this.loadRecommendations();
        }
      }

      if (number > 0) {
        const checkoutButtonParent = this.element.querySelector(
          ".CartDrawer--Footer"
        );
        const checkoutButtonToReplace = tempElement.querySelector(
          ".CartFooter--Totals"
        );
        const checkoutMetaParent = checkoutButtonParent.querySelector('.MetaIcon--Wrappers');
        if (checkoutMetaParent) {
          checkoutMetaParent.replaceChild(
            checkoutButtonToReplace,
            checkoutButtonParent.querySelector(".CartFooter--Totals")
          );
        }
      } else {
        this.element
          .querySelector(".CartDrawer--Footer")
          .classList.add("removing");

        const mainPartParent = this.element.querySelector(".CartDrawer");

        mainPartParent.innerHTML =
          tempElement.querySelector(".CartDrawer").innerHTML;

        if (window.theme.enableAnimations) {
          const mainPartchildren =
            mainPartParent.querySelector("#main-cartItems");
          mainPartchildren.animate(
            [
              // keyframes
              { opacity: "0" },
              { opacity: "1" },
            ],
            {
              // timing options
              duration: 500,
              fill: "forwards",
            }
          );
        }
      }
      if (this.element.querySelector(".itemLoader")) {
        setTimeout(() => {
          this.element
            .querySelector(".itemLoader")
            .classList.remove("is-visible");
        }, 250);
      }
    } else {
      const cartNodeParent =
        this.element.querySelector(".CartDrawer").parentNode;
      const currentScrollPosition =
        this.element.querySelector("#main-cartItems").scrollTop;

      cartNodeParent.replaceChild(
        tempElement.querySelector(".CartDrawer"),
        this.element.querySelector(".CartDrawer")
      );
      this.element.querySelector("#main-cartItems").scrollTop =
        currentScrollPosition;
      if (window.theme.enableAnimations) {
        new RevolutionAnimation(this.element);
      }
    }
    setTimeout(() => {
      if (this.options["showRecommendations"] && !quantityChange) {
        this.loadRecommendations();
      }


      var focus = _this.element.querySelector("[data-scrollable]");
      if (focus && this.element.getAttribute("aria-expanded") === "true") bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
      _this.sidebarDrawer.maxHeight();
    }, 200);

    //////////////////////////////////////////// Loop ////////////////////////////////////////////
    //////// Loop dropdown ////////
    // check for line item with data-loop-item attr then sent that data to ProductElement
    const isLoopInCart = this.element.querySelector("[data-loop-item]") ? true : false;

    this.element.dispatchEvent(
      new CustomEvent("loop:cart:changed", {
        bubbles: true,
        detail: { isLoopInCart: isLoopInCart },
      })
    );
    //////// Loop dropdown end ////////

    //////// Loop quantity ////////
    const isCustomQuantityInCart = this.element.querySelector("[data-loop-item]") ? true : false;

    this.element.dispatchEvent(
      new CustomEvent("loop:cart:changed", {
        bubbles: true,
        detail: { isLoopInCart: isLoopInCart },
      })
    );
    //////// Loop quantity end ////////
    //////////////////////////////////////////// Loop end ////////////////////////////////////////////
  }

  loadRecommendations() {
    const _this = this;
    // Determine the URL to fetch recommendations based on the product ID option.
    const productId = this.options.productId;

    const url = productId
      ? `${window.routes.localeRootUrl}/recommendations/products?section_id=helper-recommendations&product_id=${productId}&limit=10`
      : "?section_id=helper-recommendations";

    // Fetch the recommendations and parse the HTML content.
    fetch(url)
      .then(function (response) {
        return response.text();
      })
      .then(function (content) {
        const container = document.createElement("div");
        container.innerHTML = content;

        // Insert the recommendations HTML into the recommendations container.
        const upsellContainer = container.querySelector(".cartUpsell");
        const recommendationsContainer = _this.element.querySelector(".CartMobileRecommendations");
        recommendationsContainer.innerHTML = upsellContainer.innerHTML;


        // Initialize the Swiper instance with the recommendations container and options.
        const swiper = new Swiper(recommendationsContainer.querySelector(".swiperUpsell"), {
          slidesPerView: 2,
          spaceBetween: 16,
          slidesOffsetAfter: 16,
          slidesOffsetBefore: 16,
          loop: false,
          pagination: {
            el: ".sidecart_pagination",
            type: "bullets",
            clickable: true,
          },
          breakpoints: {
            1025: {
              slidesPerView: 2.71,
              spaceBetween: 32,
              slidesOffsetAfter: 32,
              slidesOffsetBefore: 32,
              navigation: {
                nextEl: ".swiperNextCart",
                prevEl: ".swiperPrevCart",
              },
            },
          },
        });

        // Initialize the Swiper instance with the recommendations container and options.
        const swiper_2 = new Swiper(recommendationsContainer.querySelector(".swiperUpsell--fullCart"), {
          slidesPerView: 1.52,
          spaceBetween: 16,
          slidesOffsetAfter: 16,
          slidesOffsetBefore: 16,
          loop: false,
          nested: true,
          pagination: {
            el: ".sidecart_pagination",
            type: "bullets",
            clickable: true,
          },
          breakpoints: {
            1025: {
              slidesPerView: 1.7,
              spaceBetween: 16,
              slidesOffsetAfter: 32,
              slidesOffsetBefore: 32,
              navigation: {
                nextEl: ".swiperNextCart",
                prevEl: ".swiperPrevCart",
              },
            },
          },
        });

        // Dispatch a custom event to toggle favorites state.
        _this.element.dispatchEvent(new CustomEvent("favorites:toggle", { bubbles: true }));

        // Show the recommendations section and run the Revolution animation if enabled.
        const recommendationsSection = _this.element.querySelector(".cartRecommendations");
        recommendationsSection.style.display = "block";
        if (window.theme.enableAnimations) {
          new RevolutionAnimation(_this.element);
        }

        const cartDrawerRecommendation = _this.element.querySelector("#cartDrawer--recommendation");

        let cartDrawerSlidesRecommendation = _this.element.querySelectorAll('#cartDrawer--recommendation .cartSlideItem');

        if (cartDrawerSlidesRecommendation.length === 0) {

          cartDrawerRecommendation.style.display = 'none';
        }
      })
      .catch(function (error) {
        // Handle the error gracefully by logging it or displaying an error message to the user.
        // For this implementation, we will not output errors to the console.
        // Instead, we can display an error message in the UI or send the error to a monitoring service.
      });
  }
}
customElements.define("cart-drawer", CartDrawer);



class FeaturedCollection extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    this.carouselElement = this.element.querySelector(".ProductCarousel--Swiper");
    if (this.carouselElement) {
      this.carousel = new RevolutionSwiper(this.carouselElement);
    }

    this.delegateElement = new Delegate(this.element);
    this.animationClass = 'animateIn'
    this.delayTime = 5;
    this.bindEvents();
  }

  bindEvents() {
    let responsive = new Responsive();
    let breakpoint = responsive.getCurrentBreakpoint();
    if (breakpoint == "phone" || breakpoint == "tablet") {
      this.animateInMobile();
    }
    const imageContainer = this.element.querySelector('[data-action="animate"]');
    const button = this.element.querySelector('.FeaturedCollection__Button');

    imageContainer.addEventListener("mouseenter", this.animateIn.bind(this));
    imageContainer.addEventListener("mouseleave", this.animateOut.bind(this));

    if (button) {
      button.addEventListener("mouseenter", this.animateIn.bind(this));
    }

  }

  animateInMobile() {


    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        // Check if the observed element is in view
        if (entry.isIntersecting) {
          // Perform the animation when in view
          setTimeout(() => {
            const children = this.element.querySelectorAll('.FeaturedCollection__Subtitle.not_desktop > p');
            const button = this.element.querySelector('.FeaturedCollection__Button');

            children.forEach((child, index) => {
              child.classList.add(`${this.animationClass}`);
              child.style.transitionDelay = `${index * 0.1 + 0.1}s`;
            });

            if (button) {
              button.classList.add(`${this.animationClass}`);
            }

          }, 1000);
          // Stop observing once the animation is triggered
          observer.unobserve(entry.target);

        }
      })
    })
    const featuredCollectionElement = document.querySelector('.FeaturedCollection.featuredColl--opacity');
    observer.observe(featuredCollectionElement);



  }

  animateIn(e) {
    e.preventDefault();
    const children = this.element.querySelectorAll('.FeaturedCollection__Subtitle.not_mobile > p');
    const button = this.element.querySelector('.FeaturedCollection__Button');

    children.forEach((child, index) => {
      child.classList.add(`${this.animationClass}`);
      child.style.transitionDelay = `${index * 0.1 + 0.1}s`;
    });

    if (button) {
      button.classList.add(`${this.animationClass}`);
    }

  }

  animateOut(e) {
    e.preventDefault();
    const children = this.element.querySelectorAll('.FeaturedCollection__Subtitle.not_mobile > p');

    const button = this.element.querySelector('.FeaturedCollection__Button');

    const numChildren = children.length;

    children.forEach((child, index) => {
      const delay = (numChildren - index - 1) * 0.1;
      child.style.transitionDelay = `${delay}s`;
      child.classList.remove(`${this.animationClass}`);
    });

    if (button) {
      button.classList.remove(`${this.animationClass}`);
    }

  }
}

customElements.define("featured-collection", FeaturedCollection);



class Banner extends HTMLElement {
  constructor() {
    super();

    this.initVariables();
    this.setNoSwipingClass();
  }

  connectedCallback() {
    this.changeImageQuality();
    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on('keypress', this.handleElementKeypress.bind(this));
    this.delegateElement.on('click', '[data-action="go-to-link"]', this.goToLink.bind(this));
    this.delegateElement.on("click", '[data-action="toggle-swiper"]', this.handleTogleSwiper.bind(this));

    if (this.carousel) {
      this.carousel.swiperElement.on("slideChangeTransitionStart", this.updateColors.bind(this));
      this.carousel.swiperElement.on("slideChangeTransitionStart", this.moveUpTheArrows.bind(this));
    }
  }

  handleElementKeypress() {
    if (event.key !== "Enter") return;

    event.target.click();
  }

  initVariables() {
    this.element = this;

    // settings from the section
    this.options = JSON.parse(this.element.getAttribute("data-section-settings"));

    // overlay need for ?
    this.pageOverlayElement = document.querySelector(".pageOverlay");

    // delegate
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    if (this.options["numberOfSlides"] > 1) {
      // init swiper
      this.carouselElement = this.element.querySelector("[data-swiper-settings]");
      this.carousel = new RevolutionSwiper(this.carouselElement);

      // observer
      this.onImagesReady = this.createObserver.bind(this);
      this.element.addEventListener("swiper:slide-changed", this.onImagesReady);

      // init swiper components that will have its color updated
      this.arrows = Array.from(this.element.querySelectorAll(".SwiperHelper--Button"));
      this.pagination = Array.from(this.element.querySelectorAll(".Swiper--Pagination .swiper-pagination-bullet"));
      this.pauseButton = this.element.querySelector(".Swiper--ToggleButton");

      this.updateColors();
      this.moveUpTheArrows();
    }

    //this.createObserver();
  }

  setNoSwipingClass() {
    const breakpoint = new Responsive().getCurrentBreakpoint();
    if (breakpoint !== "desk") return;

    const slides = Array.from(this.element.querySelectorAll(".swiper-slide .Slideshow--VideoSlide"));
    slides.forEach(slide => {
      slide.parentElement.classList.add("swiper-no-swiping");
    })
  }

  goToLink() {
    const target = event.target.closest('[data-action="go-to-link"]');
    const link = target.dataset.link;

    if (!link) return;

    event.preventDefault();
    event.stopPropagation();

    window.location.replace(link);
  }

  moveUpTheArrows() {
    const isCurrentSlideVideo = this.element.querySelector(".swiper-slide-active .Slideshow--VideoSlide") ? true : false;
    const arrowsHolder = this.element.querySelector(".BannerArrows-Holder");
    if (!arrowsHolder) return;

    const breakpoint = new Responsive().getCurrentBreakpoint();

    if (isCurrentSlideVideo) {
      if (breakpoint === "desk") {
        arrowsHolder.style.bottom = "66px";
      } else {
        arrowsHolder.style.bottom = "66px";
      }
    } else {
      if (breakpoint === "desk") {
        arrowsHolder.style.bottom = "51px";
      } else {
        arrowsHolder.style.bottom = "26px";
      }
    }
  }

  updateColors() {
    const currentSlide = this.element.querySelector(".Banner__Cell.swiper-slide-active");

    const currentBreakpoint = new Responsive().getCurrentBreakpoint();

    let string = "";
    if (currentBreakpoint !== "desk") {
      string = "-m"
    }

    const color1 = currentSlide.getAttribute("data-slider-color-1" + string);
    const color2 = currentSlide.getAttribute("data-slider-color-2" + string);

    this.arrows.forEach(arrow => {
      arrow.style.backgroundColor = color1;
      arrow.style.borderColor = color1;

      const path = arrow.querySelector("path");
      path.style.fill = color2;
    });

    this.pagination.forEach(dot => {
      dot.style.backgroundColor = color1;
    });

    if (!this.pauseButton) return;
    this.pauseButton.style.backgroundColor = color1;
    this.pauseButton.style.borderColor = color1;

    const paths = Array.from(this.pauseButton.querySelectorAll("path"));
    paths.forEach(path => {
      path.style.fill = color2;
    })
  }

  handleTogleSwiper() {
    this.carousel.toggleSwiper(event.target)
  }

  createObserver() {
    this.observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      threshold: 0.5,
    });

    const target = this.element;
    this.observer.observe(target);
  }

  handleIntersect(entries) {
    var _this = this;
    entries.forEach((entry) => {
      if (entry.intersectionRatio === 1 || entry.isIntersecting == true) {
        _this.changeImageQuality();
        _this.observer.unobserve(_this);
      }
    });
  }

  changeImageQuality() {
    const singleItem = this.options["numberOfSlides"] === 1;

    // Get the current breakpoint.
    const breakpoint = new Responsive().getCurrentBreakpoint();

    let imageContainers;
    // Determine which element(s) to search for based on the singleItem parameter.
    if (singleItem) {
      imageContainers = Array.from(this.element.querySelectorAll('.Banner__ImageContainer--Swap'));
    } else {
      const currentIndex = this.carousel.swiperElement.activeIndex;
      const cellElement = this.carousel.swiperElement.slides[currentIndex];
      imageContainers = Array.from(cellElement.querySelectorAll('.Banner__ImageContainer--Swap'));
    }

    // If no image containers are found, return.
    if (imageContainers.length === 0) {

      return;
    }

    // Determine which image to reveal based on the current breakpoint.
    let imageToReveal;
    const size = breakpoint === 'phone' ? "760x" : breakpoint === 'tablet' ? '1000x' : "2600x";

    if (breakpoint === 'pocket' || breakpoint === 'phone' || breakpoint === 'tablet') {
      imageToReveal = imageContainers[0].querySelector('.Banner__Image');
    } else {
      if (imageContainers.length < 2) {

        return;
      }
      imageToReveal = imageContainers[1].querySelector('.Banner__Image');
    }

    // If the image to reveal is not found or has already been loaded, return.
    if (!imageToReveal || imageToReveal.dataset.loadedImage === 'true') {

      return;
    }

    // Replace the image URL with a higher quality version.
    const replaceUrl = imageToReveal.dataset.baseUrl.replace('{width}x', size);
    imageToReveal.src = replaceUrl;
    imageToReveal.dataset.loadedImage = 'true';
  }
}

customElements.define("banner-hero", Banner);

class Header extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.options = JSON.parse(this.getAttribute("data-settings"));

    this.updateTransparentHeaderFlag();
    this.toggleColor();
    var _this = this;
    window.addEventListener("resize", function () {
      _this.updateTransparentHeaderFlag();
      _this.toggleColor();
    });

    var selectBoxes = this.element.querySelectorAll(".RevolutionSelectbox");
    if (selectBoxes.length > 0) {
      selectBoxes.forEach((item, i) => {
        new RevolutionSelectbox(item);
      });
    }

    if (this.options.sticky) {
      this.toggleSticky();
    }
    this.bindEvents();
    this.menuOverlapHandler();

  }

  menuOverlapHandler() {
    var currentClientWidth = Math.max(
      document.body.scrollWidth,
      document.documentElement.scrollWidth,
      document.body.offsetWidth,
      document.documentElement.offsetWidth,
      document.documentElement.clientWidth
    );

    var menuItems = this.element.querySelector(".header--MenuItems"),
      overlapping = false,
      menuWrapper = this.element.querySelector(".header--Wrapper"),
      allHeights = [],
      _this = this;

    if (menuItems) {
      var desiredHeight = _this.element.querySelectorAll(".header--Links:not(.not_laptop) .mainLinks");

      desiredHeight.forEach((item) => { allHeights.push(item.offsetHeight); });

      var maxHeight = Math.max.apply(null, allHeights);
      var minHeight = Math.min.apply(null, allHeights);

      if (maxHeight > minHeight) {
        overlapping = true;

        if (window.theme.menuBreakpoint == 0 || window.theme.menuBreakpoint == undefined) {
          window.theme.menuBreakpoint = currentClientWidth;
        }
      }
    }

    if (currentClientWidth > window.theme.menuBreakpoint) {
      menuItems.classList.remove("mt-m");
      menuItems.classList.remove("mainMenu--Overlapping");
      menuWrapper.querySelector(".mainMenuItems").prepend(menuItems);
      window.theme.menuBreakpoint = 0;
    } else if (overlapping) {
      menuItems.classList.add("mt-m");
      menuItems.classList.add("mainMenu--Overlapping");
      menuItems.closest(".header").appendChild(menuItems);
    }

    document.documentElement.style.setProperty("--header-height", _this.element.clientHeight + "px");
    menuItems.style.opacity = 1;
  }

  isTransparentForViewport() {
    var isDesktop = window.matchMedia && window.matchMedia("(min-width: 1025px)").matches;
    if (isDesktop) {
      return this.options.hasOwnProperty("transparentDesktop")
        ? (this.options.transparentDesktop === true)
        : (this.options.transparent === true);
    }
    return this.options.transparent === true;
  }

  updateTransparentHeaderFlag() {
    window.theme.transparentHeader = this.isTransparentForViewport();
  }

  toggleSticky() {
    this.element.parentElement.classList.add("header--Sticky");
    this.element.parentElement.classList.remove("Header--Transparent");
  }

  makeItResponsive() {
    let responsive = new Responsive();
    let breakpoint = responsive.getCurrentBreakpoint();
    if (breakpoint != "phone" && breakpoint != "tablet") {

      let staticLeftElementWidth = this.querySelector('.not_mobile.header--LogoWrapper').offsetWidth;
      let staticRightElementWidth = this.querySelector('.header--linkListWrapper').offsetWidth;

      if (staticLeftElementWidth > staticRightElementWidth) {
        staticRightElementWidth = staticLeftElementWidth;
      } else {
        staticLeftElementWidth = staticRightElementWidth;
      }

      let headerWidth = this.querySelector('.header--Wrapper').offsetWidth;

      let linksElements = this.querySelectorAll('.header--MenuItems .header--Links');
      let sum = 0;

      for (let i = 0; i < linksElements.length; i++) {
        let width = linksElements[i].offsetWidth + 24;

        sum += width;
      }

      const targetElement = this.querySelector('.mainMenuItems');
      
      if ((sum + staticLeftElementWidth + staticRightElementWidth) > headerWidth) {
        //targetElement.style.transform = 'translate(-50%, 35%)';


      } else {
        //targetElement.style.transform = 'translate(-50%, 0%)';

      }

    }
  }

  bindEvents() {


    const _this = this;
    document.addEventListener("shopify:section:load", function () {
      _this.menuOverlapHandlerListener();
    });
    this.menuOverlapHandlerListener = this.menuOverlapHandler.bind(this);
    window.addEventListener("resize", this.menuOverlapHandlerListener);
    this.toggleColorListener = this.toggleColor.bind(this);

    window.addEventListener('resize', this.makeItResponsive.bind(this));

    window.addEventListener("scroll", this.toggleColorListener);
    this.delegateBody.on("menu:close", this.closeMenu.bind(this), true);

    this.delegateElement.on(
      "mouseenter",
      "[aria-hasMenu='true']",
      this.openMenu.bind(this), true
    );

    this.delegateElement.on(
      "focusin",
      "[aria-hasMenu='true']",
      this.openMenu.bind(this), true
    );

    this.delegateElement.on(
      "mouseleave",
      "[aria-submenu]",
      this.closeMenu.bind(this), true
    );

    this.delegateElement.on(
      "mouseenter",
      "[aria-singlemenu]",
      this.closeMenu.bind(this), true
    );

    this.delegateElement.on(
      "focusout",
      "[aria-singleMenu],[aria-submenu]",
      this.closeMenu.bind(this), true
    );
 
    this.delegateElement.on(
      "keydown",
      (event)=>{
        if (event.key === "Escape") {
          this.closeMenu(event, event.target)
        }
      }
    );
  


    setTimeout(() => {
      this.makeItResponsive();
    }, 300);

  }

  updateMenuPosition(target) {
    document.documentElement.style.setProperty(
      "--submenu-position",
      `${target.getBoundingClientRect().top + target.offsetHeight + 3}px`
    );
  }

  openMenu(event, target) {
    // Dispatch a custom event to indicate that the menu is being opened.
    this.element.dispatchEvent(new CustomEvent('menu:open', { bubbles: true }));
    // If the event is a mouseenter event and the target is not the same as the event target, return.
    if (event.type === 'mouseenter' && target !== event.target) {
      return;
    }

    // Update the position of the menu and change the ARIA expanded attribute.
    this.updateMenuPosition(target);

    // The dropdown is kept display:none until first opened so its images
    // aren't fetched on initial page load. On the first open, drop that gate
    // (via [data-revealed]) and then expand on a later frame, otherwise the
    // open transition can't play when coming straight from display:none.
    const dropdown = target.querySelector('.desktopMenu--Dropdown');
    if (dropdown && !dropdown.hasAttribute('data-revealed')) {
      dropdown.setAttribute('data-revealed', '');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          target.setAttribute('aria-expanded', 'true');
        });
      });
    } else {
      target.setAttribute('aria-expanded', 'true');
    }

    // Close any siblings of the target element.
    const siblings = Array.from(target.parentElement.children).filter((child) => child !== target && child.getAttribute('aria-expanded') === 'true');
    siblings.forEach((item) => item.setAttribute('aria-expanded', 'false'));

    // Disable body scroll on the scrollable element inside the menu.
    const scrollableElement = this.element.querySelector('[data-scrollable]');
    if (!scrollableElement) {
      return;
    }
    bodyScrollLock.disableBodyScroll(scrollableElement, bodyScrollLockOptions);
  }


  closeMenu(event, target) {

    if (event.type === "mouseleave" && target !== event.target) { return; }
    if (this.isTransparentForViewport()) {
      this.element.classList.add("Header--Transparent");
    }

    const allOpen = this.element.querySelectorAll('[aria-expanded="true"]');
    allOpen.forEach(function (item) {
      item.setAttribute("aria-expanded", "false");
    });
    this.toggleColor();
    bodyScrollLock.clearAllBodyScrollLocks();
  }

  toggleColor() {
    // While the mobile menu or market drawer is open, the drawer open/close
    // handlers own the header transparency state. The on-screen keyboard
    // (market drawer's search input) fires window scroll events on real
    // devices, which must not re-apply Header--Transparent underneath them.
    if (document.querySelector('#Drawer[aria-expanded="true"], #market-drawer[aria-expanded="true"]')) return;
    if (window.pageYOffset > 25) {
      this.element.classList.add('Header--Scrolled');
    } else {
      this.element.classList.remove('Header--Scrolled');
    }
    if (this.isTransparentForViewport()) {
      if (window.pageYOffset > 25 && this.options.sticky) {
        this.element.classList.remove("Header--Transparent");
      } else {
        this.element.classList.add("Header--Transparent");
      }
    } else {
      this.element.classList.remove("Header--Transparent");
    }
  }
}
customElements.define("header-component", Header);

class MainMenuDropdown extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.SidebarMenu = new Drawer(this.element);
    this.dropdown = new Dropdown(this.element);
    this.carouselElement = this.element.querySelector(".MenuSlideshowMobile");

    const bestsellers = this.element.querySelector('product-addons:has( [data-action="add-to-cart"])');
    if (bestsellers) new AddToCart(bestsellers);
  }
}
customElements.define("main-menu-dropdown", MainMenuDropdown);


class MainMenuDrawer extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    this.SidebarMenu = new Drawer(this.element);
    this.secondDrawer = this.element.querySelectorAll('.drawer__secondColumn');
    this.pageOverlayElement = document.querySelector("#header .pageOverlay");

    this.bindEvents();
  }

  bindEvents() {
    this.delegateBody.on(
      "click",
      '[data-action="close-drawer2"]',
      this.closeDrawer.bind(this)
    );
    this.delegateBody.on(
      "click",
      ".pageOverlay",
      this.closeDrawer.bind(this)
    );

    this.delegateElement.on(
      "mouseover",
      ".drawer__secondColumn",
      this.findImageToShow.bind(this), true
    );

    this.delegateElement.on(
      "focusin",
      ".drawer__secondColumn",
      this.findImageToShow.bind(this), true
    );

    this.delegateElement.on("click", '[data-action="toggle-subdrawer"]', this.handleDrawerLinkClick.bind(this));
    this.delegateElement.on("keypress", '[data-action="toggle-subdrawer"]', this.handleDrawerLinkKeyPress.bind(this));
  }

  handleDrawerLinkKeyPress() {
    if (event.key === "Enter") this.handleDrawerLinkClick(event);
  }

  handleDrawerLinkClick() {
    const target = event.target.closest('[data-action="toggle-subdrawer"]');
    const selectedElem = this.element.querySelector('[data-action="toggle-subdrawer"][aria-selected="true"]');

    target.setAttribute("aria-selected", "true");

    if (!selectedElem) return;

    selectedElem.setAttribute("aria-selected", "false");
    const drawerId = selectedElem.dataset.toggleId;
    const prevOpenedDrawersImage = this.element.querySelector(`.drawer__secondColumn#${drawerId} [has-images][aria-expanded="true"]`);

    if (prevOpenedDrawersImage) prevOpenedDrawersImage.setAttribute("aria-expanded", "false");
  }

  findImageToShow() {
    let imageToShow = event.target.closest("[has-images]");
    const activeElem = this.element.querySelector('[has-images][aria-expanded="true"]');

    if (!imageToShow && !activeElem) {
      const drawer = event.target.closest(".drawer__secondColumn")
      imageToShow = drawer.querySelector("[has-images]");
    } else if (!imageToShow) {
      imageToShow = activeElem;
    }

    if (activeElem && activeElem !== imageToShow) this.hideImage(null, activeElem);
    this.showImage(null, imageToShow);
  }

  showImage(event, target) {
    if (!target || target.getAttribute("aria-expanded") === "true") return;

    target.setAttribute('aria-expanded', 'true');
  }

  hideImage(event, target) {
    if (!target) return;
    if (target.getAttribute("aria-expanded") === "false") return;

    target.setAttribute('aria-expanded', 'false');
  }

  closeDrawer() {
    bodyScrollLock.clearAllBodyScrollLocks();

    this.pageOverlayElement.classList.remove("is-visible");


    const selectedElem = this.element.querySelector('[data-action="toggle-subdrawer"][aria-selected="true"]');
    selectedElem?.setAttribute("aria-selected", "false");

    this.element.setAttribute("aria-expanded", "false");
    this.secondDrawer.forEach((drawer) => {
      drawer.setAttribute("aria-expanded", "false");
    })
  }
}
customElements.define("main-menu-drawer", MainMenuDrawer);


class Transition {
  constructor() {
    this.pageOverlay = document.querySelector(".pageTransition");

    if (!this.isPageLoaded) {
      document.addEventListener(
        "DOMContentLoaded",
        this.onPageLoaded.bind(this)
      );
    } else {
      this.onPageLoaded();
    }
  }

  onPageLoaded() {
    this.isPageLoaded = true;
    if (this.pageOverlay && window.theme.showPageTransition) {
      this.pageOverlay.classList.add('load_finished');

    }
  }
  onPageUnload(event, target) {
    if (
      event.defaultPrevented ||
      event.ctrlKey ||
      event.metaKey ||
      !window.theme.showPageTransition ||
      !this.pageOverlay
    ) {
      return;
    }

    event.preventDefault(); // Prevent the click to happen

    if (this.pageOverlay) {
      var timeline = new TimelineLite({
        onComplete: function onComplete() {
          window.location.href = target.href;
        },
      });

      timeline.fromTo(
        this.pageOverlay,
        0.25,
        { autoAlpha: 0, ease: Linear.easeNone },
        { autoAlpha: 1, ease: Linear.easeNone }
      );
    }
  }
}
var trans = new Transition();

class VideoComponent extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );
    this.trueObserver = false;
    if (this.options["using_fade"] == "fade") {
      if (
        this.element.dataset.position == 0 ||
        this.element
          .closest(".swiper-slide")
          .classList.contains("swiper-slide-active") ||
        this.element
          .closest(".swiper-slide")
          .classList.contains("swiper-slide-duplicate-active")
      ) {
        this.checkLoaded();
        this.bindEvents();
      } else {
        this.bindEvents();
      }
    } else {
      this.createObserver();
    }
  }

  bindEvents() {
    window.removeEventListener("swiper:slide-changed", this.onSlideChangeListener);
    this.onSlideChangeListener = this.onSlideChange.bind(this);
    window.addEventListener("swiper:slide-changed", this.onSlideChangeListener);
  }

  checkLoaded() {
    var _this = this;
    if (typeof videojs !== "undefined") {
      this.videoPlayerInicialization();
    } else {
      setTimeout(function () {
        _this.checkLoaded();
      }, 100);
    }
  }

  onSlideChange(event) {

    this.elementPosition = parseInt(this.element.getAttribute("data-position"));
    if (event.detail.currentIndex == this.elementPosition) {
      if (!this.element.getAttribute("loaded")) {
        var node = document.createElement("div");
        node.appendChild(
          this.element
            .querySelector("template")
            .content.firstElementChild.cloneNode(true)
        );
        this.element.appendChild(node.firstElementChild).focus();
        this.element.setAttribute("loaded", true);
        if (!this.videoPlayer) {
          this.checkLoaded();
        } else {
          if (this.options['viewport']) {

            this.videoPlayer.play();
            this.createObserver();
          }
        }
      } else {
        if (!this.videoPlayer) {
          this.checkLoaded();
        } else {
          if (this.options['viewport']) {

            this.videoPlayer.play();
            this.createObserver();
          }
        }
      }
    } else if (this.videoPlayer && this.videoPlayer.el_.classList.contains('vjs-playing')) {

      this.videoPlayer.pause();
    }

  }

  videoPlayerInicialization() {
    var _this = this;
    if (!this.element.getAttribute("loaded")) {
      var node = document.createElement("div");
      node.appendChild(
        this.element
          .querySelector("template")
          .content.firstElementChild.cloneNode(true)
      );
      this.element.appendChild(node.firstElementChild).focus();
      this.element.setAttribute("loaded", true);
    }
    let responsive = new Responsive();
    let breakpoint = responsive.getCurrentBreakpoint();
    if (breakpoint == "phone" || breakpoint == "tablet") {
      var isMobile = true;
    } else {
      var isMobile = false;
    }


    let img_plh = "",
      aspect_ratio = "",
      src = "",
      host = "html5",
      autoplay = this.options['viewport'];


    if (isMobile) {
      img_plh = this.options["plh_mob"];

      aspect_ratio = this.options["aspect_mob"] || "9:16";
      if (this.options["videoType"] == "video_inside_media") {
        const sources = this.options["videod"]["sources"];
        let topQuality = null;
        sources.forEach((obj) => {
          if (obj.format === "mp4") {
            if (!topQuality) topQuality = obj;
            if (topQuality.height < obj.height) topQuality = obj;
          }
        });
        const aspectRatioHeight = Math.floor(
          100 / this.options["videod"]["aspect_ratio"]
        );
        if (!this.options["videoRatio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        } else {
          aspect_ratio = this.options["videoRatio"];
        }
        src = topQuality["url"] + "#t=0.001";
      } else if (this.options["videoType"] == "video_inside_media_external") {
        const aspectRatioHeight = Math.floor(
          100 / this.options["videom"]["aspect_ratio"]
        );
        if (!this.options["videoRatio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        } else {
          aspect_ratio = this.options["videoRatio"];
        }
        host = this.options["videom"]["host"];
        if (host == "youtube") {
          src =
            "https://www.youtube.com/watch?v=" +
            this.options["videom"]["external_id"];
        } else {
          src = this.options["videom"]["external_id"];
        }
      } else {
        if (this.options["videom"].includes("youtube")) {
          host = "youtube";
        } else if (this.options["videom"].includes("vimeo")) {
          host = "vimeo";
        }
        src = this.options["videom"];
      }
    } else {
      img_plh = this.options["plh_desk"];

      aspect_ratio = this.options["aspect_desk"] || "16:9";
      if (this.options["videoType"] == "video_inside_media") {
        const sources = this.options["videod"]["sources"];
        let topQuality = null;
        sources.forEach((obj) => {
          if (obj.format === "mp4") {
            if (!topQuality) topQuality = obj;
            if (topQuality.height < obj.height) topQuality = obj;
          }
        });
        src = topQuality["url"] + "#t=0.001";
        const aspectRatioHeight = Math.floor(
          100 / this.options["videod"]["aspect_ratio"]
        );
        if (!this.options["videoRatio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        } else {
          aspect_ratio = this.options["videoRatio"];
        }
      } else if (this.options["videoType"] == "video_inside_media_external") {
        host = this.options["videod"]["host"];
        const aspectRatioHeight = Math.floor(
          100 / this.options["videod"]["aspect_ratio"]
        );
        if (!this.options["videoRatio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        } else {
          aspect_ratio = this.options["videoRatio"];
        }
        if (host == "youtube") {
          src =
            "https://www.youtube.com/watch?v=" +
            this.options["videod"]["external_id"];
        } else {
          src = this.options["videod"]["external_id"];
        }
      } else {
        if (this.options["videod"].includes("youtube")) {
          host = "youtube";
        } else if (this.options["videod"].includes("vimeo")) {
          host = "vimeo";
        }

        src = this.options["videod"];
      }
    }


    if (host == "youtube") {
      var type = "video/youtube";
    } else if (host == "vimeo") {
      var type = "video/vimeo";
    } else {
      var type = "video/mp4";
    }

    if (!this.options['plh']) {
      img_plh = false;
    }

    const payload = {
      aspectRatio: aspect_ratio,
      autoplay: autoplay,
      muted: this.options["muted"],
      loop: this.options["loop"],
      controls: this.options["controls"],
      poster: img_plh,
      preload: "metadata",
      playsinline: true,
      responsive: true,
      techOrder: [host],
      disablePictureInPicture: true,
      controlBar: {
        playToggle: true,
        captionsButton: false,
        chaptersButton: false,
        subtitlesButton: false,
        remainingTimeDisplay: true,
        pictureInPictureToggle: false,
        volumeControl: false,
        progressControl: {
          seekBar: true,
        },
        fullscreenToggle: true,
        playbackRateMenuButton: false,
      },
      sources: [
        {
          type: type,
          src: src,
        },
      ],
    };

    var videoplayerID = this.element.querySelector("video");
    this.videoPlayer = videojs(videoplayerID, payload);

    this.bindVideoEvents();
  }

  bindVideoEvents() {
    const _this = this;

    this.videoPlayer.on("ready", function () {
      _this.element.querySelector(".videoHolder").style.display = "block";
      if (_this.trueObserver == false && _this.options['pause']) {
        _this.createObserver();
      }
    });

    this.videoPlayer.on("touchstart", function () {
      if (event.target.closest('.vjs-control-bar')) {
        return;
      }

      if (event.target.classList.contains('vjs-tech')) {
        if (!this.paused()) {
          this.pause();
        } else {
          this.play();
        }
      }
    });

    this.videoPlayer.on("change:volume", function () {
      const volumeTooltip = event.target.querySelector(".vjs-volume-tooltip");
      if (!volumeTooltip) return;

      let percentage = volumeTooltip.innerText.replace("%", "") / 100;
      if (percentage > 100) percentage = 100;
      else if (percentage < 0) percentage = 0;

      if (percentage === 0) this.muted(true);
      else this.muted(false)

      this.volume(percentage);
    });

    this.videoPlayer.on("fullscreenchange", function () {
      if (!this.paused()) {
        setTimeout(() => {
          this.play();
        }, "100")
      } else {
        setTimeout(() => {
          this.pause();
        }, "100")
      }
    });

    this.videoPlayer.on('play', () => {      
      this.element.dispatchEvent(new CustomEvent('gtm:video:event', { bubbles: true, detail: { state: "playing" } }));
    });

    this.videoPlayer.on('pause', () => {
      this.element.dispatchEvent(new CustomEvent('gtm:video:event', { bubbles: true, detail: { state: "stoped" } }));
    });
  }

  createObserver() {
    const observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      threshold: 0.2,
    });

    const target = this.element;
    observer.observe(target);
    this.trueObserver = true;
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.intersectionRatio === 1 || entry.isIntersecting == true) {
        if (!this.videoPlayer) {
          this.checkLoaded();
          return;
        }

        if (this.options["viewport"] && this.videoPlayer) {
          if (this.options['muted']) {
            this.videoPlayer.muted('true');
          }
          this.videoPlayer.play();
        }
      } else if (
        entry.intersectionRatio === 0 ||
        entry.isIntersecting == false
      ) {
        if (this.videoPlayer && this.videoPlayer.el_.classList.contains('vjs-playing')) {
          this.videoPlayer.pause();
        }
      }
    });
  }
}
customElements.define("video-component", VideoComponent);

class FooterComponent extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    let responsive = new Responsive();
    let breakpoint = responsive.getCurrentBreakpoint();
    if (breakpoint == "phone" || breakpoint == "tablet") {
      this.dropdown = new Dropdown(this.element);
    }
  }
}

customElements.define("footer-component", FooterComponent);

class DropdownSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.dropdown = new Dropdown(this.element);
  }
}
customElements.define("dropdown-section", DropdownSection);

class DesktopZoom {
  constructor(wrapper) {
    this.wrapper = wrapper;
    this.delegateElement = new Delegate(this.wrapper);
    this.zoomSwiper = null;
    this.zoomScrollerState = { bound: false, onScroll: null, scrollerEl: null };
    this.zoomOverlayState = {
      overlayEl: null,
      resizeHandler: null,
      listenersBound: false
    };
    this.zoomPaginationState = {
      bound: false,
      hideTimer: null,
      lastTranslate: null,
      userInteracted: false,
      scrollerEl: null,
      onScroll: null,
      onWheel: null,
      onTouchStart: null,
      onTouchMove: null,
      onPointerDown: null
    };

    this.bindEvents();
    this.fetchAndInit();
  }

  getZoomState() {
    const vv = window.visualViewport;

    return {
      pinchZoomScale: vv ? vv.scale : 1,
      isPinchZoomed: vv ? vv.scale > 1 : false,
      devicePixelRatio: window.devicePixelRatio || 1
    };
  }

  onPossibleZoomChange() {
    const overlay = this.zoomOverlayState.overlayEl;
    if (!overlay) return;
    if (overlay.getAttribute("aria-hidden") === "true") return;

    const state = this.getZoomState();

    overlay.classList.toggle("product__zoom-overlay-pinched-in", !!state.isPinchZoomed);
  }

  releaseViewportZoomListeners() {
    if (!this.zoomOverlayState.listenersBound) {
      this.zoomOverlayState.resizeHandler = null;
      this.zoomOverlayState.overlayEl = null;
      return;
    }

    const handler = this.zoomOverlayState.resizeHandler;
    if (handler) {
      if (window.visualViewport) {
        window.visualViewport.removeEventListener("resize", handler);
      }
      window.removeEventListener("resize", handler);
    }
    this.zoomOverlayState.listenersBound = false;
    this.zoomOverlayState.resizeHandler = null;
    this.zoomOverlayState.overlayEl = null;
  }

  releaseZoomScrollerListeners() {
    const scroller = this.zoomScrollerState.scrollerEl;
    const handler = this.zoomScrollerState.onScroll;
    if (scroller && handler) {
      scroller.removeEventListener("scroll", handler, { passive: true });
    }
    this.zoomScrollerState.bound = false;
    this.zoomScrollerState.onScroll = null;
    this.zoomScrollerState.scrollerEl = null;
  }

  releaseZoomPaginationListeners() {
    const s = this.zoomPaginationState.scrollerEl;
    if (this.zoomPaginationState.hideTimer) {
      clearTimeout(this.zoomPaginationState.hideTimer);
      this.zoomPaginationState.hideTimer = null;
    }
    if (s && this.zoomPaginationState.bound) {
      if (this.zoomPaginationState.onScroll) s.removeEventListener("scroll", this.zoomPaginationState.onScroll, { passive: true });
      if (this.zoomPaginationState.onWheel) s.removeEventListener("wheel", this.zoomPaginationState.onWheel, { passive: true });
      if (this.zoomPaginationState.onTouchStart) s.removeEventListener("touchstart", this.zoomPaginationState.onTouchStart, { passive: true });
      if (this.zoomPaginationState.onTouchMove) s.removeEventListener("touchmove", this.zoomPaginationState.onTouchMove, { passive: true });
      if (this.zoomPaginationState.onPointerDown) s.removeEventListener("pointerdown", this.zoomPaginationState.onPointerDown, { passive: true });
    }
    this.zoomPaginationState.bound = false;
    this.zoomPaginationState.scrollerEl = null;
    this.zoomPaginationState.onScroll = null;
    this.zoomPaginationState.onWheel = null;
    this.zoomPaginationState.onTouchStart = null;
    this.zoomPaginationState.onTouchMove = null;
    this.zoomPaginationState.onPointerDown = null;
    this.zoomPaginationState.userInteracted = false;
    this.zoomPaginationState.lastTranslate = null;
  }

  teardownZoomEventListeners() {
    this.releaseZoomPaginationListeners();
    this.releaseZoomScrollerListeners();
    this.releaseViewportZoomListeners();
  }

  ensureZoomDetection(zoomOverlay) {
    const isMobileLike = window.matchMedia?.("(pointer: coarse)")?.matches;
    if (!isMobileLike) return;

    this.zoomOverlayState.overlayEl = zoomOverlay;
    if (this.zoomOverlayState.listenersBound) return;

    this.zoomOverlayState.resizeHandler = this.onPossibleZoomChange.bind(this);
    this.zoomOverlayState.listenersBound = true;

    if (window.visualViewport) {
      window.visualViewport.addEventListener("resize", this.zoomOverlayState.resizeHandler);
    }
    window.addEventListener("resize", this.zoomOverlayState.resizeHandler);
  }

  ensureZoomPaginationAutoHide(zoomOverlay, scrollerEl) {
    if (this.zoomPaginationState.bound) return;
    if (!scrollerEl) return;

    const show = () => {
      if (zoomOverlay.getAttribute("aria-hidden") === "true") return;
      if (!this.zoomPaginationState.userInteracted) return;
      zoomOverlay.classList.add("product__zoom-overlay-pagination-active");
      if (this.zoomPaginationState.hideTimer) clearTimeout(this.zoomPaginationState.hideTimer);
      this.zoomPaginationState.hideTimer = setTimeout(() => {
        zoomOverlay.classList.remove("product__zoom-overlay-pagination-active");
      }, 800);
    };

    const markInteracted = () => {
      this.zoomPaginationState.userInteracted = true;
    };

    this.zoomPaginationState.scrollerEl = scrollerEl;
    this.zoomPaginationState.onScroll = () => {
      markInteracted();
      show();
    };
    this.zoomPaginationState.onWheel = () => {
      markInteracted();
      show();
    };
    this.zoomPaginationState.onTouchStart = () => {
      markInteracted();
    };
    this.zoomPaginationState.onTouchMove = () => {
      markInteracted();
      show();
    };
    this.zoomPaginationState.onPointerDown = () => {
      markInteracted();
    };

    scrollerEl.addEventListener("scroll", this.zoomPaginationState.onScroll, { passive: true });
    scrollerEl.addEventListener("wheel", this.zoomPaginationState.onWheel, { passive: true });
    scrollerEl.addEventListener("touchstart", this.zoomPaginationState.onTouchStart, { passive: true });
    scrollerEl.addEventListener("touchmove", this.zoomPaginationState.onTouchMove, { passive: true });
    scrollerEl.addEventListener("pointerdown", this.zoomPaginationState.onPointerDown, { passive: true });

    this.zoomPaginationState.bound = true;
  }

  /** Scroll position (content Y) needed to align `slide` top with scroller top. Works when overlay was display:none (offsetTop unreliable). */
  getZoomSlideScrollTop(scrollerEl, slide) {
    if (!scrollerEl || !slide) return 0;
    return slide.getBoundingClientRect().top - scrollerEl.getBoundingClientRect().top + scrollerEl.scrollTop;
  }

  scrollZoomSlideIntoView(scrollerEl, slide, behavior) {
    if (!scrollerEl || !slide) return;
    const top = this.getZoomSlideScrollTop(scrollerEl, slide);
    scrollerEl.scrollTo({ top: Math.max(0, top), behavior: behavior || "auto" });
    requestAnimationFrame(() => {
      scrollerEl.dispatchEvent(new Event("scroll"));
    });
  }

  renderZoomPagination(zoomOverlay, slides, initialIndex) {
    const pagination = zoomOverlay.querySelector("[data-zoom-pagination]");
    if (!pagination) return;
    pagination.innerHTML = "";

    slides.forEach((slide, idx) => {
      const bullet = document.createElement("span");
      bullet.className = "swiper-pagination-bullet" + (idx === initialIndex ? " swiper-pagination-bullet-active" : "");
      bullet.setAttribute("role", "button");
      bullet.setAttribute("tabindex", "0");
      bullet.addEventListener("click", () => {
        const scroller = zoomOverlay.querySelector("[data-scrollable]");
        if (!scroller) return;
        this.scrollZoomSlideIntoView(scroller, slide, "smooth");
      });
      pagination.appendChild(bullet);
    });
  }

  bindZoomScroller(zoomOverlay) {
    if (this.zoomScrollerState.bound) return;
    const scroller = zoomOverlay.querySelector("[data-scrollable]");
    if (!scroller) return;

    this.zoomScrollerState.scrollerEl = scroller;

    const updateActive = () => {
      const slidesContainer = zoomOverlay.querySelector("[data-zoom-slides]");
      const pagination = zoomOverlay.querySelector("[data-zoom-pagination]");
      if (!slidesContainer || !pagination) return;
      const slides = Array.from(slidesContainer.children);
      if (!slides.length) return;

      const scrollTop = scroller.scrollTop;
      let active = 0;
      let best = Infinity;
      for (let i = 0; i < slides.length; i++) {
        const slideScrollTop = this.getZoomSlideScrollTop(scroller, slides[i]);
        const d = Math.abs(slideScrollTop - scrollTop);
        if (d < best) {
          best = d;
          active = i;
        }
      }

      const bullets = Array.from(pagination.querySelectorAll(".swiper-pagination-bullet"));
      bullets.forEach((b, i) => b.classList.toggle("swiper-pagination-bullet-active", i === active));
    };

    let raf = null;
    this.zoomScrollerState.onScroll = () => {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(updateActive);
    };
    scroller.addEventListener("scroll", this.zoomScrollerState.onScroll, { passive: true });
    this.zoomScrollerState.bound = true;
  }

  getSectionUrl() {
    const base = window.routes.localeRootUrl || "";
    return base + "?section_id=product-desktop-zoom";
  }

  async fetchAndInit() {
    try {
      const response = await fetch(this.getSectionUrl());
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, "text/html");

      const overlay = doc.querySelector("#product-desktop-zoom") || doc.querySelector(".product__zoom-overlay");
      if (!overlay) return;

      const node = document.importNode ? document.importNode(overlay, true) : overlay.cloneNode(true);
      this.wrapper.appendChild(node);
    } catch (e) {}
  }

  bindEvents() {
    this.delegateElement.on("click", "[data-action='desktop-zoom']", this.handleZoom.bind(this));
    this.delegateElement.on("click", "[data-action='close-desktop-zoom']", this.closeZoom.bind(this));
    this.delegateElement.on("click", "[data-action='open-product-zoom']", this.handleZoomFromButton.bind(this));
  }

  destroy() {
    this.closeZoom();
    this.delegateElement.destroy();
  }

  handleZoom(evt) {
    const zoomOverlay = this.wrapper.querySelector(".product__zoom-overlay");
    if (!zoomOverlay) return;

    const slidesContainer = zoomOverlay.querySelector("[data-zoom-slides]");
    const scrollerEl = zoomOverlay.querySelector("[data-scrollable]");
    if (!slidesContainer || !scrollerEl) return;

    // Prevent duplicates if zoom is triggered multiple times while open (or without a proper close).
    slidesContainer.innerHTML = "";

    const prefersDesktop = window.matchMedia?.("(min-width: 1025px)")?.matches;
    const sourceRoot = prefersDesktop
      ? this.wrapper.querySelector(".product__swiper-desktop") || this.wrapper
      : this.wrapper.querySelector(".product__swiper-mobile") || this.wrapper;

    const targets = sourceRoot.querySelectorAll("[data-action='desktop-zoom']");
    if (!targets.length) return;

    // Dedupe targets (mobile+desktop markup, swiper duplicates, etc.)
    const uniqueTargets = [];
    const seen = new Set();
    targets.forEach((t) => {
      const pos = t.getAttribute("data-image-position");
      const key = pos != null ? `pos:${pos}` : t.id ? `id:${t.id}` : null;
      if (key && seen.has(key)) return;
      if (key) seen.add(key);
      uniqueTargets.push(t);
    });

    const clicked = evt.target.closest("[data-action='desktop-zoom']");
    const clickedPos = clicked ? parseInt(clicked.getAttribute("data-image-position"), 10) : 0;

    // Swiper (especially loop mode) can reorder/duplicate slide DOM nodes after interaction.
    // Always build the zoom gallery in a stable ascending `data-image-position` order.
    const sortedTargets = uniqueTargets
      .map((t, originalIndex) => ({
        t,
        originalIndex,
        pos: parseInt(t.getAttribute("data-image-position"), 10)
      }))
      .sort((a, b) => {
        const aHas = Number.isFinite(a.pos);
        const bHas = Number.isFinite(b.pos);
        if (aHas && bHas) return a.pos - b.pos;
        if (aHas) return -1;
        if (bHas) return 1;
        return a.originalIndex - b.originalIndex;
      })
      .map((x) => x.t);

    const slides = [];
    sortedTargets.forEach((target) => {
      const slide = document.createElement("div");
      slide.className = "product__zoom-overlay-slide";

      const clone = target.cloneNode(true);
      clone.removeAttribute("data-action");

      slide.appendChild(clone);
      slidesContainer.appendChild(slide);
      slides.push(slide);
    });

    const clickedPosStr = String(clickedPos);
    const matchedIndex = sortedTargets.findIndex((t) => t.getAttribute("data-image-position") === clickedPosStr);
    const initialIndex = matchedIndex >= 0 ? matchedIndex : 0;
    this.renderZoomPagination(zoomOverlay, slides, initialIndex);
    this.bindZoomScroller(zoomOverlay);

    zoomOverlay.setAttribute("aria-hidden", "false");
    zoomOverlay.style.setProperty("--zoom-scrollbar-gutter", `${Math.max(0, scrollerEl.offsetWidth - scrollerEl.clientWidth)}px`);
    bodyScrollLock.disableBodyScroll(scrollerEl, bodyScrollLockOptions);

    this.ensureZoomDetection(zoomOverlay);
    this.onPossibleZoomChange();
    this.ensureZoomPaginationAutoHide(zoomOverlay, scrollerEl);

    const slideToShow = slides[initialIndex];
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (zoomOverlay.getAttribute("aria-hidden") === "true") return;
        this.scrollZoomSlideIntoView(scrollerEl, slideToShow, "auto");
      });
    });
  }

  handleZoomFromButton(evt) {
    const swiper =
      this.wrapper.querySelector(".product__swiper-mobile.swiper-initialized") ||
      this.wrapper.querySelector(".product__swiper-mobile");

    const activeTarget =
      swiper?.querySelector(".swiper-slide-active [data-action='desktop-zoom']") ||
      this.wrapper.querySelector("[data-action='desktop-zoom']");

    if (!activeTarget) return;
    this.handleZoom({ target: activeTarget });
  }

  closeZoom() {
    this.teardownZoomEventListeners();

    const zoomOverlay = this.wrapper.querySelector(".product__zoom-overlay");
    if (!zoomOverlay) return;

    zoomOverlay.querySelector("[data-zoom-slides]")?.replaceChildren();
    zoomOverlay.querySelector("[data-zoom-pagination]")?.replaceChildren();
    zoomOverlay.classList.remove("product__zoom-overlay-pinched-in");
    zoomOverlay.classList.remove("product__zoom-overlay-pagination-active");
    zoomOverlay.style.removeProperty("--zoom-scrollbar-gutter");

    zoomOverlay.setAttribute("aria-hidden", "true");
    bodyScrollLock.clearAllBodyScrollLocks();
  }
}

/**
 * The one-time price of a delivery option, as Liquid rendered it.
 *
 * Both the delivery block and the purifier flow print the price with the money
 * filter (.Product--OneTimeRealPrice) right next to the raw cents they expose
 * in data-variant-price / data-price. Shopify's filter applies the currency's
 * own locale conventions, which Shopify.formatMoney can only approximate from
 * the placeholder name - so re-formatting those cents yields a different
 * separator from the price printed beside it ("1,700 kr" against "1 700 kr" in
 * SEK). Read the rendered string instead; only format when it isn't there.
 */
function deliveryPriceText(deliveryElement) {
  if (!deliveryElement) return "";

  const rendered = deliveryElement.querySelector(".Product--OneTimeRealPrice");
  if (rendered && rendered.innerText.trim()) return rendered.innerText.trim();

  const cents =
    deliveryElement.getAttribute("data-variant-price") ||
    deliveryElement.getAttribute("data-price");
  return cents ? Shopify.formatMoney(cents, window.theme.moneyFormat).trim() : "";
}

/*
  Match Liquid's `money_without_trailing_zeros`. Only a decimal part that is
  entirely zeros is dropped - 17,50 is left alone. Callers are responsible for
  checking that this is how the markup they are writing into was rendered; see
  updateButtonPrice.
*/
function moneyWithoutTrailingZeros(price) {
  if (typeof price !== "string") return price;
  return price.replace(/([.,])0+(?=\D*$)/, "");
}

class ProductElement extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    // Initialize recently viewed settings
   
    this.currentHandle = this.dataset.currentHandle || null;


    // Save current product to recently viewed
    if (this.currentHandle) {
      this.saveRecentlyViewedProducts();
    }

    this.assignVariables();
    this.initSubClasses();

    // large images that are visible on load should not be lazy loaded, instead we render them at lowest quality
    // as soon as js loads changeImageQuality replaces image with high quality, this improves performance
    ////// change image quality has to go before initSwiper
    ////// (swiper creates duplicates of slides and with that it takes low res image before it was replaced)
    this.changeImageQuality();
    this.initSwiper();

    if (this.options["variant_image_id"] && this.options["show_variant_image_on_load"]) {
      this.updateImage();
    }

    this.initStickyBar();

    // if filters or purifier flow is active it saves current product wrapper to the map
    this.saveCurrentProduct();

    // bind events has to be above init loop
    // init loop has line of code when it should be preselected and that is handled so that js click on it and triggers event
    this.bindEvents();
    this.initLoop();
    this.startObserver(this);
  }

  assignVariables() {
    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );

    this.valuesWrap = this.element.querySelectorAll(
      ".ProductOption--ValusWrapper"
    );

    this.moneyButton = this.element.querySelector(
      ".Product--AddToCartButton[data-money]"
    );
    this.subscription = this.element.querySelector(
      ".Product--SubscriptionButton"
    );
    this.buttonPrice = Array.from(
      this.element.querySelectorAll(".button--money")
    );
    this.pageOverlayElement = document.querySelector(".pageOverlay");

    // Find the product recommendations element if it exists on the page
    this.recommendations = document.querySelector("product-recommendations-home");

    this.productMap = new Map();

    // Images pulled into the browser cache ahead of time (cylinder flow). Held
    // so the loads can't be garbage collected before they finish.
    this.warmedImages = [];
  }

  initSubClasses() {
    // delegate
    this.domDelegate = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    // drawer
    const localPickup = this.element.querySelector("#LocalPickup");
    if (localPickup) {
      new Drawer(this.element.querySelector("#LocalPickup"));
    }

    // universal description drawer (one drawer, content injected on open)
    const descriptionDrawer = this.element.querySelector("#ProductDescriptionDrawer");
    if (descriptionDrawer) {
      new Drawer(descriptionDrawer, {
        onOpen: function () {
          var expanded = descriptionDrawer.querySelector(".description-drawer__dropdown--expanded .Dropdown--Content");
          if (expanded && typeof bodyScrollLock !== "undefined") {
            bodyScrollLock.clearAllBodyScrollLocks();
            bodyScrollLock.disableBodyScroll(expanded, bodyScrollLockOptions);
          }
        }
      });
    }

    // add to cart
    new AddToCart(this.element);

    // dropdowns
    new Dropdown(this.element);

    // image zoom
    if (this.options["enable_zoom"]) {
      new DesktopZoom(this.element);
    }

    // selectboxes
    const selectBoxes = this.element.querySelectorAll(".RevolutionSelectbox");
    if (selectBoxes.length > 0) {
      selectBoxes.forEach((item, i) => {
        new RevolutionSelectbox(item);
      });
    }
  }

  initSwiper() {
    // if old swiper exists, destroy it
    if (this.carousel) {
      this.carousel.swiperElement.destroy();
    }

    const tabletAndUp = new Responsive().matchesBreakpoint("tablet-and-up");
    const swiperClass = tabletAndUp ? ".product__swiper-desktop" : ".product__swiper-mobile";

    this.carouselElement = this.element.querySelector(swiperClass);
    this.carouselElementThumbs = this.element.querySelector(".ProductSlider--Thumbnails");

    // if there is less than one slide there is no need for swiper
    const slideNumber = Array.from(
      this.carouselElement.querySelectorAll(".swiper-slide")
    ).length;
    if (slideNumber <= 1) return;

    // if thumbnails are on init them as well
    if (this.options["show_thumbnails"] && this.carouselElementThumbs) {
      return (this.carousel = new RevolutionSwiper(
        this.carouselElement,
        this.carouselElementThumbs
      ));
    }

    // if all prev if are false init swiper
    this.carousel = new RevolutionSwiper(this.carouselElement);
  }

  // if sticky bar is enabled in schema initialize variables and start event listener
  initStickyBar() {
    const stickyBar = this.element.querySelector("[data-sticky-bar]");
    if (!stickyBar) return;

    this.productTitle = this.element.querySelector(".ProductInfo--Title");
    if (!this.productTitle) this.productTitle = this.element.querySelector(".ProductInfo--TitlePrice");

    this.productButton = this.element.querySelector(".Product--StickyBarTrigger");
    this.stickyBarMobile = stickyBar.querySelector(".Product--StickyBarMobile");
    this.stickyBarDesktop = stickyBar.querySelector(".Product--StickyBarDesktop");
    this.stickyMobileDropdown = stickyBar.querySelector('.Product--StickyDropdown[data-expanded="false"]');
    this.stickyMobileDropdownOpen = false;

    window.addEventListener("scroll", this.handleScroll.bind(this));
    this.domDelegate.on("click", '.Product--StickyArrow[data-action="open-drowpdown"]', this.handleStickyDropdownToggle.bind(this));
  }

  initLoop() {
    this.initLoopBox();
    this.initLoopQuantity();
    this.initLoopDropdown();
  }

  ////////////////////// inits loop boxes //////////////////////
  initLoopBox() {
    const checkedLoopBox = this.element.querySelector(
      '.Product--LoopBox[aria-selected="true"]'
    );
    checkedLoopBox?.click();
  }

  ////////////////////// inits loop quantity //////////////////////
  initLoopQuantity() {
    this.loopQuantityInput = this.element.querySelector(
      "#Product--LoopQuantityInput"
    );
    if (!this.loopQuantityInput) return;

    this.initLoopQuantityVariables();
    const currentStep = this.loopQuantityInput.value - 1;

    const loopProductId = this.loopQuantityObject.loopProductIds[currentStep];
    const loopVariantId = this.loopQuantityObject.loopVariantIds[currentStep];
    const loopSellingPlan = this.loopQuantityObject.loopSellingPlans[currentStep];
    const notAvailable = this.loopQuantityObject.notAvailable[currentStep];
    const notifyMe = this.loopQuantityObject.notifyMe;
    const notifyCurrentProduct = notifyMe && notAvailable === "true";

    // if first item in selector is not available disable button
    if (notAvailable === "true" && !notifyMe) {
      this.disableAllButtons();
    } else {
      this.enableAllButtons();
      this.toggleButtonAction(
        notifyCurrentProduct,
        loopProductId,
        loopVariantId
      );
    }

    // update atc button so the first item in selector is added to a cart on atc button click
    this.updateAtcId(loopVariantId, loopSellingPlan);
  }

  ////////////////////// inits loop dropdown //////////////////////
  initLoopDropdown() {
    const loopDropdown = this.element.querySelector(".Product--LoopDropdown");
    if (!loopDropdown) return;

    this.loopSettings = JSON.parse(loopDropdown.dataset.loopSettings);

    // disable atc buttons
    // until item is selected atc button should be disabled
    if (this.loopSettings.disableButton) {
      this.disableAllButtons();
    }

    // template should show price of the lowest item in dropdown
    const elemsWithPrices = Array.from(
      this.element.querySelectorAll(".Product--LoopDropdownItem[data-price]")
    );

    if (this.loopSettings.lowestPrice && elemsWithPrices.length > 0) {
      let lowestPrice = 99999999;

      elemsWithPrices.forEach((elem) => {
        const textPrice = elem.dataset.price;
        const price = parseInt(textPrice);

        if (price < lowestPrice) {
          lowestPrice = price;
        }
      });

      const formatedPrice = Shopify.formatMoney(
        lowestPrice,
        window.theme.moneyFormat
      );
      this.updateTemplatesPrices(formatedPrice);
    }

    // if one loop item is already in the cart disable atc
    this.loopItemInCart = document.querySelector("[data-loop-item]")
      ? true
      : false;
    if (this.loopSettings.onlyOne && this.loopItemInCart) {
      this.disableAllButtons();
    }
  }

  bindEvents() {
    this.domDelegate.on("click", '[data-second-action="build-drawer-content"]', this.handleBuildDrawerContent.bind(this));

    this.domDelegate.on('click', '[data-action="select-product"]', this.selectProduct.bind(this));

    this.domDelegate.on("update:pdp:image", this.updateImage.bind(this));

    this.domDelegate.on("cylinder:gallery:swap", this.swapCylinderGallery.bind(this));

    this.domDelegate.on("cylinder:gallery:prefetch", this.prefetchCylinderGalleries.bind(this));

    this.domDelegate.on(
      "click",
      '[data-action="subscription-change"]',
      this.toggleSubscription.bind(this)
    );

    this.domDelegate.on(
      "click",
      '[data-action="close-error-gas"]',
      this.gasErrorClose.bind(this)
    );
    this.onClickOutsideListener = this.gasErrorClose.bind(this);
    this.delegateBody.on("gas:error", this.gasError.bind(this));
    this.domDelegate.on(
      "click",
      '[data-action="click-atc"]',
      this.clickAtc.bind(this)
    );

    this.domDelegate.on(
      "mouseover",
      "[data-selectbox-value]",
      this.handleVariantHover.bind(this)
    );
    this.domDelegate.on(
      "mouseout",
      "[data-selectbox-value]",
      this.handleVariantHoverEnd.bind(this)
    );

    this.domDelegate.on(
      "mouseover",
      ".connected-product__image-wrapper",
      this.handleConnectedProductHover.bind(this)
    );
    this.domDelegate.on(
      "mouseout",
      ".connected-product__image-wrapper",
      this.handleConnectedProductHoverEnd.bind(this)
    );

    ///////////////////////////////////////////////// Loop events /////////////////////////////////////////////////
    this.domDelegate.on(
      "click",
      '[data-action="select-loop-box"]',
      this.handleLoopBoxClick.bind(this)
    );
    this.domDelegate.on(
      "click",
      '[data-action="change-loop-quantity"]',
      this.handleLoopQuantityChange.bind(this)
    );
    this.domDelegate.on(
      "click",
      '[data-action="toggle-loop-dropdown"]',
      this.handleLoopDropdownToggle.bind(this)
    );
    this.domDelegate.on(
      "click",
      '[data-action="select-loop-dropdown"]',
      this.handleLoopDropdownSelected.bind(this)
    );
    this.delegateBody.on(
      "loop:cart:changed",
      this.handleLoopItemInCart.bind(this)
    );
    this.domDelegate.on(
      "click",
      '[data-action="open-loop-popup"]', 
      this.openLoopPopup.bind(this)
    );
    this.delegateBody.on("open:loop:popup", this.openLoopPopup.bind(this));
    this.domDelegate.on(
      "click",
      '[data-action="close-loop-popup"]',
      this.closeLoopPopup.bind(this)
    );
    this.delegateBody.on(
      "click",
      ".pageOverlay",
      this.closeLoopPopup.bind(this)
    );
    ///////////////////////////////////////////////// Loop events end /////////////////////////////////////////////////

    ///////////////////////////////////////////////// filter events /////////////////////////////////////////////////
    this.domDelegate.on('filters:notify:me', this.handleFiltersNotifyMe.bind(this));
    this.domDelegate.on('click', 'filters-flow [data-action="select-type-block"]', this.handleFilterTypeChange.bind(this));

    this.domDelegate.on('click', '[data-action="change-purifier-variant"]', this.handlePurifierVariantChange.bind(this));
    ///////////////////////////////////////////////// filter events  end /////////////////////////////////////////////////


   // Better for accessibility - doesn't interfere with normal Tab navigation
    this.domDelegate.on('keydown', this.handleThumbSlider.bind(this));
  }

  handleBuildDrawerContent(event) {
    const container = event.target.closest("[data-second-action=\"build-drawer-content\"]");
    if (!container) return;

    const template = container.querySelector("template");
    const drawer = this.element.querySelector(".description-drawer");
    const contentSlot = drawer && drawer.querySelector(".description-drawer__content");
    if (!contentSlot || !template || !template.content) return;

    const triggerButton = container.querySelector(".description-drawer-trigger__button");
    const titleToMatch = (triggerButton && triggerButton.getAttribute("data-description-drawer-title") || "").trim();

    contentSlot.innerHTML = "";
    contentSlot.appendChild(template.content.cloneNode(true));

    if (!titleToMatch) return;

    const dropdownEl = Array.from(contentSlot.querySelectorAll(".description-drawer__dropdowns .Dropdown")).find(function (el) {
      const h = el.getAttribute("data-dropdown-heading");
      return h && h.trim() === titleToMatch;
    });
    if (!dropdownEl) return;

    const btn = dropdownEl.querySelector(".Dropdown--Button");
    const content = dropdownEl.querySelector(".Dropdown--Content");
    if (btn && content) {
      btn.setAttribute("aria-expanded", "true");
      content.setAttribute("aria-hidden", "false");
      content.style.height = "auto";
      dropdownEl.classList.add("description-drawer__dropdown--expanded");
      /* Scroll target is set in Drawer onOpen so it runs after drawer opens */
    }
  }

handleThumbSlider() {
  if (event.key === 'ArrowRight') {
    event.preventDefault();
    this.carousel?.swiperElement?.slideNext();
} else if (event.key === 'ArrowLeft') {
    event.preventDefault();
    this.carousel?.swiperElement?.slidePrev();
}
}



  selectProduct() {
    const target = event.target.closest('[data-action="select-product"]');
    if (!target) return;

    const newPdp = globalPreload.getPreloadedById(target.dataset.preloadType, target.dataset.preloadId);

    const newPathname = target.dataset.preloadUrl;
    const newURL = `${window.location.origin}${newPathname}`;

    if (!newPdp) return window.location = newPathname;

    window.history.replaceState({}, '', newURL);
    // still does not replace current element with the new one, both stay in the dom, pls fix later
    this.element.outerHTML = newPdp;
  }

  async handlePurifierVariantChange() {
    const target = event.target;
    const handle = target.dataset.handle;
    const title = target.dataset.title;
    const newProductTitle = target.dataset.newProductTitle;

    this.element.querySelector('.product__purifier-variant[aria-selected="true"]')?.setAttribute("aria-selected", "false");
    target.setAttribute("aria-selected", "true");

    const titleElem = this.element.querySelector(".variant-selectors-purifier__current-variant");
    if (titleElem) titleElem.innerText = title;

    this.toggleLoader();
    const scrollBarWidth = this.getScrollBarWidth();
    document.body.style.paddingRight = scrollBarWidth + "px";
    bodyScrollLock.disableBodyScroll(bodyScrollLockOptions);

    let newProductWrapper = await this.getTemplate(handle);
    if (!newProductWrapper) {
      bodyScrollLock.clearAllBodyScrollLocks();
      document.body.style.paddingRight = "";
      this.toggleLoader();
      return;
    }
    newProductWrapper = newProductWrapper.querySelector(".Product--Wrapper") || newProductWrapper;

    this.element.querySelector(".Product--Wrapper")?.replaceWith(newProductWrapper.cloneNode(true));
    this.element.querySelector("purifier-flow div")?.dispatchEvent(new CustomEvent('reinit:purifier:flow', { bubbles: true }));
    this.pushHistoryState(handle);
    this.initSwiper();
    this.updateTemplatesTitles(newProductTitle);
    this.disableAllButtons();

    const atcButton = this.element.querySelector(".ProductPage--ATC:not(sticky-bar__atc)");
    const notifyMe = atcButton.dataset.action === "open-bis";
    this.toggleButtonAction(notifyMe);
    this.enableAllButtons();

    bodyScrollLock.clearAllBodyScrollLocks();
    document.body.style.paddingRight = "";
    this.toggleLoader();
  }

  saveCurrentProduct() {
    const filterTypeSelectBox = this.element.querySelector('filters-flow .Product--TypeProduct[aria-selected="true"]');
    const purifierVariant = this.element.querySelector('.product__purifier-variant[aria-selected="true"]');

    let handle;

    if (filterTypeSelectBox) {
      handle = filterTypeSelectBox.dataset.handle;
    } else if (purifierVariant) {
      handle = purifierVariant.dataset.handle;
    } else {
      return;
    }

    const urlOrigin = window.location.origin;
    const url = urlOrigin + Shopify.routes.root + "products/" + handle;
    const productWrapper = this.element.querySelector(".Product--Wrapper");
    const cloneWrapper = productWrapper.cloneNode(true);

    this.productMap.set(url, cloneWrapper);
  }

  async handleFilterTypeChange() {
    const target = event.target.closest(".Product--TypeProduct");
    const handle = target.dataset.handle;
    const scrollBarWidth = this.getScrollBarWidth();

    this.toggleLoader();
    bodyScrollLock.disableBodyScroll(bodyScrollLockOptions);
    document.body.style.paddingRight = scrollBarWidth + "px";

    await this.updateTemplate(handle);

    // Update button price based on currently selected delivery option
    const selectedDelivery = this.element.querySelector('.Product--DeliveryPerVariant[aria-hidden="false"] .Product--DeliveryOneTime[aria-selected="true"]');
    if (selectedDelivery) {
      const price = deliveryPriceText(selectedDelivery);
      if (price) {
        const buttons = this.element.querySelectorAll(".ProductPage--ATC .button--money");
        buttons.forEach(button => {
          button.innerText = price;
        });
      }
    }

    bodyScrollLock.clearAllBodyScrollLocks();
    document.body.style.paddingRight = "";
    this.toggleLoader();
  }

  getScrollBarWidth() {
    // Creating invisible container
    const outer = document.createElement('div');
    outer.style.visibility = 'hidden';
    outer.style.overflow = 'scroll'; // forcing scrollbar to appear
    outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
    document.body.appendChild(outer);

    // Creating inner element and placing it in the container
    const inner = document.createElement('div');
    outer.appendChild(inner);

    // Calculating difference between container's full width and the child width
    const scrollbarWidth = (outer.offsetWidth - inner.offsetWidth);

    // Removing temporary elements from the DOM
    outer.parentNode.removeChild(outer);

    return scrollbarWidth;
  }

  handleFiltersNotifyMe(event) {
    const productId = event.detail.productId;
    const variantId = event.detail.variantId;
    const notifyMe = event.detail.notifyMe;

    this.toggleButtonAction(notifyMe, productId, variantId)
  }

  // triggers when item with attribute "data-loop-item" is added/removed from the cart
  handleLoopItemInCart(event) {
    const isLoopInCart = event.detail.isLoopInCart;

    // if there is one loop item in the cart next atc button click triggers popup
    if (isLoopInCart) {
      this.setButtonActionToTriggerPopup();
      this.loopItemInCart = true;
    } else {
      // toggleButtonAction function toggles between add-to-cart and open-bis action
      const currentItem = this.element.querySelector(
        '.Product--LoopDropdownItem[aria-selected="true"]'
      );
      if (!currentItem) return;

      const notifyMe = currentItem.dataset.notifyMe ? true : false;
      this.toggleButtonAction(notifyMe);
      this.loopItemInCart = false;
    }
  }

  // diables all atc buttons
  disableAllButtons() {
    const buttons = Array.from(
      this.element.querySelectorAll(".ProductPage--ATC")
    );

    buttons.forEach((button) => {
      button.disabled = true;
    });
  }

  // enables all atc buttons
  enableAllButtons() {
    const buttons = Array.from(
      this.element.querySelectorAll(".ProductPage--ATC")
    );

    buttons.forEach((button) => {
      button.disabled = false;
    });
  }

  // toggles loop dropdown
  handleLoopDropdownToggle() {
    const target = event.target;
    const expanded = target.getAttribute("aria-expanded");

    if (expanded === "true") {
      target.setAttribute("aria-expanded", "false");
    } else if (expanded === "false") {
      target.setAttribute("aria-expanded", "true");
    }
  }

  // triggers when dropdown loop item is selected
  async handleLoopDropdownSelected() {
    const target = event.target;

    // assign all needed data
    const productId = target.dataset.productId;
    const variantId = target.dataset.variantId;
    const handle = target.dataset.handle;
    const sellingPlanId = target.dataset.sellingPlanId;
    const title = target.innerText;
    const index = target.dataset.index;
    const price = target.dataset.price;

    // disable page scroll and turn on loader
    bodyScrollLock.disableBodyScroll(bodyScrollLockOptions);
    this.toggleLoader();

    // update all the visible data on the page
    this.updateAtcId(variantId, sellingPlanId);
    this.selectDropdownButton(target, title);
    this.fillInTheLoopContent(index);
    await this.updateTemplate(handle, price);
    this.updateTemplatesPrices(
      Shopify.formatMoney(price, window.theme.moneyFormat)
    );

    // if notify me is turned on toggle button action
    const notifyMe = target.dataset.notifyMe ? true : false;
    if (this.loopSettings.enableNotifyMe) {
      this.toggleButtonAction(notifyMe, productId, variantId);
    }

    // if loop item is in cart and notify shouln't trigger, then trigger error popup on atc click
    if (this.loopItemInCart && !notifyMe) {
      this.setButtonActionToTriggerPopup();
    }

    // enables atc buttons
    // buttons were disabled until first item is selected
    this.enableAllButtons();

    // remove loader and enable scroll
    this.toggleLoader();
    bodyScrollLock.clearAllBodyScrollLocks();
  }

  // changes all atc buttons to trigger popup on click
  setButtonActionToTriggerPopup() {
    const buttons = Array.from(
      this.element.querySelectorAll(".ProductPage--ATC")
    );

    buttons.forEach((button) => {
      if (button.dataset.oldAction !== "click-atc")
        button.dataset.action = "open-loop-popup";
    });
  }

  // opens loops error msg popup
  openLoopPopup() {
    event.preventDefault();
    event.stopPropagation();

    const popup = this.element.querySelector(".Product--LoopDropdownPopop");
    if (popup) {
      const overlay = document.querySelector(".pageOverlay");
      popup.style.display = "block";
      bodyScrollLock.disableBodyScroll(bodyScrollLockOptions);

      setTimeout(() => {
        popup.setAttribute("aria-hidden", "false");
        overlay.classList.add("is-visible");
      }, 100);
    } else {
      alert("You already have max amount of this item in cart.");
    }
  }

  // closes loops error msg popup
  closeLoopPopup() {
    const popup = this.element.querySelector(
      '.Product--LoopDropdownPopop[aria-hidden="false"]'
    );
    if (!popup) return;

    const overlay = document.querySelector(".pageOverlay");
    popup.setAttribute("aria-hidden", "true");

    setTimeout(() => {
      overlay.classList.remove("is-visible");
      popup.style.display = "block";
      bodyScrollLock.clearAllBodyScrollLocks();
    }, 300);
  }

  // toggles button action between open-bis and add-to-cart
  // toggles button when unavailable item from loop is selected
  toggleButtonAction(notifyMe, productId, variantId) {
    const buttons = Array.from(this.element.querySelectorAll(".ProductPage--ATC"));

    buttons.forEach((button) => {
      if (notifyMe && button.dataset.oldAction) {
        const notifySvg = `<svg class="mr-sl" width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M18.2778 3.33337H2.72223C2.10858 3.33337 1.61111 3.83084 1.61111 4.44449V15.5556C1.61111 16.1692 2.10858 16.6667 2.72223 16.6667H18.2778C18.8914 16.6667 19.3889 16.1692 19.3889 15.5556V4.44449C19.3889 3.83084 18.8914 3.33337 18.2778 3.33337ZM17.4222 15.5556H3.64445L7.53334 11.5334L6.73334 10.7612L2.72223 14.9112V5.28893L9.62778 12.1612C10.0612 12.592 10.7611 12.592 11.1944 12.1612L18.2778 5.11671V14.8389L14.1889 10.75L13.4056 11.5334L17.4222 15.5556ZM17.3778 4.44449H3.45L10.4111 11.3723L17.3778 4.44449Z" fill="white"/></svg>`;
        const buttonTextContainer = button.querySelector(".button--text");
        const buttonPriceContainer = button.querySelector(".button--money");

        if (buttonTextContainer.querySelector("svg")) {
          buttonTextContainer.innerHTML =
            notifySvg + " " + window.variantStrings.notify_me;
        } else {
          buttonTextContainer.innerHTML = window.variantStrings.notify_me;
        }

        if (buttonPriceContainer) {
          buttonPriceContainer.innerText = "";
        }

        if (button.dataset.oldAction !== "click-atc")
          button.dataset.action = "open-bis";

        if (productId) {
          button.setAttribute("data-product", productId);
        } else if (!button.getAttribute("data-product")) {
          button.disabled = true;
        }

        if (variantId) {
          button.setAttribute("data-variant", variantId);
        } else if (!button.getAttribute("data-variant")) {
          button.disabled = true;
        }
      } else if (!notifyMe && button.dataset.oldAction) {
        const cartSvg = `<svg class="Svg Svg--basket mr-sl" width="20" height="20" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M25.31 5.19547C25.1687 5.02127 24.9568 4.91946 24.7325 4.91797H9.11751L9.60501 6.41797H23.75L21.7475 15.418H10.4975L7.07001 4.56547C6.99476 4.33174 6.80986 4.14965 6.57501 4.07797L3.50001 3.13297C3.24278 3.05393 2.96292 3.11812 2.76584 3.30137C2.56877 3.48461 2.48443 3.75907 2.54459 4.02137C2.60476 4.28366 2.80028 4.49393 3.05751 4.57297L5.75001 5.39797L9.19251 16.273L7.96251 17.278L7.86501 17.3755C7.2374 18.0987 7.21221 19.1659 7.80501 19.918C8.21952 20.4221 8.84817 20.7002 9.50001 20.668H22.0175C22.4317 20.668 22.7675 20.3322 22.7675 19.918C22.7675 19.5038 22.4317 19.168 22.0175 19.168H9.38001C9.20436 19.162 9.0446 19.0646 8.95873 18.9113C8.87286 18.7579 8.87334 18.5709 8.96001 18.418L10.7675 16.918H22.3475C22.705 16.9267 23.0189 16.6818 23.0975 16.333L25.475 5.83297C25.5212 5.6064 25.4603 5.37117 25.31 5.19547ZM20.75 25.168C21.682 25.168 22.4375 24.4125 22.4375 23.4805C22.4375 22.5485 21.682 21.793 20.75 21.793C19.818 21.793 19.0625 22.5485 19.0625 23.4805C19.0625 24.4125 19.818 25.168 20.75 25.168ZM12.185 23.4805C12.185 24.4125 11.4295 25.168 10.4975 25.168C9.56553 25.168 8.81001 24.4125 8.81001 23.4805C8.81001 22.5485 9.56553 21.793 10.4975 21.793C11.4295 21.793 12.185 22.5485 12.185 23.4805Z" fill="#121212"></path></svg>`;
        const buttonTextContainer = button.querySelector(".button--text");

        if (buttonTextContainer.querySelector("svg")) {
          buttonTextContainer.innerHTML =
            cartSvg + " " + window.variantStrings.addToCart;
        } else {
          buttonTextContainer.innerHTML = window.variantStrings.addToCart;
        }

        if (button.dataset.oldAction !== "click-atc")
          button.dataset.action = button.dataset.oldAction;
      }
    });
  }

  // when dropdown loop item is selected it shows text connected to it under the dropdown
  fillInTheLoopContent(index) {
    const oldWrapper = this.element.querySelector(
      `.Product--LoopDropdownContent[aria-hidden="false"]`
    );
    oldWrapper?.setAttribute("aria-hidden", "true");

    const wrapper = this.element.querySelector(
      `.Product--LoopDropdownContent[data-content-index="${index}"]`
    );
    if (!wrapper) return;

    const formated = wrapper.dataset.formated;
    if (formated === "false") {
      // text is fetched from the richtext field and it needs to be formated
      this.formatContent(wrapper);
      wrapper.dataset.formated = true;
    }

    wrapper.setAttribute("aria-hidden", "false");
  }

  // updates style and adds svgs to elements from rich text
  formatContent(wrapper) {
    // get all elems from the container
    const elems = wrapper.querySelectorAll("*");

    elems.forEach((elem) => {
      const tagName = elem.tagName.toLowerCase();

      // if elem is heading (h1, h2, h3...) add u-s class to it
      // u-s1 to h1, u-s2 to h2, u-s3 to h3...
      if (/^h[1-6]$/.test(tagName)) {
        const className = "u-" + tagName.replace("h", "s");
        elem.classList.add(className);

        // if elem li, add svg of checkmark to it
      } else if (/^li$/.test(tagName)) {
        const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
          <path d="M7.62335 15.8829L1.8289 10.094C1.64014 9.87363 1.65283 9.54505 1.85803 9.33985C2.06324 9.13464 2.39181 9.12195 2.61223 9.31072L7.61224 14.3107L17.3845 4.5496C17.6049 4.36084 17.9335 4.37353 18.1387 4.57874C18.3439 4.78394 18.3566 5.11252 18.1678 5.33294L7.62335 15.8829Z" fill="black"/>
          </svg>`;

        elem.innerHTML = svg + elem.innerHTML;

        // if elem a, add svg of box to it
      } else if (/^a$/.test(tagName)) {
        const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M17.7772 6.80238C17.777 6.79422 17.7765 6.78619 17.7757 6.77809C17.7749 6.76999 17.7736 6.76176 17.7722 6.75361C17.7709 6.74601 17.7697 6.73854 17.7679 6.73108C17.7663 6.72411 17.7643 6.71726 17.7622 6.71029C17.7598 6.70262 17.7571 6.69522 17.7543 6.68769C17.7511 6.67932 17.7478 6.67115 17.7441 6.66306C17.7425 6.65979 17.7419 6.65636 17.7403 6.65306C17.7389 6.65041 17.7369 6.64832 17.7355 6.64566C17.7319 6.63884 17.7277 6.63228 17.7236 6.62566C17.7187 6.61778 17.7137 6.61025 17.7082 6.60281C17.7042 6.59736 17.7004 6.59179 17.6961 6.58662C17.6916 6.58105 17.6865 6.57602 17.6815 6.57072C17.6753 6.56409 17.6689 6.55786 17.6623 6.55161C17.6568 6.54666 17.6516 6.54161 17.646 6.53696C17.6408 6.53278 17.6353 6.52908 17.6299 6.52518C17.6224 6.51974 17.6148 6.51471 17.6069 6.50989C17.6001 6.50571 17.5935 6.50159 17.5865 6.49789C17.5839 6.49646 17.5818 6.49462 17.5793 6.49329L10.1615 2.81501C10.1115 2.79024 10.0564 2.77734 10.0005 2.77734C9.94455 2.77734 9.88941 2.79024 9.83939 2.81501L6.13057 4.65415L2.4217 6.49329C2.41918 6.49455 2.41716 6.49644 2.41467 6.49776C2.40746 6.50152 2.40056 6.50578 2.39361 6.51004C2.38583 6.51485 2.37834 6.51981 2.37095 6.52518C2.36561 6.52901 2.36016 6.53264 2.3551 6.53682C2.34934 6.54149 2.34403 6.54672 2.33851 6.55175C2.33186 6.55789 2.32555 6.56416 2.31941 6.57079C2.31448 6.57602 2.30943 6.58105 2.30489 6.58651C2.30057 6.59174 2.29677 6.59731 2.29272 6.60282C2.28726 6.61022 2.2822 6.61782 2.27732 6.62568C2.2732 6.63224 2.26912 6.63872 2.26547 6.64568C2.26403 6.64826 2.26205 6.65042 2.26068 6.65308C2.25903 6.65635 2.25839 6.65984 2.25685 6.66308C2.25308 6.67109 2.24985 6.67926 2.24668 6.68756C2.2438 6.69509 2.24112 6.70256 2.23877 6.71024C2.23666 6.71721 2.23473 6.72405 2.23301 6.73102C2.23123 6.73848 2.22996 6.74595 2.22869 6.75355C2.22725 6.76171 2.2261 6.76981 2.22529 6.77811C2.22451 6.78619 2.22398 6.79422 2.22374 6.80231C2.22361 6.80591 2.22266 6.80921 2.22266 6.81276V13.7419C2.22266 13.8082 2.24128 13.8732 2.27644 13.9296C2.31159 13.986 2.36189 14.0316 2.4217 14.0613L9.83954 17.7396C9.84242 17.7411 9.84556 17.7415 9.84851 17.7429C9.86228 17.7489 9.87641 17.7542 9.89082 17.7586C9.89746 17.7607 9.90378 17.7633 9.91053 17.765C9.91486 17.7661 9.91895 17.7676 9.92324 17.7686C9.94632 17.7735 9.96983 17.7762 9.99343 17.7766C9.99571 17.7766 9.99803 17.7773 10.0003 17.7773L10.0006 17.7773L10.0009 17.7773C10.0032 17.7773 10.0055 17.7766 10.0078 17.7766C10.0314 17.7762 10.0549 17.7735 10.078 17.7686C10.0823 17.7676 10.0864 17.7661 10.0907 17.765C10.0974 17.7633 10.1037 17.7607 10.1104 17.7586C10.1248 17.7542 10.139 17.7489 10.1527 17.7427C10.1556 17.7414 10.1588 17.741 10.1617 17.7396L17.5792 14.0614C17.639 14.0317 17.6893 13.9861 17.7244 13.9297C17.7596 13.8732 17.7782 13.8082 17.7782 13.7419V6.81276C17.7783 6.80921 17.7773 6.80591 17.7772 6.80238ZM10.0005 3.53376L16.6129 6.81276L13.7093 8.25263L10.1615 6.49252H10.1614L7.09697 4.97355L10.0005 3.53376ZM10.0006 10.0917L3.38797 6.81276L6.29168 5.3729L9.83948 7.13146L12.9042 8.65185L10.0006 10.0917ZM2.94288 7.39062L9.6405 10.7118V16.8423L2.94288 13.5211V7.39062ZM10.3607 16.8423V10.7118L13.3492 9.22983V12.1165C13.3492 12.2112 13.3871 12.302 13.4547 12.369C13.5222 12.436 13.6138 12.4736 13.7093 12.4736C13.8048 12.4736 13.8964 12.436 13.9639 12.369C14.0315 12.302 14.0694 12.2112 14.0694 12.1165V8.87262L17.058 7.39062V13.5212L10.3607 16.8423Z" fill="black"/>
          </svg>`;

        elem.innerHTML = svg + elem.innerHTML;
        elem.setAttribute("data-action", "open-loop-drawer");
        elem.removeAttribute("href");
      }
    });
  }

  selectDropdownButton(target, title) {
    if (!target || !title) return;

    const oldButton = this.element.querySelector(
      '.Product--LoopDropdownItem[aria-selected="true"]'
    );
    oldButton?.setAttribute("aria-selected", "false");

    const button = target.closest(".Product--LoopDropdownButton");
    target.setAttribute("aria-selected", "true");
    button.dataset.selected = true;
    button.querySelector(".Product--LoopDropdownSelect").innerText = title;
    button.setAttribute("aria-expanded", "false");
  }

  handleLoopBoxClick() {
    const target = event.target;
    const selectedBoxes = Array.from(
      this.element.querySelectorAll('.Product--LoopBox[aria-selected="true"]')
    );
    selectedBoxes.forEach((box) => {
      box.setAttribute("aria-selected", "false");
    });

    target.setAttribute("aria-selected", "true");

    const productId = target.dataset.productId;
    const variantId = target.dataset.variantId;
    const sellingPlanId = target.dataset.sellingPlanId;
    this.updateAtcId(variantId, sellingPlanId);

    const productPrice = target.dataset.price;
    const compareAtPrice = target.dataset.compareAtPrice;

    const formattedPrice = productPrice
      ? Shopify.formatMoney(productPrice, window.theme.moneyFormat)
      : productPrice;
    const formattedCompareAtPrice = compareAtPrice && parseInt(compareAtPrice) > 0
      ? Shopify.formatMoney(compareAtPrice, window.theme.moneyFormat)
      : "";

    this.updateTemplatesPrices(formattedPrice, formattedCompareAtPrice);

    const notifyMe = target.dataset.notifyMe ? true : false;
    this.toggleButtonAction(notifyMe, productId, variantId);
    this.enableAllButtons();
  }

  async handleLoopQuantityChange() {
    if (!this.loopQuantityInput) return;
    const button = event.target;
    const action = button.dataset.step;

    // start loader
    bodyScrollLock.disableBodyScroll(bodyScrollLockOptions);
    this.toggleLoader();

    // visially updates loop quantity selector
    this.updateLoopQuantitySelector(button, action);

    // saves current data to variables
    const currentIdsIndex = this.loopQuantityInput.value - 1;
    const loopProductId =
      this.loopQuantityObject.loopProductIds[currentIdsIndex];
    const loopVariantId =
      this.loopQuantityObject.loopVariantIds[currentIdsIndex];
    const loopSellingPlan =
      this.loopQuantityObject.loopSellingPlans[currentIdsIndex];
    const loopHandle = this.loopQuantityObject.loopHandles[currentIdsIndex];
    const notAvailable = this.loopQuantityObject.notAvailable[currentIdsIndex];
    const price = this.loopQuantityObject.prices[currentIdsIndex];
    const notifyMe = this.loopQuantityObject.notifyMe;
    const notifyCurrentProduct = notifyMe && notAvailable === "true";

    // updates atc id
    this.updateAtcId(loopVariantId, loopSellingPlan);

    // updates visuals on product page
    await this.updateTemplate(loopHandle);
    this.updateTemplatesPrices(
      Shopify.formatMoney(price, window.theme.moneyFormat)
    );

    // if notify me is turned of and variant is not available disable button
    // else enable buttons and update its action
    if (notAvailable === "true" && !notifyMe) {
      this.disableAllButtons();
    } else {
      this.enableAllButtons();
      this.toggleButtonAction(
        notifyCurrentProduct,
        loopProductId,
        loopVariantId
      );
    }

    // push history state so this product stays on refresh
    this.pushHistoryState(loopHandle);

    // remove loader and enable scroll
    this.toggleLoader();
    bodyScrollLock.clearAllBodyScrollLocks();
  }

  pushHistoryState(productHandle) {
    const url = window.location.href.toString();
    const index = url.indexOf('/products');

    if (!index) return;

    const newUrl = `${url.substring(0, index + 9)}/${productHandle}`;

    if (newUrl === url) return;

    history.replaceState({}, "", newUrl);
  }

  // saves all loop quanitity arrays to loopQuantityObject
  initLoopQuantityVariables() {
    const dataset = this.loopQuantityInput.dataset;

    this.loopQuantityObject = {
      loopProductIds: dataset.productIds.split(";"),
      loopVariantIds: dataset.variantIds.split(";"),
      loopSellingPlans: dataset.sellingPlanIds.split(";"),
      loopHandles: dataset.productHandles.split(";"),
      notAvailable: dataset.notAvailable.split(";"),
      prices: dataset.prices.split(";"),
      notifyMe: dataset.notifyMe ? true : false,
    };
  }

  // steps up/down loop quantity selector
  updateLoopQuantitySelector(button, action) {
    if (action === "down") {
      this.loopQuantityInput.stepDown();
      this.element.querySelector(
        '.Product--LoopQuantityButton[data-step="up"]'
      ).disabled = false;

      if (this.loopQuantityInput.value === this.loopQuantityInput.min) {
        button.disabled = true;
      } else {
        button.disabled = false;
      }
    } else if (action === "up") {
      this.loopQuantityInput.stepUp();
      this.element.querySelector(
        '.Product--LoopQuantityButton[data-step="down"]'
      ).disabled = false;

      if (this.loopQuantityInput.value === this.loopQuantityInput.max) {
        button.disabled = true;
      } else {
        button.disabled = false;
      }
    }
  }

  toggleLoader() {
    this.element
      .querySelector(".Product--ItemLoader")
      ?.classList.toggle("is-visible");
  }

  updateAtcId(productId, sellingPlanId) {
    if (!productId) return;
    const inputs = Array.from(
      this.element.querySelectorAll("#product-id-input")
    );

    inputs.forEach((input) => {
      input.value = productId;
    });

    // if selling plan should be added to a cart
    if (!sellingPlanId) sellingPlanId = "";
    const sellingPlanInputs = Array.from(
      this.element.querySelectorAll("input#selling_plan")
    );

    sellingPlanInputs.forEach((input) => {
      input.value = sellingPlanId;
    });
  }

  // fetches product from shopify or from product map after it has been saved once
  // unlike updateTemplate it does nothing to the fetched wrapper and returns it instead
  async getTemplate(handle, { priority } = {}) {
    if (!handle) return;

    // set the fetch url
    const urlOrigin = window.location.origin;
    const url = urlOrigin + Shopify.routes.root + "products/" + handle;

    // The map holds the *in-flight* request, not only the finished wrapper, so
    // a click that lands while a prefetch is still running joins that request
    // instead of firing a second identical fetch and waiting all over again.
    // A saved wrapper (saveCurrentProduct) is not a promise - awaiting it is a
    // no-op, so both kinds of entry read the same way.
    let entry = this.productMap.get(url);

    if (!entry) {
      entry = fetch(url, priority ? { priority } : undefined)
        .then((response) => response.text())
        .then((data) => {
          const wrapper = this.getProductWrapperFromHtmlText(data);
          // Response without the wrapper markers - don't keep it, so a later
          // call gets a fresh try rather than a cached nothing.
          if (!wrapper) this.productMap.delete(url);
          return wrapper;
        })
        .catch(() => {
          // Don't cache a failure - let the next call retry.
          this.productMap.delete(url);
          return undefined;
        });
      this.productMap.set(url, entry);
    }

    return await entry;
  }

  async updateTemplate(handle) {
    const newProductWrapper = await this.getTemplate(handle);
    if (!newProductWrapper) return;

    // update the page
    this.updateData(newProductWrapper);
  }

  // gets html text and cuts all unneeded text from it
  // return div containing .Product--Wrapper
  getProductWrapperFromHtmlText(text) {
    const startIndex = text.indexOf("<!-- Product wrapper start -->");
    const endIndex = text.indexOf("<!-- Product wrapper end -->");

    if (startIndex === -1 || endIndex === -1) return;

    const extractedData = text.substring(
      startIndex + "<!-- Product wrapper start -->".length,
      endIndex
    );
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = extractedData;

    return tempDiv;
  }

  // Cylinder payment flow: swap the gallery to the selected product's media
  // using the same fetch + swiper-replace path the purifier / filter flows use.
  async swapCylinderGallery(event) {
    const handle = event.detail && event.detail.handle;
    if (!handle) return;
    const wrapper = await this.getTemplate(handle);
    const gallery = wrapper && wrapper.querySelector(".ProductSlider--Wrapper");
    if (gallery) this.updateTemplatesSwiper(gallery);
  }

  // Cylinder payment flow: the first switch pays for two round trips the later
  // ones don't - fetching the product page and then downloading its images.
  // Warm both caches up front (the flow fires this when the page goes idle) so
  // every switch is as fast as the second one.
  async prefetchCylinderGalleries(event) {
    const detail = event.detail || {};
    const handles = detail.handles || [];

    // In parallel, at low priority: queueing these behind each other means a
    // click landing mid-prefetch inherits the wait for every handle ahead of
    // it, which is the exact case this is supposed to remove. `priority: low`
    // keeps them from competing with the page's own load instead.
    await Promise.all(
      handles.map(async (handle) => {
        const wrapper = await this.getTemplate(handle, { priority: "low" });
        if (handle !== detail.current) this.warmGalleryImages(wrapper);
      })
    );
  }

  // Pull a fetched gallery's first images into the browser cache. They are
  // mirrored onto throwaway Image()s rather than loaded off the detached
  // wrapper, so the candidate picked here is the one the markup resolves to
  // once it is injected - srcset/sizes are set before src for that reason.
  warmGalleryImages(wrapper, limit = 2) {
    if (!wrapper) return;

    const seen = new Set();
    // Scoped to the slide images themselves. `.ProductSlider--Wrapper img` also
    // matches the ruler / label images that sit above the swipers, which would
    // spend the whole budget before reaching a single slide.
    const images = wrapper.querySelectorAll(".ProductSlider--Image[src]");

    for (const image of images) {
      const src = image.getAttribute("src");
      if (seen.has(src)) continue; // mobile + desktop swipers repeat the media
      seen.add(src);

      // Kept on the instance: a loading image with no live reference can be
      // collected, and the request cancelled with it.
      const warm = new Image();
      const sizes = image.getAttribute("sizes");
      const srcset = image.getAttribute("srcset");
      if (sizes) warm.sizes = sizes;
      if (srcset) warm.srcset = srcset;
      warm.src = src;
      this.warmedImages.push(warm);

      if (seen.size >= limit) break;
    }
  }

  updateData(newProductWrapper) {
    // update images
    const swiper = newProductWrapper.querySelector(".ProductSlider--Wrapper");
    this.updateTemplatesSwiper(swiper);

    // update titles
    const title = newProductWrapper.querySelector(".ProductInfo--Title h1");
    this.updateTemplatesTitles(title);

    // update description
    const description = newProductWrapper.querySelector(".ProductDescription");
    this.updateTemplatesDescription(description);

    // update per-product dropdowns (content comes from a dynamic source per product)
    this.updateTemplatesDropdowns(newProductWrapper);

    // update breadcrumbs (product title / category link change per product)
    this.updateTemplatesBreadcrumbs(newProductWrapper);
  }

  updateTemplatesPrices(productPrice, compareAtPrice) {
    if (!productPrice) return;
    console.log(productPrice, compareAtPrice);

    const buttonPrices = Array.from(
      this.element.querySelectorAll(".ProductPage--ATC .button--money")
    );
    buttonPrices.forEach((elem) => {
      elem.innerText = productPrice;
    });

    const productPagePrices = Array.from(
      this.element.querySelectorAll(".changePrice")
    );
    productPagePrices.forEach((elem) => {
      elem.innerText = productPrice;
    });

    const compareAtPriceElem = this.element.querySelector(
      ".ProductInfo--CompareAtPrice"
    );
    if (!compareAtPriceElem) return;
    if (!compareAtPrice) compareAtPrice = "";

    compareAtPriceElem.innerHTML = compareAtPrice;
  }

  updateTemplatesSwiper(swiper) {
    if (!swiper) return;

    const currentSwiper = this.element.querySelector(".ProductSlider--Wrapper");
    currentSwiper.innerHTML = swiper.innerHTML;
    currentSwiper
      .querySelector(".ProductSlider--Thumbnails")
      ?.classList.remove("animatedContent");

    this.initSwiper();
  }

  updateTemplatesTitles(title) {
    if (!title) return;

    title = typeof (title) === "string" ? title : title.innerText;

    const currentTitle = this.element.querySelector(".ProductInfo--Title h1");
    if (currentTitle) {
      currentTitle.innerText = title;
    }

    const currentStickyTitles = Array.from(
      this.element.querySelectorAll(".Product--StickyTitle")
    );
    currentStickyTitles.forEach((stickyTitle) => {
      stickyTitle.innerText = title;
    });
  }

  updateTemplatesDescription(description) {
    if (!description) return;

    const currentDescription = this.element.querySelector(".ProductDescription");
    if (currentDescription) {
      const html = description.innerHTML;
      currentDescription.innerHTML = html;
      // The container is always rendered now, so an empty one has to be hidden
      // explicitly or its padding would show as a gap.
      currentDescription.classList.toggle(
        "ProductDescription--empty",
        !html.trim()
      );
    }
  }

  updateTemplatesDropdowns(newProductWrapper) {
    if (!newProductWrapper) return;

    const newDropdowns = Array.from(
      newProductWrapper.querySelectorAll(".Product--Dropdown[data-block-id]")
    );
    if (!newDropdowns.length) return;

    // match by block id so content lands in the right dropdown even when
    // products use different templates / dropdown counts
    newDropdowns.forEach((newDropdown) => {
      const blockId = newDropdown.dataset.blockId;
      const currentDropdown = this.element.querySelector(
        `.Product--Dropdown[data-block-id="${blockId}"]`
      );
      if (!currentDropdown) return;

      const newInner = newDropdown.querySelector(".DropdownContent__Inner");
      const currentInner = currentDropdown.querySelector(".DropdownContent__Inner");
      if (newInner && currentInner) {
        currentInner.innerHTML = newInner.innerHTML;
      }

      const newTitle = newDropdown.querySelector(".Dropdown--Button h5");
      const currentTitle = currentDropdown.querySelector(".Dropdown--Button h5");
      if (newTitle && currentTitle) {
        currentTitle.innerHTML = newTitle.innerHTML;
      }
    });
  }

  updateTemplatesBreadcrumbs(newProductWrapper) {
    if (!newProductWrapper) return;

    const newBreadcrumbs = Array.from(
      newProductWrapper.querySelectorAll(".product__breadcrumbs .breadcrumbs__list")
    );
    if (!newBreadcrumbs.length) return;

    const currentBreadcrumbs = Array.from(
      this.element.querySelectorAll(".product__breadcrumbs .breadcrumbs__list")
    );

    currentBreadcrumbs.forEach((currentList, index) => {
      const newList = newBreadcrumbs[index];
      if (newList) {
        currentList.innerHTML = newList.innerHTML;
      }
    });
  }

  handleVariantHover() {
    const target = event.target.closest("[data-selectbox-value]");
    if (!target) return;

    const colorWrapper = target.closest(".VariantSelectors");
    const colorLabelElem = colorWrapper.querySelector("[data-selectbox-label]");
    if (!colorLabelElem) return;

    const tempColor = target.dataset.selectboxValue;
    colorLabelElem.innerText = tempColor;
  }

  handleVariantHoverEnd() {
    const target = event.target.closest("[data-selectbox-value]");
    if (!target) return;

    const colorWrapper = target.closest(".VariantSelectors");
    const colorLabelElem = colorWrapper.querySelector("[data-selectbox-label]");
    if (!colorLabelElem) return;

    const currentColor = colorLabelElem.dataset.selectboxColor || colorLabelElem.dataset.selectboxLabel;
    colorLabelElem.innerText = currentColor;
  }

  handleConnectedProductHover() {
    if (!window.matchMedia?.("(min-width: 1025px)")?.matches) return;
    const target = event.target.closest(".connected-product__image-wrapper");
    if (!target) return;

    const wrapper = target.closest(".VariantSelectors");
    const labelElem = wrapper?.querySelector("[data-selectbox-label]");
    if (!labelElem) return;

    const color = target.dataset.connectedProductColor || target.dataset.connectedProductTitle;
    if (!color) return;
    labelElem.innerText = color ;
  }

  handleConnectedProductHoverEnd() {
    if (!window.matchMedia?.("(min-width: 1025px)")?.matches) return;
    const target = event.target.closest(".connected-product__image-wrapper");
    if (!target) return;

    const wrapper = target.closest(".VariantSelectors");
    const labelElem = wrapper?.querySelector("[data-selectbox-label]");
    if (!labelElem) return;

    const current = labelElem.dataset.selectboxColor;
    labelElem.innerText = current;
  }

  clickAtc() {
    const openedZoom = this.element.querySelector('.product__zoom-overlay[aria-hidden="false"]');
    openedZoom?.querySelector('.product__zoom-overlay-close')?.click();

    const button = this.element.querySelector('.ProductPage--ATC:not([data-action="click-atc"])');
    button?.click();
  }

  gasError() {
    const popup = document.querySelector(".gasErrorNotification");
    popup.setAttribute("aria-hidden", "false");
    this.pageOverlayElement.classList.add("is-visible");
    this.pageOverlayElement.addEventListener(
      "click",
      this.onClickOutsideListener
    );
  }

  gasErrorClose() {
    const popup = document.querySelector(".gasErrorNotification");
    popup.setAttribute("aria-hidden", "true");
    this.pageOverlayElement.classList.remove("is-visible");
    this.pageOverlayElement.removeEventListener(
      "click",
      this.onClickOutsideListener
    );
  }

  //when attributes of the button change it starts corresponding updates
  startObserver(_this) {
    // Only the regular gas flow needs the observer: <gas-exchange-us> writes the ATC
    // price itself in GasExchangeUS.updateButtonPrice.
    const isRegular = document.querySelector("gas-exchange") ? true : false;
    const isVariantSelect = document.querySelector(".Product-Section variant-selects") ? true : false;

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type !== "attributes") return;

        switch (mutation.attributeName) {
          case "data-money":
            _this.updateGasSubLastBox();

            if (isRegular) {
              const currentPrice = mutation.target.getAttribute("data-money");
              _this.updateSubscriptionPrice(currentPrice);

              _this.updateGasSub();
              _this.updateButtonPrice();
            } else if (isVariantSelect) {
              window.theme.store === "regular" ? _this.updateButtonPrice() : _this.updateButtonPriceUS();
            }
            break;

          case "data-discount":
            if (isRegular) {
              _this.updateButtonPrice();
            }
            break;

          case "data-quantity":
            _this.updateGasSubLastBox();

            if (isRegular) {
              _this.updateGasSub();
              _this.updateButtonPrice();
            }
            break;
        }
      });
    });

    observer.observe(this.moneyButton, {
      attributes: true,
    });
  }

  updateImage(event) {
    if (event) {
      var imageID = event.detail.new_image;
    } else {
      var imageID = this.options["variant_image_id"];
    }

    var selector = "#Image--" + imageID;
    var imageEl = this.element.querySelector(selector);
    // No carousel when the gallery has a single slide (initSwiper skips it),
    // but update:pdp:image can still be dispatched (e.g. cylinder flow).
    if (imageEl && this.carousel) {
      this.carousel.selectCell(
        parseInt(imageEl.getAttribute("data-position")) + 1
      );
    }
  }

  changeImageQuality() {
    const imageToReveal = this.element.querySelector(
      ".ProductSlider--ImageFirst"
    );
    if (!imageToReveal) return;

    const replaceUrl = imageToReveal
      .getAttribute("data-base-url")
      .replace("width=50", "width=1400x");

    imageToReveal.src = replaceUrl;
  }

  handleScroll() {
    let targetElem = this.productTitle; // default for mobile
    let stickyBar = this.stickyBarMobile;
  
    const footer = document.querySelector(".mainFooter--Wrapper");
    if (!footer) return;
  
    // Switch target/stickyBar for desktop
    if (new Responsive().matchesBreakpoint('lap-and-up')) {
      targetElem = this.productButton;
      stickyBar = this.stickyBarDesktop;
    }
  
    const rect = targetElem.getBoundingClientRect();
    const elementVisible = rect.top < window.innerHeight && rect.bottom > 0;
    const footerVisible = footer.getBoundingClientRect().top < window.innerHeight;
  
    // Show sticky bar only when target is NOT visible and footer is NOT visible
    if (!elementVisible && !footerVisible) {
      stickyBar.classList.add("Product--StickyBarShown");
    } else {
      stickyBar.classList.remove("Product--StickyBarShown");
    }
  }
  

  handleStickyDropdownToggle() {
    if (this.stickyMobileDropdownOpen) {
      this.stickyMobileDropdown.setAttribute("data-expanded", "false");
    } else {
      this.stickyMobileDropdown.setAttribute("data-expanded", "true");
    }

    this.stickyMobileDropdownOpen = !this.stickyMobileDropdownOpen;
  }

  //toggles between selected subscription
  toggleSubscription() {
    const oneTimeButton = this.element.querySelector(
      ".Product--SubscriptionOneTimeButton"
    );
    const oldButton = this.element.querySelector(
      '.Product--SubscriptionButton[aria-selected="true"]'
    );
    const subscriptionButton = event.target.closest(
      ".Product--SubscriptionButton"
    );
    const addToCartBtn = this.element.querySelector(".ProductPage--ATC");

    if (!oneTimeButton || !addToCartBtn) {
      return;
    }

    if (event.target.dataset.value === "one_time") {
      oneTimeButton.setAttribute("aria-selected", "true");
      oldButton.setAttribute("aria-selected", "false");

      this.element.querySelector("#selling_plan").value = "";

      this.moneyButton.setAttribute("data-discount", "");
    } else if (
      event.target.dataset.value !== "one_time" &&
      subscriptionButton
    ) {
      oldButton?.setAttribute("aria-selected", "false");
      oneTimeButton.setAttribute("aria-selected", "false");
      subscriptionButton.setAttribute("aria-selected", "true");

      const id = subscriptionButton.dataset.value;
      if (!id) return;

      this.element.querySelector("#selling_plan").value =
        subscriptionButton.dataset.value;

      const discount = subscriptionButton.getAttribute("data-discount");
      this.moneyButton.setAttribute("data-discount", discount);
    }
  }

  //updates regular subscription prices
  updateSubscriptionPrice(money) {
    const subs = Array.from(
      this.element.querySelectorAll(
        ".Product--SubscriptionPrice[data-discount]"
      )
    );

    subs.forEach((elem) => {
      if (elem.getAttribute("data-discount") !== "") {
        const discount = elem.getAttribute("data-discount");
        const quantity = this.moneyButton.getAttribute("data-quantity");

        let subPrice = 0;
        if (this.element.querySelector("gas-exchange[data-subprice]")) {
          subPrice = this.element
            .querySelector("gas-exchange[data-subprice]")
            .getAttribute("data-subprice");
        }

        const finalMoney = Shopify.formatMoney(
          (money * (100 - discount)) / 100 + subPrice * quantity,
          window.theme.moneyFormat
        );
        if (elem.innerText !== finalMoney) {
          this.animatePriceChange(elem, finalMoney, "animationLeft");
        }
      } else {
        const finalMoney = Shopify.formatMoney(money, window.theme.moneyFormat);
        if (elem.innerText !== finalMoney) {
          this.animatePriceChange(elem, finalMoney, "animationLeft");
        }
      }
    });
  }

  //updates button price
  updateButtonPrice() {
    if (!window.variantInfo.show_price) return;
    if (this.element.querySelector("purifier-flow")) return;
    if (this.element.querySelector("filters-flow")) return;

    const discount = (100 - this.moneyButton.getAttribute('data-discount')) / 100;
    const money = this.moneyButton.getAttribute('data-money');

    let subPrice = 0;

    const isSubPrice = this.element.querySelector('.gasExchangeSubscription[aria-selected="true"]');
    const selectedSubMobile = document.querySelector('.gasMobilePopup .selecteditem[data-selectboxid="gas_product_quantity"]');

    if (isSubPrice && new Responsive().matchesBreakpoint('lap-and-up')) {
      subPrice = parseInt(this.element.querySelector('gas-exchange .selecteditem').getAttribute('data-price'));
    } else if (isSubPrice && selectedSubMobile && new Responsive().matchesBreakpoint('pocket')) {
      subPrice = parseInt(selectedSubMobile.getAttribute('data-price'));
    }

    this.price = Shopify.formatMoney((money * discount) + (subPrice), window.theme.moneyFormat);

    this.buttonPrice.forEach((elem) => {
      if (elem.innerText !== this.price) {
        this.animatePriceChange(elem, this.price, 'animationUp');
      }
    });
  }

  //updates gas subscription prices
  updateGasSub() {
    const subBoxes = Array.from(
      this.element.querySelectorAll(".gasExchange.selecteditem")
    );
    const money = this.moneyButton.getAttribute("data-money");

    let subPrice = 0;
    if (this.element.querySelector("gas-exchange[data-subprice]")) {
      subPrice = this.element
        .querySelector("gas-exchange[data-subprice]")
        .getAttribute("data-subprice");
    }

    subBoxes.forEach((elem) => {
      const tempPriceElem = elem.querySelector(".gasExchange--Price");

      if (elem.classList.contains("gasExchangeProduct")) {
        const tempPrice = Shopify.formatMoney(money, window.theme.moneyFormat);
        if (tempPriceElem.innerHTML !== tempPrice) {
          this.animatePriceChange(tempPriceElem, tempPrice, "animationLeft");
        }
      } else {
        const tempPrice = Shopify.formatMoney(
          parseInt(money) + parseInt(subPrice),
          window.theme.moneyFormat
        );
        if (tempPriceElem.innerHTML !== tempPrice) {
          this.animatePriceChange(tempPriceElem, tempPrice, "animationLeft");
        }
      }
    });
  }

  //updates button price
  updateButtonPriceUS() {
    let thirdOption = false;
    if (document.querySelector("gas-exchange")?.dataset.load) {
      thirdOption = true;
    }

    let kitOption = false;
    if (document.querySelector("gas-exchange")?.dataset.kit) {
      kitOption = true;
    }

    if (window.variantInfo.show_price) {
      const discount =
        (100 - this.moneyButton.getAttribute("data-discount")) / 100;
      let money = this.moneyButton.getAttribute("data-money");

      let subPrice = 0;
      if (
        this.element.querySelector("gas-exchange[data-subprice]") &&
        this.element.querySelector(
          '.gasExchangeSubscription[aria-selected="true"]'
        )
      ) {
        const breakpoint = new Responsive().matchesBreakpoint("lap-and-up");
        if (breakpoint) {
          const subPriceElem = this.element.querySelector(
            "gas-exchange .selecteditem"
          );
          subPrice = parseInt(subPriceElem.getAttribute("data-price"));
        } else {
          const subPriceElem = document.querySelector(
            ".GasExchange--MobileQuantityToggle.selecteditem"
          );
          subPrice = parseInt(subPriceElem.getAttribute("data-price"));
        }
      }

      if (
        (this.element.querySelector("gas-exchange .selecteditem")?.dataset
          .value !== 0 &&
          kitOption &&
          this.element.querySelector(
            '.gasExchangeSubscription[aria-selected="true"]'
          )) ||
        (this.element.querySelector('.gasExchangeOne[aria-selected="true"]') &&
          kitOption &&
          this.element.querySelector("gas-exchange .selecteditem")?.dataset
            .value !== 0)
      ) {
        money = document.querySelector("gas-exchange").dataset.singleprice;
      }

      if (thirdOption) {
        this.price = Shopify.formatMoney(subPrice, window.theme.moneyFormat);
      } else {
        this.price = Shopify.formatMoney(
          money * discount + subPrice,
          window.theme.moneyFormat
        );
      }

      this.buttonPrice.forEach((elem) => {
        if (elem.innerText !== this.price) {
          this.animatePriceChange(elem, this.price, "animationUp");
        }
      });
    }
  }

  //updates gas subscription prices
  updateGasSubUS() {
    const subBoxes = Array.from(
      this.element.querySelectorAll(".gasExchange.selecteditem")
    );
    const money = this.moneyButton.getAttribute("data-money");

    let subPrice = 0;
    if (this.element.querySelector("gas-exchange[data-subprice]")) {
      subPrice = this.element
        .querySelector("gas-exchange[data-subprice]")
        .getAttribute("data-subprice");
    }
  }

  //updates gas subscription price (only the last box)
  updateGasSubLastBox() {
    if (!document.querySelector(".gasExchangeSubscription")) return;

    const gasPrice = document.querySelectorAll(".gasExchangeSubscription .gasExchange--Price");
    let subPrice = "";
    const money = this.moneyButton.getAttribute("data-money");
    if (new Responsive().matchesBreakpoint("pocket")) {
      subPrice = document.querySelector(".gasMobilePopup .selecteditem").dataset
        .price;
    } else {
      subPrice = document.querySelector(
        ".RevolutionSelectbox--GasExchange .selecteditem"
      ).dataset.price;
    }
    let tempMoney = 0;
    if (document.querySelector('gas-exchange[data-load="true"]')) {
      tempMoney = Shopify.formatMoney(
        parseInt(subPrice),
        window.theme.moneyFormat
      );
      const buttons = document.querySelectorAll(
        ".Product--Wrapper .button--money"
      );
      buttons.forEach((item) => {
        item.innerHTML = tempMoney;
      });
    } else {
      tempMoney = Shopify.formatMoney(
        parseInt(money) + parseInt(subPrice),
        window.theme.moneyFormat
      );
    }

    gasPrice.forEach((item) => {
      if (item.innerHTML !== tempMoney) {
        this.animatePriceChange(item, tempMoney, "animationLeft");
      }
    });
  }

 

  //animation for changing prices
  animatePriceChange(elem, price, animation) {
    const duration = 250; //animation last double of this amount
    const fill = "forwards";
    const easing = "ease-in-out";

    if (animation === "animationUp") {
      //object moving up
      var elementMove = [
        // keyframes
        { transform: `translateY(0) scale(1)`, opacity: `1` },
        { transform: `translateY(-10px) scale(0.95)`, opacity: `0.75` },
        { transform: `translateY(-7px) scale(0.9)`, opacity: `0` },
      ];
      elem.animate(elementMove, {
        // timing options
        duration: duration,
        fill: fill,
        easing: easing,
      });

      //after first animation change price and move object from down to starting position
      setTimeout(() => {
        elem.innerText = price;
        var elementMove = [
          // keyframes
          { transform: `translateY(7px) scale(0.9)`, opacity: `0` },
          { transform: `translateY(10px) scale(0.95)`, opacity: `0.75` },
          { transform: "translateY(0px) scale(1)", opacity: "1" },
        ];
        elem.animate(elementMove, {
          // timing options
          duration: duration,
          fill: fill,
          easing: easing,
        });
      }, duration);
    } else if (animation === "animationLeft") {
      //object moving left
      var elementMove = [
        // keyframes
        { transform: `translateX(0) scale(1)`, opacity: `1` },
        { transform: `translateX(-15px) scale(0.85)`, opacity: `0.75` },
        { transform: `translateX(-10px) scale(0.75)`, opacity: `0` },
      ];
      elem.animate(elementMove, {
        // timing options
        duration: duration,
        fill: fill,
        easing: easing,
      });

      //after first animation change price and move object from right to starting position
      setTimeout(() => {
        elem.innerText = price;
        var elementMove = [
          // keyframes
          { transform: `translateX(10px) scale(0.75)`, opacity: `0` },
          { transform: `translateX(15px) scale(0.85)`, opacity: `0.75` },
          { transform: "translateX(0px) scale(1)", opacity: "1" },
        ];
        elem.animate(elementMove, {
          // timing options
          duration: duration,
          fill: fill,
          easing: easing,
        });
      }, duration);
    }
  }

  saveRecentlyViewedProducts() {
    const maxCachedAttr = this.element.getAttribute("data-max-cached");
    const maxCached = parseInt(maxCachedAttr);

    // If maxCached is invalid (null, undefined, or NaN), skip saving to avoid data corruption
    if (!maxCached || isNaN(maxCached)) {
      console.warn("data-max-cached attribute is missing or invalid, skipping recently viewed save");
      return;
    }

    const storageKey = "recently_viewed_products";
    try {
      let viewed = JSON.parse(localStorage.getItem(storageKey)) || [];

      viewed = viewed.filter(handle => handle !== this.currentHandle);

      viewed.unshift(this.currentHandle);

      if (viewed.length > maxCached) {
        viewed = viewed.slice(0, maxCached + 1);
      }

      localStorage.setItem(storageKey, JSON.stringify(viewed));
    } catch (error) {
      console.error("Error saving recently viewed products:", error);
    }
  }
}

customElements.define("product-component", ProductElement);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    this.initVariables();
    this.initCurrentVariant();
  }

  connectedCallback() {
    this.delegateBody.on("quantity:changed", this.onQuantityChange.bind(this));

    var selectboxes = this.element.querySelectorAll("select, input");
    selectboxes.forEach((item) => {
      item.addEventListener("change", this.onVariantChange.bind(this));
    });
  }

  initVariables() {
    this.type = this.element.getAttribute("data-type");
    this.productID = this.element.getAttribute("data-product-id");
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
  }

  initCurrentVariant() {
    this.updateOptions();
    this.updateMasterId();
    this.updateMedia();
    this.upadateSelectedVariantTitle();
  }

  onQuantityChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton();
  }


  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton();
    this.updatePickupAvailability();

    this.updateMedia();
    this.updateURL();
    this.updateVariantInput();
    this.renderProductInfo();
    this.updateButtonAtributePrice();
    this.upadateSelectedVariantTitle();
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select, input:checked"),
      (select) => select.value
    );
  }

  updateMasterId() {
    if (!this.options.length) return this.currentVariant = undefined;

    this.currentVariant = this.getVariantData().find((variant) => {
      return this.options.every(option => variant.options.includes(option));
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const newMedia = this.currentVariant.featured_media.id;
    if (!newMedia) return;
    this.element.dispatchEvent(
      new CustomEvent("update:pdp:image", {
        bubbles: true,
        detail: { new_image: newMedia },
      })
    );
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {

    const productForms = document.querySelectorAll(
      `#product-form-${this.productID}, #product-form-installment`
    );

    const regex = new RegExp("/^[0-9]+$/");

    productForms.forEach((productForm) => {
      if (productForm.querySelector('input[name="id"]')) {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      } else {
        const input = productForm.querySelector('input#product_id_with_gas') || productForm.querySelector('input#mainProduct');
        input.value = this.currentVariant.id;
        input.name = `${this.currentVariant.id}_id`
        input.dataset.id = this.currentVariant.id;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      }

    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const id = ".ProductInfo--Prices";
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destinations = document.querySelectorAll(id);
        const source = html.querySelector(id);


        if (source && destinations) {
          destinations.forEach((destination) => {
            destination.innerHTML = source.innerHTML;
          });
        }

        const quantityButton = document.querySelector('.QuantityHandler');
        if (quantityButton) {
          const source = html.querySelector('.QuantityHandler');
          if (source && quantityButton) quantityButton.innerHTML = source.innerHTML;
        }
        this.toggleAddButton();
      });
  }



  toggleAddButton() {
    if (document.querySelector("purifier-flow")) return;

    const addButton = document.querySelector(".ProductPage--ATC");
    const stickyButton = document.querySelector('.Product--StickyVariantButton');
    const stickyButtonMobile = document.querySelector('.Product--StickyBarMobile .ProductPage--ATC');

    if (!addButton) return;

    let buySvg = "";
    if (window.variantInfo.show_icon) {
      buySvg = `<svg class="Svg Svg--basket mr-sl" width="20" height="20" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M25.31 5.19547C25.1687 5.02127 24.9568 4.91946 24.7325 4.91797H9.11751L9.60501 6.41797H23.75L21.7475 15.418H10.4975L7.07001 4.56547C6.99476 4.33174 6.80986 4.14965 6.57501 4.07797L3.50001 3.13297C3.24278 3.05393 2.96292 3.11812 2.76584 3.30137C2.56877 3.48461 2.48443 3.75907 2.54459 4.02137C2.60476 4.28366 2.80028 4.49393 3.05751 4.57297L5.75001 5.39797L9.19251 16.273L7.96251 17.278L7.86501 17.3755C7.2374 18.0987 7.21221 19.1659 7.80501 19.918C8.21952 20.4221 8.84817 20.7002 9.50001 20.668H22.0175C22.4317 20.668 22.7675 20.3322 22.7675 19.918C22.7675 19.5038 22.4317 19.168 22.0175 19.168H9.38001C9.20436 19.162 9.0446 19.0646 8.95873 18.9113C8.87286 18.7579 8.87334 18.5709 8.96001 18.418L10.7675 16.918H22.3475C22.705 16.9267 23.0189 16.6818 23.0975 16.333L25.475 5.83297C25.5212 5.6064 25.4603 5.37117 25.31 5.19547ZM20.75 25.168C21.682 25.168 22.4375 24.4125 22.4375 23.4805C22.4375 22.5485 21.682 21.793 20.75 21.793C19.818 21.793 19.0625 22.5485 19.0625 23.4805C19.0625 24.4125 19.818 25.168 20.75 25.168ZM12.185 23.4805C12.185 24.4125 11.4295 25.168 10.4975 25.168C9.56553 25.168 8.81001 24.4125 8.81001 23.4805C8.81001 22.5485 9.56553 21.793 10.4975 21.793C11.4295 21.793 12.185 22.5485 12.185 23.4805Z" fill="#121212"></path></svg>`;
    }

    if (this.currentVariant.available) {
      const price = Shopify.formatMoney(this.currentVariant.price, window.theme.moneyFormat);
      const stickyPrice = this.getRoundedMoney(this.currentVariant.price);

      this.setButtonPrice(addButton, price, buySvg)
      this.setStickyButtonPrice(stickyButton, stickyPrice);
      this.setStickyButtonPrice(stickyButtonMobile, stickyPrice);

      return;
    }

    if (document.querySelector('.ProductActions[data-notify]')) {
      const notifySvg = `<svg class="mr-sl" width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M18.2778 3.33337H2.72223C2.10858 3.33337 1.61111 3.83084 1.61111 4.44449V15.5556C1.61111 16.1692 2.10858 16.6667 2.72223 16.6667H18.2778C18.8914 16.6667 19.3889 16.1692 19.3889 15.5556V4.44449C19.3889 3.83084 18.8914 3.33337 18.2778 3.33337ZM17.4222 15.5556H3.64445L7.53334 11.5334L6.73334 10.7612L2.72223 14.9112V5.28893L9.62778 12.1612C10.0612 12.592 10.7611 12.592 11.1944 12.1612L18.2778 5.11671V14.8389L14.1889 10.75L13.4056 11.5334L17.4222 15.5556ZM17.3778 4.44449H3.45L10.4111 11.3723L17.3778 4.44449Z" fill="white"/>
        </svg>`;

      this.setButtonToNotifyMe(addButton, notifySvg)
      this.setStickyButtonToNotifyMe(stickyButton, notifySvg)
      this.setStickyButtonToNotifyMe(stickyButtonMobile, notifySvg)
    } else {
      this.setButtonToDisabled(addButton, buySvg);
      this.setButtonToDisabled(stickyButton, buySvg);
      this.setButtonToDisabled(stickyButtonMobile, buySvg);
    }
  }

  setButtonToNotifyMe(button, notifySvg) {
    if (!button) return;
    button.classList.add('u-p3');
    button.removeAttribute('type');
    button.dataset.action = 'open-bis';
    button.dataset.variant = this.currentVariant.id;

    const buttonText = button.querySelector("button--text");
    if (!buttonText) return;

    buttonText.classList.add('u-p3');
    buttonText.innerHTML = notifySvg + " " + window.variantStrings.notify_me;
  }

  setStickyButtonToNotifyMe(button, notifySvg) {
    if (!button) return;

    const buttonText = button.querySelector('.button--text');
    buttonText.innerHTML = notifySvg + " " + window.variantStrings.notify_me;

    const buttonPrice = button.querySelector('.button--money');
    buttonPrice.style.display = 'none';
  }

  setButtonToDisabled(button, buySvg) {
    button.setAttribute("disabled", "disabled");
    button.classList.add("ProductCard--Sold__Out");

    const buttonText = button.querySelector("button--text");
    if (!buttonText) return;

    buttonText.classList.add('u-p3');
    buttonText.innerHTML = buySvg + window.variantStrings.soldOut;

    const buttonPrice = button.querySelector('.button--money');
    if (!buttonPrice) return;

    buttonPrice.querySelector('.button--money').style.display = 'none';
  }

  setButtonPrice(button, price, buySvg) {
    if (!button || !price) return;

    button.setAttribute('type', 'submit');
    button.removeAttribute("disabled");
    button.classList.remove("ProductCard--Sold__Out");
    button.dataset.action = button.getAttribute('data-old-action');

    const buttonText = button.querySelector("button--text");
    const buttonPrice = button.querySelector("button--money");

    if (buttonText) buttonText.innerText = `${buySvg}${window.variantStrings.addToCart} `
    if (buttonText) buttonPrice.innerText = price;
  }

  setStickyButtonPrice(button, price) {
    if (!button) return;

    button.querySelector('.button--text').innerHTML = `${window.variantStrings.addToCart}`;
    const buttonMoney = button.querySelector('.button--money');

    if (!buttonMoney || !price) return
    buttonMoney.innerText = price;
    buttonMoney.style.display = 'block';
  }

  getRoundedMoney(amountInCents) {
    const numericAmount = Number(amountInCents);
    if (!Number.isFinite(numericAmount)) return "";

    const roundedAmount = Math.ceil(numericAmount / 100) * 100;
    return Shopify.formatMoney(roundedAmount, window.theme.moneyFormat).replace(/([.,]00)\b/, "");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);

    return this.variantData;
  }

  upadateSelectedVariantTitle() {
    try {
      const selectedVariantTitleElement = this.element.querySelector('.VariantSelect--SelectedVariantTitle');
      if (!selectedVariantTitleElement) return;

      const colorLabelFromData = selectedVariantTitleElement.dataset.selectboxLabel;
      const colorLabel = colorLabelFromData || this.currentVariant?.options?.[0] || this.currentVariant?.title;

      if (colorLabel) {
        selectedVariantTitleElement.innerText = colorLabel;
      }
    } catch (e) {
      console.log("Variant has no title to change or:", e);
    }
  }

  updateButtonAtributePrice() {
    const money = this.currentVariant.price;
    const moneyButton = document.querySelector(".Product--AddToCartButton[data-money]");

    if (money !== "") {
      moneyButton.setAttribute("data-money", money);
    }
  }
}
customElements.define("variant-selects", VariantSelects);

class ProductVariantSelector extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
  }

  connectedCallback() {
    this.delegateElement.on("click", '[data-action="select-variant-option"]', this.onSelectVariantOption.bind(this));
    this.delegateElement.on("click", '[data-action="add-to-cart"]', this.closeDrawer.bind(this));
    this.syncVariantIdToForm();
  }

  disconnectedCallback() {
    this.delegateElement.destroy();
  }

  getVariantData() {
    const script = this.querySelector('[type="application/json"]');
    if (script && !this.variantData) {
      this.variantData = JSON.parse(script.textContent);
    }
    return this.variantData || [];
  }

  getSelectedOptions() {
    const inputs = this.querySelectorAll(".variant-selectors__input");
    return Array.from(inputs, (input) => input.value);
  }

  getCurrentVariant() {
    const options = this.getSelectedOptions();
    const data = this.getVariantData();
    if (!options.length) return null;
    return data.find((variant) => {
      return (
        variant.options &&
        variant.options.length === options.length &&
        variant.options.every((opt, i) => opt === options[i])
      );
    }) || null;
  }

  syncVariantIdToForm() {
    const variant = this.getCurrentVariant();
    const form = this.querySelector("form");
    if (!form || !variant) return;

    const idInput = form.querySelector('[name="id"]');
    if (!idInput) return;
    
    idInput.value = String(variant.id);
    if (idInput.dataset.sku !== undefined) {
      idInput.dataset.sku = variant.sku || "";
    }
  }

  onSelectVariantOption(evt) {
    const button = evt.target.closest("[data-action=\"select-variant-option\"]");
    if (!button) return;

    const position = button.getAttribute("data-option-position");
    const value = button.getAttribute("data-option-value");
    const select = button.closest(".variant-selectors__select");

    if (!select) return;

    const input = select.querySelector(".variant-selectors__input[data-option-position=\"" + position + "\"]");
    if (!input || input.value === value) return;

    input.value = value;
    select.querySelectorAll("[data-action=\"select-variant-option\"]").forEach((btn) => {
      btn.setAttribute("aria-selected", btn.getAttribute("data-option-value") === value ? "true" : "false");
    });

    const titleValueSpan = select.querySelector(".variant-selectors__title-value");
    if (titleValueSpan) titleValueSpan.textContent = value;

    this.syncVariantIdToForm();
  }

  closeDrawer() {
    setTimeout(() => {
      this.element.dispatchEvent(new CustomEvent("close:product:drawer", { bubbles: true }));
    }, 300);
  }
}
customElements.define("product-variant-selector", ProductVariantSelector);

class BlogSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    this.blogWrapper = this.element.querySelector("#BlogArticleWrapper");
    this.blogElement = this.element.querySelectorAll(".BlogArticle");



    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    if (this.options.layout == "masonary") {
      window.addEventListener('resize', this.setupGetInspredGrid.bind(this));
      document.addEventListener('DOMContentLoaded', this.setupGetInspredGrid.bind(this));
    }
  }

  setupGetInspredGrid() {
    const el = this.blogWrapper;
    if (el.lengtth == 0) {
      return;
    }

    var currentClientWidth = Math.max(
      document.body.offsetWidth,
      document.documentElement.offsetWidth,
      document.documentElement.clientWidth
    );


    const items = this.blogElement;
    const lastItem = items[items.length - 1];
    if (items.length == 0) {
      return;
    }

    const itemWidth = parseFloat(window.getComputedStyle(lastItem).width);

    let maxItemHeight = lastItem.offsetHeight;
    const numberOfCols = Math.floor(currentClientWidth / itemWidth);

    let isSmall = false;
    let rowTemp = 0;
    let maxHeight = 0;
    items.forEach((item, i) => {
      let rowHeiht = 0;


      const col = i % numberOfCols;
      const row = Math.floor(i / numberOfCols);

      /*calculate height of row, global max item height */
      if (row > 0) {
        for (let i = 1; i <= row; i++) {
          const preParalelIndex = col + (i - 1) * numberOfCols;
          const paralelEl = items[preParalelIndex];
          rowHeiht = rowHeiht + paralelEl.offsetHeight;

          maxItemHeight =
            maxItemHeight < paralelEl.offsetHeight
              ? paralelEl.offsetHeight
              : maxItemHeight;
        }

        maxHeight = maxHeight < rowHeiht ? rowHeiht : maxHeight;
      }

      /* initialize is small flag for that row */
      if (row !== rowTemp) {
        rowTemp = row;

        isSmall = row % 2 != 0;
      }

      const left = col * itemWidth;

      const top = rowHeiht.toFixed(2);

      if (top !== "NaN") {
        const isHidden = false; //row > numberOfRows-2 && col%2 == 0; //hidden last two blog posts, overflow problem

        if (!isHidden) {
          const padding = isSmall
            ? `${90 + Math.random() * 20}%`
            : `${110 + Math.random() * 40}%`;

          item.querySelector(".BlogItem--Wrapper").style.paddingTop =
            padding + "px";

          const myitem = item;
          myitem.style.cssText = "left:" + left + "px;top:" + top + "px";

          isSmall = !isSmall;
        }
      }
    });

    var elHeight = parseInt(maxHeight) + parseInt(maxItemHeight);
    el.style.cssText =
      "width:" +
      numberOfCols * itemWidth +
      "px;height:" +
      elHeight +
      "px;margin:auto";
  }
}
customElements.define("blog-section", BlogSection);

class SearchBar extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.searchElement = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.searchInputElement = this.element.querySelector('[name="q"]');
    this.queryMap = {};
    this.searchResultsElement = this.element.querySelector(".SearchInitial");
    if (new Responsive().matchesBreakpoint('lap-and-up')) {
      this.pageOverlayElement = document.querySelector(".pageOverlay");
    } else {
      this.pageOverlayElement = document.querySelector(".searchOverlay");
    }

    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    if (this.searchResultsElement) {
      this.initialSearchLayout = this.searchResultsElement.cloneNode(true);
    }

    if (window.theme.showRecentSearches) {
      this.getRecentSearches();
    }
    if (window.theme.showSuggestedSearches) {
      this.getSuggestedSearches();
    }
    this.carouselElement = this.element.querySelector(".SearchCollection");
    if (this.carouselElement) {

      this.carousel = new RevolutionSwiper(this.carouselElement);

    }
    new AddToCart(this.element);
    document.documentElement.style.setProperty(
      "--search-header-height",
      `${this.searchInputElement.offsetHeight + 48}px`
    );

    if (window.theme.enableAnimations) {
      new RevolutionAnimation(this.element);
    }

    this.bindEvents();
  }

  bindEvents() {
    this._onInputListener = this.debounce(this.onInput.bind(this), 450);

    this.delegateBody.on(
      "click",
      '[data-action="open-search"]',
      this.openSearch.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="close-search"]',
      this.closeSearch.bind(this)
    );
    this.delegateElement.on(
      "keydown",
      (event)=>{
        if (event.key === "Escape") {
          this.closeSearch();
        }
      }
    );

    this.searchInputElement.addEventListener("input", this._onInputListener);

    this.delegateElement.on(
      "click",
      '[data-action="search-string"]',
      this.onInput.bind(this)
    );

    this.delegateElement.on(
      "keypress",
      '[data-action="search-string"]',
      this.onInput.bind(this)
    );

    this.delegateElement.on(
      "click",
      '[data-action="clear-search"]',
      this.clearSearch.bind(this)
    );

    this.delegateBody.on("menu:open", this.closeSearch.bind(this));
    this.delegateBody.on('search:open', this.openSearch.bind(this));
    this.delegateBody.on("close:search", this.closeSearch.bind(this));
  }

  initCarousel() {

    var carousel = this.searchResultsElement.querySelector(
      "[data-swiper-settings]"
    );
    if (carousel) {
      this.newCarousel = new RevolutionSwiper(carousel);
    }
    this.element.dispatchEvent(
      new CustomEvent("favorites:toggle", { bubbles: true })
    );

  }

  debounce(fn, delay) {
    var _this0 = this;

    var timer = null;

    return function () {
      for (
        var _len = arguments.length, args = Array(_len), _key = 0;
        _key < _len;
        _key++
      ) {
        args[_key] = arguments[_key];
      }

      clearTimeout(timer);

      timer = setTimeout(function () {
        fn.apply(_this0, args);
      }, delay);
    };
  }

  clearSearch() {
    this.clearBtn = this.element.querySelector(".clearSeacrh");
    this.inputValue = this.element.querySelector(".SearchInput");

    this.inputValue.value = "";
    this.clearBtn.style.display = "none";

    this.resetSearch();
  }

  openSearch(event) {
    event.preventDefault();
    if (this.isOpen) {
      this.closeSearch();
      return;
    }
    var _this = this;

    if (
      !this.searchElement.querySelector(".SearchSlide ") &&
      this.options["product"] &&
      this.options["collection"] == ""
    ) {

      this.loadRecommendations();
    }


    document
      .querySelector(".SearchWrapper")
      .setAttribute("aria-hidden", false);

    this.pageOverlayElement.classList.add("is-visible");
    this.closeListener = _this.closeSearch.bind(this);
    this.isOpen = true;

    setTimeout(() => {
      _this.searchInputElement.focus();
    }, 200);

    this.element.dispatchEvent(
      new CustomEvent("menu:close", { bubbles: true })
    );
    this.pageOverlayElement.addEventListener("click", _this.closeListener);
    const focus = document.querySelector('search-bar [data-scrollable]');
    bodyScrollLock.disableBodyScroll(
      focus,
      bodyScrollLockOptions
    );
  }

  closeSearch() {

    event.preventDefault();
    var _this = this;
    if (!this.isOpen) {
      return;
    }

    document.body.querySelectorAll(".SearchWrapper").forEach((item, i) => {
      item.setAttribute("aria-hidden", true);
    });
    _this.pageOverlayElement.classList.remove("is-visible");
    document.body.querySelector(
      "#shopify-section-header"
    ).style.backgroundColor = "transparent";


    bodyScrollLock.clearAllBodyScrollLocks();
    this.isOpen = false;
  }

  onInput(event) {
    this.clearBtn = this.element.querySelector(".clearSeacrh");

    this.lastInputValue = event.target.value;
    var passTrough = false;
    var _this = this;

    // Hide search results element
    this.searchResultsElement.style.opacity = 0;

    // Handle data-value attribute if present
    if (event.target.getAttribute("data-value") && _this.lastInputValue === 0) {
      this.lastInputValue = event.target.getAttribute("data-value");
      const el = _this.searchElement.querySelector(".SearchInput");
      passTrough = true;
      el.setAttribute("value", _this.lastInputValue);
      el.value = _this.lastInputValue;
    } else {
      // Handle Enter key press and empty input value
      if (event.keyCode === 13) {
        return;
      }
      if (this.lastInputValue === "") {
        this.initialSearchLayout.style.opacity = 0;
        this.clearSearch();
        return;
      }
    }

    // Set the input value and display/hide the clear button
    this.inputValue = this.element.querySelector(".SearchInput").value;
    if (this.inputValue == "") {
      this.clearBtn.style.display = "none";
    } else {
      this.clearBtn.style.display = "flex";
    }

    // Set up query options for fetch requests
    var queryOptions = {
      method: "GET",
      credentials: "same-origin",
    };

    // Add suggested collections query if option is enabled
    if (_this.options && _this.options["suggestedCollections"]) {
      const url = `${window.routes.localeRootUrl}/search/suggest.json?q=${encodeURIComponent(
        this.lastInputValue
      )}&resources[type]=collection&resources[limit]=1`;
      var queries = [fetch(url, queryOptions)];
    }

    // Add product and/or other search queries based on search mode
    if (window.theme.searchMode !== "product") {
      const url = `${window.routes.localeRootUrl}/search?view=ajax&q=${encodeURIComponent(
        this.lastInputValue
      )}&type=${window.theme.searchMode.replace("product,", "")}`;
      queries.push(fetch(url, queryOptions));
    }

    const url = `${window.routes.localeRootUrl}/search?view=ajax&q=${encodeURIComponent(
      this.lastInputValue
    )}&type=product`;
    queries.push(fetch(url, queryOptions));

    // Set query map entry for the last input value
    this.queryMap[this.lastInputValue] = true;

    Promise.all(queries)
      .then(function (responses) {
        // Handle case where input value has changed before query has finished
        if (
          _this.lastInputValue !== event.target.value &&
          passTrough === false
        ) {
          return;
        }

        // Delete query map entry for the current input value
        delete _this.queryMap[event.target.value];

        // Get the text content of each response
        Promise.all(responses.map((response) => response.text()))
          .then(function (contents) {
            // Determine if any other results exist
            var resultExistsObject = [],
              resultExists,
              collectionHTML = document.createElement("div");

            contents.forEach((item, i) => {
          
              if (item.includes("collections")) {
                // Handle collections results
                let collectionInner = "",
                  collectionObject = JSON.parse(item);
                if (collectionObject.resources.results.collections.length > 0) {
                  collectionHTML.innerHTML = _this.layouts(
                    _this.lastInputValue,
                    false,
                    false,
                    "collectionLayout"
                  );
                  resultExistsObject.push(true);
                  collectionObject.resources.results.collections.forEach(function (
                    entry
                  ) {
                    collectionInner += _this.layouts(
                      entry.url,
                      entry.featured_image.url,
                      entry.title,
                      "collectionItem"
                    );
                  });
                  collectionHTML.querySelector(".Segment__Content").innerHTML =
                    collectionInner;
                } else {
                  resultExistsObject.push(false);
                  collectionHTML.innerHTML = _this.layouts(
                    false,
                    false,
                    false,
                    "collectionItemNoResults"
                  );
                }

                contents[i] = collectionHTML.innerHTML;
              } else {
                // Handle product and other search results
                if (item.includes("js-noresult")) {
                  resultExistsObject.push(false);
                } else {
                  resultExistsObject.push(true);
                }
              }
            });

            // Determine if any results exist
            if (resultExistsObject.includes(true)) {
              resultExists = true;
            } else {
              resultExists = false;
            }

            // Display recent searches if option is enabled
            if (window.theme.showRecentSearches) {
              _this.recentSearches();
            }

            // Load data based on whether results exist or not
            _this.loadData(resultExists, contents);
          });
      });
  }

  loadData(resultExists, data) {
    // Check if search results element exists
    if (!this.searchResultsElement) {
      throw new Error("Search results element not found");
    }

    // Get a reference to the search results element
    const searchResultsElement = this.searchResultsElement;

    // Display search results if there are any
    if (resultExists) {
      // Create a block element to hold the first two items
      const block = document.createElement("div");
      let tempContent = "";

      // Loop through the data and add the first two items to the block element
      // Add the rest of the items to a temporary variable
      data.forEach((item, i) => {
        if (i < 2) {
          block.innerHTML += item;
        } else {
          tempContent += item;
        }
      });

      // Combine the block element and the rest of the items into one HTML string
      const content = `<div class="Collection--Article">${block.innerHTML}</div>${tempContent}`;
      searchResultsElement.innerHTML = `<div class='SearchLayout--2items'>${content}</div>`;
    } else {
      // Display a message if there are no search results
      const tempElement = document.createElement("div");
      tempElement.innerHTML = data[1];
      const template = tempElement.querySelector("template")?.content.firstElementChild?.cloneNode(true);

      // Check if layout type option exists
      const layoutType = this.options && this.options["noResultcollection"] ? "noResults" : "noResultsNoSuggestions";

      searchResultsElement.innerHTML = this.layouts(template?.innerHTML || "", false, false, layoutType);
    }

    // Set search results element attributes and initialize carousel
    searchResultsElement.style.display = "flex";
    searchResultsElement.setAttribute("aria-hidden", "false");
    this.initCarousel();
    this.element.dispatchEvent(new CustomEvent("favorites:toggle", { bubbles: true }));
    searchResultsElement.style.opacity = 1;

    // Check if animation is enabled
    if (window.theme.enableAnimations) {
      // Initialize animation
      new RevolutionAnimation(searchResultsElement);
    }
  }


  layouts(string1, string2, string3, type) {
    var template = "";
    switch (type) {
      case "collectionLayout":
        template = `<div class='SearchLayout__Section--collections'>
          <div class='SearchSegmentHeader'>
            <span class='u-s3'>${window.languages.collections}</span>
          </div>
          <div class='Segment__Content'>${string3}</div>
        </div>`;
        break;

      case "collectionItem":
        if (string2) {
          template = `<a href='${string1}' class='CollectionSearchItem mt-l u-p3 SearchSlide' >
            <h5 class='u-p3 hoverLinks'>${string3}</h5>
        </a>`;
        } else {
          template = `<a href='${string1}' class='CollectionSearchItem u-p3 SearchSlide' >
            <div class='SearchCollectionContent'>
              <h5 class='u-p3 hoverLinks'>${string3}</h5>
            </div>
        </a>`;
        }

        break;

      case "collectionItemNoResults":

        template = `<div class='searchSegment'>
          <div class="SearchSegmentHeader">
            <span class=" u-s3">${window.languages.collections}</span>
          </div>
          <div class="Segment__Content">
            <p class="SegmentNoResult u-p3">${window.languages.no_results}</p>
          </div>
        </div>`;
        break;

      case "noResults":
        template = `<div class="SearchLayout__Section Search--Recommendations-noResults">${string1}</div>\n`;
        break;

      case "noResultsNoSuggestions":
        template = `<div class="SearchLayout__Section Search--Recommendations-noResultsAll">${string1}</div>\n`;
        break;
    }

    return template;
  }

  loadRecommendations() {
    var _this = this,
      product_to_search = _this.options["product"],
      url =
        window.routes.localeRootUrl +
        "/recommendations/products?section_id=search_suggested&product_id=" +
        product_to_search +
        "&limit=8";

    return fetch(url).then(function (response) {
      return response.text().then(function (content) {
        var container = document.createElement("div");
        var contentjq = document.createElement("div");
        contentjq.innerHTML = content;
        container.innerHTML = contentjq.innerHTML;
        const newSwiper = _this.element.querySelector(
          ".SearchInitial--Products"
        );
        newSwiper.innerHTML = container.querySelector(
          ".ProductRecommendations"
        ).innerHTML;
        _this.initCarousel();
        if (window.theme.enableAnimations) {
          new RevolutionAnimation(newSwiper);
        }

        new AddToCart(_this.element);
      });
    });
  }

  resetSearch() {
    let initialProducts = this.searchResultsElement.querySelector(
      ".SearchInitial--Products"
    ),
      initialLayout = this.initialSearchLayout.querySelector(
        ".SearchInitial--Recents"
      );

    this.searchResultsElement.classList.remove("SearchInitial--SecondView");
    this.searchResultsElement.style.display = "";

    if (initialLayout) {
      initialLayout.style.opacity = 0;
    }
    if (initialProducts) {
      initialProducts.style.opacity = 0;
    }

    this.searchResultsElement.innerHTML = this.initialSearchLayout.innerHTML;

    const el = this.searchElement.querySelector(".Search__Form");
    el.value = "";
    el.removeAttribute("value");
    this.searchElement.querySelector(".SearchInput").value = "";
    this.searchResultsElement.setAttribute("aria-hidden", "false");

    if (window.theme.showRecentSearches) {
      this.getRecentSearches();
    }
    if (window.theme.showSuggestedSearches) {
      this.getSuggestedSearches();
    }
    if (this.options["product"] && this.options["collection"] == "") {
      this.loadRecommendations();
    }
    if (window.theme.enableAnimations) {
      new RevolutionAnimation(this.element);
    }

    initialLayout = this.element.querySelector(".SearchInitial--Recents");
    if (initialLayout) {
      initialLayout.style.opacity = 1;
    }
    if (initialProducts) {
      initialProducts.style.opacity = 1;
    }

    this.initCarousel();
    this.searchResultsElement.style.opacity = 1;
  }

  recentSearches() {
    this.searchResultsElement.style.opacity = 0;

    if (this.lastInputValue === "") {
      this.initialSearchLayout.style.opacity = 0;
      this.resetSearch();
      return;
    }

    if (this.lastInputValue.length > 3) {
      var searchTerm = JSON.parse(localStorage.getItem("searchTerms") || "[]");
      if (!searchTerm.includes(this.lastInputValue)) {
        searchTerm.unshift(this.lastInputValue);
      }

      // Then, we save the search info into the local storage, by keeping only the 5 most recent
      try {
        localStorage.setItem(
          "searchTerms",
          JSON.stringify(searchTerm.slice(0, 5))
        );
      } catch (error) { }
    }
  }

  getRecentSearches() {
    var appendString = "";
    var items = JSON.parse(localStorage.getItem("searchTerms") || "[]");
    var appElement = this.searchElement.querySelector(
      ".Search--Recent__results"
    );

    items = items.slice(0, 3);
    if (items.length > 0) {
      items.forEach((id, index) => {
        appendString =
          appendString +
          "<li tabIndex='0' class='u-p3 hoverLinks' data-action='search-string' data-value='" +
          id +
          "'>" +
          id +
          "</li>";
      });

      appElement.innerHTML = appendString;
    } else {
      var appEl = this.searchElement.querySelector(".Search--Recent");
      appEl.style.display = "none";
    }
  }
  getSuggestedSearches() {
    var appendString = "";
    const arr = this.options.items;

    if (arr.length == 0) {
      return;
    }
    arr.sort(function () {
      return 0.5 - Math.random();
    });
    var filtred = arr.filter(function (a) {
      if (!a.includes("_")) {
        return a;
      }
    });

    var i;
    appendString = "";
    for (i = 0; i < 3; i++) {
      if (filtred[i]) {
        var filteredResult = filtred[i].replace(":", " ");
        filteredResult = filteredResult.replace("-", " ");
        appendString =
          appendString +
          "<li tabindex='0' class='u-p3 hoverLinks' data-action='search-string' data-value='" +
          filteredResult +
          "'>" +
          filteredResult +
          "</li>";
      }
    }
    var appElement = this.searchElement.querySelector(
      ".Search--Suggested__results"
    );
    appElement.innerHTML = appendString;
  }
}
customElements.define("search-bar", SearchBar);

class Search extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);

    // Find result elements
    this.resultElements = this.element.querySelectorAll(".Search--Result");

    // Find buttons to toggle between products and articles
    this.openProductBtn = this.element.querySelector("#productBtn");
    this.openArticleBtn = this.element.querySelector("#articleBtn");
    new AddToCart(this.element);
    this.bindEvents();

    // Find number of products and articles and display them
    const productElements = this.element.querySelectorAll(".SearchProductWrapper");
    const productNumber = productElements.length;
    const itemNumber = this.element.querySelector(".itemNumber");
    if (itemNumber) {
      itemNumber.innerHTML = productNumber;
      if (productNumber === 0) {
        this.openProductBtn.style.display = "none";
      }
    }

    const articleElements = this.element.querySelectorAll(".article-wrapper");
    const articleNumber = articleElements.length;
    const itemNumber_2 = this.element.querySelector(".itemNumber_2");
    if (itemNumber_2) {
      itemNumber_2.innerHTML = articleNumber;
      if (articleNumber === 0) {
        this.openArticleBtn.style.display = "none";
      }
    }

    this.showProducts();
  }

  bindEvents() {
    // Toggle between products and articles when buttons are clicked
    this.delegateElement.on(
      "click",
      '[data-action="toggle-products"]',
      this.showProducts.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="toggle-articles"]',
      this.showArticles.bind(this)
    );
  }

  showProducts() {
    // Show product elements and hide article elements
    const productElements = this.element.querySelectorAll(".SearchProductWrapper");
    if (!productElements.length) {
      return;
    }
    const articleElements = this.element.querySelectorAll(".article-wrapper");
    articleElements.forEach((article) => {
      article.classList.add("hidden");
    });
    productElements.forEach((product) => {
      product.classList.remove("hidden");
    });

    // Update button styles
    this.openProductBtn.classList.add("active");
    this.openArticleBtn.classList.remove("active");
  }

  showArticles() {

    // Show article elements and hide product elements
    const articleElements = this.element.querySelectorAll(".article-wrapper");
    if (!articleElements.length) {
      return;
    }
    const productElements = this.element.querySelectorAll(".SearchProductWrapper");
    productElements.forEach((product) => {
      product.classList.add("hidden");
    });
    articleElements.forEach((article) => {
      article.classList.remove("hidden");
    });

    // Update button styles
    this.openProductBtn.classList.remove("active");
    this.openArticleBtn.classList.add("active");
  }
}

customElements.define("search-component", Search);

class ContactSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.bindEvents();
    this.toggleButton();


    var selectBoxes = this.element.querySelectorAll(".RevolutionSelectbox");


    if (selectBoxes.length > 0) {
      selectBoxes.forEach((item, i) => {
        new RevolutionSelectbox(item);
      });
    }

  }

  bindEvents() {
    this.delegateElement.on(
      "change",
      "[data-state='required']",
      this.toggleButton.bind(this)
    );



  }


  toggleButton() {
    this.buttonState = true;

    var allBoxes = this.element.querySelectorAll("[data-state='required']");
    allBoxes.forEach((item, i) => {
      if (item.checked == false) {
        this.buttonState = false;
      }
    });
    if (this.buttonState == true) {
      this.element.querySelector(".Contact-Btn").removeAttribute("disabled");
    } else {
      this.element.querySelector(".Contact-Btn").setAttribute("disabled", true);
    }
  }
}

customElements.define("contact-section", ContactSection);


class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector(
        'input[name="language_code"], input[name="country_code"]'
      ),
    };
    this.querySelectorAll("a").forEach((item) =>
      item.addEventListener("click", this.onItemClick.bind(this))
    );
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector("form");
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }
}

customElements.define("localization-form", LocalizationForm);

class PickupAvailability extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    if (!this.hasAttribute("available")) return;
    this.fetchAvailability(this.dataset.variantId);
  }

  fetchAvailability(variantId) {
    const variantSectionUrl = `${window.routes.localeRootUrl}/variants/${variantId}/?section_id=pickup`;

    fetch(variantSectionUrl)
      .then((response) => response.text())
      .then((text) => {
        const sectionInnerHTML = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector(".shopify-section");
        this.renderPreview(sectionInnerHTML);
      })
      .catch((e) => {
        this.renderError();
      });
  }

  renderError() { }

  renderPreview(sectionInnerHTML) {
    this.element.innerHTML = "";

    this.element.appendChild(
      sectionInnerHTML.querySelector(".LocalPickup_--Wrapper")
    );
    if (sectionInnerHTML.querySelector("#LocalPickup")) {
      this.element.appendChild(sectionInnerHTML.querySelector("#LocalPickup"));
      new Drawer(this.element.querySelector("#LocalPickup"));
    }
  }
}

customElements.define("pickup-availability", PickupAvailability);

class CartNote extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.textarea = this.element.querySelector("textarea");
    this.button = this.element.querySelector(".CartNote--Submit");
    this.noteSucess = this.element.querySelector(".cartNote--Success");
    this.bindEvents();
  }
  bindEvents() {
    this.delegateElement.on(
      "click",
      "[data-action='update-note']",
      this.updateNote.bind(this)
    );

    this.delegateElement.on(
      "click",
      "[data-action='edit-note']",
      this.editNote.bind(this)
    );
  }
  editNote() {
    this.textarea.removeAttribute("disabled");
    this.button.innerText = window.cartStrings.enter_note;
    this.button.setAttribute("data-action", "update-note");
    this.textarea.focus();
    this.noteSucess.style.visibility = "hidden";
    this.noteSucess.style.opacity = "0";
  }

  updateNote() {
    var _this = this;
    this.value = this.textarea.value;

    fetch(window.routes.localeRootUrl + "/cart/update.js", {
      body: JSON.stringify({ note: this.value }),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then(function (response) {
      if (response.ok) {
        if (_this.value == "") {
          return;
        }
        _this.textarea.setAttribute("disabled", "disabled");
        _this.button.innerText = window.cartStrings.note_change;
        _this.button.setAttribute("data-action", "edit-note");
        _this.noteSucess.style.visibility = "visible";
        _this.noteSucess.style.opacity = "1";
      }
    });
  }
}

customElements.define("cart-note", CartNote);

class AnimationWrapper extends HTMLElement {
  constructor() {
    super();
    this.element = this;

  }
}
customElements.define("animation-wrapper", AnimationWrapper);

class NewsletterPopup extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.options = JSON.parse(this.element.getAttribute("data-section-settings"));
    this.isOpen = false;
    this.hasBeenOpened = false;
    this.boundScrollListener = this.scrollListener.bind(this);
    this.boundCloseNewsletter = this.closeNewsletter.bind(this);

    if (this.options.edit_mode) {
      this.options.delay = 0;
      this.openNewsletter();
    } else {
      this.handleOpenOptions();
    }
  }

  handleOpenOptions() {
    const sessionKey = sessionStorage.getItem("popup-seen");
    const localKey = localStorage.getItem("popup-seen");

    if (this.options.show_only_once && localKey === "true") return;

    if (sessionKey !== "true") {
      if (this.options.scroll_amount > 0) {
        document.addEventListener("scroll", this.boundScrollListener);
      } else {
        this.openNewsletter();
      }
    }
  }

  scrollListener() {
    if (this.hasBeenOpened) return;

    const body = document.body;
    const html = document.documentElement;

    const docHeight = Math.max(
      body.scrollHeight,
      body.offsetHeight,
      html.clientHeight,
      html.scrollHeight,
      html.offsetHeight
    );

    const percScrolled = (window.scrollY / docHeight) * 100;

    if (percScrolled >= this.options.scroll_amount) {
      document.removeEventListener("scroll", this.boundScrollListener);
      this.openNewsletter();
    }
  }

  openNewsletter() {
    if (this.hasBeenOpened) return;
    this.hasBeenOpened = true;

    sessionStorage.setItem("popup-seen", true);
    localStorage.setItem("popup-seen", true);

    setTimeout(() => {
      if (this.isOpen) return;
      this.isOpen = true;

      this.element.setAttribute("aria-hidden", false);

      if (this.pageOverlayElement.classList.contains("is-visible")) {
        this.hideOverlay = false;
      } else {
        bodyScrollLock.disableBodyScroll(this.element, bodyScrollLockOptions);
        this.pageOverlayElement.classList.add("is-visible");
        this.hideOverlay = true;
      }

      this.pageOverlayElement.addEventListener(
        "click",
        this.boundCloseNewsletter
      );


      this.delegateElement.on(
        "click",
        '[data-action="close-modal"]',
        this.boundCloseNewsletter
      );
    }, 1000 * this.options.delay);
  }

  closeNewsletter() {
    if (!this.isOpen) return;
    this.isOpen = false;

    this.element.setAttribute("aria-hidden", true);

    if (this.hideOverlay) {
      this.pageOverlayElement.classList.remove("is-visible");
      bodyScrollLock.clearAllBodyScrollLocks();
    }

    this.pageOverlayElement.removeEventListener(
      "click",
      this.boundCloseNewsletter
    );

    document.removeEventListener("scroll", this.boundScrollListener);
  }
}

customElements.define("newsletter-popup", NewsletterPopup);

class MainArticleSwiper extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.carouselElement = this.element.querySelector(".swiper");
    this.carousel = new RevolutionSwiper(this.carouselElement);
  }
}

customElements.define("main-article-swiper", MainArticleSwiper);

class FormShowBlog extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.formBlog = this.element.querySelector('.comments--form');
    this.successMessage = this.element.querySelector('.successMessage');
    this.bindEvents();
    this.handleAfterState();

    if (window.location.href.indexOf("comments") != -1) {
      const buttonWrite = this.element.querySelectorAll('.comments--buttonWrite');
      buttonWrite.forEach(btn => {
        btn.style.display = "none";
      })
      return;
    }
  }
  bindEvents() {
    this.delegateElement.on('click', '[data-action="handle-hidden"]', this.toggleEffect.bind(this));
    this.delegateElement.on('click', '[data-action="load-more"]', this.loadMore.bind(this));
    this.delegateElement.on('click', '[data-action="copy"]', this.copy.bind(this));
  }

  copy() {
    var url = document.querySelector("#currentUrl");
    url.value = window.location.href;

    this.successMessage.classList.remove('hidden');
    setTimeout(() => { this.successMessage.classList.add('hidden'); }, 3000);

    navigator.clipboard.writeText(url.value);

  }

  handleAfterState() {
    if (window.location.href.indexOf("#comment_form") > -1) {
      this.element.querySelector('.comments--buttonWrite').setAttribute('aria-hidden', 'true');
      this.formBlog.classList.remove('comments--formHide');
    }
  }

  toggleEffect(event, target) {
    const form = this.element.querySelector('#comment_form');
    target.style.display = 'none';
    form.setAttribute('aria-hidden', 'false');
    this.formBlog.classList.remove('comments--formHide');
  }

  loadMore(event, target) {

    const _this = this;
    let dataHref = target.getAttribute("data-href");


    return fetch(window.routes.localeRootUrl + dataHref, {
      credentials: "same-origin",
      method: "GET",
    }).then(function (content) {
      content.text().then(function (htmlData) {
        let html = new DOMParser().parseFromString(htmlData, "text/html");
        let newComments = html.querySelectorAll('.ArticleComments--Comment');

        let curDocument = _this.element.querySelector('.ArticleComments');
        curDocument.append(...newComments);
        let dataHref = html.querySelector('.comments--buttonFooter');

        if (dataHref) {
          dataHref = dataHref.dataset.href;
          _this.element.querySelector('.comments--buttonFooter').dataset.href = dataHref;
        } else {
          _this.element.querySelector('.comments--buttonFooter').remove();

        }
      });
    });

  }

}
customElements.define("blog-post", FormShowBlog);

class CustomTwo extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.startSwiper();
    this.activeMobileBlock = this.element.querySelector('.CustomTwo--MobileWrapper[aria-hidden="false"]');
    this.activeDesktopBlock = this.element.querySelector('.CustomTwo--DesktopWrapper[aria-hidden="false"]');


    this.element.addEventListener('click', this.handleColorPick.bind(this));
  }

  handleColorPick(event) {
    if (event.target.matches('.CustomTwo--ColorOuter')) {
      const productId = event.target.dataset.colorId;
      const newDesktopBlock = this.element.querySelector(`[data-block-id="${productId}"]`);
      const newMobileBlock = this.element.querySelector(`[data-block-id-m="${productId}"]`);

      //desktop active block change
      this.activeDesktopBlock.setAttribute('aria-hidden', true);
      newDesktopBlock.setAttribute('aria-hidden', false);
      this.activeDesktopBlock = newDesktopBlock;

      //mobile active block change
      this.activeMobileBlock.setAttribute('aria-hidden', true);
      newMobileBlock.setAttribute('aria-hidden', false);
      this.activeMobileBlock = newMobileBlock;

      this.startSwiper();
    }
  }

  startSwiper() {
    if (this.carousel) {
      this.carousel.swiperElement.destroy();
    }

    this.carouselElement = this.element.querySelector(`.swiper[aria-hidden="false"]`);
    this.carousel = new RevolutionSwiper(this.carouselElement);
  }
}
customElements.define("custom-two", CustomTwo);

class ProductRuler extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.ruler = this.element.querySelector('.Product--Ruler');
  }

  connectedCallback() { 
    this.bind = this.handleDrawerToggle.bind(this);
    this.ruler.addEventListener('click', this.bind);
  }

  disconnectedCallback() {
    this.ruler.removeEventListener('click', this.bind);
  }

  handleDrawerToggle(event) {
    const open = event.target.closest('.Product--RulerIcon');
    const close = event.target.closest('.Product--RulerCloseIcon');

    if (!open && !close) return;

    const rulerIcon = this.element.querySelector('.Product--RulerIcon');
    const image = this.element.querySelector('.Product--RulerImgWrapper');

    this.ruler.classList.toggle('Product--RulerClosed');

    if (open) {
      image.style.display = "block";

      requestAnimationFrame(() => {
        rulerIcon.setAttribute("aria-hidden", true);
        image.setAttribute("aria-hidden", false);
      })
    } else {
      rulerIcon.setAttribute("aria-hidden", false);
      image.setAttribute("aria-hidden", true);

      setTimeout(() => {
        image.style.display = "none";
      }, 300);
    }
  }
}

customElements.define("product-ruler", ProductRuler);

class RichText extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);

    const links = document.querySelectorAll('.navbtn');


    function handleLinkClick(event) {
      const clickedLink = event.target;


      links.forEach(function (link) {
        link.classList.remove('u-s3');
        link.classList.remove('u-p3');
        link.classList.remove('active');

        const navNameElement = link.querySelector('.nav-name');
        if (navNameElement) {
          navNameElement.classList.remove('u-s3');
          navNameElement.classList.remove('u-p3');
          navNameElement.classList.remove('active');
        }

      });


      clickedLink.classList.add('active');
      clickedLink.classList.add('u-s3');

      const clickedNavNameElement = clickedLink.querySelector('.nav-name');
      if (clickedNavNameElement) {
        clickedNavNameElement.classList.add('u-s3');
        clickedNavNameElement.classList.remove('active');
      }

      links.forEach(function (link) {
        if (link !== clickedLink) {
          link.classList.add('u-p3');

          const navNameElement = link.querySelector('.nav-name');
          if (navNameElement) {
            navNameElement.classList.add('u-p3');
            navNameElement.classList.remove('active');
          }
        }
      });

    }


    links.forEach(function (link) {
      link.addEventListener('click', handleLinkClick);
    });


    const currentURL = window.location.href;

    links.forEach(function (link) {
      if (link.href === currentURL) {
        link.classList.add('active');
        link.classList.add('u-s3');

        const navNameElement = link.querySelector('.nav-name');
        if (navNameElement) {
          navNameElement.classList.add('u-s3');
          navNameElement.classList.remove('active');
        }
      } else {
        link.classList.add('u-p3');

        const navNameElement = link.querySelector('.nav-name');
        if (navNameElement) {
          navNameElement.classList.add('u-p3');
          navNameElement.classList.remove('active');
        }
      }
    });


    const buttons = document.querySelectorAll('.navbtn');
    function handleNavButtonClick(event) {
      buttons.forEach(function (button) {
        button.classList.remove('active-link');
      });
      const clickedBtn = event.currentTarget;
      clickedBtn.classList.add('active-link');
    }

    buttons.forEach(function (button) {
      button.addEventListener('click', handleNavButtonClick);
    })


  }
}
customElements.define("richtext-section", RichText);

class FaqSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);

    const buttons = document.querySelectorAll('.FAQNav--rowLink');

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {

        const activeElements = document.querySelectorAll('.active');
        activeElements.forEach(function (element) {
          element.classList.remove('active');
        });

        buttons.forEach(function (btn) {
          const navName = btn.querySelector('.nav--name');
          if (btn === button) {
            navName.classList.add('u-s3');
          } else {
            navName.classList.add('u-p3');
            navName.classList.remove('u-s3');
          }
        });

        button.classList.add('active');
      });
    });
  }
}

customElements.define("faq-section", FaqSection);


class SupportFaq extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.DrawerBrowse = new Drawer(
      this.element.querySelector('#browse-drawer')
    );
    this.DrawerSearchFaq = new Drawer(
      this.element.querySelector('#faq-search-drawer')
    );
    this.recentSearchesList = this.querySelector('.recent-searches');
    // Retrieve recent searches from local storage
    this.recentSearches =
      JSON.parse(localStorage.getItem('recentSearches')) || [];

    this.renderRecentSearches();
    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on(
      'click',
      '[data-action="clear-search"]',
      this.clearSearch.bind(this)
    );

    this.delegateElement.on(
      'click',
      '[data-action="clear-search-d"]',
      this.clearSearchDesktop.bind(this)
    );

    this.delegateElement.on(
      'click',
      '[data-action="click-action"]',
      this.insertInInput.bind(this)
    );

    this.delegateElement.on(
      'keyup',
      '[data-action="search-string"]',
      this.handleSearch.bind(this)
    );

    this.delegateElement.on(
      'keyup',
      '[data-action="search-string-d"]',
      this.handleSearchDesktop.bind(this)
    );

    this.setupSuggestedSearches();
    this.setupMenuLinks();

  }
  insertInInput(event, target) {
    this.inputEl = this.element.querySelector('.faq--search.mobile');
    const liText = event.target.textContent;
    this.inputEl.value = liText;

  }
  handleSearch(event) {
    //Mobile
    const clearBtn = this.element.querySelector(
      '.clearSeacrh.supportFaq--mobileClearBtn'
    );
    // Set the input value and display/hide the clear button
    let inputValue = this.element.querySelector('.faq--search.mobile').value;
    if (inputValue == '') {
      clearBtn.style.display = 'none';
    } else {
      clearBtn.style.display = 'flex';
    }
    if (event.key === 'Enter') {
      // Cancel the default action, if needed
      event.preventDefault();
      // Trigger the button element with a click
      this.handleEnter();
    }
  }

  handleSearchDesktop(event) {
    //Desktop
    const clearBtn_d = this.element.querySelector(
      '.clearSeacrh.supportFaq--desktopClearBtn'
    );

    let inputValue_d = this.element.querySelector('.faq--search.desktop').value;

    if (inputValue_d.length == 0) {
      clearBtn_d.style.display = 'none';
    } else {
      clearBtn_d.style.display = 'flex';
    }

    this.quickSearch(inputValue_d);
  }

  quickSearch(inputSearch) {
    inputSearch = inputSearch.toLowerCase();

    const divContainers = this.querySelectorAll('.specification-data');

    divContainers.forEach((container) => {
      const containerText = container.textContent.toLowerCase();

      if (containerText.includes(inputSearch)) {
        container.style.display = 'block';
        container.classList.add('supportFaq--showed');
      } else {
        container.style.display = 'none';
        container.classList.remove('supportFaq--showed');
      }
    });
    this.handleNoResults(divContainers);
  }

  handleNoResults(containers) {
    let sign = false;
    this.noResEl = this.querySelectorAll('.faq--noResultsText');

    containers.forEach((container) => {
      if (container.classList.contains('supportFaq--showed')) {
        sign = true;
      }
    });

    if (sign === false) {
      this.noResEl.forEach(item => {
        item.style.display = 'flex';
        item.classList.add('noResult--showed');
      })

    } else {
      this.noResEl.forEach(item => {
        item.style.display = 'none';

      })
    }
  }

  handleEnter() {
    let searchTerm = this.element.querySelector('#searchbox').value.trim();
    this.recentSearches.push(searchTerm);
    // Limit the recent searches array to the last 10 entries
    if (this.recentSearches.length > 8) {
      this.recentSearches.shift();
    }
    // Save the recent searches array to local storage
    localStorage.setItem('recentSearches', JSON.stringify(this.recentSearches));

    // Render the recent searches
    this.renderRecentSearches();

    this.quickSearch(searchTerm);



    this.DrawerSearchFaq.closeDrawer();


    this.clearSearch();
  }



  renderRecentSearches() {
    this.recentSearchesList.innerHTML = '';

    // Iterate over the recent searches array
    for (let i = 0; i < this.recentSearches.length; i++) {
      // Create a new list item
      let listItem = document.createElement('li');
      listItem.textContent = this.recentSearches[i];

      // Add the new list item to the recent searches list
      this.recentSearchesList.appendChild(listItem);
      listItem.setAttribute('data-action', 'click-action')
    }
  }

  clearSearch() {
    this.clearBtn = this.element.querySelector(
      '.clearSeacrh.supportFaq--mobileClearBtn'
    );
    this.inputValue = this.element.querySelector('.faq--search.mobile');
    this.inputValue.value = '';
    this.clearBtn.style.display = 'none';
    this.noReslutEl = this.element.querySelector('.faq--noResultsText.mobile');
    this.noReslutEl.style.display = 'none';
  }

  clearSearchDesktop() {
    this.clearBtn_d = this.element.querySelector(
      '.clearSeacrh.supportFaq--desktopClearBtn'
    );
    this.inputValue_d = this.element.querySelector('.faq--search.desktop');
    this.inputValue_d.value = '';
    this.clearBtn_d.style.display = 'none';
    this.quickSearchDesktop(this.inputValue_d.value);
  }

  setupSuggestedSearches() {
    const ulElement = document.querySelector('.Supportfaq--suggested_searches');
    const inputString = ulElement.textContent;
    const items = inputString.split(';');

    ulElement.textContent = '';

    items.forEach((item) => {
      const liElement = document.createElement('li');

      liElement.textContent = item;
      ulElement.appendChild(liElement);
      liElement.setAttribute('data-action', 'click-action')
    });
  }

  setupMenuLinks() {
    const links = this.querySelectorAll('.menu-link');

    function handleLinkClick(event) {
      const clickedLink = event.target;

      links.forEach(function (link) {
        link.classList.remove('active');
      });

      clickedLink.classList.add('active');
    }

    links.forEach(function (link) {
      link.addEventListener('click', handleLinkClick);
    });
  }


}

customElements.define("supportfaq-section", SupportFaq);


class sectionTabs extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.newSpec = this.element.parentElement;
    this.delegateElement = new Delegate(this.element);
    this.specBtn = this.element.querySelector('#spec-title');
    this.bindEvents();
  }
  bindEvents() {
    this.delegateElement.on('click', '[data-action="toggle-specification"]', this.markTab.bind(this));

  }





  markTab(event, target) {
    const id = target.getAttribute('data-id');
    this.element.querySelectorAll('.specification-data').forEach((item, i) => {
      item.classList.add('hidden');
    });

    this.element.querySelector('#' + id).classList.remove('hidden');

    this.element.querySelectorAll('#spec-title').forEach((item, i) => {
      item.classList.remove('active');
    });
    target.classList.add('active');
  }
}
customElements.define("section-tabs", sectionTabs);



class QuoteSlider extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delElem = new Delegate(this.element)

    this.startSwiper();
    this.parseQuotes();
    this.createIntersection();
    this.bindEvents();
  }

  bindEvents() {
    this.delElem.on("click", '[data-action="toggle-swiper"]', this.handleTogleSwiper.bind(this));
    this.swiper.on('slideChange', this.updateQuote.bind(this));
  }

  handleTogleSwiper() {
    this.carousel.toggleSwiper(event.target)
  }

  startSwiper() {
    this.carouselElement = this.element.querySelector(".swiper");
    const pauseButton = this.element.querySelector('[data-action="pause-swiper"]') ? true : false;
    const useTumbs = false;

    this.carousel = new RevolutionSwiper(this.carouselElement, useTumbs, pauseButton);
    this.swiper = this.carousel.swiperElement;
  }

  createIntersection() {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        this.updateQuote();
      });
    });

    observer.observe(this.element);
  }

  updateQuote() {
    var keyframes = [
      { color: 'transparent' },
      { color: 'var(--text_1)' }
    ];

    var options = {
      duration: 200,
      easing: 'linear',
      fill: 'forwards'
    };

    var delay = 0;

    //Remove color from old slide
    if (this.currentSlide) {
      var words = this.currentSlide.querySelectorAll('.Quote--Letter')
      words.forEach(function (elem) {
        var keyframes2 = [
          { color: 'transparent' }
        ];

        var options2 = {
          duration: 300,
          fill: 'forwards'
        };

        elem.animate(keyframes2, options2);
      })
    }

    //Animate new slide
    this.currentSlide = this.swiper.slides[this.swiper.activeIndex];
    var words = this.currentSlide.querySelectorAll('.Quote--Letter')
    words.forEach(function (elem) {
      options.delay = delay;
      elem.animate(keyframes, options);
      delay += 20;
    })
  }

  parseQuotes() {
    this.element.querySelectorAll('.Quote--Heading').forEach((elem) => {

      var words = elem.textContent.split(' ');

      elem.innerHTML = words.map(function (word) {
        var letters = word.split('');
        letters = letters.map(function (l) {
          return '<span class="Quote--Letter u-h2">' + l + '</span>';
        }).join('');

        return '<span class="Quote--Word">' + letters + ' </span>';
      }).join('');


    })
  }
}
customElements.define("quote-slider", QuoteSlider);


class LocalizationSelectors extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    let responsive = new Responsive();
    let breakpoint = responsive.getCurrentBreakpoint();
    var selectBoxes = this.element.querySelectorAll(".RevolutionSelectbox");
    var location = this.element.getAttribute('data-settings');

    this.delegateElement.on(
      "change",
      '[data-action="country-change"]',
      this.submitForm.bind(this)
    );
    if (location == "sidebarMenu") {
      var additionalOverlay = true;
    } else {
      var additionalOverlay = false;
    }
    if (breakpoint != "phone" && breakpoint != "tablet") {
      if (selectBoxes.length > 0) {
        selectBoxes.forEach((item, i) => {
          new RevolutionSelectbox(
            item
          );
        });
      }
    } else {
      if (selectBoxes.length > 0) {

        selectBoxes.forEach((item, i) => {
          new RevolutionSelectbox(
            item, true, additionalOverlay
          );
        });
      }
    }

  }

  submitForm() {
    event.target.closest('form').submit();

  }

}
customElements.define("localization-selectors", LocalizationSelectors);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.swiperElements = this.element.querySelectorAll('.swiper');

    if (this.swiperElements) {
      this.swiperElements.forEach((item) => {
        new RevolutionSwiper(item);
      })
    }

    new AddToCart(this.element);
    if (window.theme.enableImageAnimations) {
      new RevolutionAnimation(this.element);
    }

    const _this = this;

    if (this.element.querySelector('.productRecommendations--Automatic')) {
      this.options = JSON.parse(this.element.querySelector('.productRecommendations--Automatic').getAttribute("data-options"));
      this.handleRecommendations();
    }

    this.bindEvents();

    window.onload = function () {
      _this.tabSize();
    };
  }


  bindEvents() {
    this.delegateElement.on(
      "click",
      '[data-action="toggle-collection"]',
      this.toggleCollection.bind(this)
    );
  }

  handleRecommendations() {
    const urlToFetch = `${this.options.data_url}?section_id=${this.options.section_id}&product_id=${this.options.product}&limit=10`
    const item = this.querySelector('.productRecommendations--Automatic .animatedContent');
    if (item) return;
    fetch(urlToFetch)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.productRecommendations--Automatic');
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.querySelector('.productRecommendations--Automatic').innerHTML = recommendations.innerHTML;
          const swiper = this.querySelector('.productRecommendations--Automatic.swiper');
          if (swiper) {
            new RevolutionSwiper(swiper);
          }

          if (window.theme.enableAnimations) {
            new RevolutionAnimation(this);
          }
        }

      })
      .catch(e => {
        console.error(e);
      });
  }

  toggleCollection(event) {
    const id = event.target.dataset.id;
    this.element.querySelector('[aria-expanded="true"]').setAttribute('aria-expanded', 'false');
    this.element.querySelector('[aria-hidden="false"]').setAttribute('aria-hidden', 'true');
    event.target.setAttribute('aria-expanded', 'true');
    this.element.querySelector(`#${id}`).setAttribute('aria-hidden', 'false');
  }

  tabSize() {

    const mainTabWrapper = this.element.querySelector('.productRecommendations--Tabs');
    if (mainTabWrapper) {
      const allTabs = this.element.querySelectorAll('.productRecommendations--Tab');
      let biggestWidth = 0;

      if (allTabs.length > 1) {
        allTabs.forEach(function (element, index) {
          biggestWidth = element.offsetWidth > biggestWidth ? element.offsetWidth : biggestWidth;
        });
        allTabs.forEach((item) => {
          item.style.width = `${biggestWidth}px`;
        })
      }

    }
  }

}
customElements.define("product-recommendations", ProductRecommendations);

class AnimationText extends HTMLElement {
  static eventsBinded = false;

  constructor() {
    super();
    this.element = this;
    this.backup = this.element.innerHTML;
    this.int = 1;

    this.refreshElem();
  }

  connectedCallback() {
    window.addEventListener('resize', this.restart.bind(this));
    document.addEventListener("cart-drawer:open", this.restart.bind(this));
  }

  restart() {    
    this.element.innerHTML = this.backup;
    this.cloneNodes();
  }

  cloneNodes() {
    this.wrapper = this.element.querySelector(".metaItem--content");
    const elem = this.element.querySelector(".metaItem--animHolder");

    const wrapperWidth = this.wrapper.getBoundingClientRect().width;
    this.elemWidth = elem.getBoundingClientRect().width;

    this.ratio = Math.round((wrapperWidth / this.elemWidth) * 2);

    for (let i = 0; i < this.ratio; i++) {
      const clone = elem.cloneNode(true);
      clone.setAttribute("data-id", i + 1);

      clone.style.left = this.elemWidth * (i + 1) + "px"
      this.wrapper.appendChild(clone);
    }

    Array.from(this.wrapper.children).forEach(elem => {
      this.animate(elem, 100);
    });
  }

  refreshElem() {
    setTimeout(() => {      
      const tempMain = document.querySelector("animation-text");
      tempMain.innerHTML = this.element.innerHTML;
      this.element = tempMain;

      this.cloneNodes();
    }, 100)
  }

  async animate(elem, moveBy) {
    const elementMove = [
      { transform: `translateX(-${moveBy}%)` },
    ];

    const animation = elem.animate(elementMove, {
      duration: 20000,
      fill: "forwards",
    });

    const finished = await animation.finished;
    if (finished.playState === "finished") {
      this.handleAnimationEnd(elem, moveBy);
    }
  }

  handleAnimationEnd(elem, moveBy) {
    const wrapperRect = this.getBoundingClientRect();
    const rect = elem.getBoundingClientRect();

    if ((rect.x + rect.width) < wrapperRect.x) {

      const tempElem = elem.cloneNode(true);
      const tempChild = this.wrapper.querySelector(`.metaItem--animHolder[data-id="${elem.getAttribute("data-id")}"]`);

      this.wrapper.removeChild(tempChild);

      tempElem.style.transform = "";
      tempElem.style.left = (this.ratio - 1) * this.elemWidth + "px";

      this.wrapper.appendChild(tempElem);
      this.animate(tempElem, 100);
    } else {
      this.animate(elem, moveBy + 100);
    }
  }
}

customElements.define("animation-text", AnimationText);


class MainCart extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    this.delegateElement = new Delegate(this.element);
    this.carouselElement = this.element.querySelectorAll(".swiper");

    this.carouselElement.forEach(swiper => {
      new RevolutionSwiper(swiper);
    })

    new AddToCart(this.element);

    if (this.element.querySelector('[data-gas-item]')) {
      window.theme.gasInCart = "true";
    }
  }

  connectedCallback() {
    this.handleRecommendation();

    this.delegateElement.on(
      "click",
      ".cart--checkoutBtn",
      this.sendCartData.bind(this)
    );

    this.delegateElement.on(
      "click",
      '[data-action="update-item-quantity"], [data-action="remove-item"]',
      this.updateItemQuantity.bind(this)
    );
  }

  async updateItemQuantity(event, target) {
    event.preventDefault();

    document.querySelector(".pageLoader").style.width = "100%";

    var quantity = null;
    if (target.tagName === "INPUT") {
      quantity = parseInt(Math.max(parseInt(target.value) || 0, 0));

      if (target.max && quantity > target.max) quantity = target.max
    } else {
      quantity = parseInt(target.getAttribute("data-quantity"));
    }

    try {
      const response = await fetch(window.routes.localeRootUrl + "/cart/change.js", {
        body: JSON.stringify({
          id: target.getAttribute("data-line-id"),
          quantity: quantity,
        }),
        credentials: "same-origin",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
      })
      
      if (!response.ok) throw "Status: " + response.status + " " + "Msg: " + response.statusText;
  
      window.location.reload()

    } catch (error) {
      console.error("Change.js error.", error)
    }
  }

  handleRecommendation() {
    const recommendation = this.element.querySelectorAll('#main-cart-recommendation');
    let swiperElements = this.element.querySelectorAll('.cartSlideItem');
    if (swiperElements.length === 0) {

      recommendation.forEach(item => {
        item.style.display = 'none';
      })
    }
  }

  async sendCartData() {
    event.preventDefault();
    event.stopPropagation();

    const gifts = document.querySelector("gwp-block")?.getAttribute("data-gifts");
    let bundleElems = this.element.querySelectorAll("[data-bundle-content]");

    const attributes = {};

    if (bundleElems.length) {
      let bundlesString = "";

      Array.from(bundleElems).forEach(bundle => {
        bundlesString = bundlesString + bundle.dataset.bundleContent;
      });

      attributes.bundles = bundlesString;
    } else {
      attributes.bundles = "";
    }

    if (gifts) {
      attributes.gifts = gifts;
    } else {
      attributes.gifts = "";
    }

    try {
      await fetch(window.routes.localeRootUrl + "/cart/update.js", {
        body: JSON.stringify({ attributes: attributes }),
        credentials: "same-origin",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
      });
    } catch (error) {
      console.log(error);
    }

    location.href = "/checkout";
  }

}

customElements.define("cart-items", MainCart);

class GasExchange extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    this.pageOverlay = document.querySelector('.pageOverlaySubscriptions');
    this.mobilePopup = document.querySelector('.SubscriptionInfoPopupMobile');

    var selectBoxes = this.element.querySelector(".RevolutionSelectbox--GasExchange");

    if (this.element.dataset.load) {
      const thisButton = document.querySelector('.mainATC');
      const thisButtonPrice = thisButton.querySelector('.button--money');
      const gasPrice = this.element.dataset.subprice;
      const itemPrice = thisButton.querySelector('[data-money]').dataset.money;

      const price = Shopify.formatMoney(parseInt(gasPrice) + parseInt(itemPrice), window.theme.moneyFormat);
      thisButtonPrice.innerHTML = price;


      if (new Responsive().matchesBreakpoint('pocket')) {

        thisButton.setAttribute('data-action', 'toggle-msub');


      } else {
        this.toggleSubscription();
      }
    }

    this.useZip = false;

    if (this.element.querySelector('.gasExchange--ZIPWrapper')) {
      this.useZip = true;
      this.zips = window.zips;
    }

    this.arrow = this.element.querySelector('.gasExchange--RichBottomCheckArrow');
    const currentText = this.element.querySelector('.gasExchange--RichBottomUSP[aria-hidden="false"]');
    if (currentText) {
      this.setRichText(currentText, currentText.getAttribute('data-id'));
    }
  }

  connectedCallback() {
    this.delegateBody.on('keyup', '.gasExchange--ZIPCheck', this.checkZip.bind(this));
    this.delegateElement.on(
      "click",
      '[data-action="toggle-carbonator"]',
      this.toggleOption.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="toggle-gas"]',
      this.toggleOption.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="toggle-subscription"]',
      this.toggleOption.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="selectbox-change"]',
      this.handleQuantityChange.bind(this)
    );
    this.delegateBody.on('click', '[data-action="toggle-msub"]', this.toggleMobileSubscription.bind(this));

    this.delegateBody.on(
      "click",
      '[data-action="next-step"]',
      this.toggleSteps.bind(this)
    );

    this.delegateBody.on(
      "click",
      '[data-action="mobile-add"]',
      this.mobileAdd.bind(this)
    );

    this.delegateBody.on(
      "click",
      '[data-action="close-mobile-popup"]',
      this.closePopup.bind(this)
    );

    this.delegateBody.on(
      "click",
      '[data-action="open-subpopup"]',
      this.openSubpopup.bind(this)
    );

    this.delegateBody.on(
      "click",
      '[data-action="close-subpopup"]',
      this.closeSubpopup.bind(this)
    );

    this.delegateBody.on('click', '[data-action="toggle-subscription-quantity"]', this.adjustMobileSubscription.bind(this));

    this.delegateElement.on('click', '.gasExchange-TopSubInfo', this.openMobilePopup.bind(this));
    this.delegateBody.on('click', '.SubscriptionInfoPopupMobile .closeSub', this.closeMobilePopup.bind(this));

    this.delegateElement.on(
      "click",
      '[data-action="selectbox-change"]',
      this.handleTextChange.bind(this)
    );
  }

  disconnectedCallback() {    
    this.delegateElement.destroy();
    this.delegateBody.destroy();
  }





  openMobilePopup() {
    if (this.mobilePopup) {
      const scrollable = this.mobilePopup.querySelector("[data-scrollable]");
      bodyScrollLock.disableBodyScroll(scrollable, bodyScrollLockOptions);
      this.mobilePopup.setAttribute('aria-hidden', 'false');

      this.pageOverlay.classList.add('is-visible');
      this.pageOverlay.addEventListener(
        "click",
        this.closeMobilePopup.bind(this)
      );
    }
  }

  closeMobilePopup() {
    if (this.mobilePopup) {
      this.pageOverlay.removeEventListener(
        "click",
        this.closeMobilePopup.bind(this)
      );
      this.pageOverlay.classList.remove('is-visible');

      bodyScrollLock.clearAllBodyScrollLocks();
      this.mobilePopup.setAttribute('aria-hidden', 'true');
    }
  }

  handleTextChange() {
    /* Left usps */
    const id = event.target.getAttribute('data-text-id');
    const letfOldText = this.element.querySelector('.gasExchange--bottomUSPSLeft .gasExchange--RichBottomUSP[aria-hidden="false"]');
    const leftNewText = this.element.querySelector(`.gasExchange--bottomUSPSLeft .gasExchange--RichBottomUSP[data-id="${id}"]`);

    if (letfOldText && leftNewText) {
      letfOldText.setAttribute('aria-hidden', 'true');
      leftNewText.setAttribute('aria-hidden', 'false');

      this.setRichText(leftNewText, id);
    }

    /* right usps */
    const rightOldText = this.element.querySelector('.gasExchange--bottomUSPSRight .gasExchange--RichBottomUSP[aria-hidden="false"]');
    const rightOnewText = this.element.querySelector(`.gasExchange--bottomUSPSRight .gasExchange--RichBottomUSP[data-id="${id}"]`);

    if (rightOldText && rightOnewText) {
      rightOldText.setAttribute('aria-hidden', 'true');
      rightOnewText.setAttribute('aria-hidden', 'false');
    }
  }

  handleMobileTextChange(id) {
    /* Left usps */
    const letfOldTextMobile = document.querySelector('.gasExchange--MobileBottomLeftUSP[aria-hidden="false"]');
    const leftNewTextMobile = document.querySelector(`.gasExchange--MobileBottomLeftUSP[data-id="${id}"]`);

    if (letfOldTextMobile && leftNewTextMobile) {
      letfOldTextMobile.setAttribute('aria-hidden', 'true');
      leftNewTextMobile.setAttribute('aria-hidden', 'false');

      this.setRichText(leftNewTextMobile, id);
    }

    /* right usps */
    const rightOldTextMobile = document.querySelector('.gasExchange--MobileBottomRightUSP[aria-hidden="false"]');
    const rightOnewTextMobile = document.querySelector(`.gasExchange--MobileBottomRightUSP[data-id="${id}"]`);

    if (rightOldTextMobile && rightOnewTextMobile) {
      rightOldTextMobile.setAttribute('aria-hidden', 'true');
      rightOnewTextMobile.setAttribute('aria-hidden', 'false');
    }
  }

  setRichText(newText, id) {
    const textHasArrow = newText.querySelector(".gasExchange--RichBottomCheckArrow") ? true : false;
    if (textHasArrow) {
      return;
    }

    const index1 = newText.innerHTML.indexOf('<h');
    const index2 = newText.innerHTML.indexOf('>');

    if (index1 !== -1 && index2 !== -1) {
      const title = newText.innerHTML.substring(index1 + 1, index2);
      if (title.length === 2) {
        newText.querySelector(`${title}`).classList.add(`u-s${title.charAt(1)}`);
      }
    }

    const lis = Array.from(newText.querySelectorAll('li'));
    lis.forEach((li) => {
      const tempArrow = this.arrow.cloneNode(true);
      li.appendChild(tempArrow);
    })
  }

  checkZip(event) {
    const zips = this.zips;
    this.buttons = document.querySelectorAll('.Product--AddToCartButton');

    const nextButton = document.querySelector('.mobileGasExchange-Continue');
    if (zips.includes(event.target.value) && event.target.value.length == 5) {
      event.target.removeAttribute('style');
      this.buttons.forEach((item) => {
        item.removeAttribute('disabled');
      })
      if (nextButton) {
        nextButton.removeAttribute('disabled');
      }

    } else if (event.target.value.length >= 5) {
      event.target.style.color = "red";
      event.target.style.borderColor = "red";
      const allInfo = document.querySelectorAll('.gasExchange--ZIPError');
      this.buttons.forEach((item) => {
        item.setAttribute('disabled', 'true');
      })
      allInfo.forEach((item) => {
        item.setAttribute('aria-hidden', 'false');
      })

      setTimeout(() => {
        allInfo.forEach((item) => {
          item.setAttribute('aria-hidden', 'true');
        })

      }, 5000);
    } else {
      if (nextButton) {
        nextButton.setAttribute('disabled', 'true');
      }
      this.buttons.forEach((item) => {
        item.setAttribute('disabled', 'true');
      })
      event.target.removeAttribute('style');
    }

  }
  closeSubpopup() {

    const control = event.target.dataset.control;
    const popup = document.querySelector(`#${control}`);

    popup.setAttribute('aria-hidden', 'true');
  }
  openSubpopup() {
    const control = event.target.dataset.control;
    const popup = document.querySelector(`#${control}`);

    popup.setAttribute('aria-hidden', 'false');
  }

  mobileAdd() {
    document.querySelector('.mainATC').setAttribute('data-action', 'add-all-to-cart');
    document.querySelector('.mainATC').click();
    this.closePopup();
    document.querySelector('.mainATC').setAttribute('data-action', 'toggle-msub');
  }

  closePopup() {
    bodyScrollLock.clearAllBodyScrollLocks();
    const mobilePopup = document.querySelector('.gasMobilePopup');
    mobilePopup.setAttribute('aria-visible', 'false');
    this.ATCbutton = document.querySelector('.mainATC');
    this.ATCbutton.setAttribute('data-action', 'toggle-msub');
    const pageOverlay = document.querySelector('.pageOverlaySubscriptions');
    pageOverlay.classList.remove('is-visible');
    document.querySelector('.gasExchangeSubscription').setAttribute('aria-selected', 'false');
  }

  toggleSteps(event, step, direction) {
    if (event) {
      step = event.target.dataset.step;
      direction = event.target.dataset.direction;
    }

    const hideStep = (step) => {
      document.querySelector(`.gasStep[data-step='${step}']`).style.display = "none";
    };

    const showStep = (step) => {
      document.querySelector(`.gasStep[data-step='${step}']`).style.display = "block";
    };

    const hideBackButton = () => {
      mobilePopup.querySelector('.gasMobile--BackButton').style.display = "none";
    };

    const showBackButton = () => {
      mobilePopup.querySelector('.gasMobile--BackButton').style.display = "block";
    };

    const updateDataStep = (element, step) => {
      element.dataset.step = step;
    };

    const mobilePopup = document.querySelector('.gasMobilePopup');

    if (step == 1 && direction == "next") {
      hideStep(1);
      hideStep(3);
      showStep(2);
      showBackButton();

      updateDataStep(mobilePopup.querySelector('.mobileGasExchange-Continue'), "2");
      updateDataStep(mobilePopup.querySelector('.gasMobile--BackButton'), "2");
    } else if (step == 2 && direction == "backwards") {
      hideStep(2);
      showStep(1);
      hideStep(3);
      hideBackButton();

      updateDataStep(mobilePopup.querySelector('.mobileGasExchange-Continue'), "1");
      updateDataStep(mobilePopup.querySelector('.gasMobile--BackButton'), "1");
    } else if (step == 2 && direction == "next") {
      hideStep(2);
      showStep(3);
      showBackButton();

      updateDataStep(mobilePopup.querySelector('.mobileGasExchange-Continue'), "3");
      updateDataStep(mobilePopup.querySelector('.gasMobile--BackButton'), "3");
    } else if (step == 3 && direction == "backwards") {
      hideStep(3);
      showStep(2);
      if (this.useZip == true) {
        showBackButton();
      } else {
        hideBackButton();
      }


      updateDataStep(mobilePopup.querySelector('.mobileGasExchange-Continue'), "2");
      updateDataStep(mobilePopup.querySelector('.gasMobile--BackButton'), "2");
    }
  }


  handleQuantityChange() {
    let gasProductQuantity = event.target.dataset.value;
    if (gasProductQuantity == 0) {
      gasProductQuantity = 2;
    }
    const gasProductInput = this.element.querySelector('#gas_product_id');
    if (event.target.dataset.id) {
      gasProductInput.setAttribute('name', `${event.target.dataset.id}_id`);
      gasProductInput.dataset.id = event.target.dataset.id;
      gasProductInput.dataset.title = event.target.dataset.title;
      gasProductInput.dataset.price = event.target.dataset.priceItem;
      gasProductInput.dataset.sku = event.target.dataset.sku;
      gasProductInput.removeAttribute('disabled');
    } else {
      gasProductInput.setAttribute('disabled', true);
    }

    const containerQuantity = this.element.querySelector('.gasBottomUSP[data-string]');
    if (containerQuantity) {
      const sellingInner = containerQuantity.dataset.string;
      containerQuantity.innerHTML = sellingInner.replace("{cylinder_count}", gasProductQuantity);
    }

    const button = document.querySelector('.Product--AddToCartButton[data-quantity]');
    button.setAttribute("data-quantity", gasProductQuantity);

    this.element.querySelector('.gasExchangeSubscription').setAttribute("data-quantity", gasProductQuantity);
  }

  toggleOption(event) {
    const button = document.querySelector('.Product--AddToCartButton[data-quantity]');
    const action = event.target.dataset.action;
    const allOptions = this.element.querySelectorAll(".gasExchange");

    if (
      event.target.getAttribute("aria-selected") === "true" ||
      event.target.classList.contains("RevolutionSelectbox--Button") ||
      event.target.classList.contains("RevolutionSelectbox--Item") ||
      (event.target.classList.contains("gasExchangeSubscription") === false &&
        event.target.classList.contains("gasExchangeOne") === false &&
        event.target.classList.contains("gasExchangeProduct") === false)
    ) {
      if (event.target.getAttribute("aria-selected") === "true" &&
        event.target.classList.contains("gasExchangeSubscription") &&
        new Responsive().matchesBreakpoint('pocket')) {
        // On mobile popup does not open if option is toggled (and it should open)
      } else {
        return; // Option is already toggled on, no action needed
      }
    }

    allOptions.forEach((item) => {
      item.setAttribute("aria-selected", "false");
      item.querySelector(".gasExchange--CheckmarkFull").setAttribute("aria-hidden", "true");
      item.querySelector(".gasExchange--CheckmarkEmpty").setAttribute("aria-hidden", "false");
    });

    const gas_product_id = document.querySelector("#gas_product_id");
    const gas_product_quantity = document.querySelector("#gas_product_quantity");
    const sellingPlan = document.querySelector("#selling_plan_id");
    const sellingPlanProduct = this.element.querySelector('#selling_product_id');
    const gasExchangeContent = this.element.querySelector(".gasExchange--Content");

    event.target.setAttribute("aria-selected", "true");
    event.target.querySelector(".gasExchange--CheckmarkFull").setAttribute("aria-hidden", "false");
    event.target.querySelector(".gasExchange--CheckmarkEmpty").setAttribute("aria-hidden", "true");
    this.ATCbutton = document.body.querySelectorAll('.mainATC');


    gasExchangeContent.setAttribute("aria-hidden", "true");

    if (action === "toggle-carbonator") {
      this.ATCbutton.forEach((item) => {
        item.setAttribute('data-action', 'add-all-to-cart');
      })
      gas_product_id.setAttribute("disabled", true);
      gas_product_quantity.setAttribute("disabled", true);
      gasExchangeContent.setAttribute("aria-hidden", "true");
      sellingPlanProduct.setAttribute('disabled', 'true');
      sellingPlan.setAttribute('disabled', 'true');
      gas_product_quantity.value = "1";
      this.element.querySelector(".gasExchange-TopSubInfo").style.display = "flex";
      this.buttons = document.querySelectorAll('.Product--AddToCartButton');
      this.buttons.forEach((item) => {
        item.removeAttribute('disabled');
      })
      button.setAttribute("data-quantity", "0");
    } else if (action === "toggle-gas") {
      this.ATCbutton.forEach((item) => {
        item.setAttribute('data-action', 'add-all-to-cart');
      })
      sellingPlanProduct.setAttribute('disabled', 'true');
      sellingPlan.setAttribute('disabled', 'true');
      gas_product_id.setAttribute('name', `${this.element.dataset.single}_id`);
      gas_product_id.dataset.id = this.element.dataset.single;

      gas_product_id.removeAttribute("disabled");
      // +.setAttribute("aria-hidden", "true");
      gas_product_quantity.value = "1";
      this.element.querySelector(".gasExchange-TopSubInfo").style.display = "flex";
      if (this.querySelector('.gasExchange--ZIPWrapper')) {
        this.buttons = document.querySelectorAll('.Product--AddToCartButton');
        this.buttons.forEach((item) => {
          item.removeAttribute('disabled');
        })

      }
      button.setAttribute("data-quantity", "1");
    } else {

      if (new Responsive().matchesBreakpoint('pocket')) {
        this.toggleMobileSubscription();
      } else {
        this.toggleSubscription();
      }

      const gasProductQuantity = document.querySelector("#gas_product_quantity");
      button.setAttribute("data-quantity", gasProductQuantity.value);
    }
  }

  adjustMobileSubscription() {
    const mobileQuantityToggle = event.target.closest(".GasExchange--MobileQuantityToggle");
    if (mobileQuantityToggle) {
      const name = mobileQuantityToggle.getAttribute("data-name");
      const namePlaceholder = this.element.querySelector(".GasExchange--MobileTitle");

      namePlaceholder.innerText = name;
    }

    this.toggleSteps(false, "2", "next");

    const selectedItem = document.querySelector('.gasMobilePopup .selecteditem');

    selectedItem.classList.remove('selecteditem')

    event.target.classList.add('selecteditem');

    const gas_product_quantity = document.querySelector("#gas_product_quantity");
    const sellingPlan = document.querySelector("#selling_plan_id");
    const sellingPlanProduct = document.querySelector("#selling_product_id");

    sellingPlanProduct.removeAttribute("disabled");
    sellingPlan.removeAttribute("disabled");

    let gasProductQuantity = event.target.dataset.value;
    if (gasProductQuantity == 0) {
      gasProductQuantity = 2;
    }
    const gasProductInput = this.element.querySelector('#gas_product_id');
    if (event.target.dataset.id) {
      gasProductInput.setAttribute('name', `${event.target.dataset.id}_id`);
      gasProductInput.dataset.id = event.target.dataset.id;
      gasProductInput.dataset.title = event.target.dataset.title;
      gasProductInput.dataset.price = event.target.dataset.priceItem;
      gasProductInput.dataset.sku = event.target.dataset.sku;
      gasProductInput.removeAttribute('disabled');
    } else {
      gasProductInput.setAttribute('disabled', true);
    }

    const containerQuantity = document.querySelector('.gasMobilePopup .gasBottomUSP[data-string]');
    if (containerQuantity) {

      const gas_product_quantity = document.querySelector("#gas_product_quantity");

      let sellingInner = containerQuantity.dataset.string;
      sellingInner = sellingInner.replace("{cylinder_count}", gasProductQuantity);
      containerQuantity.innerHTML = sellingInner;
    }

    const button = document.querySelector('.Product--AddToCartButton[data-quantity]');
    button.setAttribute("data-quantity", gasProductQuantity);
    this.element.querySelector('.gasExchangeSubscription').setAttribute("data-quantity", gasProductQuantity);

    const id = event.target.getAttribute("data-text-id");
    if (id) {
      this.handleMobileTextChange(id);
    }
  }

  toggleMobileSubscription() {
    if (event) {
      event.preventDefault();
    }
    const gas_product_id = document.querySelector("#gas_product_id");
    gas_product_id.setAttribute('name', `${this.element.dataset.last}_id`);
    gas_product_id.dataset.id = this.element.dataset.last;

    gas_product_id.removeAttribute("disabled");
    const pageOverlay = document.querySelector('.pageOverlaySubscriptions');
    pageOverlay.classList.add('is-visible');
    pageOverlay.addEventListener(
      "click",
      this.closePopup
    );
    const existingNode = document.querySelector('.gasMobilePopup');

    if (existingNode) {
      existingNode.remove();
    }

    const node = document.createElement('div');
    node.appendChild(
      this.element
        .querySelector("template#zipMobile")
        .content.firstElementChild.cloneNode(true)
    );
    document.body.appendChild(node.firstElementChild).focus();

    const mobilePopup = document.querySelector('.gasMobilePopup');
    bodyScrollLock.disableBodyScroll(mobilePopup, bodyScrollLockOptions);

    mobilePopup.querySelector('.mobileGasExchange-Continue').dataset.step = '1';
    mobilePopup.querySelector('.gasMobile--BackButton').dataset.step = '1';
  }


  toggleSubscription() {
    this.buttons = document.querySelectorAll('.Product--AddToCartButton');
    if (this.querySelector('.gasExchange--ZIPWrapper')) {
      this.buttons.forEach((item) => {
        item.setAttribute('disabled', 'true');
      })
    }

    const gas_product_id = document.querySelector("#gas_product_id");
    gas_product_id.setAttribute('name', `${this.element.dataset.last}_id`);
    gas_product_id.dataset.id = this.element.dataset.last;

    gas_product_id.removeAttribute("disabled");

    const gas_product_quantity = document.querySelector("#gas_product_quantity");
    const sellingPlan = document.querySelector("#selling_plan_id");
    const sellingPlanProduct = document.querySelector("#selling_product_id");
    const gasExchangeContent = this.element.querySelector(".gasExchange--Content");
    gas_product_quantity.value = this.element.querySelector("gas-exchange .selecteditem").dataset.value;

    sellingPlan.removeAttribute("disabled");
    sellingPlanProduct.removeAttribute('disabled');
    gasExchangeContent.setAttribute("aria-hidden", "false");
    const sellingPoint = this.element.querySelector("gas-exchange .gasExchange--bottomUSPSSelling p");
    this.element.querySelector(".gasExchange-TopSubInfo").style.display = "none";

    if (sellingPoint) {
      let sellingInner = sellingPoint.innerHTML.toString();
      const price = Shopify.formatMoney(this.element.dataset.subprice, window.theme.moneyFormat);
      sellingInner = sellingInner.replace("{cylinder_count}", gas_product_quantity.value);
      sellingInner = sellingInner.replace("{cylinder_price}", price);
      sellingPoint.innerHTML = sellingInner;
    }

    const containerQuantity = this.element.querySelector('gas-exchange .gasBottomUSP[data-string]');

    if (containerQuantity) {

      const gas_product_quantity = document.querySelector("#gas_product_quantity");
      let sellingInner = containerQuantity.dataset.string;

      sellingInner = sellingInner.replace("{cylinder_count}", gas_product_quantity.value);

      containerQuantity.innerHTML = sellingInner;
    }
  }
}

customElements.define("gas-exchange", GasExchange);

class GasExchangeUS extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    this.zips = window.zips;

    this.gasPopup = document.querySelector('.gasMobilePopup');


    if (this.element.dataset.load) {
      const exchangeProductPlan = document.querySelector('#exchange_plan_id');
      const exchangeProductId = document.querySelector('#exchange_product_id');

      if (exchangeProductId) {
        exchangeProductId.setAttribute('disabled', 'true');
        exchangeProductPlan.setAttribute('disabled', 'true');
      }

      const thisButton = document.querySelector('.AddToCartAjax');
      document.querySelector('#mainProduct').setAttribute('disabled', 'disabled');
      if (new Responsive().matchesBreakpoint('pocket')) {
        // New design: selectors are inline on mobile, so the main ATC adds
        // directly instead of opening the subscription popup.
        thisButton.setAttribute('data-action', 'add-all-to-cart');
      }
      this.toggleSubscription();
    }

    this.setStrings();
  }

  

  setStrings() {
    const count = this.getSelectedCylinderCount();
    if (count === null) return;
    this.updateCylinderCountStrings(count);
  }

  /* Current cylinder count taken from the inline quantity selectbox. */
  getSelectedCylinderCount() {
    const selectedValue = this.element.querySelector(
      ".RevolutionSelectbox--GasExchange .RevolutionSelectbox--InnerContent .selecteditem"
    );
    return selectedValue ? selectedValue.dataset.value : null;
  }

  /* Replace {cylinder_count} in every bottom USP that carries the raw string
     in data-string. Covers both the inline block and the mobile popup (the
     popup is cloned from a <template> into document.body, so it lives outside
     this element), and all USPs - not just the first match. */
  updateCylinderCountStrings(count) {
    if (count === null || count === undefined || count === "") return;

    const scopes = [this.element];
    const mobilePopup = document.querySelector(".gasMobilePopup");
    if (mobilePopup) scopes.push(mobilePopup);

    scopes.forEach((scope) => {
      scope.querySelectorAll(".gasBottomUSP[data-string]").forEach((elem) => {
        elem.innerHTML = elem.dataset.string.replace("{cylinder_count}", count);
      });
    });
  }

  connectedCallback() {
    this.delegateBody.on('keyup', '.gasExchange--ZIPCheck', this.checkZip.bind(this));
    this.delegateElement.on(
      "click",
      '[data-action="toggle-carbonator"]',
      this.toggleOption.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="toggle-gas"]',
      this.toggleOption.bind(this)
    );
    this.delegateBody.on(
      "click",
      '[data-action="toggle-subscription"]',
      this.toggleOption.bind(this)
    );
    // On mobile/tablet, tapping the inline cylinders selectbox opens the popup
    // straight on the cylinders step. Bound in the capture phase so it can stop
    // the inline RevolutionSelectbox dropdown (and the subscription toggle) from
    // firing for the same click.
    this.delegateElement.on(
      "click",
      '.RevolutionSelectbox--GasExchange .RevolutionSelectbox--Button',
      this.openMobileCylinders.bind(this),
      true
    );
    this.delegateElement.on(
      "click",
      '[data-action="selectbox-change"]',
      this.handleQuantityChange.bind(this)
    );

    this.delegateBody.on(
      "click",
      '[data-action="next-step"]',
      this.toggleSteps.bind(this)
    );

    this.delegateBody.on(
      "click",
      '[data-action="mobile-add"]',
      this.mobileAdd.bind(this)
    );

    this.delegateBody.on(
      "click",
      '[data-action="toggle-popup"]',
      this.toggleMobileSubscription.bind(this)
    );

    this.delegateBody.on(
      "click",
      '[data-action="close-mobile-popup"]',
      this.closePopup.bind(this)
    );

    this.delegateBody.on(
      "click",
      '[data-action="open-subpopup"]',
      this.openSubpopup.bind(this)
    );
    this.delegateBody.on(
      "focusin",
      'input.gasExchange--ZIPCheck',
      this.handleGasInputFocus.bind(this)
    );
    this.delegateBody.on(
      "focusout",
      'input.gasExchange--ZIPCheck',
      this.handleGasInputReset.bind(this)
    );

    this.delegateBody.on(
      "click",
      '[data-action="close-subpopup"]',
      this.closeSubpopup.bind(this)
    );
    this.delegateBody.on('click', '[data-action="toggle-msub"]', this.toggleMobileSubscription.bind(this));
    this.delegateBody.on('click', '[data-action="toggle-subscription-quantity"]', this.adjustMobileSubscription.bind(this));

    // The first cylinder option is rendered as pre-selected (.selecteditem) but
    // its state was never applied, so the hidden product inputs didn't match the
    // shown choice. Apply it now so the visible selection is the real one and
    // its availability is evaluated up front.
    this.initPreselectedCylinder();
  }

  // Apply the currently pre-selected cylinder option on load. Only the
  // subscription ("third option") layout drives add-to-cart from this inline
  // selectbox. handleQuantityChange only reads event.target, so a lightweight
  // { target } stand-in is enough to reuse it here.
  initPreselectedCylinder() {
    if (!this.element.dataset.load) return;
    const selected = this.element.querySelector(
      ".RevolutionSelectbox--GasExchange .RevolutionSelectbox--InnerContent .selecteditem"
    );
    if (selected) this.handleQuantityChange({ target: selected });
  }

  disconnectedCallback() {
    this.delegateElement.destroy();
    this.delegateBody.destroy();
  }


  checkZip(event) {
    let zipInput = "";
    let zipInputElement = "";
    if (!event) {
      zipInputElement = this.element.querySelector('.gasExchange--ZIPCheck');
      zipInput = zipInputElement.value;
    } else {
      zipInput = event.target.value;
      zipInputElement = event.target;
    }

    const zips = this.zips;

    this.buttons = document.querySelectorAll('.Product--AddToCartButton');

    const nextButton = document.querySelector('.mobileGasExchange-Continue');
    if (zips.includes(zipInput) && zipInput.length == 5) {
      zipInputElement.removeAttribute('style');

      this.buttons.forEach((item) => {
        item.removeAttribute('disabled');
      })
      if (nextButton) {
        nextButton.removeAttribute('disabled');
      }

    } else if (zipInput.length >= 5) {
      zipInputElement.style.color = "red";
      zipInputElement.style.borderColor = "red";
      const allInfo = document.querySelectorAll('.gasExchange--ZIPError');
      this.buttons.forEach((item) => {
        item.setAttribute('disabled', 'true');
      })
      allInfo.forEach((item) => {
        item.setAttribute('aria-hidden', 'false');
      })

      setTimeout(() => {
        allInfo.forEach((item) => {
          item.setAttribute('aria-hidden', 'true');
        })

      }, 5000);
    } else {
      if (nextButton) {
        nextButton.setAttribute('disabled', 'true');
      }
      this.buttons.forEach((item) => {
        item.setAttribute('disabled', 'true');
      })
      zipInputElement.removeAttribute('style');
    }

  }
  closeSubpopup() {

    const control = event.target.dataset.control;
    const popup = document.querySelector(`#${control}`);

    popup.setAttribute('aria-hidden', 'true');
  }
  openSubpopup() {
    const control = event.target.dataset.control;
    const popup = document.querySelector(`#${control}`);

    popup.setAttribute('aria-hidden', 'false');
  }

  mobileAdd() {
    const button = document.querySelector('.Product--AddToCartButton');
    // Same ZIP gate as the main ATC: the ZIP check disables this button when no
    // valid ZIP is entered, so refuse to add from the popup while it's disabled
    // and keep the popup's disabled state / "zip missing" note in sync.
    if (button.hasAttribute('disabled')) {
      this.syncMobilePopupGate();
      return;
    }
    button.setAttribute('data-action', 'add-all-to-cart');
    button.click();
    this.closePopup();
    document.querySelector('.AddToCartAjax').setAttribute('data-action', 'add-all-to-cart');
  }

  // Reflect the ZIP gate on the mobile popup's Add step: when the main ATC is
  // disabled (no valid ZIP) show the Add button as disabled and reveal the
  // "zip missing" note; otherwise enable it and hide the note.
  syncMobilePopupGate() {
    const mainButton = document.querySelector('.Product--AddToCartButton');
    const gasPopup = document.querySelector('.gasMobilePopup');
    if (!mainButton || !gasPopup) return;
    const zipMissing = mainButton.hasAttribute('disabled');
    const addButton = gasPopup.querySelector('[data-action="mobile-add"]');
    const note = gasPopup.querySelector('.product__mobile-gas-error-msg');
    if (addButton) {
      if (zipMissing) addButton.setAttribute('disabled', 'true');
      else addButton.removeAttribute('disabled');
    }
    if (note) note.setAttribute('aria-hidden', zipMissing ? 'false' : 'true');
  }

  closePopup() {
    bodyScrollLock.clearAllBodyScrollLocks();
    const mobilePopup = document.querySelector('.gasMobilePopup');
    mobilePopup.setAttribute('aria-visible', 'false');
    const pageOverlay = document.querySelector('.pageOverlaySubscriptions');
    pageOverlay.classList.remove('is-visible');
    document.querySelector('.AddToCartAjax').removeAttribute('disabled');
    // Closing the cylinders popup keeps the subscription selected and the main
    // ATC in direct-add mode (the popup is now only used to pick cylinders).
    document.querySelector('.AddToCartAjax').setAttribute('data-action', 'add-all-to-cart');
  }

  toggleSteps(event, step, direction) {
    if (event) {
      step = event.target.dataset.step;
      direction = event.target.dataset.direction;
    }

    const hideStep = (step) => {
      document.querySelector(`.gasStep[data-step='${step}']`).style.display = "none";
    };

    const showStep = (step) => {
      document.querySelector(`.gasStep[data-step='${step}']`).style.display = "block";
    };

    const hideBackButton = () => {
      mobilePopup.querySelector('.gasMobile--BackButton').style.display = "none";
    };

    const showBackButton = () => {
      mobilePopup.querySelector('.gasMobile--BackButton').style.display = "block";
    };

    const updateDataStep = (element, step) => {
      element.dataset.step = step;
    };

    const mobilePopup = document.querySelector('.gasMobilePopup');

    if (step == 1 && direction == "next") {
      hideStep(1);
      hideStep(3);
      showStep(2);
      showBackButton();

      updateDataStep(mobilePopup.querySelector('.mobileGasExchange-Continue'), "2");
      updateDataStep(mobilePopup.querySelector('.gasMobile--BackButton'), "2");
    } else if (step == 2 && direction == "backwards") {
      hideStep(2);
      showStep(1);
      hideStep(3);
      hideBackButton();

      updateDataStep(mobilePopup.querySelector('.mobileGasExchange-Continue'), "1");
      updateDataStep(mobilePopup.querySelector('.gasMobile--BackButton'), "1");
    } else if (step == 2 && direction == "next") {
      hideStep(2);
      showStep(3);
      showBackButton();
      this.syncMobilePopupGate();

      updateDataStep(mobilePopup.querySelector('.mobileGasExchange-Continue'), "3");
      updateDataStep(mobilePopup.querySelector('.gasMobile--BackButton'), "3");
    } else if (step == 3 && direction == "backwards") {
      hideStep(3);
      showStep(2);
      showBackButton();

      updateDataStep(mobilePopup.querySelector('.mobileGasExchange-Continue'), "2");
      updateDataStep(mobilePopup.querySelector('.gasMobile--BackButton'), "2");
    }
  }


  handleQuantityChange(event) {
    const priceContainer = this.element.querySelector('.gasExchangeSubscription .gasExchange--Price');
    const sellingPoint = this.element.querySelector(".gasExchange--bottomUSPSSelling p");
    const sellingPlan = this.element.querySelector('#selling_plan_id');
    const exchangeProductPlan = document.querySelector('#exchange_plan_id');
    const exchangeProductId = document.querySelector('#exchange_product_id');
    const gasProductQuantity = event.target.dataset.value;
    const gasProductInput = this.element.querySelector('#gas_product_id');

    // Record whether the chosen option can actually be purchased (Liquid marks
    // data-available from the real variant). The add-to-cart guard reads this so
    // an empty cart is only reported as "unavailable" when that's verified.
    this.element.dataset.selectedAvailable =
      event.target.dataset.available === "false" ? "false" : "true";

    sellingPlan.setAttribute('name', `plan_${event.target.dataset.id}`);
    sellingPlan.value = event.target.dataset.plan;
    sellingPlan.removeAttribute('disabled');

    let unitPrice = 0;

    const singlePrice = this.element.dataset.singleprice;

    if (event.target.dataset.price) {
      unitPrice = event.target.dataset.price;
    }
    let totalPrice = parseInt(singlePrice) + parseInt(unitPrice);

    if (gasProductQuantity == 0) {
      totalPrice = parseInt(this.element.dataset.mainprice);
    }

    if (this.dataset.load) {
      totalPrice = parseInt(unitPrice);
    }


    totalPrice = Shopify.formatMoney(totalPrice, window.theme.moneyFormat);
    totalPrice = totalPrice.replace('.00', '');

    if (event.target.dataset.id) {
      gasProductInput.setAttribute('name', `${event.target.dataset.id}_id`);
      gasProductInput.dataset.id = event.target.dataset.id;
      gasProductInput.dataset.title = event.target.dataset.title;
      gasProductInput.dataset.price = event.target.dataset.priceItem;
      gasProductInput.dataset.sku = event.target.dataset.sku;
      gasProductInput.removeAttribute('disabled');

    } else {
      gasProductInput.setAttribute('disabled', true);
    }
    const kitProduct = this.element.querySelector('#kit_product_id');
    if (gasProductQuantity == 0 && this.dataset.load) {
      gasProductInput.setAttribute('disabled', true);
    }
    if (gasProductQuantity == 0 && exchangeProductId) {

      exchangeProductId.removeAttribute('disabled');
      exchangeProductPlan.removeAttribute('disabled');

    } else if (kitProduct && gasProductQuantity == 1 && exchangeProductId) {
      exchangeProductId.removeAttribute('disabled');
      exchangeProductPlan.removeAttribute('disabled');

    } else if (exchangeProductId) {
      exchangeProductId.setAttribute('disabled', 'true');
      exchangeProductPlan.setAttribute('disabled', 'true');
    }

    if (kitProduct && gasProductQuantity == 0) {
      mainProduct.removeAttribute('disabled');
      kitProduct.setAttribute('disabled', 'true');

    } else {

      if (kitProduct) {
        kitProduct.removeAttribute('disabled');
      }
      mainProduct.setAttribute('disabled', 'true');
    }

    if (sellingPoint) {
      const sellingInner = this.element.querySelector(".gasExchange--bottomUSPSSelling").dataset.string;
      const price = Shopify.formatMoney(this.element.dataset.subprice, window.theme.moneyFormat);
      sellingPoint.innerHTML = sellingInner
        .replace("{cylinder_count}", gasProductQuantity)
        .replace("{cylinder_price}", price);
    }

    priceContainer.innerHTML = totalPrice;

    this.updateCylinderCountStrings(gasProductQuantity);

    this.updateButtonPrice(totalPrice);
    this.element.querySelector('.gasExchangeSubscription').setAttribute("data-quantity", gasProductQuantity);
  }

  toggleOption(event) {
    event.preventDefault();
    const button = document.querySelector('.mainATC.ProductPage--ATC');
    const action = event.target.dataset.action;
    const allOptions = this.element.querySelectorAll(".gasExchange");

    if (
      event.target.getAttribute("aria-selected") === "true" ||
      event.target.classList.contains("RevolutionSelectbox--Button") ||
      event.target.classList.contains("RevolutionSelectbox--Item") ||
      (event.target.classList.contains("gasExchangeSubscription") === false &&
        event.target.classList.contains("gasExchangeOne") === false &&
        event.target.classList.contains("gasExchangeProduct") === false)
    ) {
      if (event.target.getAttribute("aria-selected") === "true" &&
        event.target.classList.contains("gasExchangeSubscription") &&
        new Responsive().matchesBreakpoint('pocket')) {
        // On mobile popup does not open if option is toggled (and it should open)
      } else {
        return; // Option is already toggled on, no action needed
      }
    }

    allOptions.forEach((item) => {
      item.setAttribute("aria-selected", "false");
      item.querySelector(".gasExchange--CheckmarkFull")?.setAttribute("aria-hidden", "true");
      item.querySelector(".gasExchange--CheckmarkEmpty")?.setAttribute("aria-hidden", "false");
    });

    const exchangeProductPlan = document.querySelector('#exchange_plan_id');
    const exchangeProductId = document.querySelector('#exchange_product_id');

    const gas_product_id = document.querySelector("#gas_product_id");
    const gas_product_quantity = document.querySelector("#gas_product_quantity");
    const sellingPlan = document.querySelector("#selling_plan_id");
    const mainProduct = document.querySelector('#mainProduct');
    const gasExchangeContent = this.element.querySelector(".gasExchange--Content");

    const kitProduct = document.querySelector('#kit_product_id');

    event.target.setAttribute("aria-selected", "true");
    event.target.querySelector(".gasExchange--CheckmarkFull")?.setAttribute("aria-hidden", "false");
    event.target.querySelector(".gasExchange--CheckmarkEmpty")?.setAttribute("aria-hidden", "true");

    gasExchangeContent.setAttribute("aria-hidden", "true");

    if (action === "toggle-carbonator") {
      if (exchangeProductId) {
        exchangeProductId.setAttribute('disabled', 'true');
        exchangeProductPlan.setAttribute('disabled', 'true');
      }

      if (kitProduct) {
        mainProduct.removeAttribute('disabled');
        kitProduct.setAttribute('disabled', 'true');
      }

      mainProduct.removeAttribute('disabled');
      gas_product_id.setAttribute("disabled", true);
      gas_product_quantity.setAttribute("disabled", true);
      gasExchangeContent.setAttribute("aria-hidden", "true");


      gas_product_quantity.value = "1";
      this.element.querySelector(".gasExchange-TopSubInfo").style.display = "flex";
      this.buttons = document.querySelectorAll('.Product--AddToCartButton');
      this.buttons.forEach((item) => {
        item.removeAttribute('disabled');
      })
      button.setAttribute("data-quantity", "0");
      button.setAttribute('data-action', 'add-all-to-cart');
    } else if (action === "toggle-gas") {
      if (exchangeProductId) {
        exchangeProductId.setAttribute('disabled', 'true');
        exchangeProductPlan.setAttribute('disabled', 'true');
      }

      mainProduct.setAttribute('disabled', 'true');

      gas_product_id.setAttribute('name', `${this.element.dataset.single}_id`);
      gas_product_id.dataset.id = this.element.dataset.single;
      gas_product_id.removeAttribute("disabled");
      gasExchangeContent.setAttribute("aria-hidden", "true");
      gas_product_quantity.value = "1";


      if (kitProduct) {

        kitProduct.setAttribute('disabled', 'true');
      }

      this.element.querySelector(".gasExchange-TopSubInfo").style.display = "flex";
      if (this.querySelector('.gasExchange--ZIPWrapper')) {
        this.buttons = document.querySelectorAll('.Product--AddToCartButton');
        this.buttons.forEach((item) => {
          item.removeAttribute('disabled');
        })

      }
      button.setAttribute("data-quantity", "1");
      button.setAttribute('data-action', 'add-all-to-cart');

    } else {

      gas_product_id.setAttribute('name', `${this.element.dataset.biggest}_id`);
      gas_product_id.dataset.id = this.element.dataset.biggest;
      gas_product_id.removeAttribute('disabled');


      if (exchangeProductId) {
        exchangeProductId.setAttribute('disabled', 'true');
        exchangeProductPlan.setAttribute('disabled', 'true');
      }

      if (kitProduct) {

        kitProduct.removeAttribute('disabled');
        mainProduct?.setAttribute('disabled', 'true');
      } else {
        mainProduct.removeAttribute('disabled');
      }
      if (new Responsive().matchesBreakpoint('pocket')) {
        // New design: selecting the subscription reveals the inline selectors
        // (it no longer opens the popup). The cylinders popup is opened from the
        // cylinders selectbox instead, and the main ATC adds directly.
        button.setAttribute('data-action', 'add-all-to-cart');
      }
      this.toggleSubscription();

      const gasProductQuantity = document.querySelector("#gas_product_quantity");
      button.setAttribute("data-quantity", gasProductQuantity.value);
    }

    this.syncButtonPriceToOption(event.target);
  }

  /* Mirror the selected option's own price onto the ATC button. Each option box
     already shows the price that will be added to the cart - Liquid seeds it and
     handleQuantityChange keeps the subscription box in sync when the cylinder
     count changes - so it is the single source of truth for the button. */
  syncButtonPriceToOption(option) {
    const priceElem = option.querySelector(".gasExchange--RightWrapper .u-s3");
    if (!priceElem) return;

    this.updateButtonPrice(priceElem.innerText.trim());
  }

  adjustMobileSubscription() {
    const mobileQuantityToggle = event.target.closest(".GasExchange--MobileQuantityToggle");
    if (mobileQuantityToggle) {
      const oldItem = document.querySelector(".GasExchange--MobileQuantityToggle.selecteditem");
      if (oldItem) oldItem.classList.remove("selecteditem");

      mobileQuantityToggle.classList.add("selecteditem");

      const name = mobileQuantityToggle.getAttribute("data-name");

      // Reflect the chosen quantity on every inline cylinders-selectbox
      // button. The button visible on mobile has a plain
      // .RevolutionSelectbox--Title span (no GasExchange--MobileTitle class -
      // only the tablet block has that), so target the selectbox titles.
      this.element
        .querySelectorAll(".RevolutionSelectbox--GasExchange .RevolutionSelectbox--Title")
        .forEach((elem) => {
          elem.innerText = name;
        });
    }

    this.toggleSteps(false, "2", "next");
    const exchangeProductPlan = document.querySelector('#exchange_plan_id');
    const exchangeProductId = document.querySelector('#exchange_product_id');
    const priceContainer = this.element.querySelector('.gasExchangeSubscription .gasExchange--Price');
    const sellingPoint = this.element.querySelector(".gasExchange--bottomUSPSSelling p");
    const sellingPlan = this.element.querySelector('#selling_plan_id');
    const gasProductQuantity = event.target.dataset.value;
    const gasProductInput = this.element.querySelector('#gas_product_id');
    this.element.dataset.selectedAvailable =
      event.target.dataset.available === "false" ? "false" : "true";
    let unitPrice = 0;
    const singlePrice = this.element.dataset.singleprice;
    if (event.target.dataset.price) {
      unitPrice = event.target.dataset.price;
    }

    let totalPrice = parseInt(singlePrice) + parseInt(unitPrice);
    if (gasProductQuantity == 0) {
      totalPrice = parseInt(this.element.dataset.mainprice);
    }

    if (this.dataset.load) {
      totalPrice = parseInt(unitPrice);
    }

    totalPrice = Shopify.formatMoney(totalPrice, window.theme.moneyFormat);
    totalPrice = totalPrice.replace('.00', '');

    priceContainer.innerText = totalPrice;

    sellingPlan.setAttribute('name', `plan_${event.target.dataset.id}`);
    sellingPlan.value = event.target.dataset.plan;
    sellingPlan.removeAttribute('disabled');

    if (event.target.dataset.id) {
      gasProductInput.setAttribute('name', `${event.target.dataset.id}_id`);
      gasProductInput.dataset.id = event.target.dataset.id;
      gasProductInput.dataset.title = event.target.dataset.title;
      gasProductInput.dataset.price = event.target.dataset.priceItem;
      gasProductInput.dataset.sku = event.target.dataset.sku;
      gasProductInput.removeAttribute('disabled');

    } else {
      gasProductInput.setAttribute('disabled', true);
    }
    const kitProduct = this.element.querySelector('#kit_product_id');
    if (gasProductQuantity == 0 && this.dataset.load) {
      gasProductInput.setAttribute('disabled', true);
    }
    if (gasProductQuantity == 0 && exchangeProductId) {

      exchangeProductId.removeAttribute('disabled');
      exchangeProductPlan.removeAttribute('disabled');

    } else if (kitProduct && gasProductQuantity == 1 && exchangeProductId) {
      exchangeProductId.removeAttribute('disabled');
      exchangeProductPlan.removeAttribute('disabled');

    } else if (exchangeProductId) {
      exchangeProductId.setAttribute('disabled', 'true');
      exchangeProductPlan.setAttribute('disabled', 'true');
    }

    if (kitProduct && gasProductQuantity == 0) {
      mainProduct.removeAttribute('disabled');
      kitProduct.setAttribute('disabled', 'true');

    } else {

      if (kitProduct) {
        kitProduct.removeAttribute('disabled');
      }
      mainProduct.setAttribute('disabled', 'true');
    }

    this.updateCylinderCountStrings(event.target.dataset.value);

    this.updateButtonPrice(totalPrice);
  }

  updateButtonPrice(price) {
    if (!price) return;
    const buttons = Array.from(document.querySelectorAll(".ProductPage--ATC .button--money"));

    buttons.forEach(elem => {
      elem.innerText = price;
    })
  }

  openMobileCylinders(event) {
    // Desktop keeps the inline RevolutionSelectbox dropdown behaviour.
    if (!new Responsive().matchesBreakpoint('pocket')) return;

    // Open the mobile popup straight on the cylinders step. The zip is handled
    // by the inline selectors, so step 1 and the back button are skipped.
    this.toggleMobileSubscription();

    const mobilePopup = document.querySelector('.gasMobilePopup');
    if (mobilePopup) {
      mobilePopup.querySelector(".gasStep[data-step='1']").style.display = "none";
      mobilePopup.querySelector(".gasStep[data-step='2']").style.display = "block";
      const backButton = mobilePopup.querySelector('.gasMobile--BackButton');
      if (backButton) backButton.style.display = "none";
    }

    // Returning false flags the event so the inline dropdown and the
    // subscription toggle do not also fire for this click.
    return false;
  }

  toggleMobileSubscription() {
    event.preventDefault();
    const pageOverlay = document.querySelector('.pageOverlaySubscriptions');
    pageOverlay.classList.add('is-visible');
    pageOverlay.addEventListener(
      "click",
      this.closePopup
    );
    const existingNode = document.querySelector('.gasMobilePopup');

    if (existingNode) {
      existingNode.remove();
    }

    const node = document.createElement('div');
    node.appendChild(
      this.element
        .querySelector("template#zipMobile")
        .content.firstElementChild.cloneNode(true)
    );
    document.body.appendChild(node.firstElementChild).focus();

    const mobilePopup = document.querySelector('.gasMobilePopup');
    bodyScrollLock.disableBodyScroll(mobilePopup, bodyScrollLockOptions);
    mobilePopup.querySelector('.mobileGasExchange-Continue').dataset.step = '1';
    mobilePopup.querySelector('.gasMobile--BackButton').dataset.step = '1';
    // The popup is cloned fresh from the <template>, so its USPs still contain
    // the raw {cylinder_count} placeholder - sync them to the current selection.
    this.setStrings();
    this.checkZip();
  }


  toggleSubscription() {

    this.buttons = document.querySelectorAll('.Product--AddToCartButton');
    if (this.querySelector('.gasExchange--ZIPWrapper')) {
      this.buttons.forEach((item) => {
        item.setAttribute('disabled', 'true');
      })
    }


    const sellingPlan = document.querySelector("#selling_plan_id");
    const gasExchangeContent = this.element.querySelector(".gasExchange--Content");
    sellingPlan.removeAttribute("disabled");

    gasExchangeContent.setAttribute("aria-hidden", "false");
    this.element.querySelector(".gasExchange-TopSubInfo").style.display = "none";

    // The old selectors here were prefixed with "gas-exchange " (the non-US
    // component) and never matched inside <gas-exchange-us>, so the strings
    // kept their raw {cylinder_count} placeholder. Use the current inline
    // selection; '3' mirrors the old intended default before any selection.
    const count = this.getSelectedCylinderCount() ?? "3";

    const sellingWrapper = this.element.querySelector(".gasExchange--bottomUSPSSelling");
    const sellingPoint = sellingWrapper ? sellingWrapper.querySelector("p") : null;
    if (sellingPoint && sellingWrapper.dataset.string) {
      const price = Shopify.formatMoney(this.element.dataset.subprice, window.theme.moneyFormat);
      sellingPoint.innerHTML = sellingWrapper.dataset.string
        .replace("{cylinder_count}", count)
        .replace("{cylinder_price}", price);
    }

    this.updateCylinderCountStrings(count);
    this.checkZip();
  }

  handleGasInputFocus(){
    const gasPopup = document.querySelector('.gasMobilePopup'); 
    requestAnimationFrame(() => {
     const windowHeight = window.innerHeight;

    setTimeout(() => {
      gasPopup.style.bottom = windowHeight - window.visualViewport.height + "px";
    },100)
    });
}

handleGasInputReset() {
  const gasPopup = document.querySelector('.gasMobilePopup');
    gasPopup.style.bottom = "0px";
}

}

customElements.define("gas-exchange-us", GasExchangeUS);


class AccountHandler extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);

    const account = true;

    this.drawer = new Drawer(this.element.querySelector('#accountDrawer'));
    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on('click', '[data-action="toggle-tab"]', this.toggleTab.bind(this));
    this.delegateElement.on('click', '[data-action="submit-login"]', this.submitLogin.bind(this));
    this.delegateElement.on('click', '[data-action="submit-register"]', this.submitRegistration.bind(this));
    this.delegateElement.on('click', '[data-action="toggle-recovery"]', this.toggleRecovery.bind(this));
    this.delegateElement.on('click', '[data-action="submit-recovery"]', this.accountRecover.bind(this));
    this.delegateElement.on('click', '[data-action="submit-activate"]', this.submitActivation.bind(this));
    this.delegateElement.on('keyup', this.handleEnterPress.bind(this));
    
  }

  handleEnterPress() {
    if (event.type === "keyup" && event.keyCode !== 13) return;
    const target = event.target;

    if (target.getAttribute("data-action")) {
      target.click();

    } else if (target.getAttribute("data-enter-target")) {
      const action = target.getAttribute("data-enter-target");
      document.querySelector(`[data-action="${action}"]`).click();
    }
  }

  toggleRecovery() {
    event.preventDefault();
    const id = event.target.dataset.id;

    if (id == 'recoverFlex') {
      this.element.querySelector('#recoverFlex').setAttribute('aria-visible', 'true');
      this.element.querySelector('#loginFlex').setAttribute('aria-visible', 'false');
    }
    else {
      this.element.querySelector('#recoverFlex').setAttribute('aria-visible', 'false');
      this.element.querySelector('#loginFlex').setAttribute('aria-visible', 'true');
    }
  }

  async accountRecover(event) {
    event.preventDefault();

    event.target.querySelector('.button--text').style.visibility = "hidden";
    event.target.querySelector('.itemLoader').classList.add('is-visible');

    const recoverEndpoint = '/account/recover';

    // Create the request body with the registration data
    const requestBody = {
      email: this.element.querySelector('#RecoverEmail').value
    };

    // If hCaptcha is present, append the info into the request body
    if (window.hcaptcha) {
      const captchaToken = await window.hcaptcha.execute(null, { async: true });
      requestBody['h-captcha-response'] = captchaToken.response;
    }

    const responseText = await this.executeFetch(requestBody, recoverEndpoint, "password recovery");

    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = responseText;

    if (responseText.indexOf('RecoverEmail-email-error') !== -1) {
      this.element.querySelector('#recoverFlex .accountDrawer--ErrorSpace').innerHTML = tempDiv.querySelector('#RecoverEmail-email-error').innerHTML;
    } else if (responseText.indexOf('recoverSuccess') !== -1) {
      this.element.querySelector('#recoverFlex .accountDrawer--SuccessSpace').innerHTML = tempDiv.querySelector('#recoverSuccess').innerHTML;
    }


    event.target.querySelector('.button--text').style.visibility = "visible";
    event.target.querySelector('.itemLoader').classList.remove('is-visible');
  }

  async submitActivation(event) {
    event.preventDefault();

    event.target.querySelector('.button--text').style.visibility = "hidden";
    event.target.querySelector('.itemLoader').classList.add('is-visible');

    const registrationEndpoint = '/account';

    // Create the request body with the registration data
    const requestBody = {
      'customer': {
        'email': this.element.querySelector('#activate #RegisterForm-email').value
      }
    };

    // If hCaptcha is present, append the info into the request body
    if (window.hcaptcha) {
      const captchaToken = await window.hcaptcha.execute(null, { async: true });
      requestBody['h-captcha-response'] = captchaToken.response;
    }

    const responseText = await this.executeFetch(requestBody, registrationEndpoint, "activation");

    if (responseText.indexOf('registerErrors') !== -1) {
      console.log('Error occurred during registration');
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = responseText;

      this.element.querySelector('#activate .accountDrawer--ErrorSpace').innerHTML = tempDiv.querySelector('#registerErrors').innerHTML;
    } else {
      location.href = window.routes.account_url;
    }

    event.target.querySelector('.button--text').style.visibility = "visible";
    event.target.querySelector('.itemLoader').classList.remove('is-visible');
  }

  async submitRegistration(event) {
    event.preventDefault();

    event.target.querySelector('.button--text').style.visibility = "hidden";
    event.target.querySelector('.itemLoader').classList.add('is-visible');

    const registrationEndpoint = '/account';

    // Create the request body with the registration data
    const requestBody = {
      'customer': {
        'first_name': this.element.querySelector('#register #RegisterForm-FirstName').value,
        'last_name': this.element.querySelector('#register #RegisterForm-LastName').value,
        'email': this.element.querySelector('#register #RegisterForm-email').value,
        'password': this.element.querySelector('#register #RegisterForm-password').value
      }
    };

    // If hCaptcha is present, append the info into the request body
    if (window.hcaptcha) {
      const captchaToken = await window.hcaptcha.execute(null, { async: true });
      requestBody['h-captcha-response'] = captchaToken.response;
    }

    const responseText = await this.executeFetch(requestBody, registrationEndpoint, "registration");

    if (responseText.indexOf('registerErrors') !== -1) {
      console.log('Error occurred during registration');
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = responseText;


      this.element.querySelector('#register .accountDrawer--ErrorSpace').innerHTML = tempDiv.querySelector('#registerErrors').innerHTML;
    } else {
      location.href = window.routes.account_url;
    }

    event.target.querySelector('.button--text').style.visibility = "visible";
    event.target.querySelector('.itemLoader').classList.remove('is-visible');
  }

  async submitLogin(event) {
    event.preventDefault();

    if (event.type === "keyup" && event.keyCode !== 13) return;

    event.target.querySelector('.button--text').style.visibility = "hidden";
    event.target.querySelector('.itemLoader').classList.add('is-visible');

    const loginEndpoint = '/account/login';

    // Create the request body with the login credentials
    const requestBody = {
      'customer': {
        'email': this.element.querySelector('#customer_login #CustomerEmail').value,
        'password': this.element.querySelector('#customer_login #CustomerPassword').value
      }
    };

    // If hCaptcha is present, append the info into the request body
    if (window.hcaptcha) {
      const captchaToken = await window.hcaptcha.execute(null, { async: true });
      requestBody['h-captcha-response'] = captchaToken.response;
    }

    const responseText = await this.executeFetch(requestBody, loginEndpoint, "login");

    if (responseText.indexOf('loginError') !== -1) {
      console.log('Incorrect email or password');
      const tempDiv = document.createElement('div');

      tempDiv.innerHTML = responseText;

      this.element.querySelector('#login .accountDrawer--ErrorSpace').innerHTML = tempDiv.querySelector('.AlertError').innerHTML;
    } else {
      location.href = window.routes.account_url;
    }

    event.target.querySelector('.button--text').style.visibility = "visible";
    event.target.querySelector('.itemLoader').classList.remove('is-visible');
  }

  async executeFetch(requestBody, endpoint, process) {
    try {
      const response = await fetch(endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

        const responseText = await response.text();

      return responseText;
    } catch (error) {
      console.error(`An error occurred during the ${process} process:`, error);
    }
  }

  toggleTab(event) {
    const id = event.target.dataset.id;
    const allTabs = this.element.querySelectorAll('.accountDrawer--Tab[aria-expanded="true"]');
    const allContent = this.element.querySelectorAll('.accountContent');

    allTabs.forEach((tab) => {
      tab.setAttribute('aria-expanded', 'false');
    });

    event.target.setAttribute('aria-expanded', 'true');
    allContent.forEach((content) => {
      content.setAttribute('aria-visible', 'false');
    });

    const content = this.element.querySelector(`#${id}`);
    if (content) {
      content.setAttribute('aria-visible', 'true');
    }
  }

}

customElements.define("account-handler", AccountHandler);

class CustomThree extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    this.initSwiper();
    new AddToCart(this.element);

    // sets product height
    this.products = Array.from(this.element.querySelectorAll('.CustomThree--ProductCard'));
    this.findLargestProductCard();

    // sets row height
    this.findLastRow();

    this.handleResize();
    setTimeout(() => {
      this.handleResize();
    }, 800)

    this.bindEvents();
  }

  initSwiper() {
    this.carouselElement = this.element.querySelector(".swiper");
    if (this.carouselElement) {
      this.carousel = new RevolutionSwiper(this.carouselElement);
    }
  }

  // finds last row and sets its index to this.index
  findLastRow() {
    const items = this.element.querySelectorAll(".CustomThree--MetafieldRow");
    let index = 0;

    items.forEach(item => {
      const currIndex = Number(item.dataset.index);
      if (currIndex > index) index = currIndex;
    })

    this.index = index;
  }

  // finds largest product in this.products and saves it to this.largestProduct
  findLargestProductCard() {
    let largestHeight = 0;

    this.products.forEach(product => {
      if (product.offsetHeight > largestHeight) {
        largestHeight = product.offsetHeight;
      }
    });

    this.products.forEach(product => {
      if (product.offsetHeight === largestHeight) {
        product.classList.add("largest");
      }
    })
  }

  bindEvents() {
    window.addEventListener('resize', this.handleResize.bind(this))
  }

  handleResize() {
    this.resizeRows();
    this.setProductCardHeights(this.products, this.element.querySelector(".CustomThree--ProductCard.largest"));
  }

  setProductCardHeights(blocks, largest) {
    if (!blocks || !largest) return;

    const height = largest.getBoundingClientRect().height;

    blocks.forEach((elem) => {
      if (!elem.classList.contains("largest")) {
        elem.style.height = height + "px";
      }
    });
  }

  resizeRows() {
    if (!this.index) return;

    for (let i = 0; i <= this.index; i++) {
      const row = Array.from(this.element.querySelectorAll(`.CustomThree--MetafieldRow[data-index="${i}"]`));

      if (row.length > 1) {
        this.findLargestElem(i, row);
        const height = this.getLargestHeight(i);
        this.setElemsHeight(row, height);
      }

      const titleRow = Array.from(this.element.querySelectorAll(`.CustomThree--BlockTitle[data-index="${i}"]`));

      if (titleRow.length > 1) {
        this.findLargestElem(i, titleRow);
        const height = this.getLargestHeight(i);
        this.setElemsHeight(titleRow, height);
      }
    }
  }

  findLargestElem(index, array) {
    if (this.element.querySelector(`.largest[data-index="${index}"]`)) return;

    let height = 0;
    let largestInnerHtml = 0;

    array.forEach(elem => {
      const elemHeigh = elem.getBoundingClientRect().height;

      if (elemHeigh > height) {
        height = elemHeigh;
        largestInnerHtml = elem.innerHTML.length;

      } else if (elemHeigh === height && elem.innerHTML.length > largestInnerHtml) {
        height = elemHeigh;
        largestInnerHtml = elem.innerHTML.length;
      }
    })

    array.forEach(elem => {
      const elemHeight = elem.getBoundingClientRect().height;
      const elemInnerHtmlLenght = elem.innerHTML.length;

      if (elemHeight === height && elemInnerHtmlLenght === largestInnerHtml) {
        elem.classList.add("largest");
      }
    })
  }

  getLargestHeight(index) {
    const elem = this.element.querySelector(`.largest[data-index="${index}"]`);
    return elem.getBoundingClientRect().height;
  }

  setElemsHeight(array, height) {
    array.forEach(elem => {
      if (!elem.classList.contains("largest")) {
        elem.style.height = height + "px";
      }
    })
  }
}
customElements.define("custom-three", CustomThree);

class ConnectedItems extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.carouselElement = this.element.querySelector(".swiper");
    this.carousel = new RevolutionSwiper(this.carouselElement);

    this.delegateElement = new Delegate(this.element);
    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on('click', '.ConnectedItems--Dropdown', this.handleDropdownClick.bind(this));
  }

  handleDropdownClick(event) {
    event.stopPropagation();
  }
}

customElements.define("connected-items", ConnectedItems);

class SliderText extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    this.carouselElement = this.element.querySelector(".swiper");
    if (this.carouselElement) {
      this.carousel = new RevolutionSwiper(this.carouselElement);
    }
  }
}

customElements.define("slider-text", SliderText);

class BottomAction extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.bindEvents();

  }

  bindEvents() {
    this.observeFeaturedCollection();

  }

  observeFeaturedCollection() {
    const bottomActionWrapper = this.querySelector('.bottomAction--wrapper');
    const featuredCollectionSection = document.querySelector('.FeaturedCollectionSection--Wrapper ');

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          bottomActionWrapper.style.opacity = 0;

        } else {
          bottomActionWrapper.style.opacity = 1;

        }
      });
    });

    if (featuredCollectionSection) {
      observer.observe(featuredCollectionSection);
    }
  };


}
customElements.define('bottom-action', BottomAction);

class ProductCard extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    this.carouselElement = this.element.querySelector(".swiper");
    if (this.carouselElement) {
      this.carousel = new RevolutionSwiper(this.carouselElement);
    }

    this.delegateElement = new Delegate(this.element);
    this.colorDrawer = this.element.querySelector('.ProductCardDesktop--SelectColorDropdown:has( [data-variant-id])');
    this.colorDrawerMobile = this.element.querySelector('.ProductCardMobile--SelectColorDropdown:has( [data-variant-id])');
    this.pageOverlayElement = document.querySelector(".pageOverlay");

    if (this.colorDrawer && this.colorDrawerMobile) {
      this.colorDrawerOpen = false;
      this.colorDrawerMobileOpen = false;

      this.delegateElement.on('click', '.product-card__atc', this.handleATCButtonClick.bind(this));
    }
    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on('click', '.connectedProducts--colorWrapperLink', this.handleColorClick.bind(this));
    this.delegateElement.on('click', '.cardProduct--Inner', this.handleProductCardClick.bind(this));
    this.delegateElement.on('click', '[data-action="go-to-link"]', this.goToLink.bind(this));

    this.onClickOutsideListener = this.handleMouseOut.bind(this);

     this.delegateElement.on("keydown", (event)=>{
        if (event.key === "Enter") {
          const activeElement = document.activeElement;
          const isNext = activeElement.getAttribute("aria-label")?.toLowerCase().includes("next");
          const isPrev = activeElement.getAttribute("aria-label")?.toLowerCase().includes("previous");

          if(isNext){
            this.carousel.swiper.slideNext();
          }
          if(isPrev){
            this.carousel.swiper.slidePrev();
          }
        }
      }
    );
    this.delegateElement.on("keydown", (event)=>{
      if (event.key === "Enter") {
        this.handleProductCardClick(event);
      }
    });
  }

  handleATCButtonClick(event) {
    event.preventDefault();
    event.stopPropagation();

    if (window.innerWidth > 1025) {
      this.colorDrawer.setAttribute('aria-hidden', false);
      this.colorDrawerOpen = true;
    } else {
      this.pageOverlayElement.classList.add("is-visible");
      this.pageOverlayElement.addEventListener(
        "click",
        this.onClickOutsideListener
      );
      if (this.colorDrawerMobileOpen) {
        this.colorDrawerMobile.setAttribute('aria-hidden', true);
        this.colorDrawerMobileOpen = false;

        setTimeout(() => {
          document.body.removeChild(this.colorDrawerMobile);

          document.body.appendChild(this.colorDrawerMobile);

          setTimeout(() => {
            this.colorDrawerMobile.setAttribute('aria-hidden', false);
            this.colorDrawerMobileOpen = true;
            this.currentMobileColorSelector = document.querySelector('.ProductCardMobile--SelectColorDropdown[aria-hidden="false"]');
            this.currentMobileColorSelector.addEventListener('click', this.handleMobileColorClick.bind(this));
          }, "100");

        }, "400");
      } else {
        document.body.appendChild(this.colorDrawerMobile);

        setTimeout(() => {
          this.colorDrawerMobile.setAttribute('aria-hidden', false);
          this.colorDrawerMobileOpen = true;
          this.currentMobileColorSelector = document.querySelector('.ProductCardMobile--SelectColorDropdown[aria-hidden="false"]');
          this.currentMobileColorSelector.addEventListener('click', this.handleMobileColorClick.bind(this));
        }, "100");
      }
    }
  }

  handleColorClick(event) {
    if (this.colorDrawerOpen) {
      this.colorDrawer.setAttribute('aria-hidden', true);
      this.colorDrawerOpen = false;
    } else if (this.colorDrawerMobileOpen) {
      this.colorDrawerMobile.setAttribute('aria-hidden', true);
      this.colorDrawerMobileOpen = false;

      setTimeout(() => {
        document.body.removeChild(this.colorDrawerMobile);
      }, "400");
    }
  }

  handleMobileColorClick(event) {

    if (event.target.closest('.SelectboxCircle')) {
      let currentId = event.target.getAttribute('data-variant-id');

      this.element.querySelector(`[data-variant-id="${currentId}"]`).click();
    } else if (event.target.closest('.ProductCardMobile--CloseIcon')) {
      this.colorDrawerMobile.setAttribute('aria-hidden', true);
      this.colorDrawerMobileOpen = false;
      this.pageOverlayElement.classList.remove("is-visible");
      setTimeout(() => {
        document.body.removeChild(this.colorDrawerMobile);
      }, "400");
    }
  }

  handleMouseOut() {

    if (this.colorDrawerOpen) {
      this.colorDrawer.setAttribute('aria-hidden', true);
      this.colorDrawerOpen = false;
    } else if (this.colorDrawerMobile) {
      this.colorDrawerMobile.setAttribute('aria-hidden', true);
      this.colorDrawerMobileOpen = false;
      this.pageOverlayElement.classList.remove("is-visible");
    }
  }

  handleProductCardClick(event) {

    if (!event.target.matches('button, .Button, a.Button, div[data-action="add-to-cart"], button *, .Button *, a.Button *, div[data-action="add-to-cart"] *, .ProductCardDesktop--SelectColorDropdown, .ProductCardDesktop--SelectColorDropdown *')) {
      let link = this.element.querySelector('.cardProduct--Inner').getAttribute('data-link');
      window.location.href = link;
    }
  }

  goToLink() {
    event.preventDefault();
    event.stopPropagation();

    const link = event.target.closest('[data-action="go-to-link"]').getAttribute('data-link');
    if (link) {
      window.location.href = link;
    }
  }
};

customElements.define('product-card', ProductCard);

class ProductCarousel extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    this.carouselElement = this.element.querySelector(".ProductCarousel--Swiper");
    if (this.carouselElement) {
      this.carousel = new RevolutionSwiper(this.carouselElement);
    }

    new AddToCart(this.element);
  }

  bindEvents() {
    let responsive = new Responsive();
    let breakpoint = responsive.getCurrentBreakpoint();
    if (breakpoint == "phone" || breakpoint == "tablet") {
      this.animateInMobile();
    }
    const imageContainer = this.element.querySelector('[data-action="animate"]');
    const button = this.element.querySelector('.FeaturedCollection__Button');

    imageContainer.addEventListener("mouseenter", this.animateIn.bind(this));
    imageContainer.addEventListener("mouseleave", this.animateOut.bind(this));

    button.addEventListener("mouseenter", this.animateIn.bind(this));
  }

  animateInMobile() {


    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        // Check if the observed element is in view
        if (entry.isIntersecting) {
          // Perform the animation when in view
          setTimeout(() => {
            const children = this.element.querySelectorAll('.FeaturedCollection__Subtitle.not_desktop > p');
            const button = this.element.querySelector('.FeaturedCollection__Button');

            children.forEach((child, index) => {
              child.classList.add(`${this.animationClass}`);
              child.style.transitionDelay = `${index * 0.1 + 0.1}s`;
            });
            if (button) {
              button.classList.add(`${this.animationClass}`);
            }

          }, 1000);
          // Stop observing once the animation is triggered
          observer.unobserve(entry.target);

        }
      })
    })
    const featuredCollectionElement = document.querySelector('.FeaturedCollection.featuredColl--opacity');
    observer.observe(featuredCollectionElement);



  }

  animateIn(e) {
    e.preventDefault();
    const children = this.element.querySelectorAll('.FeaturedCollection__Subtitle.not_mobile > p');
    const button = this.element.querySelector('.FeaturedCollection__Button');

    children.forEach((child, index) => {
      child.classList.add(`${this.animationClass}`);
      child.style.transitionDelay = `${index * 0.1 + 0.1}s`;
    });

    button.classList.add(`${this.animationClass}`);
  }

  animateOut(e) {
    e.preventDefault();
    const children = this.element.querySelectorAll('.FeaturedCollection__Subtitle.not_mobile > p');

    const button = this.element.querySelector('.FeaturedCollection__Button');

    const numChildren = children.length;

    children.forEach((child, index) => {
      const delay = (numChildren - index - 1) * 0.1;
      child.style.transitionDelay = `${delay}s`;
      child.classList.remove(`${this.animationClass}`);
    });

    if (button) {
      button.classList.remove(`${this.animationClass}`);
    }

  }
}

customElements.define("product-carousel", ProductCarousel);


class NotifyMe extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    this.initVariables();
  }

  initVariables() {
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.pageOverlayElement = document.querySelector(".pageOverlay");

    this.checkmarkSvg =
      `<svg class="Svg Svg--checkmark mr-m" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 21 20" fill="none">
        <path d="M8.12213 15.3833L2.32768 9.59442C2.13892 9.37399 2.15161 9.04542 2.35681 8.84021C2.56202 8.63501 2.89059 8.62232 3.11101 8.81108L8.11101 13.8111L17.8832 4.04997C18.1037 3.86121 18.4322 3.8739 18.6374 4.0791C18.8426 4.28431 18.8553 4.61288 18.6666 4.8333L8.12213 15.3833Z" fill="white"/>
      </svg>`
  }

  /**
   * Binds necessary events to elements.
   */
  connectedCallback() {
    this.delegateBody.on("click", '[data-action="open-bis"]', this.openNotifyMe.bind(this));
    this.delegateBody.on("click", '[data-action="triger-bis"]', this.handleSubscribeClick.bind(this));
    this.delegateElement.on("click", '[data-action="close-modal"]', this.closeModal.bind(this));

    this.onClickOutsideListener = this.closeModal.bind(this);
  }

  /**
   * Handles the subscription process.
   */
  handleSubscribeClick() {
    event.preventDefault();
    event.stopPropagation();

    const emailInput = this.element.querySelector('[name="bis_mail"]');
    const email = emailInput.value;
    const checked = this.element.querySelector("#bis-popup__newsletter-checkbox:checked");

    if (!emailInput.checkValidity()) return emailInput.reportValidity();

    this.subToNotifyMe(email);
    if (checked) subscribeToKlaviyo(email); //this.subscribeToKlaviyo(email);
  }

  subscribeToKlaviyo(email) {
    const klaviyoForm = document.querySelector(".klaviyo-form-Wp2Jgv");
    if (!klaviyoForm) return;

    const input = klaviyoForm.querySelector('input[name="email"]');

    input.focus();
    input.click();
    input.value = email;
    input.removeAttribute("novalidate");
    input.setAttribute("aria-invalid", "false");
    input.reportValidity();

    const button = klaviyoForm.querySelector('button[type="submit"]');
    button.click();
  }

  validateEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  async subToNotifyMe(event) {
    const email = document.querySelector('.bis_input')?.value?.trim();


    if (!email || !this.validateEmail(email)) {
      alert("Molimo unesite validan email.");
      return;
    }

    console.log('Email:', email, 'Variant:', this.variantId, 'Product:', this.productId);
    
    // await fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=REH2E6`, {
    //   method: 'POST',
    //   headers: {
    //     'Content-Type': 'application/json',
    //     'revision': '2025-04-15' // opcionalno
    //   },
    //   body: JSON.stringify({
    //     data: {
    //       type: 'back-in-stock-subscription',
    //       attributes: {
    //         profile: { data: { type: 'profile', attributes: { email: email } } },
    //         channels: ['EMAIL']
    //       },
    //       relationships: {
    //         variant: {
    //           data: { type: 'catalog-variant', id: `$shopify:::$default:::${this.variantId}` }
    //         }
    //       }
    //     }
    //   })
    // });
    
    const payload = {
      "data": {
        "type": "back-in-stock-subscription",
        "attributes": {
          "profile": {
            "data": {
                "type": "profile",
                "attributes": {
                    "email": email,
                }
            }
          },
          "channels": ["EMAIL"],
        },
        "relationships": {
          "variant": {
            "data": {
              "type": "catalog-variant",
              "id": `$shopify:::$default:::${this.variantId}`
            }
          }
        }
      }
    }

    var requestOptions = {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          "revision":"2024-06-15"
        },
        body: JSON.stringify(payload),
    };

    fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${window.theme.klaviyoBackInStock}`,requestOptions)
      .then(result => {
        console.log(result)
        if (result.ok) {
            this.showSuccessState();
          } else {
            console.log("Došlo je do greške. Pokušajte ponovo.");
          }
      })
      .catch(error => console.log('error', error));

      
    }


  /**
   * Shows a success message upon successful subscription.
   */
  showSuccessState() {
    this.element.querySelector('.preSuccessText').style.display = "none";
    this.element.querySelector('.successText')?.setAttribute('aria-hidden', 'false');
    this.emailInput = this.element.querySelector(".bis_input");
    this.emailInput.style.display = "none";

    const legalInfo = this.element.querySelector('.Newsletter--LegalInfo');
    const newsletterCheckbox = this.element.querySelector('.bis-popup__sub-to-newsletter');

    if (legalInfo) legalInfo.style.display = "none";
    if (newsletterCheckbox) newsletterCheckbox.style.display = "none";

    this.updateButtonState();
    this.updateAtcButtonState();
    this.updateStickyButtonState();
  }

  /* updates submit button to successful state */
  updateButtonState() {
    const button = this.element.querySelector('.NewsletterPopupSubmit');
    const buttonTextElem = button.querySelector(".button--text");
    this.buttonText = buttonTextElem.innerText;

    button.setAttribute('data-action', 'close-modal');
    buttonTextElem.innerHTML = "OK";
    button.style.maxWidth = "134px";
    button.style.margin = '0 auto';
  }

  /* updates atc button state to signed up */
  updateAtcButtonState() {
    if (this.successTextButton) {
      const ButtonTextWrapper = this.successTextButton.querySelector(".button--text");
      ButtonTextWrapper.innerText = this.successTextButton.getAttribute("data-success-form-text");

      const oldSvg = this.successTextButton.querySelector("svg");
      if (oldSvg) {
        const tempParent = oldSvg.parentElement;
        oldSvg.remove();
        ButtonTextWrapper.innerHTML = this.checkmarkSvg + ButtonTextWrapper.innerHTML;
      }

      this.successTextButton.setAttribute("disabled", "");
    }
  }

  /* updates atc button state to signed up */
  updateStickyButtonState() {
    const isMobile = new Responsive().matchesBreakpoint("pocket");
    let stickyBar = document.querySelector(".Product--StickyBarDesktop");
    if (isMobile) {
      stickyBar = document.querySelector(".Product--StickyBarMobile");
    }

    if (stickyBar && isMobile) {
      const stickyButton = stickyBar.querySelector('.ProductPage--ATC');
      const stickyButtonTextWrapper = stickyBar.querySelector(".button--text");

      stickyButtonTextWrapper.innerText = stickyButton.getAttribute("data-success-form-text");
      stickyButtonTextWrapper.innerHTML = this.checkmarkSvg + stickyButtonTextWrapper.innerHTML;

      stickyButton.setAttribute("disabled", "");
    } else if (stickyBar) {
      const stickyButton = stickyBar.querySelector('.ProductPage--ATC');
      const stickyButtonTextWrapper = stickyBar.querySelector(".button--text");

      stickyButtonTextWrapper.innerText = stickyButton.getAttribute("data-success-form-text");

      stickyButton.setAttribute("disabled", "");
    }
  }

  /**
   * Opens the NotifyMe modal.
   * @param {Event} event - The event object.
   */
  openNotifyMe(event) {
    event.preventDefault();
    event.stopPropagation();
    this.element.dispatchEvent(
      new CustomEvent("close:search", { bubbles: true })
    );

    const target = event.target.closest('[data-action="open-bis"]');
    if (!target) {
      console.log("Target not found!");
      return;
    }

    this.successTextButton = target.closest("[data-success-form-text]");

    this.pageOverlayElement.classList.add("is-visible");
    this.activeModal = document.getElementById('bis_popup');
    this.productId = target.dataset.product;
    this.variantId = target.dataset.variant;

    this.activeModal.setAttribute("aria-hidden", "false");
    this.activeModal.setAttribute("aria-expanded", "true");
    this.activeModal.style.display = "block";
    this.pageOverlayElement.addEventListener("click", this.onClickOutsideListener);

    const legalInfo = this.element.querySelector('.Newsletter--LegalInfo');
    const newsletterCheckbox = this.element.querySelector('.bis-popup__sub-to-newsletter');

    if (legalInfo) legalInfo.style.display = "block";
    if (newsletterCheckbox) newsletterCheckbox.style.display = "block";

    const input = this.querySelector('.bis_input');
    const buttonSubmit = this.querySelector('.NewsletterPopupSubmit');

    input.addEventListener("input", (event) => {

      let inputValue = event.target.value;
      if (inputValue.includes('@') && inputValue != '') {
        buttonSubmit.setAttribute("enabled", "");
      } else {
        buttonSubmit.removeAttribute("enabled");
      }
    });



    setTimeout(() => {
      trapFocus(this.activeModal);
    }, 100);
    bodyScrollLock.disableBodyScroll(this.element, bodyScrollLockOptions);
  }

  /**
   * Closes the NotifyMe modal.
   */
  closeModal() {
    event.preventDefault();

    this.activeModal = document.body.querySelector('#bis_popup');
    this.pageOverlayElement.classList.remove("is-visible");
    this.pageOverlayElement.removeEventListener("click", this.onClickOutsideListener);
    this.activeModal.setAttribute("aria-hidden", "true");
    this.activeModal.setAttribute("aria-expanded", "false");

    bodyScrollLock.clearAllBodyScrollLocks();
    this.activeModal.removeAttribute("style");

    setTimeout(() => {
      this.emailInput.style.display = "block";
      this.defaultSubmitButtonState();
    }, 200)
  }

  /* after you submit your email button state turns to "ok" and it closes popup */
  /* sets submit buttons state back to normal after the popup has been closed */
  defaultSubmitButtonState() {
    const button = this.element.querySelector('.NewsletterPopupSubmit[data-action="close-modal"]');
    if (!button || !this.buttonText) return;

    const action = "triger-bis";
    button.dataset.action = action;
    button.querySelector(".button--text").innerText = this.buttonText;
  }
}

customElements.define("bis-popup", NotifyMe);

class GwpBlock extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    /* get cart then when data is returned initialise */
    this.getCart(true, false);
  }

  async getCart(intialise, item) {
    try {
      const response = await fetch(window.routes.localeRootUrl + "/cart.js", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
      });

      const data = await response.json();
      this.cart = data;

      if (intialise) {
        this.intialise();
      }

      if (item) {
        item.style.pointerEvents = "all";
      }

      const itemCount = document.querySelector(".CartCount__Count");
      if (itemCount) {
        itemCount.innerText = `${this.cart.item_count}`;
      }
    } catch (error) {
      console.log('Fetch Error:', error);
    }
  }

  intialise() {
    this.gwp = this.element.querySelector('.Gwp--Wrapper');
    if (!this.gwp) {
      return false;
    }

    this.gifts = [];
    this.giftItem = this.element.querySelector(".Gwp--GiftItemTemplate").content;
    this.swiperWrapper = this.gwp.querySelector(".Gwp--SwiperWrapper");
    this.limit = 0;

    this.isSkuCondition();
    this.isPriceCondition();
    this.isAmountCondition();

    if (this.gifts.length > 0) {
      this.cleanUpTheArray();
      this.addGiftsToSwiper(this.gifts);
    }

    this.refreshGwp();
  }

  cleanUpTheArray() {
    // first we remove duplicates then we add certain amount of them only if needed
    // remove duplicates

    const tempGiftList = this.gifts.filter(
      (obj, index, self) =>
        index ===
        self.findIndex(
          (t) => t.id === obj.id
        )
    );
    this.gifts = tempGiftList;

    // needed amount of duplicates is limit number * gift
    for (let i = 1; i < this.limit; i++) {
      this.gifts = this.gifts.concat(tempGiftList);
    }
  }

  /* check if all products in gwp condition are in the cart */
  isSkuCondition() {
    const conditionSkuJson = this.gwp.getAttribute("data-sku-condition");
    let skuGiftsJson = this.gwp.getAttribute("data-sku-gifts");

    if (!conditionSkuJson || !skuGiftsJson) {
      console.log("Sku not activated");
      return;
    }

    skuGiftsJson = skuGiftsJson.replace(/&quot/g, '"');
    skuGiftsJson = skuGiftsJson.replace(/&apos/g, "'");

    const skuLimit = parseInt(this.gwp.getAttribute("data-sku-limit"));
    const customSkuLimit = this.gwp.getAttribute("data-custom-sku-limit");
    const conditionProducts = JSON.parse(conditionSkuJson);

    const cartItems = this.cart.items;
    let cartSkus = [];

    cartItems.forEach(item => {
      if (item.properties.Type !== "Gift") {
        cartSkus.push(item.sku);
      }
    })

    if (cartSkus.length === 0) {
      console.log("Cart empty");
      return;
    }

    let conditionMeet = 0;
    conditionProducts.forEach(item => {
      item.variants.forEach(variant => {
        if (cartSkus.includes(variant.sku) && variant.sku) {
          conditionMeet++;
        }
      })
    })

    if (conditionMeet) {
      if (customSkuLimit === "false") {
        this.limit = this.limit + (skuLimit * conditionMeet);
      } else {
        this.limit = this.limit + skuLimit;
      }

      const skuGifts = JSON.parse(skuGiftsJson);
      this.gifts = this.gifts.concat(skuGifts);
      console.log("Sku achived");
    } else {
      console.log("Sku not achived");
    }
  }

  /* check if price condition is achived */
  isPriceCondition() {
    let conditionPrice = this.gwp.getAttribute("data-price-condition");
    let priceGiftsJson = this.gwp.getAttribute("data-price-gifts");
    const limit = parseInt(this.gwp.getAttribute("data-price-limit"));

    if (!conditionPrice || !priceGiftsJson || !limit) {
      console.log("Price not activated");
      return;
    }

    priceGiftsJson = priceGiftsJson.replace(/&quot/g, '"');
    priceGiftsJson = priceGiftsJson.replace(/&apos/g, "'");

    /*
    const string = "SEK:100,EUR:10".toLocaleLowerCase();
    let price;
    const activeCurrency = Shopify.currency.active.toLowerCase();

    if (string.includes(activeCurrency)) {
      price = string.split(activeCurrency + ":")[1].split(",")[0];
    } else {
      console.log("Price not achived");
      return;
    }*/

    conditionPrice = parseFloat(conditionPrice) * Shopify.currency.rate;
    let tempPrice = this.cart.total_price;

    const cartItems = this.cart.items;
    cartItems.forEach(item => {
      if (item.properties.Type === "Gift") {
        tempPrice = tempPrice - (item.discounted_price * item.quantity);
      }
    })

    const formatedPrice = Shopify.formatMoney(tempPrice, "{{ amount_no_decimals }}");
    const cartPrice = parseFloat(formatedPrice.replace(",", ""));

    if (conditionPrice !== "" && cartPrice !== "") {
      if (cartPrice >= conditionPrice) {
        this.limit = this.limit + limit;

        const priceGifts = JSON.parse(priceGiftsJson);
        this.gifts = this.gifts.concat(priceGifts);
        console.log("Price achived");
      } else {
        console.log("Price not achived");
      }
    } else {
      console.log("Price not achived");
    }
  }

  /* check if product amount condition is achived */
  isAmountCondition() {
    let conditionAmount = this.gwp.getAttribute("data-amount-condition");
    let amountGiftsJson = this.gwp.getAttribute("data-amount-gifts");

    let excludeProducts = this.gwp.getAttribute("data-exlude-products");

    if (!conditionAmount || !amountGiftsJson) {
      console.log("Amount not activated");
      return;
    }

    amountGiftsJson = amountGiftsJson.replace(/&quot/g, '"');
    amountGiftsJson = amountGiftsJson.replace(/&apos/g, "'");

    conditionAmount = parseInt(conditionAmount);
    let cartAmount = this.cart.item_count;
    const cartItems = this.cart.items;
    cartItems.forEach(item => {
      if (item.properties.Type === "Gift") {
        cartAmount -= item.quantity;
      }
    })

    if (excludeProducts) {
      excludeProducts = excludeProducts.replace(/&quot/g, '"');
      excludeProducts = excludeProducts.replace(/&apos/g, "'");

      excludeProducts = JSON.parse(excludeProducts);
      const excludeSkus = [];
      excludeProducts.forEach(product => {
        product.variants.forEach(variant => {
          excludeSkus.push(variant.sku);
        });
      });

      cartItems.forEach(item => {
        if (excludeSkus.includes(item.sku)) {
          cartAmount -= 1;
        }
      })
    }

    if (conditionAmount !== "" && cartAmount !== "" && cartAmount >= conditionAmount) {
      const limit = parseInt(this.gwp.getAttribute("data-amount-limit"));
      this.limit = this.limit + limit;

      const amountGifts = JSON.parse(amountGiftsJson);
      this.gifts = this.gifts.concat(amountGifts);
      console.log("Amount yes");
    } else {
      console.log("Amount no");
    }
  }

  getIdFromGid(gid) {    
    const firstPartOfTheString = gid.substring(0, gid.lastIndexOf("/") + 1);
    return gid.substring(firstPartOfTheString.length, gid.length);
  }

  addGiftsToSwiper(gifts) {
    const unavailableProducts = this.element.querySelector(".Gwp--UnavailableProducts").textContent;
    const items = [];

    gifts.forEach(product => {
      product.variants.forEach(variant => {
        if (!unavailableProducts.includes(variant.sku)) {
          const tempDiv = this.giftItem.cloneNode(true);

          tempDiv.querySelector(".Gwp--GiftName").innerText = product.title;
          tempDiv.querySelector(".Gwp--InnerImage").setAttribute("data-base-url", variant.image.originalSrc);
          tempDiv.querySelector(".Gwp--InnerImage").alt = variant.image.altText

          const id = this.getIdFromGid(variant.id);
          tempDiv.querySelector(".Gwp--GiftItem").setAttribute("data-id", id);

          this.swiperWrapper.appendChild(tempDiv);

          items.push(this.buildGtmItem(product, variant));
        }
      })
    })

    this.buildGtmScript(items);
  }

  buildGtmItem(product, variant) {    
    return {
      item_id: variant.sku || "",
      id: this.getIdFromGid(product.id) || "",
      item_name: product.title || "",
      item_brand: product.brand || "",
      item_category: product.category || "",
      item_category2: product.category2 || "",
      item_variant: variant.displayName || "",
      price: 0,
      quantity: 1,
      item_list_id: "gwp_" + this.gwp.dataset.id,
      item_list_name: "Gift with purchase"
    }
  }

  buildGtmScript(items) {
    items.forEach((item, i) => item.index = i++);

    try {
      const template = this.element.querySelector(".gwp__gtm-script-template");
      const fragment = template.content.cloneNode(true);

      const scriptWrapper = fragment.querySelector(".gwp__gtm-script");
      const script = scriptWrapper.querySelector("script");
      const json = JSON.parse(script.innerText);

      json.ecommerce.items = items;
      script.innerText = JSON.stringify(json);

      const oldScript = this.element.querySelector(".gwp__gtm-script");
      oldScript?.remove();

      this.gwp.prepend(scriptWrapper);
      
    } catch (error) {
      console.log("Error during gtm script creation.", error);
    }
  }

  bindEvents() {
    this.delegateElement.on("click", ".Gwp--GiftItem", this.handleGiftSelect.bind(this));
  }

  handleGiftSelect() {
    // selects or deselects gifts and updates items selected number
    const target = event.target;
    const limitReached = this.limit === this.itemsSelected;

    if (target.getAttribute("aria-selected") === "false" && !limitReached) {
      this.addGiftToCart(target);
    } else if (target.getAttribute("aria-selected") === "true") {
      const [key, quantity] = this.getKeyFromItem(target);
      this.removeGiftFromCart(target, key, quantity);
    }
  }

  async addGiftToCart(item) {
    const id = item.getAttribute("data-id");
    item.style.pointerEvents = "none";
    item.querySelector(".itemLoader")?.classList.add("is-visible");
    this.itemsSelected++;

    //If item with the same variant id is in the cart as gift that will be added 
    //It updates existing item to gift and adds regular one. 
    //So that gift is always at first position.

    let quantityInCart = 1;
    let keyInCart = false;


    try {
      this.cart.items.forEach(item => {
        if (item.variant_id.toString() === id) {
          keyInCart = item.key;
          quantityInCart = item.quantity;
        }
      });

      await fetch(window.routes.localeRootUrl + "/cart/add.js", {
        body: JSON.stringify({
          id: id,
          quantity: "1",
          properties: {
            "Type": "Gift"
          }
        }),
        credentials: "same-origin",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
      });

      this.element.dispatchEvent(new CustomEvent('gwp:added', { bubbles: true }));

      this.cart = false;
      this.getCart(false, item);
      this.updateSelectable(item, "+");
      item.querySelector(".itemLoader")?.classList.remove("is-visible");
      console.log("Gift added");

    } catch (error) {
      console.error("Failed to add gift");
      this.itemsSelected--;
      item.querySelector(".itemLoader")?.classList.remove("is-visible");
      item.style.pointerEvents = "all";
    }
  }

  /* returns line item key from given gwp item (item has to be already in the cart) */
  getKeyFromItem(item) {
    const cartItems = this.cart.items;
    const id = parseInt(item.getAttribute("data-id"));

    let key = false;
    let quantity = 0;
    cartItems?.forEach(item => {
      if (item.variant_id === id && item.properties.Type === "Gift") {
        key = item.key;
        item.quantity -= 1;
        quantity = item.quantity;
      }
    })

    return [key, quantity];
  }

  /* removes gifts from cart */
  async removeGiftFromCart(item, key, quantity) {
    if (key) {
      try {
        if (item) {
          item.style.pointerEvents = "none";
          item.querySelector(".itemLoader")?.classList.add("is-visible");
        }

        const response = await fetch(window.routes.localeRootUrl + "/cart/change.js", {
          body: JSON.stringify({
            id: key,
            quantity: quantity,
          }),
          credentials: "same-origin",
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
        });

        this.cart = await response.json();
        console.log("Gift removed");

        if (item) {
          this.updateSelectable(item, "-")
          item.style.pointerEvents = "all";
          item.querySelector(".itemLoader")?.classList.remove("is-visible");
        }

        const itemCount = document.querySelector(".CartCount__Count");
        if (itemCount) {
          itemCount.innerText = `${this.cart.item_count}`;
        }
      } catch (error) {
        console.error("Gift does not exist in cart");
      }
    } else {
      console.error("Gift does not exist in cart");
    }
  }

  updateSelectable(target, action) {
    if (action === "+") {
      target.setAttribute("aria-selected", "true");
      this.gwp.setAttribute("data-selected", this.itemsSelected);
    } else if (action === "-") {
      target.setAttribute("aria-selected", "false");
      this.itemsSelected--;
      this.gwp.setAttribute("data-selected", this.itemsSelected);
    }

    this.amountSelectedNum.innerText = this.itemsSelected;

    const limitReached = this.limit === this.itemsSelected;
    this.gwp.setAttribute("data-gifts-selectable", !limitReached)
  }

  /* selects gifts from slider that are already in the cart 
  also if gift item is in the cart and not longer selectable it removes it from the cart */
  loadData() {
    const cartItems = this.cart.items;
    let items = {
      'updates': {}
    };
    let removeItems = false;

    cartItems.forEach(item => {
      if (item.properties.Type === "Gift") {
        let quantity = item.quantity;

        for (let i = 0; i < item.quantity; i++) {
          const limitReached = this.limit === this.itemsSelected;
          const tempItem = this.gwp.querySelector(`.Gwp--GiftItem[data-id="${item.id}"][aria-selected="false"]`);

          if (tempItem && !limitReached) {
            this.itemsSelected++;
            this.updateSelectable(tempItem, "+")
          } else if (!tempItem || limitReached) {
            removeItems = true;
            quantity -= 1;
            items['updates'][`${item.key.toString()}`] = quantity;
          }
        }
      }
    });

    if (removeItems) {
      this.removeAllGifts(items);
    }
  }

  findAllGifts() {
    const cartItems = this.cart.items;
    let i = false;
    let items = {
      'updates': {}
    };

    cartItems.forEach(item => {
      if (item.properties.Type === "Gift") {
        i = true;
        items['updates'][`${item.key.toString()}`] = 0;
      }
    })

    if (i) {
      this.removeAllGifts(items)
    }
  }

  async removeAllGifts(items) {
    if (items) {
      try {
        const response = await fetch(window.routes.localeRootUrl + "/cart/update.js", {
          body: JSON.stringify(
            items,
          ),
          credentials: "same-origin",
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
        });

        await response.json();
        console.log("Gifts removed");
      } catch (error) {
        console.error("One of the gifts does not exist in cart or", error);
      }
    }
  }

  refreshGwp() {
    /* on main cart there are two gwps so it ensures both will be refreshed */
    let tempGWP = document.querySelector(".Gwp--Block");
    if (this.element.matches(".Gwp--Block.Gwp--MainCartDesktop")) {
      tempGWP = document.querySelector(".Gwp--Block.Gwp--MainCartDesktop");
    } else if (this.element.matches(".Gwp--Block.Gwp--MainCartMobile")) {
      tempGWP = document.querySelector(".Gwp--Block.Gwp--MainCartMobile");
    }

    tempGWP.innerHTML = this.element.innerHTML;
    this.element = tempGWP;

    const atLeastOneGift = this.element.querySelectorAll(".Gwp--GiftItem");
    if (atLeastOneGift.length === 0) {
      this.findAllGifts();

      this.element.setAttribute("aria-hidden", "true");
      setTimeout(() => {
        this.element.style.display = "none";
      }, 300);
    } else {
      this.element.style.display = "block";
      setTimeout(() => {
        this.element.setAttribute("aria-hidden", "false");
      }, 100);

      this.gwp = this.element.querySelector(".Gwp--Wrapper")
      this.carouselElement = this.gwp.querySelector(".Gwp--Swiper");
      this.carousel = new RevolutionSwiper(this.carouselElement);

      this.element.querySelector(".Gwp--Limit").innerText = this.limit;
      this.itemsSelected = parseInt(this.gwp.getAttribute("data-selected"));
      this.amountSelectedNum = this.gwp.querySelector(".Gwp--AmountSelectedNum");

      this.delegateElement = new Delegate(this.element);

      this.loadData();
      this.bindEvents();

      this.element.setAttribute("data-gifts", JSON.stringify(this.gifts));
      if (atLeastOneGift.length === 1) {
        this.autoSelectGift(atLeastOneGift[0]);
      }
    }
  }

  autoSelectGift(gift) {
    const wasSelected = sessionStorage.getItem("wasGiftSelected");
    if (wasSelected === "true") return;
    
    sessionStorage.setItem("wasGiftSelected", "true");
    gift.click();
  }
}

customElements.define("gwp-block", GwpBlock);

class LoopDrawer extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    this.initVariables();
    this.editMode();
    this.bindEvents();
  }

  initVariables() {
    this.overlay = document.querySelector(".pageOverlay");
    this.delBody = new Delegate(document.body);
    this.delElem = new Delegate(this.element);
    new Dropdown(this.element);
  }

  editMode() {
    const edit = this.element.dataset.editMode ? true : false;
    if (edit) {
      this.openLoopDrawer();
    }
  }

  bindEvents() {
    this.delBody.on("click", '[data-action="open-loop-drawer"]', this.openLoopDrawer.bind(this));
    this.delBody.on("click", ".pageOverlay", this.closeLoopDrawer.bind(this));
    this.delElem.on("click", '[data-action="close-loop-drawer"]', this.closeLoopDrawer.bind(this));
  }

  openLoopDrawer() {
    this.element.style.display = "flex";

    setTimeout(() => {
      this.element.setAttribute("aria-hidden", "false");
      bodyScrollLock.disableBodyScroll(this.element, bodyScrollLockOptions);

      this.overlay?.classList.add("is-visible");
    }, 100);
  }

  closeLoopDrawer() {
    const isHidden = this.element.getAttribute("aria-hidden");
    if (isHidden === "true") return;

    this.element.setAttribute("aria-hidden", "true");
    bodyScrollLock.clearAllBodyScrollLocks();
    this.overlay?.classList.remove("is-visible");

    setTimeout(() => {
      this.element.style.display = "none";
    }, 400)
  }
}

customElements.define("loop-drawer", LoopDrawer);

class FilterAndPurifierFunctions extends HTMLElement {
  constructor(elemClass) {
    super();
    this.element = document.querySelector(elemClass);

    this.closeDeliveryDropdown = this.closeDeliveryDropdown.bind(this);
  }

  connectedCallback() {
    this.initCurrentDiscount();
  }

  // The discount percentage must be visible immediately on page load 
  
  initCurrentDiscount() {
    requestAnimationFrame(() => {
      const subsWrapper = this.element.querySelector('.Product--DeliverySubsWrapper');
      if (!subsWrapper) return;

      const currentSubOption =
        subsWrapper.querySelector('.Product--DeliverySubOption');

      this.showCurrentDiscount(currentSubOption);
    });

  }

  selectElement(elemClass, target) {
    if (!target) return;

    const oldElem = target.parentElement.querySelector(`.${elemClass}[aria-selected="true"]`);
    oldElem?.setAttribute("aria-selected", "false");

    target.setAttribute("aria-selected", "true");
  }

  updateSelectedTypeHeading(target) {
    if (!target) return;

    const headingSpan = this.element.querySelector(".product-type__selected-product--heading");
    if (!headingSpan) return;

    const typeHeading = target.querySelector(".Product--TypeProductHeading");
    if (typeHeading) headingSpan.textContent = typeHeading.textContent.trim();
  }

  closeOpenedDropdown() {
    const target = this.element.querySelector('[data-action="toggle-sub-dropdown"][aria-expanded="true"]');
    if (!target) return;

    const dropdown = target.querySelector(".Product--DeliverySubOptionsWrapper");
    target.setAttribute("aria-expanded", "false");
    this.settleSubDropdown(target, dropdown);
  }

  closeDeliveryDropdown(option) {
    if (!option || !option.classList.contains("FiltersFlowDropdown")) return;

    const dropdownButton = option.querySelector(".Dropdown--Button");
    const dropdownContent = option.querySelector(".Dropdown--Content");
    if (dropdownButton) {
      dropdownButton.setAttribute("aria-expanded", "false");
    }
    if (dropdownContent) {
      dropdownContent.style.height = getComputedStyle(dropdownContent).height;
      dropdownContent.offsetHeight;
      dropdownContent.style.height = "0px";

      const onCloseEnd = function(event) {
        if (event.propertyName !== "height") return;
        dropdownContent.removeEventListener("transitionend", onCloseEnd);
        if (dropdownButton && dropdownButton.getAttribute("aria-expanded") !== "true") {
          dropdownContent.setAttribute("aria-hidden", "true");
          dropdownContent.style.height = "";
          dropdownContent.style.pointerEvents = "";
        }
      };
      dropdownContent.addEventListener("transitionend", onCloseEnd);
    }
  }

  hideDiscount() {
    const oldDiscount = this.element.querySelector('.Product--QuantityDiscount[aria-hidden="false"]');
    oldDiscount?.setAttribute("aria-hidden", "true");
  }

  disableButtons() {
    const buttons = document.querySelectorAll(".ProductPage--ATC");
    buttons.forEach(button => {
      button.disabled = true;
    })
  }

  enableButtons() {
    const buttons = document.querySelectorAll(".ProductPage--ATC:disabled");
    buttons.forEach(button => {
      button.disabled = false;
    })
  }

  updateButtonPrice(price) {
    if (!price) return;

    /*
      With remove_decimal_pricing on, Liquid renders the button price through
      money_without_trailing_zeros ("17 kr") while the prices JS copies in come
      from `| money` markup and Shopify.formatMoney, which keep the decimals -
      so the button flipped to "17,00 kr" on the first product or quantity
      switch. With the setting off the button is rendered with `| money` too,
      and the decimals are what it is supposed to show, so leave them.

      Normalised here rather than at each call site: this is the only place the
      button price is written, and it is reached from four different switches.
    */
    const cleanPrice = window.theme?.removeDecimalPricing
      ? moneyWithoutTrailingZeros(price.trim())
      : price.trim();

    const buttons = this.productWrapper.querySelectorAll(".ProductPage--ATC .button--money");
    buttons.forEach(button => {
      button.innerText = cleanPrice;
    })
  }

  showCorrespondingQuantity(productId, variantId) {
    const elemClass = "Product--Quantity";
    const elemAttribute = `data-product-id="${productId}"`;

    const newQuantity = this.hideElement(elemClass, elemAttribute);
    if (!newQuantity) return;

    const event = null;
    const selectedQuantity =
      newQuantity.querySelector('.Product--QuantityVariant[aria-selected="true"]') ||
      newQuantity.querySelector(`.Product--QuantityVariant[data-variant-id="${variantId}"]`);

    if (!selectedQuantity) return;

    this.handleQuantityChange(event, selectedQuantity);
    if (selectedQuantity.dataset.action === "filters-quantity-notify-me") this.handleNotifyMeClick(event, selectedQuantity);
  }

  hideElement(elemClass, elemAttribute) {
    const oldElem = this.element.querySelector(`.${elemClass}[aria-hidden="false"]`);
    oldElem?.setAttribute("aria-hidden", "true");

    const newElem = this.element.querySelector(`.${elemClass}[${elemAttribute}]`);
    newElem?.setAttribute("aria-hidden", "false");

    return newElem;
  }

  toggleDropdown(event) {
    const target = event.target.closest('[data-action="toggle-sub-dropdown"]');
    if (!target) return;
    const dropdown = target.querySelector(".Product--DeliverySubOptionsWrapper");
    if (!dropdown) return;

    const willOpen = target.getAttribute("aria-expanded") !== "true";
    if (willOpen) {
      dropdown.style.display = "block";
      void dropdown.offsetHeight; // flush the display change so the enter transition runs
      target.setAttribute("aria-expanded", "true");
    } else {
      target.setAttribute("aria-expanded", "false");
    }

    // Reconcile `display` with the committed state once the CSS transition ends.
    // debounce cancels its own pending run, so a rapid double-click can't leave
    // aria-expanded and display out of sync.
    this.settleSubDropdown(target, dropdown);
  }

  // Hide/show the wrapper to match aria-expanded after the 0.3s transition.
  // The debounced callback is stored per element so its timer survives calls.
  settleSubDropdown(target, dropdown) {
    if (!target._settleSubDropdown) {
      target._settleSubDropdown = debounce(() => {
        const open = target.getAttribute("aria-expanded") === "true";
        dropdown.style.display = open ? "block" : "none";
      }, 300);
    }
    target._settleSubDropdown();
  }

  sendEvent(notifyMe, productId, variantId) {
    this.element.dispatchEvent(
      new CustomEvent("filters:notify:me", {
        bubbles: true,
        detail: {
          productId: productId,
          variantId: variantId,
          notifyMe: notifyMe,
        },
      })
    );
  }

  handleNotifyMeClick(event, target) {
    target = event ? target.closest('[data-action="filters-quantity-notify-me"]') : target;
    if (!target) return;

    const elemClass = "Product--QuantityVariant";
    const productId = target.dataset.productId;
    const variantId = target.dataset.variantId;
    const notifyMe = true;
    const textClass = "Product--QuantityVariantInfo";
    const textAttribute = `data-variant-id="${variantId}"`;

    this.selectElement(elemClass, target);
    this.sendEvent(notifyMe, productId, variantId);
    this.showCorrespondingDelivery(variantId, "");
    this.hideDiscount();
    this.hideElement(textClass, textAttribute);
  }

  updateFormProductData(productId) {
    if (!this.forms || !productId) return;

    this.forms.forEach(form => {
      const input = form.querySelector('[name="id"]');
      if (input) {
        input.setAttribute("data-productId", productId);
      }
    })
  }

  updateFormVariantData(variantId) {
    if (!this.forms || !variantId) return;

    this.forms.forEach(form => {
      const input = form.querySelector('[name="id"]');
      if (input) {
        input.value = variantId;
      }
    })
  }

  updateFormSubData(subId) {
    if (!this.forms) return;
    if (!subId) subId = "";

    this.forms.forEach(form => {
      const input = form.querySelector('input#selling_plan');
      if (input) {
        input.value = subId;
      }
    })
  }

  showCurrentDiscount(target) {
    if (!target) return;

    const discount = target.dataset.discount;
    const subsWrapper = target.closest('.Product--DeliverySubsWrapper') || this.element.querySelector('.Product--DeliverySubsWrapper');
    const discountContainer = subsWrapper?.querySelector('.Product--QuantityDiscount');
    if (!discountContainer) return;

    if (discountContainer.getAttribute("aria-hidden") === "false") discountContainer.setAttribute("aria-hidden", "true");
    if (discount <= 0) return;

    discountContainer.querySelector("span").innerText = discount + "%";
    discountContainer.setAttribute("aria-hidden", "false");
  }
}
class FiltersFlow extends FilterAndPurifierFunctions {
  constructor() {
    super("filters-flow");
    this.element = this;

    this.initVariables();
    this.bindEvents();
    this.initFlow();
  }

  initVariables() {
    this.toggleButtonBasedOnDelivery();

    this.delElem = new Delegate(this.element);
    this.dropdown = new Dropdown(this.element, "FiltersFlowDropdown");

    const formId = this.element.dataset.atcId;
    this.productWrapper = document.querySelector("product-component");
    this.forms = this.productWrapper.querySelectorAll(`#${formId}`);

    // Get delivery element from currently visible/selected product type, not just the first one
    const deliveryElement = this.element.querySelector('.Product--DeliveryPerVariant[aria-hidden="false"] .Product--DeliveryOneTime[aria-selected="true"]')
      || this.element.querySelector(".Product--DeliveryOneTime");
    this.checkedDeliveryPrice = deliveryElement ? deliveryElement.getAttribute("data-variant-price") : null;

    const renderedDeliveryPrice = deliveryPriceText(deliveryElement);
    if (renderedDeliveryPrice) {
      requestAnimationFrame(()=>{
        this.updateButtonPrice(renderedDeliveryPrice);
      })
    }

  }

  bindEvents() {
    this.delElem.on("click", '[data-action="select-type-block"][aria-selected="false"]', this.handleTypeChange.bind(this));
    this.delElem.on("click", '[data-action="select-quantity"][aria-selected="false"]', this.handleQuantityChange.bind(this));
    this.delElem.on("click", '[data-action="select-purchase-option"]', this.handleDeliveryChange.bind(this));
    this.delElem.on("click", '[data-action="toggle-sub-dropdown"]', this.toggleDropdown.bind(this));
    this.delElem.on("click", '[data-action="select-sub-option"][aria-selected="false"]', this.handleSubOptionClick.bind(this));
    this.delElem.on("click", '[data-action="filters-quantity-notify-me"][aria-selected="false"]', this.handleNotifyMeClick.bind(this));

    document.addEventListener("DOMContentLoaded", () => {
      // Find the initially selected delivery option
      const selectedDelivery = document.querySelector('.Product--DeliveryPerVariant[aria-hidden="false"] .Product--DeliveryOneTime[aria-selected="true"]');

      if (selectedDelivery) {
        const productId = selectedDelivery.dataset.productId;
        const variantId = selectedDelivery.dataset.variantId;
        const price = deliveryPriceText(selectedDelivery);

        // Update the form to point to the selected connected product variant
        const form = document.querySelector("product-component form");
        const input = form.querySelector('[name="id"]');
        input.value = variantId;
        input.setAttribute("data-productId", productId);

        // Update button price to match selected delivery option
        if (price) {
          this.updateButtonPrice(price);
        }
      }

    });

  }

  initFlow() {
    const optionSelected = this.element.querySelector('.Product--TypeProduct[aria-selected="true"]');
    const availableOption = this.element.querySelector('.Product--TypeProduct[aria-disabled="false"]');
    const firstOption = this.element.querySelector('.Product--TypeProduct');
    const event = null;

    if (optionSelected) {
      // Still need to initialize price for pre-selected option
      const productId = optionSelected.dataset.productId;
      const variantId = optionSelected.dataset.variantId;
      this.showCorrespondingQuantity(productId, variantId);
      return;
    }
    if (!availableOption) return this.handleTypeChange(event, firstOption);

    this.handleTypeChange(event, availableOption);
  }

  toggleButtonBasedOnDelivery() {
    const visibleDelivery = this.element.querySelector('.Product--DeliveryPerVariant[aria-hidden="false"]');
    const outOfStockSelected = this.element.querySelector('.Product--QuantityVariant[aria-disabled="true"][aria-selected="true"]');
    if (!visibleDelivery && outOfStockSelected) {
      const notSelectedElem = 
        this.element.querySelector('.Product--QuantityVariant[aria-selected="false"]:not([aria-disabled="true"])') || 
        this.element.querySelector('.Product--QuantityVariant[aria-selected="false"]')

      requestAnimationFrame(() => {
        notSelectedElem?.click();
      })

      console.log(notSelectedElem);
      
      return;
    }

    if (!visibleDelivery) return this.enableButtons();

    const optionSelected = visibleDelivery.querySelector('.Product--DeliveryOption[aria-selected="true"]');
    if (!optionSelected) return this.disableButtons();

    if (optionSelected.classList.contains("Product--DeliverySubsWrapper")) {

      const subDeliverySelected = optionSelected.querySelector('.Product--DeliverySubOption[aria-selected="true"]');
      if (!subDeliverySelected) return this.disableButtons();
    }

    this.enableButtons();
  }

  handleTypeChange(event, target) {
    target = event ? target.closest('[data-action="select-type-block"]') : target;
    if (!target) return;

    const openDropdown = this.element.querySelector('.FiltersFlowDropdown:has(.Dropdown--Button[aria-expanded="true"])');
    if (openDropdown) this.closeDeliveryDropdown(openDropdown);

    const productId = target.dataset.productId;
    const variantId = target.dataset.variantId;
    const elemClass = "Product--TypeProduct";
    const handle = target.dataset.handle;

    this.selectElement(elemClass, target);
    this.updateSelectedTypeHeading(target);
    this.showCorrespondingQuantity(productId, variantId);
    this.updateFormProductData(productId);
    this.updateHistoryState(handle);
  }

  updateHistoryState(handle) {
    // if product page is opened in customiser don't continue
    if (Shopify.designMode) return;

    if (!handle) return;

    const url = window.location.href.toString();
    const index = url.indexOf('/products');

    if (!index) return;

    const newUrl = `${url.substring(0, index + 9)}/${handle}`;

    if (newUrl === url) return;

    history.replaceState({}, "", newUrl);
  }

  handleQuantityChange(event, target) {
    if (!target) return;

    const openDropdown = this.element.querySelector('.FiltersFlowDropdown:has(.Dropdown--Button[aria-expanded="true"])');
    if (openDropdown) this.closeDeliveryDropdown(openDropdown);

    const variantId = target.dataset.variantId;
    const elemClass = "Product--QuantityVariant";
    const price = Shopify.formatMoney(target.dataset.price);
    const compareAtPrice = target.dataset.compareAtPrice;
    const textClass = "Product--QuantityVariantInfo";
    const textAttribute = `data-variant-id="${variantId}"`;

    const pdpPrice = document.querySelector(".ProductInfo--RegularPrice .changePrice")

    if (this.productWrapper.querySelector('[data-action="open-bis"]')) {
      const notifyMe = false;
      this.sendEvent(notifyMe);
    }

    if (pdpPrice) {
      console.log(pdpPrice, compareAtPrice, price);
      pdpPrice.textContent = compareAtPrice || price;
    }

    this.selectElement(elemClass, target);
    this.showCorrespondingDelivery(variantId, price, compareAtPrice);
    this.hideElement(textClass, textAttribute);
    
    this.toggleButtonBasedOnDelivery();

    // The discount is always visible, so surface the new variant's discount
    // regardless of which purchase option is currently selected.
    const visibleDelivery = this.element.querySelector('.Product--DeliveryPerVariant[aria-hidden="false"]');
    const currentSubOption =
      visibleDelivery?.querySelector('.Product--DeliverySubOption[aria-selected="true"]') ||
      visibleDelivery?.querySelector('.Product--DeliverySubOption');
    this.showCurrentDiscount(currentSubOption);
  }

  handleDeliveryChange(event, target, isToggle = false) {
    target = event ? target.closest('[data-action="select-purchase-option"]') : target;

    if (!target) return;

    // clicks inside the opened subscription dropdown (frequency options, links)
    // bubble up to the subs wrapper - they are handled by handleSubOptionClick
    // and must not toggle the purchase option back to one-time, which would
    // clear the selling plan from the form and add the full price to cart
    if (event && event.target.closest(".Dropdown--Content")) return;

    // --- TOGGLE LOGIC ---
    if (!isToggle && target.getAttribute("aria-selected") === "true") {
      const parent = target.parentElement;
      const otherOption = [...parent.querySelectorAll('[data-action="select-purchase-option"]')]
        .find(el => el !== target);

      if (otherOption) {
        target.setAttribute("aria-selected", "false");
        this.closeDeliveryDropdown(target);
        otherOption.setAttribute("aria-selected", "true");

        // Call again but prevent re‑toggling
        this.handleDeliveryChange(null, otherOption, true);
        return;
      }
    }



    const elemClass = "Product--DeliveryOption";

    // this closes custom dropdown where you select delivery frequency
    this.closeOpenedDropdown();
    this.selectElement(elemClass, target);

    // Collapse the subscription dropdown when switching away from it, so
    // picking the one-time option doesn't leave its content expanded.
    const openDropdown = this.element.querySelector('.FiltersFlowDropdown:has(.Dropdown--Button[aria-expanded="true"])');
    if (openDropdown && openDropdown !== target) this.closeDeliveryDropdown(openDropdown);

    const isSubsWrapperSelected = target.classList.contains("Product--DeliverySubsWrapper");
    const variantId = target.dataset.variantId;

    // For subscription option, use subscription variant if available
    // For one-time option, always use the regular variant
    let finalVariantId = variantId;
    if (isSubsWrapperSelected) {
      const deliveryBlock = target.closest('.Product--DeliveryPerVariant');
      const subscriptionVariantId = deliveryBlock?.dataset.subscriptionVariantId;
      finalVariantId = subscriptionVariantId || variantId;
    }

    if (!isSubsWrapperSelected) {
      const price = target.querySelector(".Product--OneTimeRealPrice").innerText;
      this.updateButtonPrice(price)
      this.updateFormSubData();
      this.updateFormVariantData(finalVariantId);
      this.enableButtons();

      return;
    }

    const dropdownButton = target.querySelector(".Dropdown--Button");
    if (dropdownButton && dropdownButton.getAttribute("aria-expanded") !== "true") {
      this.dropdown.openDropdown(target);
    }

    this.updateFormVariantData(finalVariantId);

    const currentSubOption = target.querySelector('.Product--DeliverySubOption[aria-selected="true"]');
    if (currentSubOption) {
      this.showCurrentDiscount(currentSubOption);
    } else {
      this.disableButtons();
    }

    const preselect = target.querySelector("[data-preselect]") || target.querySelectorAll(".Product--DeliverySubOption").length === 1 || target.querySelector('.Product--DeliverySubOption[aria-selected="true"]');
    if (!preselect) return;

    const subOption = target.querySelector('.Product--DeliverySubOption[aria-selected="true"]') || target.querySelector('.Product--DeliverySubOption');
    this.handleSubOptionClick(null, subOption);
  }

  handleSubOptionClick(event, target) {
    if (!target) target = event.target;
    const elemClass = "Product--DeliverySubOption";
    const subWrapper = target.closest(".Product--DeliverySubsWrapper");
    const dropdownWrapper = target.closest(".Product--DeliveryInnerDropdown");

    this.selectElement(elemClass, target);
    this.enableButtons();

    // update current selected plan text
    const optionName = target.innerText;
    const currentOptionWrapper = dropdownWrapper?.querySelector(".Product--DeliveryCurrentOptionText");
    if (currentOptionWrapper) currentOptionWrapper.innerHTML = optionName;

    // update current selected plan price
    const optionPrice = target.dataset.price;
    const priceElem = subWrapper?.querySelector(".Product--SubPrice");
    if (priceElem) priceElem.innerText = optionPrice;
    this.updateButtonPrice(optionPrice);

    // and the undiscounted price struck through next to it, where the flow shows
    // one. Hidden rather than emptied when the chosen plan doesn't discount, so
    // the element is still there for the next plan that does.
    const originalElem = subWrapper?.querySelector(".product-sub__original-price");
    if (originalElem) {
      const originalPrice = target.dataset.originalPrice;
      const discounts = !!originalPrice && originalPrice !== optionPrice;
      if (discounts) originalElem.innerText = originalPrice;
      originalElem.setAttribute("aria-hidden", discounts ? "false" : "true");
    }

    // show curent discount
    this.showCurrentDiscount(target);

    const subId = target.dataset.id;
    this.updateFormSubData(subId);

  }

  showCorrespondingDelivery(variantId, price, compareAtPrice) {
    const oldDelivery = this.element.querySelector('.Product--DeliveryPerVariant[aria-hidden="false"]');
    oldDelivery?.setAttribute("aria-hidden", "true");

    const newDelivery = this.element.querySelector(`.Product--DeliveryPerVariant[data-variant-id="${variantId}"]`);
    if (newDelivery) {
      newDelivery.setAttribute("aria-hidden", "false");
      const oneTimeOption = newDelivery.querySelector(".Product--DeliveryOneTime");

      const oneTimePriceElem = oneTimeOption.querySelector(".Product--OneTimeRealPrice");
      if (oneTimePriceElem) oneTimePriceElem.innerText = price;

      const compareAtPriceElem = oneTimeOption.querySelector(".Product--OneTimeCompareAtPrice");
      if (compareAtPrice && compareAtPriceElem) compareAtPriceElem.innerText = compareAtPrice;

      // Reset all delivery options in the new delivery block
      const allDeliveryOptions = newDelivery.querySelectorAll('.Product--DeliveryOption');
      allDeliveryOptions.forEach(option => option.setAttribute('aria-selected', 'false'));

      // Always select one-time purchase when switching quantities
      oneTimeOption.setAttribute('aria-selected', 'true');

      // Reset all sub-options to unselected state
      const allSubOptions = newDelivery.querySelectorAll('.Product--DeliverySubOption');
      allSubOptions.forEach(opt => opt.setAttribute('aria-selected', 'false'));

      // Update form and button
      this.toggleButtonBasedOnDelivery();
      const event = null;
      this.handleDeliveryChange(event, oneTimeOption, true)

    } else {
      this.updateFormSubData();
      this.updateButtonPrice(price);
      this.updateFormVariantData(variantId);

      const selectedElem = this.element.querySelector(`.Product--DeliveryOption[aria-selected="true"]`);
      if (!selectedElem) return;

      if (selectedElem.classList.contains("FiltersFlowDropdown")) this.dropdown.closeDropdown(selectedElem);
    }
  }
}

customElements.define("filters-flow", FiltersFlow);

class PurifierFlow extends FilterAndPurifierFunctions {
  constructor() {
    super("purifier-flow");
    this.element = this;

    this.initVariables();
    this.bindEvents();
  }

  connectedCallback() {
    // Handle pre-selected delivery option on page load
    const preselectedOption = this.element.querySelector('.Product--DeliveryOption[aria-selected="true"]');

    if (preselectedOption) {
      this.enableButtons();

      if (preselectedOption.classList.contains("Product--DeliveryOneTime")) {
        this.oneTimePurchase(preselectedOption);
      }
    } else {
      // If no preselected option (subscription might be hidden by market), check for one-time purchase
      const oneTimeOption = this.element.querySelector('.Product--DeliveryOneTime');
      const subscriptionOption = this.element.querySelector('.Product--PurifierSub');
      const isSubsHidden = subscriptionOption && subscriptionOption.style.display === 'none';

      if (oneTimeOption && isSubsHidden) {
        oneTimeOption.setAttribute('aria-selected', 'true');
        this.oneTimePurchase(oneTimeOption);
        this.enableButtons();
      }
    }
  }

  initVariables() {
    if (!this.delElem) this.delElem = new Delegate(this.element);
    if (!this.delBody) this.delBody = new Delegate(document.body);
    if (!this.dropdown) this.dropdown = new Dropdown(this.element, "FiltersFlowDropdown");

    this.productWrapper = document.querySelector("product-component");
    this.forms = this.productWrapper.querySelectorAll(`.ProductActions form`);
    this.enableButtons();
  }

  bindEvents() {
    this.delElem.on("reinit:purifier:flow", this.initVariables.bind(this));
    this.delElem.on('click', '[data-action="select-purchase-option"]', this.handlePurchaseChange.bind(this));
    this.delElem.on("click", '[data-action="select-type-block"][aria-selected="false"]', this.handleTypeChange.bind(this));
    this.delElem.on("click", '[data-action="select-quantity"][aria-selected="false"]', this.handleQuantityChange.bind(this));
    this.delElem.on("click", '[data-action="select-sub-option"][aria-selected="false"]', this.handleSubOptionClick.bind(this));
    this.delElem.on("click", '[data-action="toggle-sub-dropdown"]', this.toggleDropdown.bind(this));
    this.delElem.on("click", '[data-action="filters-quantity-notify-me"][aria-selected="false"]', this.handleNotifyMeClick.bind(this));
  }

  handlePurchaseChange(event, target, isToggle = false) {
    // Resolve the clicked purchase option. This works for both the one-time
    // option and the subscription dropdown, so each can be selected directly
    // instead of only reachable by toggling/deselecting the other one.
    const option = event
      ? event.target.closest('[data-action="select-purchase-option"]')
      : target;

    if (!option) return;

    // Clicks inside the opened subscription dropdown (frequency options,
    // type/quantity blocks, links) bubble up to the option - they have their
    // own handlers and must not re-trigger the purchase-option selection.
    if (event && event.target.closest(".Dropdown--Content")) return;

    // --- TOGGLE LOGIC ---
    // Clicking the already-selected subscription option deselects it and falls
    // back to the one-time option (mirrors the filters flow). Guarded to the
    // header click only - clicks inside the dropdown content are handled above.
    if (!isToggle && option.getAttribute("aria-selected") === "true") {
      if (option.classList.contains("Product--PurifierSub")) {
        const oneTimeOption = this.element.querySelector(".Product--PurifierOneTime");
        if (oneTimeOption) {
          option.setAttribute("aria-selected", "false");
          this.closeDeliveryDropdown(option);
          this.handlePurchaseChange(null, oneTimeOption, true);
        }
      }
      // Already the selected option - nothing else to do. The subscription
      // button still toggles its own dropdown open/closed via the
      // toggle-dropdown handler when it isn't being deselected here.
      return;
    }

    // --- NORMAL LOGIC ---
    const elemClass = "Product--DeliveryOption";
    this.enableButtons();

    this.closeOpenedDropdown();
    this.selectElement(elemClass, option);
    this.hideDiscount();

    // Collapse the subscription dropdown when switching away from it.
    const openDropdown = this.element.querySelector('.FiltersFlowDropdown:has(.Dropdown--Button[aria-expanded="true"])');
    if (openDropdown && openDropdown !== option) this.closeDeliveryDropdown(openDropdown);

    if (option.classList.contains("Product--DeliveryOneTime")) {
      return this.oneTimePurchase(option);
    }

    this.subPurchase(option);
  }



  oneTimePurchase(target) {
    this.updateButtonPrice(deliveryPriceText(target));

    const action = "add-to-cart"
    this.toggleButtonAction(action);

    const productId = target.dataset.productId;
    const variantId = target.dataset.variantId;

    this.updateFormProductData(productId);
    this.updateFormVariantData(variantId);

    const notifyMe = target.getAttribute("aria-disabled") === "true";
    this.sendEvent(notifyMe, productId, variantId);
  }

  subPurchase(target) {
    const price = target.querySelector(".Product--PurifierCombinedPrice").innerText;
    this.updateButtonPrice(price);

    const type = target.querySelector(".Product--TypeProduct");
    const event = null;
    this.handleTypeChange(event, type);

    const action = "add-all-to-cart-purifier"
    this.toggleButtonAction(action);

    const productId = target.dataset.porductId;
    const variantId = target.dataset.variantId;

    this.updateFormProductData(productId);
    this.updateFormVariantData(variantId);

    // Update side product with subscription variant if available
    const visibleDelivery = this.element.querySelector('.Product--DeliveryPerVariant[aria-hidden="false"]');
    if (visibleDelivery) {
      const subscriptionVariantId = visibleDelivery.dataset.subscriptionVariantId;
      const selectedQuantityId = visibleDelivery.dataset.variantId;
      const sideVariantId = subscriptionVariantId || selectedQuantityId;
      this.updateFormSideVariantData(sideVariantId);

      // If there's a preselected sub option, trigger it to set the selling plan
      const preselectedSubOption = visibleDelivery.querySelector('.Product--DeliverySubOption[aria-selected="true"]');
      if (!preselectedSubOption && visibleDelivery.querySelector('[data-preselect]')) {
        const firstSubOption = visibleDelivery.querySelector('.Product--DeliverySubOption');
        if (firstSubOption) {
          this.handleSubOptionClick(null, firstSubOption);
        }
      } else if (preselectedSubOption) {
        this.handleSubOptionClick(null, preselectedSubOption);
      }
    }
  }

  handleTypeChange(event, target) {
    target = event ? target.closest('[data-action="select-type-block"]') : target;
    if (!target) return;

    const productId = target.dataset.productId;
    const variantId = target.dataset.variantId;
    const elemClass = "Product--TypeProduct";

    this.selectElement(elemClass, target);
    this.updateSelectedTypeHeading(target);
    this.showCorrespondingQuantity(productId, variantId);
    this.updateFormSideProductData(productId);
    requestAnimationFrame(()=>{
      this.preselectDeliveryOption(productId);

    })
  }

  preselectDeliveryOption(productId){
    const deliveryOption = this.element.querySelector(`.Product--Quantity[data-product-id="${productId}"]`);
    if (!deliveryOption) return;
    deliveryOption.querySelector(".Product--QuantityVariant").click();
  }

  handleQuantityChange(event, target) {
    if (!target) return;

    const variantId = target.dataset.variantId;
    const elemClass = "Product--QuantityVariant";
    const textClass = "Product--QuantityVariantInfo";
    const textAttribute = `data-variant-id="${variantId}"`;

    if (this.productWrapper.querySelector('[data-action="open-bis"]')) {
      const notifyMe = false;
      this.sendEvent(notifyMe);
    }

    this.selectElement(elemClass, target);
    this.showCorrespondingDelivery(variantId);
    this.hideElement(textClass, textAttribute);
    // Don't update side variant here - showCorrespondingDelivery handles it
    // to ensure subscription variant is used when available
  }

  showCorrespondingDelivery(variantId) {
    const oldDelivery = this.element.querySelector('.Product--DeliveryPerVariant[aria-hidden="false"]');
    oldDelivery?.setAttribute("aria-hidden", "true");

    const newDelivery = this.element.querySelector(`.Product--DeliveryPerVariant[data-variant-id="${variantId}"]`);
    if (!newDelivery) return;

    newDelivery.setAttribute("aria-hidden", "false");
    this.hideDiscount();

    // Update form with subscription variant if available, otherwise use connected product variant
    const subscriptionVariantId = newDelivery.dataset.subscriptionVariantId;
    const finalVariantId = subscriptionVariantId || variantId;

    if (newDelivery.querySelector("[data-preselect]") || newDelivery.querySelectorAll(".Product--DeliverySubOption").length === 1) {
      const selectedSubOption = newDelivery.querySelector('.Product--DeliverySubOption[aria-selected="true"]') ?
        newDelivery.querySelector('.Product--DeliverySubOption[aria-selected="true"]') : newDelivery.querySelector('.Product--DeliverySubOption')

      this.handleSubOptionClick(null, selectedSubOption);
    } else {
      this.updateFormSideSubData();
      this.updateFormSideVariantData(finalVariantId);
    }
  }

  handleSubOptionClick(event, target) {
    if (!target) return;

    const elemClass = "Product--DeliverySubOption";
    const dropdownWrapper = target.closest(".Product--DeliveryInnerDropdown");

    this.selectElement(elemClass, target);

    const optionName = target.innerText;
    const currentOptionWrapper = dropdownWrapper?.querySelector(".Product--DeliveryCurrentOptionText");
    if (currentOptionWrapper) currentOptionWrapper.innerHTML = optionName;

    const optionPrice = target.dataset.price;
    const optionUnformatedPrice = target.dataset.unformatedPrice;
    this.updateSubOptionCombinedPrice(
      optionPrice,
      optionUnformatedPrice,
      target.dataset.combinedPrice
    );

    this.showCurrentDiscount(target);

    const subId = target.dataset.id;
    this.updateFormSideSubData(subId);

    const deliveryBlock = target.closest('.Product--DeliveryPerVariant');
    const subscriptionVariantId = deliveryBlock?.dataset.subscriptionVariantId;

    if (subscriptionVariantId) {
      this.updateFormSideVariantData(subscriptionVariantId);
    }
      this.updateFormSubData(subId);
  }


  toggleButtonAction(action) {
    this.forms.forEach(form => {
      if (action === "add-to-cart") {
        const buttonAll = form.querySelector('[data-action="add-all-to-cart-purifier"]')

        if (buttonAll) {
          buttonAll.setAttribute("data-action", "add-to-cart");
          buttonAll.setAttribute("data-old-action", "add-to-cart");
        }

      } else {
        const button = form.querySelector('[data-action="add-to-cart"]');

        if (button) {
          button.setAttribute("data-action", "add-all-to-cart-purifier");
          button.setAttribute("data-old-action", "add-all-to-cart-purifier");
        }
      }
    })
  }

  updateFormSideProductData(productId) {
    if (!this.forms || !productId) return;

    this.forms.forEach(form => {
      const input = form.querySelector('.side-product');
      if (input) {
        input.dataset.productId = productId;
      }
    })
  }

  updateFormSideVariantData(variantId) {
    if (!this.forms || !variantId) return;

    this.forms.forEach(form => {
      const input = form.querySelector('.side-product');
      if (input) {
        input.value = variantId;
      }
    })
  }

  updateFormSideSubData(subId) {
    if (!this.forms) return;
    if (!subId) subId = "";

    this.forms.forEach(form => {
      const input = form.querySelector('.side-product');
      if (input) {
        input.dataset.sellingPlan = subId;
      }
    })
  }

  updateSubOptionCombinedPrice(subPrice, unformatedSubPrice, renderedCombinedPrice) {
    if (!subPrice || !unformatedSubPrice) return;

    // Normalize decimal separator (replace comma with period)
    let normalizedPrice = unformatedSubPrice.replace(",", ".");
    let priceInCents;

    // Check if the value contains a decimal point
    if (normalizedPrice.includes(".")) {
      // It's in decimal format (e.g., "20.00"), convert to cents
      priceInCents = Math.round(Number(normalizedPrice) * 100);
    } else {
      // It's already in cents format (e.g., "2000"), use as is
      priceInCents = Number(normalizedPrice);
    }

    const subPriceElem = this.element.querySelector(".Product--PurifierSubPrice");
    if (subPriceElem) subPriceElem.innerText = subPrice;

    const combinedSubPriceElem = this.element.querySelector(".Product--PurifierCombinedPrice");
    if (!combinedSubPriceElem) return;

    // Use the data-product-price that was set on page load or by oneTimePurchase
    // This is the purifier's current variant price in cents
    const productPrice = combinedSubPriceElem.dataset.productPrice;
    if (!productPrice) {
      console.warn('Product price not set on combined price element');
      return;
    }

    // Prefer the combined price Liquid pre-rendered for this plan
    // (data-combined-price); only fall back to summing and re-formatting the
    // cents ourselves, which cannot reproduce Shopify's own separators.
    const combinedPrice =
      renderedCombinedPrice ||
      Shopify.formatMoney(Number(productPrice) + priceInCents, window.theme.moneyFormat);
    combinedSubPriceElem.innerText = combinedPrice;
    combinedSubPriceElem.dataset.subPrice = priceInCents;

    this.updateButtonPrice(combinedPrice);
  }
}

customElements.define("purifier-flow", PurifierFlow);

class TextSplitDropdown extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delElem = new Delegate(this.element);


    if (this.element.dataset.noBuild) this.initDropdown();
    this.firstOpen = true;
    this.bindEvents();
  }

  initDropdown() {
    if (this.element.querySelector('[data-action="open-text-split-dropdown"]')) return;

    const desc = this.element.dataset.text;
    const splitWord = this.element.dataset.splitWord;
    const descSplit = desc.split(splitWord);

    const divClass = "Product--FirstTextSplit";
    const content = descSplit[0] + " " + splitWord + " ";
    const tempDiv = this.createTextElem(divClass, content);

    const divClass2 = "Product--SecondTextSplit";
    const content2 = descSplit[1];
    const tempDiv2 = this.createTextElem(divClass2, content2);

    const openButtonClass = "Product--TextSplitOpenButton";
    const openButtonText = this.element.dataset.openButton;
    const openButtonAction = "open-text-split-dropdown";
    const openButton = this.createButtonElement(openButtonClass, openButtonText, openButtonAction);

    const closeButtonClass = "Product--TextSplitCloseButton";
    const closeButtonText = this.element.dataset.closeButton;
    const closeButtonAction = "close-text-split-dropdown";
    const closeButton = this.createButtonElement(closeButtonClass, closeButtonText, closeButtonAction);

    tempDiv.append(openButton);
    tempDiv2.append(closeButton);

    this.element.append(tempDiv);
    this.element.append(tempDiv2);
  }

  createTextElem(divClass, content) {
    const tempSpan = document.createElement("span");

    tempSpan.classList.add("u-p3");
    tempSpan.innerText = content;

    const tempDiv = document.createElement("div");

    tempDiv.classList.add(divClass);
    tempDiv.append(tempSpan);

    return tempDiv;
  }

  createButtonElement(buttonClass, buttonText, buttonAction) {
    const button = document.createElement("div");

    button.dataset.action = buttonAction;
    button.classList.add("u-pb1");
    button.classList.add("pt-l");
    button.classList.add(buttonClass);
    button.innerText = buttonText;

    return button;
  }

  calulateHeight() {
    const tempDiv = this.element.querySelector(".Product--FirstTextSplit");
    const tempDiv2 = this.element.querySelector(".Product--SecondTextSplit");
    const openButton = this.element.querySelector(".Product--TextSplitOpenButton");

    this.closedHeight = tempDiv.getBoundingClientRect().height;
    this.openedHeight = tempDiv.getBoundingClientRect().height + tempDiv2.getBoundingClientRect().height - openButton.getBoundingClientRect().height;
  }

  bindEvents() {
    this.delElem.on('click', '[data-action="open-text-split-dropdown"]', this.openDropdown.bind(this));
    this.delElem.on('click', '[data-action="close-text-split-dropdown"]', this.closeDropdown.bind(this));
  }

  openDropdown() {
    this.calulateHeight();

    if (this.firstOpen) {
      this.element.style.height = this.closedHeight + "px";
      this.element.querySelector(".Product--SecondTextSplit").style.height = "auto";

      this.calulateHeight();
      this.firstOpen = false;
    }

    this.element.style.height = this.openedHeight + "px";

    this.element.setAttribute("aria-expanded", "true");
  }

  closeDropdown() {
    this.element.style.height = this.closedHeight + "px";

    this.element.setAttribute("aria-expanded", "false");
  }
}

customElements.define("text-split-dropdown", TextSplitDropdown);

class KlaviyoForm extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    setTimeout(() => {
      this.setData();
      this.startObserving();
    }, 100);
  }

  setData() {
    const location = this.element.querySelector("[data-location]");
    if (!location) return;

    this.isNewsletter = location.dataset.location === "newsletter";
    this.isFooter = location.dataset.location === "footer";
  }

  startObserving() {
    const existingWrapper = this.element.querySelector(".custom-klaviyo__email-wrapper");
    if (existingWrapper) {
      this.initForm();
      return;
    }

    const klaviyoForm = this.element.querySelector(".klaviyo-form__class");
    if (!klaviyoForm) return;

    const observer = new MutationObserver(() => {
      this.initForm();
      observer.disconnect();
    });

    observer.observe(klaviyoForm, { childList: true });
  }

  initForm() {
    const successMsg = this.element.querySelector('.klaviyo-form__success-msg');
    const errorMsg = this.element.querySelector('.klaviyo-form__error-msg');
    if (successMsg) successMsg.classList.add("hidden-msg")
    if (errorMsg) errorMsg.classList.add("hidden-msg")

    const klaviyoForm = this.element.querySelector('.custom-klaviyo__form');
    const emailInput = klaviyoForm?.querySelector('.custom-klaviyo__email-input');
    const submitBtn = klaviyoForm?.querySelector('.custom-klaviyo__submit-button');

    if (!klaviyoForm || !emailInput || !submitBtn) return;

    // Determine type and key
    const formType = this.isNewsletter ? 'Newsletter Form' : 'Footer Form';
    const listKey = this.isNewsletter
      ? window.theme.klaviyo?.klaviyoNewsletterKey
      : window.theme.klaviyo?.klaviyoFooterNewsletterKey;

    klaviyoForm.addEventListener('submit', async (e) => {
      e.preventDefault();

      const email = emailInput.value.trim();
      if (!email) return;

      const result = await subscribeToKlaviyo(email, formType, listKey);

      if (result?.success) {
        if (successMsg) successMsg.classList.remove("hidden-msg");
        emailInput.value = '';
        emailInput.style.display = 'none';
        submitBtn.style.display = 'none';
      }else{
        if (errorMsg) errorMsg.classList.remove("hidden-msg");
         emailInput.value = '';
        emailInput.style.display = 'none';
        submitBtn.style.display = 'none';
      }
    });
  }
}


customElements.define("klaviyo-form", KlaviyoForm);

class KlaviyoAtc {
  constructor() {
    this.delBody = new Delegate(document.body);
    this.bindEvents();
  }

  bindEvents() {
    window.addEventListener('load', this.sendData());
    this.delBody.on("product:added", this.sendData.bind(this));
    this.delBody.on("gwp:added", this.sendData.bind(this));
  }

  async sendData() {
    const _learnq = window._learnq || [];

    try {
      const response = await fetch(`${window.routes.localeRootUrl}/cart.js`);
      const data = await response.clone().json();

      const cart = {
        total_price: data.total_price / 100,
        $value: data.total_price / 100,
        total_discount: data.total_discount,
        original_total_price: data.original_total_price / 100,
        items: data.items
      }

      _learnq.push(['track', 'Added to Cart', cart]);
      console.log("Klaviyo _learnq pushed.");

    } catch (e) {
      console.log("Data not send to klaviyo", e);
    }
  }
}

new KlaviyoAtc();

class FooterLocalization extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    const dropdown = this.element.querySelector('.RevolutionSelectbox--Content');
    dropdown?.classList.remove('PopoverContent');

    setTimeout(() => {
      window.requestAnimationFrame(() => {
        const selectBoxes = this.element.querySelectorAll(".RevolutionSelectbox");
        if (selectBoxes.length > 0) {
          selectBoxes.forEach((item, i) => {
            new RevolutionSelectbox(item);
          });
        }
      }, 100)
    })
  }
}
customElements.define("footer-localization", FooterLocalization);

class InspirationSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegate = new Delegate(this.element);

    this.isDesktop = new Responsive().matchesBreakpoint('lap-and-up');

    const swiperElement = this.isDesktop ? this.element.querySelector(".not_mobile.swiper") : this.element.querySelector(".inspiration__mobile-drawer .swiper");
    this.swiper = new RevolutionSwiper(swiperElement);

    this.turnOffActiveDot();
  }

  connectedCallback() {
    this.delegate.on('click', '[data-action="select-slide"]', this.handleDotClick.bind(this));
    this.delegate.on('keypress', '[data-action="select-slide"]', this.handleDotKeypress.bind(this));
    this.swiper.swiperElement.on("slideChange", this.handleSlideChange.bind(this));

    if (this.isDesktop) return;

    this.delegate.on('click', '[data-action="select-slide"]', this.openInspirationDrawer.bind(this));
    this.delegate.on('click', '[data-action="close-inspiration-drawer"]', this.closeInspirationDrawer.bind(this));
    this.delegate.on('click', '[data-initial="true"]', this.handleInitialClick.bind(this));
  }

  handleDotKeypress() {
    if (event.key === "enter") event.target.click();
  }

  handleDotClick() {
    const index = event.target.dataset.index;
    this.element.querySelector(`.swiper-pagination-bullet:nth-child(${index})`)?.click();
  }

  handleSlideChange() {
    const activeDot = this.element.querySelector('.inspiration__dot[aria-selected="true"]');
    if (activeDot) {
      activeDot.setAttribute("aria-selected", "false");
      activeDot.tabIndex = 0;
    }

    let index = this.swiper.swiperElement.activeIndex + 1;
    const newDot = this.element.querySelector(`.inspiration__dot[data-index="${index}"]`);

    newDot.setAttribute("aria-selected", "true");
    newDot.tabIndex = -1;
  }

  openInspirationDrawer() {
    const drawer = this.element.querySelector(".inspiration__mobile-drawer");

    drawer.style.display = "block";
    requestAnimationFrame(() => {
      drawer.setAttribute("aria-hidden", "false")
      drawer.setAttribute("aria-expanded", "true")
    }
  );
    bodyScrollLock.disableBodyScroll(drawer, bodyScrollLockOptions);

    const mobileInfo = this.element.querySelector('.inspiration__mobile-button[aria-hidden="true"]');
    mobileInfo?.setAttribute("aria-hidden", "false")
  }

  closeInspirationDrawer() {
    const drawer = this.element.querySelector(".inspiration__mobile-drawer");

    drawer.setAttribute("aria-hidden", "true");
    drawer.setAttribute("aria-expanded", "false")

    setTimeout(() => {
      drawer.style.display = "none";
      bodyScrollLock.clearAllBodyScrollLocks();
    }, 300);
  }

  // on desktop first dot is active from start but it should not be on mobile
  turnOffActiveDot() {
    if (this.isDesktop) return;

    const initialDot = this.element.querySelector('.inspiration__dot[aria-selected="true"]');
    if (!initialDot) return;

    initialDot.setAttribute("aria-selected", "false");
    initialDot.setAttribute("data-initial", "true");
  }

  handleInitialClick() {
    event.target.removeAttribute("data-initial");
    this.handleSlideChange();
  }
}

customElements.define("inspiration-section", InspirationSection);

async function subscribeToKlaviyo(email, source, key) {
  try {

    if (!key || !email) throw "Data missing - " + "list id: " + key + " email: " + email;

    // pass in additional fields, each additional field
    // must be included in the $fields string separated by commas
    //"$fields": "$message, $first_name, $last_name",
    // https://community.klaviyo.com/developer-group-64/how-to-use-form-element-to-post-member-to-a-list-4126

    const settings = new URLSearchParams({
      g: key,
      $fields: "$source, $shopify_country, $shopify_currency_code, $shopify_language, $shopify_locale",
      email: email,
      $source: source || "Popup form",
      $shopify_country: window.theme.klaviyo.shopify_country,
      $shopify_currency_code: window.theme.klaviyo.shopify_currency_code,
      $shopify_language: window.theme.klaviyo.shopify_language,
      $shopify_locale: window.theme.klaviyo.shopify_locale
    })


    const url = `https://manage.kmail-lists.com/ajax/subscriptions/subscribe`;

    const response = await fetch(url, {
      method: "POST",
      headers: {
        "content-type": "application/x-www-form-urlencoded",
        "cache-control": "no-cache",
      },
      body: settings.toString()
    });

    if (!response.ok) throw response;

    
    const reponseBody = await response.json();
    if (!reponseBody.success) throw reponseBody.errors;

    return {success: true};

  } catch (error) {
    console.error("Error occurred during subscription creation:", error);
  }
}

class Preload {
  constructor() {      
    this.preloaded = this.getPreloadedSession();
    
    this.startPreloading();
  }

  getPreloadedSession() {
    const session = sessionStorage.getItem("aarke_preloaded");
    return session ? JSON.parse(session) : {};
  }

  getPreloadedById(type, id) {
    return this.preloaded[`${type}-${id}`];
  }

  setPreloadedSession() {    
    const session = JSON.stringify(this.preloaded);    
    sessionStorage.setItem("aarke_preloaded", session);    
  }

  async startPreloading() {
    const elements = document.querySelectorAll("[data-preload]");

    const preloadPromises = Array.from(elements).map(elem => this.preload(elem.dataset));
    const responses = await Promise.all(preloadPromises);
    
    if (responses.some(preloaded => preloaded === true)) this.setPreloadedSession();
  }

  async preload(dataset) {
    const { preloadUrl: url, preloadType: type, preloadId: id, preloadSection: section } = dataset;    
    
    if (this.preloaded[type + "-" + id] || !url) return false;

    try {
      const response = await fetch(url);
      const html = await response.text();

      // Extract the section between the opening and closing section tags
      const sectionContent = this.extractSection(html, section);      
      if (!sectionContent) return false;

      // Replace custom elements in the section with a 'div' and store the preloaded content
      this.preloaded[`${type}-${id}`] = sectionContent;

      return true;
    } catch (error) {
      console.error('Error preloading:', error);
      return false;
    }
  }

  // Helper function to extract the section content from the HTML
  extractSection(html, section) {
    const startTag = `<${section}`;
    const endTag = `</${section}>`;
    const start = html.indexOf(startTag);
    const end = html.indexOf(endTag, start);

    if (start === -1 || end === -1) return null;

    return html.slice(start, end + endTag.length);
  }
}

const globalPreload = new Preload();

class ProductRecommendationsAuto extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.carouselElement = this.element.querySelector(".swiper");
    this.carousel = new RevolutionSwiper(this.carouselElement);
    new AddToCart(this.element)


    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;

            new RevolutionSwiper(this.querySelector('.swiper'));

          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '-100px 0px 200px 0px'}).observe(this);
  }
}

customElements.define('product-recommendations-auto', ProductRecommendationsAuto);

class ProductRecommendationsHome extends HTMLElement {
    constructor() {
      super();
      this.element = this;
      this.delegateElement = new Delegate(this.element); 
      this.tabButtons = this.element.querySelectorAll('[data-action="toggle-tab"]');
      this.tabContainers = this.element.querySelectorAll('.FeaturedCollection--Wrapper');

      this.recentlyViewedLoaded = false; // Track if recently viewed products are loaded
      this.isLoading = false; // Track loading state

      // Initialize all carousel elements - store them with their tab ID
      this.carousels = new Map();
      this.tabContainers.forEach((container) => {
        const carouselElement = container.querySelector(".swiper");
        if (carouselElement) {
          const tabId = container.getAttribute('data-toggle-id');
          this.carousels.set(tabId, new RevolutionSwiper(carouselElement));
        }
      });

      new AddToCart(this.element);

    }

    connectedCallback(){
       this.initializeTabs();
       this.populateRecentlyViewedProducts();
       this.bindEvents();
    }

    initializeTabs() {
      // Update swipers for initially visible tabs
      this.tabContainers.forEach(container => {
        const isVisible = container.getAttribute('aria-hidden') === 'false';
        if (isVisible) {
          const tabId = container.getAttribute('data-toggle-id');
          const carousel = this.carousels.get(tabId);
          if (carousel && carousel.swiperElement) {
            carousel.swiperElement.update();
          }
        }
      });
    }

    disconnectedCallback() {
      if (this.delegateElement) {
        this.delegateElement.destroy(); 
      }

      this.tabButtons.forEach(button => {
        button.removeEventListener('click', this._tabClickHandler);
      });
    }


    bindEvents() {
      this.delegateElement.on('click', '[data-action="toggle-tab"]', this.handleTabClick.bind(this));
    }

    handleTabClick(e){
      e.preventDefault();
      const target = e.target.closest('[data-action="toggle-tab"]');
      if(!target) return;
      const toggleId = target.getAttribute("data-toggle-id");
      if(toggleId){
        this.switchTab(toggleId);
      }
    }

   switchTab(activeTabId) {
      this.tabContainers.forEach(container => {
        container.style.display = "none";
        container.setAttribute('aria-hidden', 'true');
      });

      this.tabContainers.forEach(container => {
        const containerId = container.getAttribute('data-toggle-id');

        if (containerId === activeTabId) {
          container.style.display = "block";

          const carousel = this.carousels.get(activeTabId);
          if (carousel && carousel.swiperElement) {
            carousel.swiperElement.update();
          }

          requestAnimationFrame(() => {
            container.setAttribute('aria-hidden', 'false');
          });
        }
      });

      this.tabButtons.forEach((button)=>{
        if(button.getAttribute("data-toggle-id") !== activeTabId){
          button.classList.remove("Button--PrimaryOnLight");
          button.classList.add("Button--PrimaryOnDark");
        }else{
          button.classList.add("Button--PrimaryOnLight");
          button.classList.remove("Button--PrimaryOnDark");
        }
      });

    }

    loadRecentlyViewedProducts() {
      const maxCached = this.element.querySelector("[data-max-cached]").getAttribute("data-max-cached");
      const currentHandle = this.element.getAttribute("data-current-handle");
      const storageKey = "recently_viewed_products";
      let viewed = JSON.parse(localStorage.getItem(storageKey)) || [];

      // Filter out the current product
      if (currentHandle) {
        viewed = viewed.filter(handle => handle !== currentHandle);
      }

      return viewed.slice(0, maxCached);
    }

    

    async populateRecentlyViewedProducts(forceRefresh = false){
      // Check if already loaded (caching) - skip if forceRefresh is true
      if (!forceRefresh && (this.recentlyViewedLoaded || this.isLoading)) {
        return;
      }

      let viewedHandles = this.loadRecentlyViewedProducts();

      const currentHandle = document.querySelector("product-component")?.getAttribute("data-current-handle");
      const navButtons = this.element.querySelector('[data-toggle-id="recently-viewed-tab"] .swiper-helper__wrapper');

      if(currentHandle){
        viewedHandles = viewedHandles.filter(handle => handle !== currentHandle)
      }

      if(viewedHandles.length <= 4){
        navButtons.style.display="none";
      }

      // If no recently viewed products, don't fetch
      if (viewedHandles.length === 0) {
        this.element.querySelector(".recently-viewed__button")?.setAttribute("disabled","true");
        return;
      }

      this.isLoading = true;

      const q = viewedHandles.map(handle => `handle:${handle}`).join(' OR ');

      try{
        const response = await fetch(`${window.routes.localeRootUrl}/search?view=recently-viewed&q=${encodeURIComponent(q)}`);
        const html = await response.text();

        const wrapper = this.element.querySelector('[data-toggle-id="recently-viewed-tab"] .swiper-wrapper');

        if (!wrapper) {
          console.error('Recently viewed wrapper not found');
          return;
        }

        wrapper.innerHTML = html;

        viewedHandles.forEach(handle => {
            const node = wrapper.querySelector(`[data-handle="${handle}"]`);
            if (node) wrapper.appendChild(node);
          });

        // Update the swiper after adding new products
        const tabId = 'recently-viewed-tab';
        const carousel = this.carousels.get(tabId);
        if (carousel && carousel.swiperElement) {
          carousel.swiperElement.update();
        }

        this.recentlyViewedLoaded = true;

        } catch(error){
          console.error('Error loading recently viewed products:', error);

        }finally{
          this.isLoading = false;
        };

    }

    refreshRecentlyViewedProducts() {
      // Force a refresh by calling populate with forceRefresh flag
      this.populateRecentlyViewedProducts(true);
    }

  }

  customElements.define('product-recommendations-home', ProductRecommendationsHome);

function updateVisibleHeight(element, cssVar) {
  if (!element) return;

  const rect = element.getBoundingClientRect();
  const windowHeight = window.innerHeight;

  let visibleHeight = Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);

  visibleHeight = Math.max(visibleHeight, 0);

  document.documentElement.style.setProperty(cssVar, `${visibleHeight}px`);
}

class AnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.handleScroll = this.handleScroll.bind(this);
  }

  connectedCallback() {
    updateVisibleHeight(this,'--announcement-dynamic-height');
    document.addEventListener('scroll', this.handleScroll);
  }

  disconnectedCallback() {
    document.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    updateVisibleHeight(this,'--announcement-dynamic-height');
  }
}

class AnnouncementBarSwiper extends AnnouncementBar {}

customElements.define('announcement-bar', AnnouncementBar);
customElements.define('announcement-bar-swiper', AnnouncementBarSwiper);


class ShippingPopup extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
  }

  connectedCallback() {
    // If user already closed the popup before → DO NOT show it again
    const isClosed = localStorage.getItem("shipping_popup_closed");
    if (isClosed) return;

    setTimeout(() => {
      this.openPopup();
    }, 500);

    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on(
      "click",
      "[data-action='close-modal']",
      this.handleCloseClick.bind(this)
    );
  }

  disconnectedCallback() {
    this.delegateElement.destroy();
  }

  handleCloseClick() {
    // Save to localStorage so popup never shows again
    localStorage.setItem("shipping_popup_closed", "true");
    this.closePopup();
  }

  openPopup() {
    this.element.style.display = "flex";
    this.element.offsetHeight;
    this.element.setAttribute("aria-hidden", "false");
  }

  closePopup() {
    this.element.setAttribute("aria-hidden", "true");

    const handleTransitionEnd = (e) => {
      if (e.target === this.element) {
        this.element.style.display = "none";
        this.element.removeEventListener("transitionend", handleTransitionEnd);
      }
    };

    this.element.addEventListener("transitionend", handleTransitionEnd);
  }
}

customElements.define("shipping-popup", ShippingPopup);

class NewAddons extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    
    this.initSwiper();
    this.bindAddonNavigation();

    if (this.element.querySelector('[data-action="open-product-drawer"]')) {
      this.delegateElement = new Delegate(this.element);
      this.prepareDrawer();
      if (this.drawer) this.delegateBody = new Delegate(document.body);
    }
    this.boundOnProductAdded = this.onProductAdded.bind(this);
  }

  bindAddonNavigation() {
    this.delegateBodyNav = new Delegate(this.element);
    this.delegateBodyNav.on("click", ".product__addon", (event) => {
      const addon = event.target.closest(".product__addon");
      if (!addon) return;

      // Let add-to-cart clicks behave normally.
      if (event.target.closest?.('[data-action="add-to-cart"]')) return;

      const url = addon.getAttribute("data-url");
      if (!url) return;

      event.preventDefault();
      window.location.href = url;
    });
  }

  connectedCallback() {
    if (!this.delegateBody) return;

    this.delegateBody.on('click', '[data-action="open-product-drawer"]', this.openDrawer.bind(this));
    this.delegateBody.on('click', '[data-action="close-product-drawer"]', this.closeDrawer.bind(this));
    this.delegateBody.on('close:product:drawer', this.closeDrawer.bind(this));
    this.delegateBody.on('click', '[data-action="update-product-drawer"]', this.fetchNewDrawer.bind(this));
    this.delegateBody.on('click', '[data-action="add-to-cart"]', this.onDrawerAddToCartClick.bind(this));
    document.addEventListener('product:added', this.boundOnProductAdded);
  }

  disconnectedCallback() {
    document.removeEventListener('product:added', this.boundOnProductAdded);
    this.delegateElement?.destroy();
    this.delegateBody?.destroy();
    this.delegateBodyNav?.destroy();
  }
 
  initSwiper() {    
    const swiperElement = this.element.querySelector(".product__addons.swiper");
    if (swiperElement) new RevolutionSwiper(swiperElement);
  }

  prepareDrawer() {
    if (!this.element.querySelector('[data-action="open-product-drawer"]')) return;

    const template = this.element.querySelector(".product-drawer__template");
    if (!template) return;

    const parser = new DOMParser();
    const elem = parser.parseFromString(template.innerHTML, "text/html");

    this.drawer = elem.querySelector(".product-drawer");
    document.querySelector("product-component")?.appendChild(this.drawer);
  }

  openDrawer(event) {
    if (!this.drawer) return;
    const target = event.target.closest('[data-action="open-product-drawer"]');
    const template = target?.querySelector(".product-drawer__inner-template");
    if (!template) return;

    const wasClosed = this.drawer.style.display === 'none' || this.drawer.style.display === '';
    this.drawer.style.display = 'block';
    this.drawer.setAttribute('aria-hidden', 'false');

    const loader = this.drawer.querySelector(".product-drawer__loader");
    if (loader) {
      loader.classList.add("is-visible");
      void this.drawer.offsetHeight;
    }

    if (wasClosed) {
      bodyScrollLock.disableBodyScroll(this.drawer, bodyScrollLockOptions);
      const overlay = document.querySelector(".pageOverlay");
      if (overlay) {
        overlay.classList.add("is-visible");
        this.overlayEventbind = this.closeDrawer.bind(this);
        overlay.removeEventListener("click", this.overlayEventbind);
        overlay.addEventListener("click", this.overlayEventbind);
      }
    }

    const templateHtml = template.innerHTML;
    const hideLoader = () => loader?.classList.remove("is-visible");
    setTimeout(() => {
      try {
        const parser = new DOMParser();
        const elem = parser.parseFromString(templateHtml, "text/html");
        this.buildDrawer(elem);
        setTimeout(hideLoader, 120);
      } catch (e) {
        hideLoader();
      }
    }, 20);
  }

  onDrawerAddToCartClick(event) {
    if (event.target.closest?.('[data-action="select-variant-option"]')) return;
    if (event.target.closest?.('.variant-selectors__options') || event.target.closest?.('product-variant-selector .variant-selectors')) return;
    const trigger = event.target.closest?.('[data-action="add-to-cart"]') || event.target;
    if (this.drawer && trigger && this.drawer.contains(trigger)) {
      const loader = this.drawer.querySelector(".product-drawer__loader");
      loader?.classList.add("is-visible");
      if (this.drawerAtcLoaderTimeout) clearTimeout(this.drawerAtcLoaderTimeout);
      this.drawerAtcLoaderTimeout = setTimeout(() => loader?.classList.remove("is-visible"), 5000);
    }
  }

  onProductAdded(event) {
    if (this.drawer && (event.target === this.drawer || this.drawer.contains(event.target))) {
      if (this.drawerAtcLoaderTimeout) clearTimeout(this.drawerAtcLoaderTimeout);
      this.drawerAtcLoaderTimeout = null;
      this.drawer.querySelector(".product-drawer__loader")?.classList.remove("is-visible");
      this.closeDrawer(undefined, { keepOverlay: true });
    }
  }

  closeDrawer(event, options) {
    if (!this.drawer) return;
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    this.drawer.setAttribute('aria-hidden', 'true');

    const keepOverlay = options?.keepOverlay;

    setTimeout(() => {
      this.drawer.style.display = 'none';
      bodyScrollLock.clearAllBodyScrollLocks();

      if (!keepOverlay) {
        const overlay = document.querySelector(".pageOverlay");
        if (overlay) {
          overlay.classList.remove("is-visible");
          overlay.removeEventListener("click", this.overlayEventbind);
        }
      }
    }, 400);
  }

  buildDrawer(template) {
    const oldInner = this.drawer.querySelector(".product-drawer__inner");
    const newInner = template?.querySelector(".product-drawer__inner");
    if (!newInner) throw "Drawer inner is missing.";

    this.drawer.replaceChild(newInner, oldInner);

    const swiperElement = this.drawer.querySelector(".swiper");
    if (swiperElement) new RevolutionSwiper(swiperElement);

    if (this.drawer.querySelector('[data-action="add-to-cart"]') && !this.drawerAddToCart) {
      this.drawerAddToCart = new AddToCart(this.drawer);
    }
  }

  async fetchNewDrawer() {
    if (!this.drawer) return;
    const loader = this.drawer.querySelector(".product-drawer__loader");
    loader?.classList.add("is-visible");

    const target = event.target.closest('[data-action="update-product-drawer"]');
    const url = target?.dataset.url;

    try {
      if (!url) throw "Url is missing: " + url;

      const response = await fetch(url);
      const text = await response.text();

      const parser = new DOMParser();
      const elem = parser.parseFromString(text, "text/html");

      this.buildDrawer(elem);
    } catch (error) {
      console.log(error);
    } finally {
      loader?.classList.remove("is-visible");
    }
  }
}

customElements.define("product-addons", NewAddons);

class SwiperInit extends HTMLElement {
  constructor() {
    super();
    this.element = this;
  }
  connectedCallback() {
    this.swiper = new RevolutionSwiper(this.element);
  }

  disconnectedCallback() {
    if (this.swiper) this.swiper.swiperElement.destroy();
  }
}

customElements.define("swiper-init", SwiperInit);

class MarketSelectorDrawer extends HTMLElement {
  constructor() {
    super();
    this.element = this;
  }

  connectedCallback() {
    if (!this.drawer) this.drawer = new Drawer(this.element);
  }

  disconnectedCallback() {
    if (this.drawer && typeof this.drawer.destroy === "function") this.drawer.destroy();
    this.drawer = null;
  }
}
customElements.define("market-selector-drawer", MarketSelectorDrawer);

class LocalizationModal extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.selectboxInstances = [];
    this.pendingRedirectUrl = null;
  }

  connectedCallback() {
    this.delegateElement = new Delegate(this.element);
    this.selectContainer = this.element.querySelector(
      ".rs-country__selectbox .RevolutionSelectbox--Content"
    );

    // Reuse the existing RevolutionSelectbox component for both selectors.
    this.element.querySelectorAll(".RevolutionSelectbox").forEach((box) => {
      this.selectboxInstances.push(new RevolutionSelectbox(box));
    });

    this.bindEvents();

    this.resetPendingRedirect();
    this.ensureLanguageSelection();
    this.sortMarketsAlphabetically();

    const countrySelectWrapper = this.element.querySelector(".rs-country__selectbox");
    if (countrySelectWrapper) this.initSearchableSelect(countrySelectWrapper);

    // Preload localization data for the language fallback path.
    this.ensureLocalizationData();
  }

  bindEvents() {
    
    // Track the in-flight language rebuild so submit can await it (the fallback
    // path loads /localization.json asynchronously).
    this._languageUpdatePromise = null;
    this._onCountrySelectorChange = (event) => {
      this._languageUpdatePromise = this.updateLanguageOptions(event);
    };
    this._onFadeVisibility = this.checkFadeVisibility.bind(this);

   
    document.addEventListener("change:countrySelector", this._onCountrySelectorChange);

    this.delegateElement.on("click", '[data-action="select-language"]', this.selectLanguageItem.bind(this));
    this.delegateElement.on("keydown", '[data-action="select-language"]', (event, target) => {
      if (event.key === "Enter" || event.keyCode === 13) {
        event.preventDefault();
        this.selectLanguageItem(event, target);
      }
    });

    this.delegateElement.on("click", '[data-action="custom-country-redirect"]', this.redirectToCustomUrl.bind(this));
    this.delegateElement.on("click", '[data-action="check-location-submit"]', this.checkLocationSubmit.bind(this));

    // Regular (non-redirect) market selection just marks the choice; it is
    // applied on submit. Redirect entries are handled separately above.
    this.delegateElement.on(
      "click",
      '.rs-country__selectbox .RevolutionSelectbox--Item:not([data-action="custom-country-redirect"])',
      this.handleRegularMarketSelection.bind(this)
    );

    if (this.selectContainer) {
      this.selectContainer.addEventListener("scroll", this._onFadeVisibility);
    }
    window.addEventListener("resize", this._onFadeVisibility);
  }

  disconnectedCallback() {
    document.removeEventListener("change:countrySelector", this._onCountrySelectorChange);
    window.removeEventListener("resize", this._onFadeVisibility);
    if (this.selectContainer && this._onFadeVisibility) {
      this.selectContainer.removeEventListener("scroll", this._onFadeVisibility);
    }
    if (this._searchObserver) this._searchObserver.disconnect();
    clearTimeout(this._clearFilterTimeout);

    // Tear down delegated events and the reused selectbox instances so their
    // listeners (and the RevolutionSelectbox static registry) don't leak.
    if (this.delegateElement) this.delegateElement.destroy();
    if (this.selectboxInstances) {
      this.selectboxInstances.forEach((instance) => {
        if (instance && typeof instance.destroy === "function") instance.destroy();
      });
      this.selectboxInstances = [];
    }
    this._languageUpdatePromise = null;
  }

  // Enforce a single selected item within a scope (clears the rest).
  selectSingle(scope, target) {
    if (!scope) return;
    scope.querySelectorAll(".RevolutionSelectbox--Item.is-selected").forEach((item) => {
      if (item !== target) item.classList.remove("is-selected");
    });
    if (target) target.classList.add("is-selected");
  }

  // Title-case each word; tolerant of null/already-capitalised input.
  capitalizeWords(value) {
    return String(value || "").replace(/\b\w/g, (c) => c.toUpperCase());
  }

  // Close a specific RevolutionSelectbox via its instance.
  closeSelectbox(wrapper, event) {
    if (!wrapper) return;
    const instance = this.selectboxInstances.find((i) => i.element === wrapper);
    // RevolutionSelectbox.closeDropdown(event, target, keepOverlay) ignores event.
    if (instance) instance.closeDropdown(event, wrapper);
  }

  checkFadeVisibility() {
    if (!this.selectContainer) return;
    const fade = this.element.querySelector(".rs-country__selectbox .container__fade--bottom");
    if (!fade) return;
    const isScrollable = this.selectContainer.scrollHeight > this.selectContainer.clientHeight + 1;
    const isAtBottom =
      this.selectContainer.scrollTop + this.selectContainer.clientHeight >= this.selectContainer.scrollHeight - 1;
    fade.classList.toggle("hidden", !isScrollable || isAtBottom);
  }

  sortMarketsAlphabetically() {
    const container = this.element.querySelector(".rs-country__selectbox .RevolutionSelectbox--InnerContent");
    if (!container) return;
    const items = Array.prototype.slice.call(container.querySelectorAll(".RevolutionSelectbox--Item:not(.market-search__no-results)"));
    if (!items.length) return;
    items.sort((a, b) => {
      const nameA = (a.dataset.name || "").toLowerCase();
      const nameB = (b.dataset.name || "").toLowerCase();
      if (nameA < nameB) return -1;
      if (nameA > nameB) return 1;
      return 0;
    });
    items.forEach((item) => container.appendChild(item));
  }

  /**
   * Searchable market dropdown: filter items and focus the search field on open.
   */
  initSearchableSelect(wrapper) {
    if (!wrapper || wrapper.dataset.localizationSearchInit === "1") return;
    wrapper.dataset.localizationSearchInit = "1";

    const searchInput = wrapper.querySelector(".market-search__input");
    const searchField = searchInput && searchInput.closest(".market-search__field");
    const placeholderVisual = wrapper.querySelector(".market-search__placeholder-visual");
    const items = Array.from(wrapper.querySelectorAll(".RevolutionSelectbox--Item:not(.market-search__no-results)"));
    const button = wrapper.querySelector(".RevolutionSelectbox--Button");
    if (!searchInput || !items.length || !button) return;

    const syncSelectedCountryHint = () => {
      if (!placeholderVisual) return;
      const selected = wrapper.querySelector(".RevolutionSelectbox--Item.is-selected");
      if (selected && selected.dataset.name) placeholderVisual.textContent = selected.dataset.name;
    };

    const syncSearchEmptyState = () => {
      if (searchField) searchField.classList.toggle("is-empty", searchInput.value.length === 0);
    };

    const syncFilterStateClasses = () => {
      const content = wrapper.querySelector(".RevolutionSelectbox--Content");
      if (!content) return;
      const visibleCount = items.reduce((acc, item) => acc + (item.style.display === "none" ? 0 : 1), 0);
      content.classList.toggle("no-results", visibleCount === 0);
      content.classList.toggle("hide-fade", visibleCount < 8);
    };

    const focusSearchInput = (fromUserGesture = false) => {
      if (!searchInput) return;
      try {
        searchInput.focus({ preventScroll: true });
      } catch (_error) {
        searchInput.focus();
      }
      if (fromUserGesture && typeof searchInput.setSelectionRange === "function") {
        const cursorPos = searchInput.value.length;
        searchInput.setSelectionRange(cursorPos, cursorPos);
      }
    };

    const activateSearchMode = (fromUserGesture = false) => {
      wrapper.classList.add("is-searching");
      searchInput.value = "";
      items.forEach((item) => {
        item.style.display = "";
      });
      syncSelectedCountryHint();
      syncSearchEmptyState();
      syncFilterStateClasses();
      focusSearchInput(fromUserGesture);
      requestAnimationFrame(() => {
        this.checkFadeVisibility();
        focusSearchInput(false);
      });
      setTimeout(() => {
        if (document.activeElement !== searchInput && wrapper.classList.contains("is-searching")) {
          focusSearchInput(false);
        }
      }, 250);
    };

    const clearFilter = () => {
      searchInput.value = "";
      items.forEach((item) => {
        item.style.display = "";
      });
      syncSearchEmptyState();
      syncFilterStateClasses();
      wrapper.classList.remove("is-searching");
    };

    const applyFilter = () => {
      const query = searchInput.value.trim().toLowerCase();
      if (!query) {
        items.forEach((item) => {
          item.style.display = "";
        });
        syncFilterStateClasses();
        return;
      }
      items.forEach((item) => {
        const nameNode = item.querySelector(".RevolutionSelectbox--Title--country");
        const text = (nameNode ? nameNode.textContent : item.textContent || "").trim().toLowerCase();
        item.style.display = text.indexOf(query) !== -1 ? "" : "none";
      });
      syncFilterStateClasses();
    };

    button.addEventListener("click", () => {
      const expanded = button.getAttribute("aria-expanded") === "true";
      if (!expanded) activateSearchMode(true);
    });

    const focusFromTouch = () => {
      if (wrapper.classList.contains("is-searching")) focusSearchInput(true);
    };
    if (searchField) searchField.addEventListener("touchend", focusFromTouch, { passive: true });
    searchInput.addEventListener("touchend", focusFromTouch, { passive: true });

    this._searchObserver = new MutationObserver(() => {
      if (button.getAttribute("aria-expanded") === "true") return;
      
      if (document.activeElement === searchInput) searchInput.blur();
      
      const content = wrapper.querySelector(".RevolutionSelectbox--Content");
      if (content && content.style.display !== "none") {
        content.style.transition = "none";
        content.style.maxHeight = content.scrollHeight + "px";
        void content.offsetHeight;
        content.style.transition = "";
        content.style.maxHeight = "";
      }
      
      wrapper.classList.remove("is-searching");
      clearTimeout(this._clearFilterTimeout);
      this._clearFilterTimeout = setTimeout(() => {
        if (button.getAttribute("aria-expanded") !== "true") clearFilter();
      }, 300);
    });
    this._searchObserver.observe(button, { attributes: true, attributeFilter: ["aria-expanded"] });

    searchInput.addEventListener("input", () => {
      applyFilter();
      syncSearchEmptyState();
    });

    const stop = (event) => event.stopPropagation();
    searchInput.addEventListener("mousedown", stop);
    searchInput.addEventListener("click", stop);

    searchInput.addEventListener("keydown", (event) => {
      if (event.key === "Escape" || event.key === "Esc") {
        event.stopPropagation();
        clearFilter();
      } else if (event.key === "Enter") {
        // Prevent the search field from implicitly submitting the localization form.
        event.preventDefault();
      }
    });
  }

  updateMarketButtonDisplay(wrapper, name) {
    if (!wrapper || !name) return;
    const display = wrapper.querySelector(".country-selector__header-display .RevolutionSelectbox--Title");
    if (display) {
      const countrySpan = display.querySelector(".RevolutionSelectbox--Title--country");
      if (countrySpan) countrySpan.textContent = name;
      else display.textContent = name;
    }
    const placeholderVisual = wrapper.querySelector(".market-search__placeholder-visual");
    if (placeholderVisual) placeholderVisual.textContent = name;
  }

  handleRegularMarketSelection(event, target) {
    this.pendingRedirectUrl = null;
    const wrapper = target.closest(".rs-country__selectbox");

    // Keep a single selected market (clears any previously selected market or redirect entry).
    this.selectSingle(wrapper, target);

    const countryInput = this.element.querySelector('#country-selector__country-code, input[name="country_code"]');
    if (countryInput) countryInput.value = (target.getAttribute("data-value") || "").trim();

    this.updateMarketButtonDisplay(wrapper, target.getAttribute("data-name"));

    // Rebuild language options for the chosen market.
    document.dispatchEvent(
      new CustomEvent("change:countrySelector", {
        detail: {
          languages: target.getAttribute("data-languages") || "",
          languageNames: target.getAttribute("data-language-names") || "",
          country: target.getAttribute("data-value") || "",
        },
      })
    );

    this.ensureLanguageSelection();
    this.closeSelectbox(wrapper, event);
  }

  redirectToCustomUrl(event, target) {
    const url = target.getAttribute("data-url");
    if (!url) return;
    this.pendingRedirectUrl = url;

    const wrapper = target.closest(".rs-country__selectbox");
    this.selectSingle(wrapper, target);

    this.updateMarketButtonDisplay(wrapper, target.getAttribute("data-name"));
    this.closeSelectbox(wrapper, event);
  }

  selectLanguageItem(event, target) {
    const wrapper = target.closest(".rs-language__selectbox");
    if (!wrapper) return;

    this.selectSingle(wrapper, target);

    this.element.querySelectorAll(".language-selector__radio").forEach((r) => {
      r.checked = false;
    });
    const radio = target.querySelector(".language-selector__radio");
    if (radio) radio.checked = true;
    const hidden = this.element.querySelector("#selected-language");
    if (hidden && radio) hidden.value = radio.value;

    this.ensureLanguageSelection();
    this.closeSelectbox(wrapper, event);
  }

  updateLanguageButtonTitle(wrapper, name) {
    const button = wrapper.querySelector(".RevolutionSelectbox--Button");
    if (!button || !name) return;
    const titleLang = button.querySelector(".RevolutionSelectbox--Title--language");
    if (titleLang) {
      titleLang.textContent = name;
    } else {
      const title = button.querySelector(".RevolutionSelectbox--Title");
      if (title) title.textContent = name;
    }
  }

  ensureLanguageSelection() {
    const hidden = this.element.querySelector("#selected-language");
    const radios = Array.from(this.element.querySelectorAll(".language-selector__radio"));
    if (!radios.length) return;

    let checked = radios.find((r) => r.checked);
    if (!checked && hidden && hidden.value) {
      checked = radios.find((r) => r.value.toLowerCase() === hidden.value.toLowerCase());
    }
    if (!checked) checked = radios[0];
    if (checked && !checked.checked) checked.checked = true;
    if (hidden && checked && hidden.value !== checked.value) hidden.value = checked.value;

    const languageWrapper = this.element.querySelector(".rs-language__selectbox");
    if (languageWrapper && checked) {
      const parentItem = checked.closest(".RevolutionSelectbox--Item");
      this.selectSingle(languageWrapper, parentItem);
      this.updateLanguageButtonTitle(languageWrapper, (parentItem && parentItem.getAttribute("data-name")) || checked.value);
    }
  }

  async ensureLocalizationData() {
    if (this._localizationData) return this._localizationData;
    if (!this._localizationDataPromise) {
      this._localizationDataPromise = fetch("/localization.json")
        .then((r) => (r.ok ? r.json() : Promise.reject("Failed localization.json")))
        .then((data) => {
          this._localizationData = data;
          return data;
        })
        .catch((err) => {
          console.warn("[Localization] fetch /localization.json failed", err);
          return null;
        });
    }
    return this._localizationDataPromise;
  }

  resetPendingRedirect() {
    this.pendingRedirectUrl = null;
    this.element.querySelectorAll('[data-action="custom-country-redirect"].is-selected').forEach((item) => {
      item.classList.remove("is-selected");
    });
  }

  async checkLocationSubmit(event) {
    if (event) event.preventDefault();
    try {
      // A linked-store (external domain) entry was chosen: redirect on confirm.
      if (this.pendingRedirectUrl) {
        window.location.href = this.pendingRedirectUrl;
        return;
      }

      // Scope to this instance's own form.
      const form = this.element.closest("form");
      if (!form) {
        console.error("[Localization] localization form not found for this modal");
        return;
      }

      const selectedItem = this.element.querySelector(".rs-country__selectbox .RevolutionSelectbox--Item.is-selected");

      const countryInput = form.querySelector('#country-selector__country-code, input[name="country_code"]');
      if (selectedItem && countryInput) {
        const chosenCountryCode = (selectedItem.getAttribute("data-value") || "").trim();
        if (!chosenCountryCode) {
          console.warn("[Localization] Selected market has empty data-value.");
          return;
        }

        // Preserve original behaviour: flag switches into stock-managed markets.
        const stockManagedCountries = ["US", "GB", "SE", "DE", "NO"];
        try {
          if (stockManagedCountries.includes(chosenCountryCode.toUpperCase())) {
            sessionStorage.setItem("switchingToStockManagedMarket", "true");
          } else {
            sessionStorage.removeItem("switchingToStockManagedMarket");
          }
        } catch (e) {}

        countryInput.value = chosenCountryCode;
      }

      // Wait for any in-flight language-option rebuild (async /localization.json
      // fallback) so we never submit the previous market's language.
      if (this._languageUpdatePromise) {
        try {
          await this._languageUpdatePromise;
        } catch (e) {}
      }

      // Make sure a language is selected and mirrored to the hidden input.
      this.ensureLanguageSelection();
      const hiddenLang = form.querySelector('#selected-language, input[type="hidden"][name="language_code"]');
      if (hiddenLang && !hiddenLang.value) {
        const firstRadio = this.element.querySelector(".language-selector__radio");
        if (firstRadio) {
          firstRadio.checked = true;
          hiddenLang.value = firstRadio.value;
        }
      }

      form.submit();
    } catch (error) {
      console.error("Localization submit error:", error);
    }
  }

  updateLanguageOptions(event) {
    if (!event || !event.detail) return Promise.resolve();
    const raw = event.detail.languages || "";
    const rawNames = event.detail.languageNames || "";
    const countryIso = (event.detail.country || "").trim().toUpperCase();

    let isoList = [];
    if (!raw) {
      isoList = [];
    } else if (raw.trim().startsWith("[")) {
      try {
        const parsed = JSON.parse(raw);
        if (Array.isArray(parsed)) {
          if (parsed.length && typeof parsed[0] === "string") {
            isoList = parsed.map((s) => String(s).trim());
          } else if (parsed.length && typeof parsed[0] === "object") {
            isoList = parsed.map((o) => o.iso || o.code).filter(Boolean);
          }
        }
      } catch (err) {
        console.warn("[Localization] Failed to parse languages JSON", err);
      }
    } else {
      isoList = raw.split(",").map((s) => s.trim()).filter(Boolean);
    }

    let nameList = [];
    if (rawNames) nameList = rawNames.split(",").map((s) => s.trim()).filter(Boolean);

    const languages = isoList.map((iso, idx) => {
      const name = this.capitalizeWords(nameList[idx] || iso.toUpperCase());
      return { iso: iso, name: name };
    });

    const buildFromLocalizationJson = async () => {
      try {
        const data = await this.ensureLocalizationData();
        if (!data || !countryIso) return [];
        const match = (data.available_countries || []).find(
          (c) => c.iso_code && c.iso_code.toUpperCase() === countryIso
        );
        if (!match) return [];
        return (match.available_languages || []).map((l) => ({
          iso: l.iso_code,
          name: this.capitalizeWords(l.endonym_name || l.name || l.iso_code),
        }));
      } catch (err) {
        console.warn("[Localization] Fallback localization.json failed", err);
        return [];
      }
    };

    const proceed = (finalLangs) => {
      const languageOptionsContainer = this.element.querySelector(".language-selector__options");
      const selectedLanguageInput = this.element.querySelector("#selected-language");
      const languageContainer = this.element.querySelector(".language-selector__container");
      const languageWrapper = this.element.querySelector(".rs-language__selectbox");
      if (!languageOptionsContainer || !selectedLanguageInput || !languageContainer) return;

      // Collapse the language dropdown if it was open when the market changed.
      this.closeSelectbox(languageWrapper);

      if (!finalLangs.length) {
        // No languages for this market: clear the stale option list and reset
        // the hidden input to the default language so we never submit the
        // previously selected market's language.
        languageOptionsContainer.innerHTML = "";
        selectedLanguageInput.value = this.element.getAttribute("data-default-language") || "";
        languageContainer.classList.add("is-language-disabled");
        const langButton = languageWrapper && languageWrapper.querySelector(".RevolutionSelectbox--Button");
        if (langButton) langButton.removeAttribute("data-action");
        return;
      }

      const prevValue = selectedLanguageInput.value;
      languageOptionsContainer.innerHTML = "";
      let matched = false;

      finalLangs.forEach((lang) => {
        const isMatch = prevValue && prevValue.toLowerCase() === lang.iso.toLowerCase();
        if (isMatch) matched = true;

        const item = document.createElement("div");
        item.className = "RevolutionSelectbox--Item";
        item.setAttribute("tabindex", "0");
        item.setAttribute("data-value", lang.iso);
        item.setAttribute("data-name", lang.name);
        item.setAttribute("data-selectboxid", "selected-language");
        item.setAttribute("data-action", "select-language");
        if (isMatch) item.classList.add("is-selected");

        const titleWrap = document.createElement("div");
        titleWrap.className = "RevolutionSelectbox--Title";
        const titleSpan = document.createElement("span");
        titleSpan.className = "RevolutionSelectbox--Title--language u-p3";
        titleSpan.textContent = lang.name;
        titleWrap.appendChild(titleSpan);
        item.appendChild(titleWrap);

        const input = document.createElement("input");
        input.type = "radio";
        input.className = "language-selector__radio";
        input.value = lang.iso;
        input.style.display = "none";
        if (isMatch) input.checked = true;
        item.appendChild(input);

        languageOptionsContainer.appendChild(item);
      });

      if (!matched) {
        selectedLanguageInput.value = finalLangs[0].iso;
        const firstItem = languageOptionsContainer.querySelector(".RevolutionSelectbox--Item");
        if (firstItem) {
          firstItem.classList.add("is-selected");
          const firstRadio = firstItem.querySelector("input.language-selector__radio");
          if (firstRadio) firstRadio.checked = true;
        }
      } else {
        selectedLanguageInput.value = prevValue;
      }

      // Single language available: keep visible but disabled + greyed out.
      const isSingle = finalLangs.length <= 1;
      languageContainer.classList.toggle("is-language-disabled", isSingle);
      const langButton = languageWrapper && languageWrapper.querySelector(".RevolutionSelectbox--Button");
      if (langButton) {
        if (isSingle) langButton.removeAttribute("data-action");
        else langButton.setAttribute("data-action", "toggle-selectbox");
      }

      this.ensureLanguageSelection();
    };

    if (languages.length === 0) {
      return buildFromLocalizationJson().then((fallbackLangs) => proceed(fallbackLangs));
    }
    proceed(languages);
    return Promise.resolve();
  }
}
customElements.define("localization-modal", LocalizationModal);

/**
 * <cylinder-payment-flow>
 *
 * Drives the gas cylinder payment flow on the PDP. Two mutually exclusive
 * options ("Starter" and "Exchange & refill") live in the same component.
 * Selecting an option (and, for Starter, a quantity of 1 or 2) syncs the
 * choice into the product form and updates the price, USP content, gallery
 * image and the Add to cart CTA price.
 *
 * The matching markup is rendered by snippets/cylinder_payment_flow.liquid and
 * the synced form inputs by snippets/product-form.liquid (cylinder_flow branch).
 */
class CylinderPaymentFlow extends HTMLElement {
  connectedCallback() {
    this.formId = this.dataset.formId;
    this.form = document.getElementById(this.formId);

    this.options = this.querySelectorAll(".cylinder-flow__option");
    this.productButtons = this.querySelectorAll('[data-action="cylinder-product"]');
    this.starterCardPrice = this.querySelector("[data-starter-card-price]");

    // Internal state.
    this.selectedOption = "starter"; // "starter" | "exchange"
    // Default Starter box: the one whose product is the current PDP product
    // (resolved in Liquid via data-default-product), falling back to box 1.
    this.selectedProduct = this.dataset.defaultProduct === "2" ? "2" : "1";

    this.handleClick = this.handleClick.bind(this);
    this.addEventListener("click", this.handleClick);

    // Guarantee the form matches the selection at the moment of adding. This
    // runs in the capture phase (before the product form's own add handler) and
    // re-syncs from the actually-checked radio, so a missed selection click can
    // never submit the other option's id / quantity.
    this.handleAddClick = this.handleAddClick.bind(this);
    document.addEventListener("click", this.handleAddClick, true);

    // Load with the option the page itself is rendering (resolved in Liquid via
    // data-default-option): Exchange on the exchange product's own page, else
    // Starter with the box that matches. Nothing else needs syncing here - the
    // title, gallery and description are already the landing product's, so the
    // rAF below only has to point the form and CTA price at it.
    const defaultOption =
      this.dataset.defaultOption === "exchange" && this.variantFor("exchange")
        ? "exchange"
        : "starter";
    this.selectOption(defaultOption, { silent: true });
    this.selectProduct(this.selectedProduct, { silent: true });

    // The gallery shows the *page's* product, which is only sometimes the
    // default box's product (data-default-product falls back to box 1 when
    // neither box matches the page). Seed from the page handle so the first
    // switch away from it isn't mistaken for a re-selection and skipped.
    this._lastGalleryHandle =
      this.dataset.pageHandle || this.productData(this.currentKey())?.handle;

    // Sync the form once the rest of the page (incl. the buy buttons block) has
    // been parsed, so the product form and its inputs are available.
    requestAnimationFrame(() => {
      this.syncForm();
      this.updateCtaPrice(this.priceFor(this.currentKey()));
      this.reflectAvailability();
    });

    this.prewarmGalleries();
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.handleClick);
    document.removeEventListener("click", this.handleAddClick, true);
  }

  // Runs in capture phase, before the product form's add handler. Forces the
  // form to the *actually-checked* option's product / quantity / property right
  // before submit. If that option has no purchasable variant, the add is blocked
  // outright - it must never fall back to the other option's product/quantity.
  handleAddClick(event) {
    if (!this.form) this.form = document.getElementById(this.formId);
    const btn = event.target.closest('[data-action="add-to-cart"]');
    if (!btn || !this.form || !this.form.contains(btn)) return;

    // Source of truth = the actually-checked radio + the active Starter box.
    const checked = this.querySelector(".cylinder-flow__radio-input:checked");
    if (checked && checked.value !== this.selectedOption) this.selectedOption = checked.value;

    const data = this.productData(this.currentKey());

    // No variant for the selection -> stop; never submit a different product.
    if (!data || !data.variant) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    // Write the selected product straight into the form (always quantity 1).
    const idInput = this.form.querySelector('[name="id"]');
    if (idInput) {
      idInput.value = data.variant;
      idInput.dataset.id = data.variant;
      idInput.removeAttribute("disabled");
    }
    this.getOrCreateInput("quantity", "cylinder-flow-quantity").value = 1;
    const propLabel = this.dataset.propertyLabel || "Option";
    this.getOrCreateInput("properties[" + propLabel + "]", "cylinder-flow-property").value =
      data.title || "";
  }

  handleClick(event) {
    const trigger = event.target.closest("[data-action]");
    if (!trigger || !this.contains(trigger)) return;

    switch (trigger.dataset.action) {
      case "cylinder-select":
        this.selectOption(trigger.value);
        break;
      case "cylinder-product":
        event.preventDefault();
        this.selectProduct(trigger.dataset.product);
        break;
    }
  }

  /* ---- keys / product data ---------------------------------------------- */
  // The product actually in play: exchange when that radio is chosen, else the
  // active Starter box (1 or 2).
  currentKey() {
    return this.selectedOption === "exchange" ? "exchange" : this.selectedProduct;
  }

  productData(key) {
    if (key === "exchange") {
      return {
        variant: this.dataset.exVariant,
        price: this.dataset.exPrice,
        handle: this.dataset.exHandle,
        title: this.dataset.exTitle,
      };
    }
    const box = this.querySelector(
      `[data-action="cylinder-product"][data-product="${key}"]`
    );
    return box
      ? {
          variant: box.dataset.variant,
          price: box.dataset.price,
          handle: box.dataset.handle,
          title: box.dataset.title,
        }
      : null;
  }

  priceFor(key) {
    const d = this.productData(key);
    return d ? d.price : "";
  }

  variantFor(key) {
    const d = this.productData(key);
    return d ? d.variant : "";
  }

  /* ---- option (Starter / Exchange radio) -------------------------------- */
  selectOption(option, { silent = false } = {}) {
    if (option !== "starter" && option !== "exchange") return;
    // Can't switch to Exchange when there's no exchange product configured.
    if (option === "exchange" && !this.variantFor("exchange")) {
      this.syncRadios();
      return;
    }
    if (!silent && this.selectedOption === option) return;
    this.selectedOption = option;

    this.options.forEach((el) => {
      const isSelected = el.dataset.option === option;
      el.setAttribute("aria-selected", isSelected ? "true" : "false");
      const radio = el.querySelector(".cylinder-flow__radio-input");
      if (radio) radio.checked = isSelected;
      const body = el.querySelector(".cylinder-flow__option-body");
      if (isSelected) this.expandBody(el, body, { immediate: silent });
      else this.collapseBody(el, body, { immediate: silent });
    });

    if (!silent) this.refresh();
  }

  /* ---- product box (Starter 1 / 2) -------------------------------------- */
  selectProduct(key, { silent = false } = {}) {
    if (key !== "1" && key !== "2") return;
    // Ignore a box with no product (e.g. option 2 not configured).
    if (!this.variantFor(key)) return;
    // Re-clicking the active box is a no-op - nothing about the selection has
    // changed, so don't re-run the description swap / form sync (mirrors the
    // same guard in selectOption).
    if (!silent && this.selectedProduct === key) return;
    this.selectedProduct = key;

    this.productButtons.forEach((btn) => {
      const isSelected = btn.dataset.product === key;
      btn.classList.toggle("cylinder-flow__qty--selected", isSelected);
      btn.setAttribute("aria-pressed", isSelected ? "true" : "false");
    });

    // Reflect the chosen product's price inside the Starter card.
    const price = this.priceFor(key);
    if (price && this.starterCardPrice) this.starterCardPrice.textContent = price;

    if (!silent && this.selectedOption === "starter") this.refresh();
  }

  // Push the current selection everywhere: gallery, description, form, CTA price.
  refresh() {
    const key = this.currentKey();
    this.updateGallery(key);
    this.updateProductInfo(key);
    this.syncForm();
    this.updateCtaPrice(this.priceFor(key));
  }

  /* ---- availability ------------------------------------------------------ */
  // Disable a Starter box with no product, and the Exchange radio when there is
  // no exchange product.
  reflectAvailability() {
    this.productButtons.forEach((btn) => {
      const ok = !!btn.dataset.variant;
      btn.disabled = !ok;
      btn.classList.toggle("cylinder-flow__qty--disabled", !ok);
    });
    const exOption = this.querySelector('.cylinder-flow__option[data-option="exchange"]');
    if (exOption) {
      const ok = !!this.dataset.exVariant;
      exOption.classList.toggle("cylinder-flow__option--disabled", !ok);
      const radio = exOption.querySelector(".cylinder-flow__radio-input");
      if (radio) radio.disabled = !ok;
    }
  }

  // Reset radios to reflect selectedOption (used when a click is rejected).
  syncRadios() {
    this.options.forEach((el) => {
      const radio = el.querySelector(".cylinder-flow__radio-input");
      if (radio) radio.checked = el.dataset.option === this.selectedOption;
    });
  }

  /* Mirror the selected product into the page: swap the product title, the
     description and the current breadcrumb label. Keyed by product ("1", "2",
     "exchange"). */
  updateProductInfo(key) {
    const template = this.querySelector(`[data-cylinder-description="${key}"]`);
    if (template) {
      document.querySelectorAll(".ProductDescription").forEach((el) => {
        this.swapDescription(el, template.innerHTML);
      });
    }
    const data = this.productData(key);
    if (data && data.title) {
      // querySelectorAll, not querySelector: the section can render both a
      // `title` and a `title_price` block, so there is more than one h1.
      document.querySelectorAll(".ProductInfo--Title h1").forEach((el) => {
        el.textContent = data.title;
        el.setAttribute("data-name", data.title);
      });
      document.querySelectorAll(".Product--StickyTitle").forEach((el) => {
        el.textContent = data.title;
      });
      document
        .querySelectorAll('.breadcrumbs__link[aria-current="page"]')
        .forEach((el) => {
          el.textContent = data.title;
        });
    }
  }

  /* Swap a description's markup, animating the container between the old and
     new content heights so the rest of the page doesn't jump. The content
     itself changes instantly (in the same frame the start height is pinned);
     only the box height is animated. Settles back on auto so the description
     keeps reflowing with late-loading images and viewport changes. */
  swapDescription(el, rawHtml) {
    // A product with no description renders an empty container (kept in the DOM
    // precisely so it can be swapped into) that ProductDescription--empty holds
    // out of the layout. Normalise whitespace-only markup to "" so the two
    // states compare equal.
    const html = rawHtml && rawHtml.trim() ? rawHtml : "";
    const isEmpty = html === "";

    // Compare against what was last written as well as the live markup: the
    // browser re-serialises on assignment (`<br/>` -> `<br>`, attribute order,
    // entities), so `innerHTML` alone can differ from the source it was set
    // from and re-run the whole animation for identical content.
    if (el.innerHTML === html || el._cylDescHtml === html) return;
    el._cylDescHtml = html;

    const wasEmpty = el.classList.contains("ProductDescription--empty");

    if (this.prefersReducedMotion()) {
      el.innerHTML = html;
      el.classList.toggle("ProductDescription--empty", isEmpty);
      return;
    }

    // Clip first, then measure. The class brings overflow:hidden, which opens a
    // block formatting context and stops child margins collapsing through the
    // container - so both heights have to be read with it applied, or they are
    // measured under two different layout modes.
    el.classList.add("cylinder-flow__description--animating");

    // Coming out of the empty state the box starts at nothing: no height and no
    // padding. The --blank modifier zeroes the padding so the animation doesn't
    // start (or end) at the padding's worth of height it can never drop below.
    el.classList.toggle("cylinder-flow__description--blank", wasEmpty);

    // The height on screen right now, which is the mid-transition value if a
    // previous swap is still running.
    const start = wasEmpty ? 0 : el.getBoundingClientRect().height;
    this.cancelDescriptionTransition(el);

    el.innerHTML = html;
    el._cylDescEmpty = isEmpty;
    // Back in flow for the animation; settleDescription re-hides it if the new
    // content is empty.
    el.classList.remove("ProductDescription--empty");

    // Measure the new content at its natural height, then animate from `start`.
    // Emptying out always targets 0 - there is nothing to measure.
    let target = 0;
    if (!isEmpty) {
      el.classList.remove("cylinder-flow__description--blank");
      el.style.height = "auto";
      target = el.getBoundingClientRect().height;
      el.classList.toggle("cylinder-flow__description--blank", wasEmpty);
    }

    // Nothing to animate (equal heights, or the description is hidden and both
    // measure 0) - drop straight back to auto rather than pin a height.
    if (Math.abs(target - start) < 1) {
      this.settleDescription(el);
      return;
    }

    el.style.height = start + "px";
    void el.offsetHeight; // commit the start frame
    el.classList.toggle("cylinder-flow__description--blank", isEmpty);
    el.style.height = target + "px";

    const handler = (event) => {
      if (event.target !== el || event.propertyName !== "height") return;
      this.cancelDescriptionTransition(el);
      this.settleDescription(el);
    };
    el._cylDescHandler = handler;
    el.addEventListener("transitionend", handler);

    // transitionend never fires if the element is hidden mid-animation, which
    // would leave the height pinned for good. Always release it.
    el._cylDescTimer = setTimeout(() => {
      this.cancelDescriptionTransition(el);
      this.settleDescription(el);
    }, CylinderPaymentFlow.DESCRIPTION_SWAP_MS + 100);
  }

  // Drop the in-flight listener/timer without touching the applied height, so a
  // swap that interrupts another one can still read the current height.
  cancelDescriptionTransition(el) {
    if (el._cylDescHandler) {
      el.removeEventListener("transitionend", el._cylDescHandler);
      el._cylDescHandler = null;
    }
    if (el._cylDescTimer) {
      clearTimeout(el._cylDescTimer);
      el._cylDescTimer = null;
    }
  }

  // Hand the element back to normal flow: no pinned height, no clipping, and
  // hidden again if what was written into it was empty.
  settleDescription(el) {
    el.classList.remove("cylinder-flow__description--animating");
    el.classList.remove("cylinder-flow__description--blank");
    el.classList.toggle("ProductDescription--empty", !!el._cylDescEmpty);
    el.style.height = "";
  }

  /* Expand a body: unhide, then animate height from its current value to the
     measured content height, and settle on `auto` once the transition ends. */
  expandBody(el, body, { immediate = false } = {}) {
    el.setAttribute("aria-selected", "true");
    if (!body) return;
    this.cancelBodyTransition(body);

    body.style.display = ""; // undo a previous display:none

    if (immediate || this.prefersReducedMotion()) {
      body.style.height = "auto";
      return;
    }

    const start = body.getBoundingClientRect().height;
    const target = body.scrollHeight;
    if (Math.abs(target - start) < 1) {
      body.style.height = "auto";
      return;
    }

    body.style.height = start + "px";
    void body.offsetHeight; // commit the start frame
    body.style.height = target + "px";

    const handler = (event) => {
      if (event.target !== body || event.propertyName !== "height") return;
      // Settle on auto so the body reflows with content/viewport changes.
      if (el.getAttribute("aria-selected") === "true") body.style.height = "auto";
      this.cancelBodyTransition(body);
    };
    body._cylHandler = handler;
    body.addEventListener("transitionend", handler);
  }

  /* Collapse a body: animate height from its current value to 0, then set
     display:none once the transition ends so it leaves layout and tab order. */
  collapseBody(el, body, { immediate = false } = {}) {
    el.setAttribute("aria-selected", "false");
    if (!body) return;
    this.cancelBodyTransition(body);

    // No animation (initial boot or reduced motion) -> hide right away, since
    // transitionend would never fire.
    if (immediate || this.prefersReducedMotion()) {
      body.style.height = "0px";
      body.style.display = "none";
      return;
    }

    const start = body.getBoundingClientRect().height;
    body.style.height = start + "px";
    void body.offsetHeight; // commit the start frame
    body.style.height = "0px";

    const handler = (event) => {
      if (event.target !== body || event.propertyName !== "height") return;
      this.cancelBodyTransition(body);
      // Defer display:none to the next frame so the final 0px frame is painted
      // first (avoids a flicker from hiding in the same frame the transition ends).
      requestAnimationFrame(() => {
        // Guard against a re-open that happened mid-transition.
        if (el.getAttribute("aria-selected") === "false") body.style.display = "none";
      });
    };
    body._cylHandler = handler;
    body.addEventListener("transitionend", handler);
  }

  cancelBodyTransition(body) {
    if (body && body._cylHandler) {
      body.removeEventListener("transitionend", body._cylHandler);
      body._cylHandler = null;
    }
  }

  prefersReducedMotion() {
    return (
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches
    );
  }

  /* Form sync -------------------------------------------------------------- */
  // Write the currently-selected product into the form: id + quantity 1 + the
  // option property (its product title).
  syncForm() {
    if (!this.form) this.form = document.getElementById(this.formId);
    if (!this.form) return;

    const data = this.productData(this.currentKey());
    if (!data || !data.variant) return;

    const idInput = this.form.querySelector('[name="id"]');
    if (idInput) {
      idInput.value = data.variant;
      idInput.dataset.id = data.variant;
      idInput.removeAttribute("disabled");
    }

    this.getOrCreateInput("quantity", "cylinder-flow-quantity").value = 1;

    const propLabel = this.dataset.propertyLabel || "Option";
    this.getOrCreateInput(
      "properties[" + propLabel + "]",
      "cylinder-flow-property"
    ).value = data.title || "";
  }

  getOrCreateInput(name, className) {
    let input =
      this.form.querySelector("." + className) ||
      this.form.querySelector('[name="' + name + '"]');
    if (!input) {
      input = document.createElement("input");
      input.type = "hidden";
      input.className = className;
      this.form.appendChild(input);
    }
    input.name = name;
    input.removeAttribute("disabled");
    return input;
  }

  /* CTA price -------------------------------------------------------------- */
  updateCtaPrice(priceLabel) {
    if (!priceLabel) return;
    document
      .querySelectorAll(".ProductPage--ATC .button--money")
      .forEach((el) => {
        el.textContent = priceLabel;
      });
  }

  /* Gallery image ---------------------------------------------------------- */
  // Swap the PDP gallery to the selected product, reusing the theme's existing
  // product-fetch mechanism (the same getTemplate + updateTemplatesSwiper path
  // the purifier / filter flows use). The product element listens for this
  // event and does the fetch + gallery replace.
  updateGallery(key) {
    const data = this.productData(key);
    const handle = data && data.handle;
    // Skip when the gallery already shows this product (avoids a needless
    // refetch + swiper re-init when re-selecting the current option).
    if (!handle || handle === this._lastGalleryHandle) return;
    this._lastGalleryHandle = handle;
    this.dispatchEvent(
      new CustomEvent("cylinder:gallery:swap", {
        bubbles: true,
        detail: { handle },
      })
    );
  }

  /* Gallery prefetch --------------------------------------------------------
     A switch is only slow the first time: it fetches the product page, then
     waits on the images that markup pulls in. Both are cached afterwards,
     which is why switching back and forth is instant. Do that work up front
     instead, off the critical path. The product element does the fetching. */
  prewarmGalleries() {
    // The current product is included so switching *back* is a cache hit too;
    // its images are already on the page, so only its markup gets prefetched.
    const handles = ["1", "2", "exchange"]
      .map((key) => this.productData(key)?.handle)
      .filter(Boolean);

    const prewarm = () => {
      // Images first - their URLs are rendered into the markup, so they can
      // start downloading without waiting on the page fetch to reveal them.
      this.warmFirstImages();

      if (!handles.length) return;
      this.dispatchEvent(
        new CustomEvent("cylinder:gallery:prefetch", {
          bubbles: true,
          detail: { handles, current: this._lastGalleryHandle },
        })
      );
    };

    // Starts once the document is parsed rather than on `load`. Waiting for
    // every image and third-party script on the PDP pushed this several
    // seconds out - straight through the window in which the first switch
    // actually happens, which is why that one switch stayed slow.
    const schedule = () => {
      if (window.requestIdleCallback) requestIdleCallback(prewarm, { timeout: 1500 });
      else setTimeout(prewarm, 200);
    };

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", schedule, { once: true });
    } else {
      schedule();
    }
  }

  /* Pull each product's first gallery image into the browser cache. The URLs
     come from the <template data-cylinder-image> blocks the snippet renders -
     a template's contents never load on their own, so nothing is downloaded
     until this runs. Mirrored onto throwaway Image()s with srcset/sizes set
     before src, so the candidate warmed here is the one the real markup
     resolves to once it is injected. */
  warmFirstImages() {
    this._warmedImages = this._warmedImages || [];

    this.querySelectorAll("[data-cylinder-image]").forEach((template) => {
      const image = template.content && template.content.querySelector("img[src]");
      if (!image) return;

      const warm = new Image();
      const sizes = image.getAttribute("sizes");
      const srcset = image.getAttribute("srcset");
      if (sizes) warm.sizes = sizes;
      if (srcset) warm.srcset = srcset;
      warm.src = image.getAttribute("src");
      // Held so the load can't be collected before it finishes.
      this._warmedImages.push(warm);
    });
  }
}

// Description height-swap duration. Keep in step with the 0.3s transition on
// .cylinder-flow__description--animating in cylinder_payment_flow.css.
CylinderPaymentFlow.DESCRIPTION_SWAP_MS = 300;

if (!customElements.get("cylinder-payment-flow")) {
  customElements.define("cylinder-payment-flow", CylinderPaymentFlow);
}